(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6562],{

/***/ 18304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ SweepType; }
/* harmony export */ });
var SweepType;
(function(SweepType) {
    SweepType["Text"] = "text";
    SweepType["Image"] = "image";
    SweepType["Music"] = "music";
    SweepType["Video"] = "video";
    SweepType["Iframe"] = "iframe";
    SweepType["Tab"] = "tab";
    SweepType["None"] = "none";
    SweepType["Panorama"] = "panorama";
    SweepType["GreenScreen"] = "green_screen";
})(SweepType || (SweepType = {}));


/***/ }),

/***/ 55348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MediaType": function() { return /* binding */ MediaType; },
/* harmony export */   "Product": function() { return /* binding */ Product; },
/* harmony export */   "ProductStatus": function() { return /* binding */ ProductStatus; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);



var MediaType;
(function(MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["YOUTUBE"] = "youtube";
    MediaType["HEXA3D"] = "hexa3d";
})(MediaType || (MediaType = {}));
var ProductStatus;
(function(ProductStatus) {
    ProductStatus["ACTIVE"] = "Active";
    ProductStatus["ARCHIVED"] = "Archived";
    ProductStatus["DRAFT"] = "Draft";
})(ProductStatus || (ProductStatus = {}));
var Product = /*#__PURE__*/ function() {
    "use strict";
    function Product() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Product);
        var ref, ref1;
        this.id = model.id || null;
        this.tourId = model.tourId || null;
        this.title = model.title || null;
        this.previewImage = model.previewImage || null;
        this.userId = model.userId || null;
        this.description = model.description || null;
        this.variants = model.variants || [];
        var customVariant = this.getMinVariant(model.variants, "price");
        this.countryId = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.countryId) || null;
        // this.status = customVariant?.status || null;
        this.weight = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.weight) || null;
        this.weightUnit = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.weightUnit) || null;
        this.isTrackQuantity = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.isTrackQuantity) || false;
        this.quantity = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.quantity) || 0;
        this.sellingOutOfStock = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.sellingOutOfStock) || false;
        this.barcode = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.barcode) || null;
        this.price = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.price) || null;
        this.comparePrice = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.comparePrice) || null;
        this.isShipping = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.isShipping) || false;
        this.hsCode = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.hsCode) || null;
        this.warrantyFile = model.warrantyFile || null;
        this.specificationsFile = model.specificationsFile || null;
        this.eCommerceVendorId = model.eCommerceVendorId || null;
        this.eCommerceProductTypeId = model.eCommerceProductTypeId || null;
        this.isMultipleOptions = model.isMultipleOptions || false;
        this.icon = model.icon || null;
        if (model.icon && ((ref = model.icon) === null || ref === void 0 ? void 0 : ref.indexOf(".")) !== -1) {
            this.iconFile = "".concat("https://cdn.treedis.com", "/users/").concat(this.userId, "/eCommerce/").concat(this.id, "/").concat(model.icon);
            this.icon = null;
        }
        this.opacity = model.opacity || 0;
        this.iconColor = model.iconColor || null;
        this.media = ((ref1 = model.media) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
                url: _this.getMediaUrl(item.url, item.type),
                embed: item.type === MediaType.YOUTUBE ? item.url : ""
            });
        })) || [];
        this.specifications = model.specifications || [];
        this.options = model.options || [];
        this.previewImage = this.media.find(function(item) {
            return item.type !== MediaType.YOUTUBE && item.type !== MediaType.HEXA3D;
        }) || {};
        this.sid = model.sid || null;
        this.positionX = model.positionX || null;
        this.positionY = model.positionY || null;
        this.positionZ = model.positionZ || null;
        this.stemVectorX = model.stemVectorX || null;
        this.stemVectorZ = model.stemVectorZ || null;
        this.stemVectorY = model.stemVectorY || null;
        this.status = model.status || null;
        var _isEnableCart;
        this.isEnableCart = (_isEnableCart = model.isEnableCart) !== null && _isEnableCart !== void 0 ? _isEnableCart : false;
        this.cartLink = model.cartLink || "#";
        this.cartLinkType = model.cartLinkType || null;
    }
    var _proto = Product.prototype;
    _proto.getMediaUrl = function getMediaUrl(url, type) {
        if (type === MediaType.YOUTUBE) {
            return "https://img.youtube.com/vi/".concat(url, "/sddefault.jpg");
        }
        if (type === MediaType.HEXA3D) {
            return url;
        }
        return "".concat("https://cdn.treedis.com", "/users/").concat(this.userId, "/eCommerce/").concat(this.id, "/media/").concat(url);
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.getMinVariant = function getMinVariant() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], field = arguments.length > 1 ? arguments[1] : void 0;
        if (!data.length) return null;
        var filtered = data.filter(function(item) {
            return data.length > 1 && !item.isDefault || data.length === 1;
        });
        return filtered.reduce(function(minItem, item) {
            return item[field] != null && minItem[field] > item[field] ? item : minItem;
        }, filtered[0]);
    };
    return Product;
}();


/***/ }),

/***/ 59524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IW": function() { return /* binding */ PolygonActionAction; },
/* harmony export */   "fD": function() { return /* binding */ PolygonAction; },
/* harmony export */   "l3": function() { return /* binding */ PolygonActionMode; },
/* harmony export */   "mg": function() { return /* binding */ Polygon; },
/* harmony export */   "zS": function() { return /* binding */ PolygonActionType; }
/* harmony export */ });
/* unused harmony export PolygonActionRes */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);

var PolygonActionType;
(function(PolygonActionType) {
    PolygonActionType["None"] = "none";
    PolygonActionType["Text"] = "text";
    PolygonActionType["Image"] = "image";
    PolygonActionType["Music"] = "music";
    PolygonActionType["Video"] = "video";
    PolygonActionType["Iframe"] = "iframe";
    PolygonActionType["Tab"] = "tab";
    PolygonActionType["Panorama"] = "panorama";
    PolygonActionType["Menu"] = "menu";
    PolygonActionType["Treedis"] = "treedis";
})(PolygonActionType || (PolygonActionType = {}));
var PolygonActionAction;
(function(PolygonActionAction) {
    PolygonActionAction["Click"] = "click";
    PolygonActionAction["Hover"] = "hover";
})(PolygonActionAction || (PolygonActionAction = {}));
var PolygonActionRes;
(function(PolygonActionRes) {
    PolygonActionRes["Percentage"] = "percentage";
    PolygonActionRes["Pixels"] = "pixels";
})(PolygonActionRes || (PolygonActionRes = {}));
var PolygonActionMode;
(function(PolygonActionMode) {
    PolygonActionMode["Ecommerce"] = "ecommerce";
    PolygonActionMode["Game"] = "game";
    PolygonActionMode["VS"] = "vs";
})(PolygonActionMode || (PolygonActionMode = {}));
var PolygonAction = function PolygonAction() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, PolygonAction);
    this.id = model.id;
    this.polygonId = model.polygonId || "";
    this.mode = model.mode || PolygonActionMode.VS;
    this.type = model.type || PolygonActionType.None;
    this.action = model.action || PolygonActionAction.Click;
    this.url = model.url || "";
    this.text = model.text || "";
    this.resolution = model.resolution || PolygonActionRes.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 80;
    this.panoramaId = model.panoramaId || null;
    this.menuId = model.menuId || null;
    this.subMenuId = model.subMenuId || null;
    this.subSubMenuId = model.subSubMenuId || null;
    this.gameBackpack = model.gameBackpack || false;
    this.fullscreen = model.fullscreen || false;
    this.autoPlay = model.autoPlay || false;
};
var Polygon = function Polygon() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Polygon);
    var ref;
    this.id = model.id;
    this.title = model.title || "";
    this.tourId = model.tourId;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.uuid = model.uuid || null;
    this.colorDefault = model.colorDefault || "#ea475c";
    this.colorHover = model.colorHover || "#FFFFFF";
    this.colorClick = model.colorClick || "#ea475c";
    this.opacityDefault = model.opacityDefault >= 0 ? model.opacityDefault : 0.2;
    this.opacityHover = model.opacityHover >= 0 ? model.opacityHover : 0.4;
    this.opacityClick = model.opacityClick >= 0 ? model.opacityClick : 0.5;
    this.edgesOpacityDefault = model.edgesOpacityDefault >= 0 ? model.edgesOpacityDefault : 0.5;
    this.edgesOpacityHover = model.edgesOpacityHover >= 0 ? model.edgesOpacityHover : 0.7;
    this.edgesOpacityClick = model.edgesOpacityClick >= 0 ? model.edgesOpacityClick : 0.8;
    this.sweep_uuid = model.sweep_uuid || null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.products = ((ref = model.products) === null || ref === void 0 ? void 0 : ref.length) > 0 ? model.products.map(function(item) {
        return item.id;
    }) : [];
    this.polygonsActions = model.polygonsActions || [];
};


/***/ }),

/***/ 98472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ SceneComponent; }
/* harmony export */ });
/* unused harmony exports ComponentInteractionType, PointerButton, PointerButtonMask, PointerDevice, KeyState, Keys */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26626);



/**
 * The base of all `SceneComponent` created with the sdk.
 * All properties of this class are always available to all components generated through the sdk.
 * These properties should all be considered reserved and should not be overwritten by the subclass.
 */ var SceneComponentPrivate = function SceneComponentPrivate() {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponentPrivate);
};
var SceneComponent = /*#__PURE__*/ function(SceneComponentPrivate) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SceneComponent, SceneComponentPrivate);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SceneComponent);
    function SceneComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponent);
        return _super.apply(this, arguments);
    }
    return SceneComponent;
}(SceneComponentPrivate);
var ComponentInteractionType;
(function(ComponentInteractionType) {
    ComponentInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    ComponentInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    ComponentInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    ComponentInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    ComponentInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    ComponentInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    ComponentInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    ComponentInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    ComponentInteractionType["KEY"] = "INTERACTION.KEY";
    ComponentInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    ComponentInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    ComponentInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    ComponentInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    ComponentInteractionType["PINCH"] = "INTERACTION.PINCH";
    ComponentInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    ComponentInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    ComponentInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(ComponentInteractionType || (ComponentInteractionType = {}));
var ComponentOutputReserved = function ComponentOutputReserved() {
    "use strict";
    _class_call_check(this, ComponentOutputReserved);
};
var ComponentOut = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ComponentOutputReserved) {
    "use strict";
    _inherits(ComponentOut, ComponentOutputReserved);
    var _super = _create_super(ComponentOut);
    function ComponentOut() {
        _class_call_check(this, ComponentOut);
        return _super.apply(this, arguments);
    }
    return ComponentOut;
}(ComponentOutputReserved)));
var PointerButton;
(function(PointerButton) {
    PointerButton[PointerButton["PRIMARY"] = 0] = "PRIMARY";
    PointerButton[PointerButton["MIDDLE"] = 1] = "MIDDLE";
    PointerButton[PointerButton["SECONDARY"] = 2] = "SECONDARY";
    PointerButton[PointerButton["BACK"] = 3] = "BACK";
    PointerButton[PointerButton["FORWARD"] = 4] = "FORWARD";
    PointerButton[PointerButton["COUNT"] = 5] = "COUNT";
})(PointerButton || (PointerButton = {}));
var PointerButtonMask;
(function(PointerButtonMask) {
    PointerButtonMask[PointerButtonMask["NONE"] = 0] = "NONE";
    PointerButtonMask[PointerButtonMask["PRIMARY"] = 1 << PointerButton.PRIMARY] = "PRIMARY";
    PointerButtonMask[PointerButtonMask["SECONDARY"] = 1 << PointerButton.SECONDARY] = "SECONDARY";
    PointerButtonMask[PointerButtonMask["MIDDLE"] = 1 << PointerButton.MIDDLE] = "MIDDLE";
    PointerButtonMask[PointerButtonMask["BACK"] = 1 << PointerButton.BACK] = "BACK";
    PointerButtonMask[PointerButtonMask["FORWARD"] = 1 << PointerButton.FORWARD] = "FORWARD";
    PointerButtonMask[PointerButtonMask["ALL"] = (1 << PointerButton.COUNT) - 1] = "ALL";
})(PointerButtonMask || (PointerButtonMask = {}));
var PointerDevice;
(function(PointerDevice) {
    PointerDevice["MOUSE"] = "mouse";
    PointerDevice["TOUCH"] = "touch";
    PointerDevice["PEN"] = "pen";
    PointerDevice["GAMEPAD"] = "gamepad";
})(PointerDevice || (PointerDevice = {}));
var KeyState;
(function(KeyState) {
    KeyState[KeyState["DOWN"] = 0] = "DOWN";
    KeyState[KeyState["PRESSED"] = 1] = "PRESSED";
    KeyState[KeyState["UP"] = 2] = "UP";
})(KeyState || (KeyState = {}));
var Keys;
(function(Keys) {
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["ZERO"] = 48] = "ZERO";
    Keys[Keys["ONE"] = 49] = "ONE";
    Keys[Keys["TWO"] = 50] = "TWO";
    Keys[Keys["THREE"] = 51] = "THREE";
    Keys[Keys["FOUR"] = 52] = "FOUR";
    Keys[Keys["FIVE"] = 53] = "FIVE";
    Keys[Keys["SIX"] = 54] = "SIX";
    Keys[Keys["SEVEN"] = 55] = "SEVEN";
    Keys[Keys["EIGHT"] = 56] = "EIGHT";
    Keys[Keys["NINE"] = 57] = "NINE";
    Keys[Keys["LEFTARROW"] = 37] = "LEFTARROW";
    Keys[Keys["UPARROW"] = 38] = "UPARROW";
    Keys[Keys["RIGHTARROW"] = 39] = "RIGHTARROW";
    Keys[Keys["DOWNARROW"] = 40] = "DOWNARROW";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["A"] = 65] = "A";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["C"] = 67] = "C";
    Keys[Keys["D"] = 68] = "D";
    Keys[Keys["E"] = 69] = "E";
    Keys[Keys["F"] = 70] = "F";
    Keys[Keys["G"] = 71] = "G";
    Keys[Keys["H"] = 72] = "H";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["J"] = 74] = "J";
    Keys[Keys["K"] = 75] = "K";
    Keys[Keys["L"] = 76] = "L";
    Keys[Keys["M"] = 77] = "M";
    Keys[Keys["N"] = 78] = "N";
    Keys[Keys["O"] = 79] = "O";
    Keys[Keys["P"] = 80] = "P";
    Keys[Keys["Q"] = 81] = "Q";
    Keys[Keys["R"] = 82] = "R";
    Keys[Keys["S"] = 83] = "S";
    Keys[Keys["T"] = 84] = "T";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["V"] = 86] = "V";
    Keys[Keys["W"] = 87] = "W";
    Keys[Keys["X"] = 88] = "X";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["RETURN"] = 13] = "RETURN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["SEMICOLON"] = 186] = "SEMICOLON";
    Keys[Keys["PLUSEQUALS"] = 187] = "PLUSEQUALS";
    Keys[Keys["DASHUNDERSCORE"] = 189] = "DASHUNDERSCORE";
    Keys[Keys["OPENBRACKET"] = 219] = "OPENBRACKET";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["CONTROL"] = 17] = "CONTROL";
})(Keys || (Keys = {}));


/***/ }),

/***/ 15864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ TourVSImageRotation; },
/* harmony export */   "Gu": function() { return /* binding */ LoadingState; },
/* harmony export */   "IG": function() { return /* binding */ VSInteractionType; },
/* harmony export */   "OV": function() { return /* binding */ VSVideoType; },
/* harmony export */   "Up": function() { return /* binding */ TourVideo; },
/* harmony export */   "Z5": function() { return /* binding */ TourImageAction; },
/* harmony export */   "aS": function() { return /* binding */ TourImageActionRes; },
/* harmony export */   "oP": function() { return /* binding */ TourImage; },
/* harmony export */   "rx": function() { return /* binding */ TourImageActionType; },
/* harmony export */   "zB": function() { return /* binding */ TourObject; }
/* harmony export */ });
/* unused harmony exports VSObject, VSImage, VSVideo */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);

// eslint-disable-next-line max-classes-per-file

var TourImageActionType;
(function(TourImageActionType) {
    TourImageActionType["None"] = "none";
    TourImageActionType["Text"] = "text";
    TourImageActionType["Image"] = "image";
    TourImageActionType["Music"] = "music";
    TourImageActionType["Video"] = "video";
    TourImageActionType["Iframe"] = "iframe";
    TourImageActionType["Tab"] = "tab";
    TourImageActionType["Panorama"] = "panorama";
    TourImageActionType["Menu"] = "menu";
    TourImageActionType["Treedis"] = "treedis";
    TourImageActionType["ExperiencePopUp"] = "experiencePopUp";
})(TourImageActionType || (TourImageActionType = {}));
var TourVSImageRotation;
(function(TourVSImageRotation) {
    TourVSImageRotation["Vertical"] = "vertical";
    TourVSImageRotation["Horizontal"] = "horizontal";
})(TourVSImageRotation || (TourVSImageRotation = {}));
var TourImageAction;
(function(TourImageAction) {
    TourImageAction["Click"] = "click";
    TourImageAction["Hover"] = "hover";
})(TourImageAction || (TourImageAction = {}));
var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var TourImageActionRes;
(function(TourImageActionRes) {
    TourImageActionRes["Percentage"] = "percentage";
    TourImageActionRes["Pixels"] = "pixels";
})(TourImageActionRes || (TourImageActionRes = {}));
var VSInteractionType;
(function(VSInteractionType) {
    VSInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    VSInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    VSInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    VSInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    VSInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    VSInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    VSInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    VSInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    VSInteractionType["KEY"] = "INTERACTION.KEY";
    VSInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    VSInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    VSInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    VSInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    VSInteractionType["PINCH"] = "INTERACTION.PINCH";
    VSInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    VSInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    VSInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(VSInteractionType || (VSInteractionType = {}));
var VSObject = function VSObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSObject);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.materialUrl = model.materialUrl || null;
    this.fileName = model.fileName || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.category = model.category || null;
    this.copyright = model.copyright || null;
    this.isDefault = model.isDefault || false;
    this.updatedAt = model.updatedAt || null;
    this.isGLTF = model.isGLTF || false;
};
var TourObject = function TourObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourObject);
    this.id = model.id || null;
    this.vsObjectId = model.vsObjectId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsObject || {});
    this.updatedAt = model.updatedAt || null;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.sweepUuid = model.sweep_uuid || null;
    this.animated = model.animated || false;
    this.loop = model.loop || false;
};
var VSImage = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function VSImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, VSImage);
        this.id = model.id || null;
        this.title = model.title || null;
        this.url = model.url || null;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = model.scaleZ || 0.1;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = true;
    }
    var _proto = VSImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat(getVersion(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    return VSImage;
}()));
var TourImage = /*#__PURE__*/ function() {
    "use strict";
    function TourImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourImage);
        this.id = model.id || null;
        this.vsImageId = model.vsImageId || null;
        this.uuid = model.uuid || null;
        this.width = model.width;
        this.height = model.height;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = model.scaleZ || 0.1;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.details = Object.assign(model.vsImage || {});
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = true;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.enableAnimation = typeof model.enableAnimation === "boolean" ? model.enableAnimation : false;
        // actions
        this.actionType = model.actionType || TourImageActionType.None;
        this.action = model.action || TourImageAction.Click;
        this.actionURL = model.actionURL || null;
        this.text = model.text || null;
        this.popupTitle = model.popupTitle || null;
        this.actionRes = model.actionRes || TourImageActionRes.Percentage;
        this.actionWidth = model.actionWidth || 80;
        this.actionHeight = model.actionHeight || 60;
        this.panoramaId = model.panoramaId || null;
        this.menuId = model.menuId || null;
        this.subMenuId = model.subMenuId || null;
        this.subSubMenuId = model.subSubMenuId || null;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.rotation = model.rotation || TourVSImageRotation.Vertical;
        this.backgroundColor = model.backgroundColor || "#000000";
        this.backgroundOpacity = model.backgroundOpacity || 0.7;
        this.textColor = model.textColor || "#ffffff";
        this.buttonColor = model.buttonColor || "#ffffff";
    }
    var _proto = TourImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        // if (this.isVSImage && this.actionType === TourImageActionType.ExperiencePopUp) {
        //   return '/play_experience.svg';
        // }
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    return TourImage;
}();
var VSVideoType;
(function(VSVideoType) {
    VSVideoType["Local"] = "local";
    VSVideoType["Vimeo"] = "vimeo";
})(VSVideoType || (VSVideoType = {}));
var VSVideo = /*#__PURE__*/ function() {
    "use strict";
    function VSVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, VSVideo);
        this.id = model.id || null;
        this.title = model.title || "";
        this.url = model.url || "";
        this.type = model.type || VSVideoType.Local;
        this.width = model.width || 2;
        this.height = model.height || 2;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = false;
        this.isVSVideo = true;
    }
    var _proto = VSVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.image.includes("http")) {
            image = this.image;
        }
        return image;
    };
    return VSVideo;
}();
var TourVideo = /*#__PURE__*/ function() {
    "use strict";
    function TourVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVideo);
        this.id = model.id || null;
        this.vsVideoId = model.vsVideoId || null;
        this.uuid = model.uuid || null;
        this.tourId = model.tourId || null;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.details = Object.assign(model.vsVideo || model.details || new VSVideo());
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = false;
        this.isVSVideo = true;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.sweep_uuid = model.sweep_uuid || null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.autoplay = typeof model.autoplay === "boolean" ? model.autoplay : true;
        this.loop = typeof model.loop === "boolean" ? model.loop : true;
    }
    var _proto = TourVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.details || !this.details.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.details || !this.details.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.details.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.image.includes("http")) {
            image = this.details.image;
        }
        return image;
    };
    return TourVideo;
}();


/***/ }),

/***/ 97387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iG": function() { return /* binding */ AVATAR_CIRCLE_RADIUS; },
/* harmony export */   "qE": function() { return /* binding */ Avatar; },
/* harmony export */   "tU": function() { return /* binding */ DEFAULT_AVATAR; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_0__);


var DEFAULT_AVATAR = "https://d1a370nemizbjq.cloudfront.net/e335336e-d0d7-4adf-bd8a-e398e5a55cb7.glb";
var AVATAR_CIRCLE_RADIUS = 0.7; // the circle radius
var Avatar = function Avatar() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Avatar);
    this.name = model.name || "";
    this.url = model.url;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.quaternionX = model.quaternionX || 0;
    this.quaternionY = model.quaternionY || 0;
    this.quaternionZ = model.quaternionZ || 0;
    this.quaternionW = model.quaternionW || 0;
    this.uuid = model.uuid || null;
    this.color = model.color || "0xEA475C";
    this.muted = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.muted) || model.muted;
    this.visible = typeof model.visible === "boolean" ? model.visible : true;
    this.degree = model.degree || null;
};


/***/ }),

/***/ 71425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AvatarPredictor; },
/* harmony export */   "v": function() { return /* binding */ AUPredictorQuality; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9995);




var AUPredictorQuality;
(function(AUPredictorQuality) {
    AUPredictorQuality["Low"] = "low";
    AUPredictorQuality["High"] = "high";
})(AUPredictorQuality || (AUPredictorQuality = {}));
var AvatarPredictor = /*#__PURE__*/ function() {
    "use strict";
    function AvatarPredictor(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AvatarPredictor);
        this.predictor = new _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_1__/* .AUPredictor */ .SM({
            apiToken: "fbd204a7-318e-4dd3-86e0-e6d524fc3f98",
            shouldMirrorOutput: false,
            fps: 30,
            predictionQuality: config.predictionQuality || AUPredictorQuality.Low
        });
    }
    var _proto = AvatarPredictor.prototype;
    _proto.start = function start(stream, cb) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, hasVideoTrack;
            return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        hasVideoTrack = stream === null || stream === void 0 ? void 0 : (ref = stream.getTracks) === null || ref === void 0 ? void 0 : ref.call(stream).some(function(track) {
                            return track.kind === "video";
                        });
                        if (hasVideoTrack) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Video track not found.");
                    case 4:
                        _ctx.next = 6;
                        return _this.predictor.start({
                            stream: stream
                        });
                    case 6:
                        _this.predictor.dataStream.subscribe(cb);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.stop = function stop() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.predictor.stop();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return AvatarPredictor;
}();


/***/ }),

/***/ 8267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iG": function() { return /* reexport */ Avatar/* AVATAR_CIRCLE_RADIUS */.iG; },
  "qE": function() { return /* reexport */ Avatar/* Avatar */.qE; },
  "KP": function() { return /* reexport */ AvatarPredictor/* AvatarPredictor */.K; },
  "bB": function() { return /* reexport */ avatarComponentType; },
  "Sr": function() { return /* reexport */ makeAvatarComponent; }
});

// UNUSED EXPORTS: AvatarComponent, DEFAULT_AVATAR

// EXTERNAL MODULE: ./_models/virtualStaging/avatar/AvatarPredictor.ts
var AvatarPredictor = __webpack_require__(71425);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/Avatar.tsx
var Avatar = __webpack_require__(97387);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@quarkworks-inc/avatar-webkit/dist/index.modern.js
var index_modern = __webpack_require__(9995);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/emojiKeyMap.ts
var emojiKeyMap = {
    mouthOpen: "mouthOpen",
    mouthSmile: "mouthSmile",
    eyesClosed: "eyesClosed",
    eyesLookUp: "eyesLookUp",
    eyesLookDown: "eyesLookDown",
    eyeBlinkLeft: "eyeBlink_L",
    eyeBlinkRight: "eyeBlink_R",
    eyeSquintLeft: "eyeSquint_L",
    eyeSquintRight: "eyeSquint_R",
    eyeWideLeft: "eyeWide_L",
    eyeWideRight: "eyeWide_R",
    jawForward: "jawForward",
    jawLeft: "jawLeft",
    jawRight: "jawRight",
    jawOpen: "jawOpen",
    mouthClose: "mouthClose",
    mouthFunnel: "mouthFunnel",
    mouthPucker: "mouthPucker",
    mouthLeft: "mouthLeft",
    mouthRight: "mouthRight",
    // mouthSmileLeft: 'mouthSmileLeft',
    mouthSmileLeft: "mouthSmile_L",
    mouthSmileRight: "mouthSmile_R",
    mouthFrownLeft: "mouthFrown_L",
    mouthFrownRight: "mouthFrown_R",
    mouthDimpleLeft: "mouthDimple_L",
    mouthDimpleRight: "mouthDimple_R",
    mouthStretchLeft: "mouthStretch_L",
    mouthStretchRight: "mouthStretch_R",
    mouthRollLower: "mouthRollLower",
    mouthRollUpper: "mouthRollUpper",
    mouthShrugLower: "mouthShrugLower",
    mouthShrugHigher: "mouthShrugHigher",
    mouthPressLeft: "mouthPress_L",
    mouthPressRight: "mouthPress_R",
    mouthLowerDownLeft: "mouthLowerDown_L",
    mouthLowerDownRight: "mouthLowerDown_R",
    mouthUpperUpLeft: "mouthUpperUp_L",
    mouthUpperUpRight: "mouthUpperUp_R",
    browDownLeft: "browDown_L",
    browDownRight: "browDown_R",
    browInnerUp: "browInnerUp",
    browOuterUpLeft: "browOuterUp_L",
    browOuterUpRight: "browOuterUp_R",
    cheekPuff: "cheekPuff",
    cheekSquintLeft: "cheekSquint_L",
    cheekSquintRight: "cheekSquint_R",
    noseSneerLeft: "noseSneer_L",
    noseSneerRight: "noseSneer_R",
    tongueOut: "tongueOut",
    mouthShrugUpper: "mouthShrugUpper",
    eyeLookInLeft: "eyeLookIn_L",
    eyeLookInRight: "eyeLookIn_R",
    eyeLookOutLeft: "eyeLookOut_L",
    eyeLookOutRight: "eyeLookOut_R",
    eyeLookUpLeft: "eyeLookUp_L",
    eyeLookUpRight: "eyeLookUp_R",
    eyeLookDownLeft: "eyeLookDown_L",
    eyeLookDownRight: "eyeLookDown_R"
}; // mouthOpen: 0
 // mouthSmile: 1

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/helper.ts
var findObject3DChildByName = function(object, name) {
    return object.children.find(function(child) {
        return child.name === name;
    });
};
var setMorphTarget = function(mesh, key, value) {
    if (!mesh) return;
    var idx = mesh.morphTargetDictionary[key];
    if (!idx) return;
    mesh.morphTargetInfluences[idx] = value;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/index.ts



// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/AbstractAvatar.ts







var AbstractAvatar = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AbstractAvatar, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(AbstractAvatar);
    function AbstractAvatar() {
        (0,_class_call_check/* default */.Z)(this, AbstractAvatar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.label = null;
        _this.labelSize = [
            0,
            0
        ];
        _this.model = null;
        _this.inputs = {
            color: 0xff0033,
            label: "User",
            url: null,
            uuid: null,
            visible: true,
            sweep: null
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        _this.getPosition = function() {
            return _this.model.position;
        };
        _this.loadAsync = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(THREE, url) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                var loader = new THREE.GLTFLoader();
                                loader.load(url, function(gltf) {
                                    return resolve(gltf);
                                }, function() {
                                    return null;
                                }, function(err) {
                                    return reject(err);
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(THREE, url) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = AbstractAvatar.prototype;
    _proto.initRoot = function initRoot() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
    };
    _proto.initLabel = function initLabel() {
        this.label = this.makeLabel(this.inputs.label, {
            fontsize: 48,
            borderColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 0.7
            },
            backgroundColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 0.8
            },
            borderThickness: 8
        });
        this.label.position.setY(0.23);
        this.pivot.add(this.label);
        if (this.root && this.root.parent) {
            this.root.parent.visible = this.inputs.visible;
        }
    };
    _proto.getLabelSize = function getLabelSize() {
        return this.labelSize;
    };
    _proto.makeLabel = function makeLabel(message, parameters) {
        var THREE = this.context.three;
        if (parameters === undefined) parameters = {};
        var fontface = parameters.hasOwnProperty("fontface") ? parameters.fontface : "Arial";
        var fontsize = parameters.hasOwnProperty("fontsize") ? parameters.fontsize : 18;
        var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters.borderThickness : 4;
        var borderColor = parameters.hasOwnProperty("borderColor") ? parameters.borderColor : {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0
        };
        var backgroundColor = parameters.hasOwnProperty("backgroundColor") ? parameters.backgroundColor : {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        var textColor = parameters.hasOwnProperty("textColor") ? parameters.textColor : {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0
        };
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        context.font = "Bold ".concat(fontsize, "px ").concat(fontface);
        var metrics = context.measureText(message);
        var textWidth = metrics.width;
        context.fillStyle = "rgba(".concat(backgroundColor.r, ",").concat(backgroundColor.g, ",").concat(backgroundColor.b, ",").concat(backgroundColor.a, ")");
        context.strokeStyle = "rgba(".concat(borderColor.r, ",").concat(borderColor.g, ",").concat(borderColor.b, ",").concat(borderColor.a, ")");
        context.lineWidth = borderThickness;
        var rectW = (textWidth + borderThickness) * 1.1;
        var rectH = fontsize * 1.4 + borderThickness;
        this.roundRect(context, borderThickness / 2, borderThickness / 2, rectW, rectH, 8);
        context.fillStyle = "rgba(".concat(textColor.r, ", ").concat(textColor.g, ", ").concat(textColor.b, ", 1.0)");
        context.fillText(message, borderThickness, fontsize + borderThickness);
        // crop exactly the rectangle size
        var label = this.crop(canvas, 0, 0, rectW + borderThickness, rectH + borderThickness);
        var texture = new THREE.Texture(label);
        texture.needsUpdate = true;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.encoding = THREE.sRGBEncoding;
        texture.repeat.set(1, 1);
        var planeWidth = label.width / 1000; // scaling down
        var planeHeight = label.height / 1000;
        // need for dynamic mute button positioning
        this.labelSize = [
            planeWidth,
            planeHeight
        ];
        var plane = this.makePlane(planeWidth, planeHeight, texture);
        plane.scale.set(1, 1, 1);
        return plane;
    };
    // function for drawing rounded rectangles
    // eslint-disable-next-line class-methods-use-this
    _proto.roundRect = function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + r);
        ctx.lineTo(x + w, y + h - r);
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
        ctx.lineTo(x + r, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    };
    _proto.makePlane = function makePlane(width, height, texture) {
        var THREE = this.context.three;
        var geometry = new THREE.PlaneGeometry(width, height, 10, 10);
        var material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            blending: THREE.NormalBlending,
            transparent: true
        });
        return new THREE.Mesh(geometry, material);
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.crop = function crop(can, x, y, w, h) {
        // get your canvas and a context for it
        var ctx = can.getContext("2d");
        // get the image data you want to keep.
        var imageData = ctx.getImageData(x, y, w * 2, h);
        // create a new cavnas same as clipped size and a context
        var newCan = document.createElement("canvas");
        newCan.width = w - x;
        newCan.height = h - y;
        var newCtx = newCan.getContext("2d");
        // put the clipped image on the new canvas.
        newCtx.putImageData(imageData, 0, 0);
        return newCan;
    };
    _proto.loadModel = function loadModel(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var modelData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.loadAsync(THREE, url);
                    case 2:
                        modelData = _ctx.sent;
                        modelData.scene.position.set(0, 0, 0);
                        return _ctx.abrupt("return", modelData.scene);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return AbstractAvatar;
}(Scene_component/* SceneComponent */.Ad);
/* harmony default export */ var component_AbstractAvatar = (AbstractAvatar);

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/Avatar.component.tsx






/* eslint-disable no-prototype-builtins */ 



var AvatarComponent = /*#__PURE__*/ function(AbstractAvatar) {
    "use strict";
    (0,_inherits/* default */.Z)(AvatarComponent, AbstractAvatar);
    var _super = (0,_create_super/* default */.Z)(AvatarComponent);
    function AvatarComponent() {
        (0,_class_call_check/* default */.Z)(this, AvatarComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setMorphTarget = function(mesh, key, value) {
            if (!mesh) return;
            var idx = mesh.morphTargetDictionary[key];
            if (!idx) return;
            mesh.morphTargetInfluences[idx] = value;
        };
        return _this;
    }
    var _proto = AvatarComponent.prototype;
    _proto.onInit = function onInit() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, THREE, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if ((ref = _this.inputs.url) === null || ref === void 0 ? void 0 : ref.length) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
                        THREE = _this.context.three;
                        _this.initRoot();
                        _ctx.next = 8;
                        return _this.loadModel(THREE, _this.inputs.url);
                    case 8:
                        _this.model = _ctx.sent;
                        _this.model.position.setY(-0.6);
                        ;
                        ref1 = (0,_sliced_to_array/* default */.Z)(_this.model.children, 1), _this.avatarRoot = ref1[0], ref1;
                        _this.faceNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Head");
                        _this.teethNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Teeth");
                        _this.wolf3DAvatar = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Avatar");
                        // console.log('this.avatarRoot', this.avatarRoot);
                        // console.log('this.faceNode', this.faceNode);
                        // console.log('this.teethNode', this.teethNode);
                        // console.log('this.wolf3DAvatar', this.wolf3DAvatar);
                        _this.pivot.add(_this.model);
                        _this.initLabel();
                        _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.onDestroy = function onDestroy() {
        if (this.label) {
            this.label.geometry.dispose();
            this.label.material.dispose();
        }
    };
    // called back when any inputs properties change
    _proto.onInputsUpdated = function onInputsUpdated() {
        this.onInit();
    };
    _proto.updateFromResults = function updateFromResults(prediction) {
        if (!this.model) return;
        this.updateMorphTargets(prediction.blendShapes);
        this.updateHeadRotation(-prediction.rotation.pitch, -prediction.rotation.yaw, -prediction.rotation.roll);
        this.updatePosition(prediction.transform.x, prediction.transform.y, prediction.transform.z);
    };
    _proto.updateMorphTargets = function updateMorphTargets(blendShapes) {
        for(var key in blendShapes){
            // RPM uses the ARKit key convention ("mouthSmileLeft" as opposed to "mouthSmile_L")
            var arKitKey = index_modern/* BlendShapeKeys.toARKitConvention */.lN.toARKitConvention(key);
            // Need to set all morphtargets for both meshes
            // ex. only setting jaw open for wolf3DAvatar will result in the mesh mouth opening but not the bones movingss1
            this.setMorphTarget(this.faceNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.teethNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.wolf3DAvatar, arKitKey, blendShapes[key]);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updateHeadRotation = function updateHeadRotation(pitch, yaw, roll) {
        // Inverse yaw & roll effects for yourself to give mirror effect
        this.pivot.rotation.set(pitch, yaw, roll);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updatePosition = function updatePosition(x, y, z) {
    // const SCALE = 0.2;
    // const Y_OFFSET = 0;
    // this.avatarRoot?.position.set(x * SCALE, Y_OFFSET + y * SCALE, z);
    };
    return AvatarComponent;
}(component_AbstractAvatar);
var avatarComponentType = "mp.avatarComponent";
var makeAvatarComponent = function() {
    return new AvatarComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/index.ts





/***/ }),

/***/ 2300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ API; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);








var API = /*#__PURE__*/ function() {
    "use strict";
    function API(options) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, API);
        this.baseUrl = (options === null || options === void 0 ? void 0 : options.baseUrl) || "";
        var _this = this;
        var _this1 = this;
        var _this2 = this;
        var _this3 = this;
        this.public = {
            get: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
                    var _url, url, rest, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                if (rest.query) {
                                    url += "?".concat(_this.objectToQueryString(rest.query));
                                }
                                _ctx.next = 5;
                                return fetch(_this.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "get"
                                }, rest));
                            case 5:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0.code === 422) {
                                    errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    ;
                                }
                            case 12:
                                return _ctx.abrupt("return", null);
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            9
                        ]
                    ]);
                }));
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            post: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param, parentOptions) {
                    var _url, url, rest, data, isFormData, body, config, headers, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                data = rest.data ? rest.data : rest;
                                isFormData = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rest.data, FormData);
                                ;
                                config = rest.config ? rest.config : {};
                                if (isFormData) {
                                    headers = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(config.headers || {});
                                    headers["Content-Type"] = "multipart/form-data";
                                    config.headers = headers;
                                    body = rest.data;
                                } else {
                                    body = JSON.stringify(data);
                                }
                                _ctx.next = 9;
                                return fetch(_this1.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "post"
                                }, rest), {
                                    body: body
                                }), config));
                            case 9:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](1);
                                if (parentOptions === null || parentOptions === void 0 ? void 0 : parentOptions.turnOffToastError) {
                                    _ctx.next = 19;
                                    break;
                                }
                                {
                                    if (_ctx.t0.code === 422) {
                                        errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                        errors.map(function(error) {
                                            return console.error(error.join(", "));
                                        });
                                    } else {
                                        ;
                                    }
                                }
                                _ctx.next = 20;
                                break;
                            case 19:
                                return _ctx.abrupt("return", _ctx.t0);
                            case 20:
                                return _ctx.abrupt("return", null);
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                return function(_param, parentOptions) {
                    return _ref.apply(this, arguments);
                };
            }(),
            put: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
                    var _url, url, rest, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return fetch(_this2.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "put"
                                }, rest, rest.data ? {
                                    body: JSON.stringify(rest.data)
                                } : {
                                    body: JSON.stringify(rest)
                                }, rest.config ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest.config) : {}));
                            case 4:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0.code === 422) {
                                    errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    ;
                                }
                            case 11:
                                return _ctx.abrupt("return", null);
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delete: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
                    var _url, url, rest, results, errors;
                    return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return fetch(_this3.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    method: "delete"
                                }, rest));
                            case 4:
                                results = _ctx.sent;
                                return _ctx.abrupt("return", results.json());
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_ctx.t0.code === 422) {
                                    errors = Object.values((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    ;
                                }
                            case 11:
                                return _ctx.abrupt("return", null);
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }()
        };
    }
    var _proto = API.prototype;
    // eslint-disable-next-line class-methods-use-this
    _proto.objectToQueryString = function objectToQueryString(obj) {
        return Object.keys(obj).map(function(key) {
            return "".concat(key, "=").concat(obj[key]);
        }).join("&");
    };
    return API;
}();



/***/ }),

/***/ 83680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26626);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);






var API_VERSION = "v1";
var PREFIX = "".concat(API_VERSION, "/admin/tour/");
var PUBLIC_PREFIX = "".concat(API_VERSION, "/public");
var GAME_PREFIX = "".concat(API_VERSION, "/admin/game");
var TreedisAdminDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisAdminDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisAdminDAO);
    function TreedisAdminDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisAdminDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            /** Virtual Staging */ getTourVSObjects: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vstaging")
                }, options));
            },
            getTourVSImages: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-images")
                }, options));
            },
            getVSSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vs-settings")
                }, options));
            },
            getPolygons: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/polygons")
                }, options));
            },
            getTourVSVideos: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-videos")
                }, options));
            },
            getFRFloors: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vs-settings/frfloors")
                }, options));
            },
            /** Game * */ saveAnalytics: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(GAME_PREFIX, "/analytic/save")
                }, options));
            },
            createPaymentSecret: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PUBLIC_PREFIX, "/payment/secret")
                }, options));
            }
        };
        return _this;
    }
    return TreedisAdminDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var DAO = new TreedisAdminDAO().public;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 80250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26626);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);







var TreedisPublicDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisPublicDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisPublicDAO);
    function TreedisPublicDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisPublicDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            getUser: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "public/getUserIdByDomain"
                }, options));
            },
            getMinimaps: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "public/getMinimaps"
                }, options));
            },
            sendEmail: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/sendEmail"
                }, options));
            },
            getGroups: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweepGroups"
                }, options));
            },
            getDuplicates: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getDuplicates/".concat(id)
                }, options));
            },
            getReels: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getReels/".concat(id)
                }, options));
            },
            getTranslations: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTranslations/".concat(id)
                }, options));
            },
            getAgents: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getAgents/".concat(id)
                }, options));
            },
            getEmails: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getEmails/".concat(id)
                }, options));
            },
            getTags: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTags"
                }, options));
            },
            getProducts: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products"
                }, options));
            },
            getVariantsByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/variants/byTour"
                }, options));
            },
            getMediaByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/medias/byTour"
                }, options));
            },
            guestLogin: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/auth/login"
                }, options));
            },
            getConferenceByToken: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/getByToken"
                }, options));
            },
            getConferenceRegisterFields: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/auth/getRegisterFields"
                }, options));
            },
            getTwilioToken: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/video/token"
                }, options));
            },
            guestRegister: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/conference/auth/register"
                }, options));
            },
            getGame: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getGame/"
                }, options));
            },
            getTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTour"
                }, options));
            },
            getTourBySlug: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTourBySlug"
                }, options));
            },
            getAgentsAndTheirSlotsFromClientId: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getAgentsAndTheirSlotsFromClientId"
                }, options));
            },
            getTicketingDiscount: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTicketingDiscount"
                }, options));
            },
            finishOrderTickets: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/finishOrderTickets"
                }, options));
            },
            payTickets: function(paymentType) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/payment/".concat(paymentType)
                }, options));
            },
            createTicketOrder: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/createOrder"
                }, options));
            },
            ticketLogin: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticketLogin"
                }, options), parentOptions);
            },
            logoutTicket: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticketLogout"
                }, options), parentOptions);
            },
            ticketSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/settings"
                }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                    query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        tourId: tourId
                    })
                })));
            },
            getFloorPlans: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getFloorPlans"
                }, options));
            },
            getSweeps: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweeps"
                }, options));
            },
            getVimeoVideo: function(videoId, clientId) {
                return parent.get({
                    url: "v1/public/vimeo",
                    query: {
                        clientId: clientId,
                        path: "/videos/".concat(videoId, "?fields=uri,play,width,height,live,description,title")
                    }
                });
            },
            // @ts-ignore
            getVimeoVideoUrl: function(url) {
                return fetch(url, {
                    method: "HEAD",
                    ignoreInterceptor: true
                }).then(function(res) {
                    return res.url;
                });
            },
            getLockByType: function() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getLockByType"
                }, options));
            },
            getExperienceTopScores: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/experience/".concat(id, "/topScores")
                }, options));
            }
        };
        return _this;
    }
    return TreedisPublicDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
var DAO = new TreedisPublicDAO().public;
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 7710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59016);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8667);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  color: #ea475c;\n  position: absolute;\n  margin-top: 41px;\n  margin-left: 40px;\n  margin-right: 40px;\n  cursor: pointer;\n  z-index: 1;\n  direction: initial;\n\n  @media screen and (max-width: 760px) {\n    display: inline-block;\n    float: initial;\n    width: 100%;\n    margin: 0;\n    padding: 15px 22px 0 22px;\n    position: relative;\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BackButton__MainWrap",
    componentId: "sc-a9e543e-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align:right;" : "");
});
var BackButton = function(props) {
    var backFunction = props.backFunction, location = props.location;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _back = ref.back, back = _back === void 0 ? "back" : _back;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .tourConfigsState */ .Uq).rtl;
    var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .useHistory */ .k6)();
    var pushBack = function() {
        if (backFunction) {
            backFunction();
        } else {
            var paths = location.pathname.split("/");
            if (paths[paths.length - 1] === "") paths.pop();
            paths.pop();
            history.push(paths.join("/"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        onClick: pushBack,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                className: "fas fa-chevron-left"
            }),
            " ",
            back
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .withRouter */ .EN)(BackButton));


/***/ }),

/***/ 73491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TourLanguageSelect.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  padding: 0 5px;\n  line-height: 1.1;\n  font-size: 15px;\n\n  @media screen and (max-width: 760px) {\n    width: 33.33%;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  color: white;\n  text-transform: uppercase;\n  position: relative;\n  margin: 0 5px;\n\n  div.mainItem {\n    cursor: pointer;\n  }\n\n  div.optionItem {\n    line-height: 1.3;\n    background: transparent;\n    cursor: pointer;\n\n    display: flex;\n    color: white;\n    align-items: center;\n    justify-content: start;\n    margin-bottom: 10px;\n\n    i {\n      font-size: 5px;\n      margin: 5px;\n      text-decoration: initial !important;\n    }\n\n    span {\n      display: block !important;\n    }\n\n    &.active {\n      text-decoration: underline;\n    }\n  }\n\n  div.optionsWrap {\n    position: absolute;\n    //padding: 16px 0 11px 27px;\n    background-color: rgba(44, 44, 44, 0.9);\n    border-radius: 12px;\n    //margin-left: -40px;\n    width: calc(100% + 51px);\n\n    //padding: 20px 3px 10px 10px;\n    padding: 10px 3px 5px 10px;\n    ",
        ";\n\n    left: 0;\n    margin-left: 0;\n    margin-top: 21px;\n  }\n\n  @media screen and (max-width: 760px) {\n    div.optionsWrap {\n      margin-top: 9px;\n      width: 100vw;\n      position: absolute;\n      left: -20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CustomSelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelectWrap",
    componentId: "sc-81eec9ae-0"
})(_templateObject());
var CustomSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelect",
    componentId: "sc-81eec9ae-1"
})(_templateObject1(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 10px 10px 5px 3px;right: 0;left: initial;right: -20px;" : "");
});
var TourLanguageSelect = function(props) {
    var tourId = props.tourId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _current_tour_has_no_language = ref.current_tour_has_no_language, current_tour_has_no_language = _current_tour_has_no_language === void 0 ? "Current tour has no language" : _current_tour_has_no_language, _no_language = ref.no_language, no_language = _no_language === void 0 ? "no language" : _no_language;
    var ref1 = (0,react.useState)(null), duplicates = ref1[0], setDuplicates = ref1[1];
    var ref2 = (0,react.useState)(false), duplicatesIsOpen = ref2[0], setDuplicatesIsOpen = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var initialDuplicatesRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tourId);
                    case 2:
                        initialDuplicatesRes = _ctx.sent;
                        if (initialDuplicatesRes && initialDuplicatesRes.message.includes("Success")) {
                            setDuplicates(initialDuplicatesRes.duplicates);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    var getCurrentLanguage = function() {
        var pathnameSplitted = window.location.pathname.split("/");
        return (duplicates || []).find(function(duplicate) {
            return pathnameSplitted.includes(duplicate.slug);
        });
    };
    var isLanguageActive = function(slug) {
        var pathnameSplitted = window.location.pathname.split("/");
        return pathnameSplitted.find(function(p) {
            return p === slug;
        });
    };
    var handleLanguageClick = function(slug) {
        return function() {
            if (!isLanguageActive(slug)) {
                replaceSlug(slug);
                setDuplicatesIsOpen(false);
            }
        };
    };
    var replaceSlug = function(slug) {
        var pathnames = window.location.pathname.split("/");
        pathnames.shift();
        var targetLink = "/".concat(pathnames[0], "/").concat(pathnames[0] === "experience" ? pathnames[1] : slug).concat(pathnames[0] === "experience" ? "/".concat(slug) : "");
        location.replace(window.location.origin + targetLink);
    };
    var currentLanguageObj = getCurrentLanguage();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return duplicates && duplicates.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelectWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "far fa-globe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelect, {
                rtl: rtl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mainItem",
                        onClick: function() {
                            return setDuplicatesIsOpen(!duplicatesIsOpen);
                        },
                        children: (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.language) || (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.languageEn) || current_tour_has_no_language
                    }),
                    duplicatesIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "optionsWrap",
                        children: duplicates.map(function(duplicate, num) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("optionItem", isLanguageActive(duplicate.slug) && "active"),
                                onClick: handleLanguageClick(duplicate.slug),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-circle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn) || "".concat(no_language, " / ").concat(duplicate.slug)
                                    })
                                ]
                            }, num);
                        })
                    })
                ]
            }),
            duplicatesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-up"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-down"
            })
        ]
    }) : null;
};
/* harmony default export */ var components_TourLanguageSelect = (TourLanguageSelect);

;// CONCATENATED MODULE: ./components/ticketingNew/components/BaseLayout.tsx




function BaseLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  margin: auto;\n  background-color: ",
        ";\n  //background: conic-gradient(from 193.61deg at 46.18% 51.15%, #000000 -139.17deg, #eeeeee 10.44deg, #ffffff 157.82deg, #000000 220.83deg, #eeeeee 370.44deg);\n  ",
        ";\n\n  header {\n    height: 58px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    display: flex;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n\n    .bl-header-clientPic {\n      //left: 15px;\n      //position: absolute;\n      //background: #ccadad;\n      width: 100px;\n      height: 100%;\n      margin-right: 15px;\n\n      &.forMobile {\n        display: none;\n      }\n      object-fit: contain;\n\n      @media screen and (max-width: 760px) {\n        display: none;\n        &.forMobile {\n          display: block;\n          order: 2;\n          width: 33.33%;\n          margin: 0;\n        }\n      }\n    }\n\n    .bl-header-block {\n      font-size: 16px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      margin: auto;\n      justify-content: center;\n      height: 100%;\n      width: auto;\n      left: ",
        ";\n      right: ",
        ";\n\n      @media screen and (max-width: 760px) {\n        width: 100%;\n        right: 0;\n        //right: auto;\n        span {\n          display: none;\n        }\n      }\n\n      & > * {\n        line-height: 1;\n      }\n\n      .bl-header-lang {\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 16px;\n        }\n\n        select {\n          line-height: 1;\n          background: transparent;\n          color: white;\n          font-size: 16px;\n          padding: 0;\n          min-width: 43px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 1;\n          width: 33.33%;\n          padding-left: 15px;\n        }\n      }\n\n      .loginButton-wrap {\n        .signButton {\n          border: 1.5px solid #ffffff;\n          box-sizing: border-box;\n          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n          border-radius: 6px;\n          width: 83px;\n          height: 31px;\n          background: transparent;\n          color: white;\n          margin: 0 15px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          margin: 0;\n          text-align: right;\n          width: 33.33%;\n          padding-right: 15px;\n          button {\n            margin: 0 !important;\n          }\n        }\n      }\n\n      .buyNowLink {\n        margin: 0 15px;\n        text-decoration: underline;\n\n        &:hover,\n        &:active {\n          color: white;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          width: 33.33%;\n          text-align: right;\n          margin: 0;\n          padding-right: 15px;\n        }\n      }\n    }\n  }\n\n  .bl-inner-content {\n    min-height: calc(100vh - 155px);\n    overflow: hidden;\n  }\n\n  footer {\n    height: 97px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    margin-top: 35px;\n\n    .bl-footer-copyright {\n      height: 45px;\n      margin: 30px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      font-size: 22px;\n\n      span {\n        margin: 0 15px 0 5px;\n      }\n\n      img {\n        margin-top: 3px;\n        margin-left: 5px;\n        width: 101px;\n        object-fit: contain;\n        height: 46px;\n\n        &[alt='treedis'] {\n          filter: brightness(0) saturate(100%) invert(45%) sepia(15%) saturate(3730%) hue-rotate(311deg) brightness(90%) contrast(105%);\n        }\n      }\n    }\n  }\n"
    ]);
    BaseLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BaseLayoutStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BaseLayout__BaseLayoutStyled",
    componentId: "sc-528ea9ef-0"
})(BaseLayout_templateObject(), function(p) {
    return p.transparentBg ? "#E5E5E528" : "#e5e5e5";
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "direction: rtl; text-align: right;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "50px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "50px");
});
var ClientPic = function(param) {
    var _forMobile = param.forMobile, forMobile = _forMobile === void 0 ? false : _forMobile, _src = param.src, src = _src === void 0 ? "" : _src;
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: src,
        alt: "client_logo",
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    });
};
var BaseLayout = function(props) {
    var ref, ref1;
    var location = props.location, children = props.children, _tourId = props.tourId, tourId = _tourId === void 0 ? 0 : _tourId, _whiteLabelData = props.whiteLabelData, whiteLabelData = _whiteLabelData === void 0 ? {} : _whiteLabelData, _transparentBg = props.transparentBg, transparentBg = _transparentBg === void 0 ? false : _transparentBg;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var ref2 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _log_in = ref2.log_in, log_in = _log_in === void 0 ? "log in" : _log_in, _buy_now = ref2.buy_now, buy_now = _buy_now === void 0 ? "Buy now" : _buy_now, _powered_by = ref2.powered_by, powered_by = _powered_by === void 0 ? "Powered by" : _powered_by, _already_have_a_ticket = ref2.already_have_a_ticket, already_have_a_ticket = _already_have_a_ticket === void 0 ? "Already have a ticket?" : _already_have_a_ticket, _dont_have_a_tour_ticket = ref2.dont_have_a_tour_ticket, dont_have_a_tour_ticket = _dont_have_a_tour_ticket === void 0 ? "Don't have a tour ticket?" : _dont_have_a_tour_ticket;
    var isLoginPage = location.pathname.includes("login");
    var pathnames = location.pathname.split("/");
    pathnames.shift();
    var homeLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/book");
    var loginLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/login");
    var clietnLogoSrc = whiteLabelData.logo && (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref = whiteLabelData.logo) === null || ref === void 0 ? void 0 : ref.includes("clients")) ? whiteLabelData.logo : "";
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref3[0], setInfoModalData = ref3[1];
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayoutStyled, {
        transparentBg: transparentBg,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                        src: clietnLogoSrc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-header-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                                forMobile: true,
                                src: clietnLogoSrc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: !isLoginPage ? already_have_a_ticket : dont_have_a_tour_ticket
                            }),
                            isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: homeLink,
                                className: "buyNowLink",
                                onClick: closeInfoModal,
                                children: buy_now
                            }),
                            !isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginLink,
                                className: "loginButton-wrap",
                                onClick: closeInfoModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "signButton",
                                    children: log_in
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TourLanguageSelect, {
                                tourId: tourId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-inner-content",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bl-footer-copyright",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-copyright"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: powered_by
                        }),
                        whiteLabelData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref1 = whiteLabelData.domainUrl) === null || ref1 === void 0 ? void 0 : ref1.includes("http")) ? whiteLabelData.domainUrl : "http://" + whiteLabelData.domainUrl,
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: whiteLabelData.logo,
                                alt: "whitelabel logo"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://treedis.com/",
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "treedis",
                                src: "/logo.png",
                                alt: "treedis logo"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_BaseLayout = ((0,react_router/* withRouter */.EN)(BaseLayout));


/***/ }),

/***/ 47887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ EInfoModal; },
  "Z": function() { return /* binding */ components_InfoModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
// EXTERNAL MODULE: ./components/ticketingNew/components/BaseLayout.tsx + 1 modules
var BaseLayout = __webpack_require__(73491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TicketItemMobile.tsx
var TicketItemMobile = __webpack_require__(47238);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx + 1 modules
var OrderSuccess = __webpack_require__(99931);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderTicketFromTour/index.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 20px;\n  width: 1162px;\n  max-width: 100%;\n  margin: 44px auto 43px auto;\n  background: rgba(79, 79, 79, 0.6);\n  backdrop-filter: blur(150px);\n  padding: 54px 180px;\n  color: white;\n  position: relative;\n  text-align: center;\n\n  .otft-home {\n    font-weight: 600;\n    font-size: 18px;\n    color: white;\n    text-decoration: none;\n    position: absolute;\n    left: 65px;\n    top: 69px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n\n  .otft-header {\n    font-weight: 400;\n    font-size: 60px;\n    line-height: 90px;\n    margin-bottom: 10px;\n  }\n\n  .otft-title {\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 33px;\n    margin-bottom: 10px;\n  }\n\n  .otft-message {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    margin-bottom: 40px;\n  }\n\n  .otft-content {\n    display: flex;\n  }\n\n  .otft-tickets {\n    color: black;\n    width: 50%;\n\n    max-height: 435px;\n    overflow-y: scroll;\n    padding-right: 5px;\n  }\n  .otft-payment {\n    text-align: initial;\n    width: 50%;\n\n    .bl-ticket-order {\n      width: 100%;\n      padding: 28px;\n      color: black;\n      margin-left: 15px;\n    }\n\n    .bl-ticket-order-pay-btn {\n      padding: 8px 15px;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderTicketFromTour__MainWrap",
    componentId: "sc-3101faca-0"
})(_templateObject());
var OrderTicketFromTour = function(props) {
    var location = props.location, _message = props.message, message = _message === void 0 ? "Your ticket time is expired.. but you can buy a new ticket" : _message, match = props.match;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    ;
    var ref1 = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.ticketLoginData, ticketing = ref1.ticketing, ticketingOrderedTicket = ref1.ticketingOrderedTicket, ticketingTourTicket = ref1.ticketingTourTicket, tour = ref1.tour;
    var participants = [
        {
            id: Date.now(),
            fullName: ticketingOrderedTicket.name,
            email: ticketingOrderedTicket.email,
            isGift: ticketingOrderedTicket.isGift
        }, 
    ];
    var ref2 = (0,react.useState)(null), pickedTicketId = ref2[0], setPickedTicketId = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var ref4 = (0,react.useState)(Order/* OrderStageEnum.order */.t9.order), orderStage = ref4[0], setOrderStage = ref4[1];
    var homePage = location.pathname.replace(/book.+|book/g, "");
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var getTicketList = function() {
        //get current orderedTicket data & return tickets of same type (guided, ys, experience)
        //for restriction, return tours that have access to restricted sweep
        if (ticketingOrderedTicket.ticketType === "gameTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if (ticketingOrderedTicket.ticketType === "tourByYourself") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if (ticketingOrderedTicket.ticketType === "guidedTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        return [];
    };
    //@ts-ignore
    var handlePaymentSuccess = function() {
    //close modal
    //go to login page with inserted ticket id
    };
    var tickets = getTicketList();
    ;
    ;
    if (!tickets || !infoModalData) {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            mode: EInfoModal.error,
            message: infoModalData.mode === EInfoModal.timeIsUp ? "Ticket time is up" : "Area is restricted for this tour"
        }));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "closing..."
        });
    }
    ;
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        children: [
            orderStage === Order/* OrderStageEnum.order */.t9.order && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
                        to: homePage,
                        className: "otft-home",
                        onClick: closeInfoModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            "Home Page"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-header",
                        children: "Oops!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-title",
                        children: message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-message",
                        children: "Pick your new ticket"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "otft-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-tickets",
                                children: tickets === null || tickets === void 0 ? void 0 : tickets.map(function(e) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TicketItemMobile/* default */.Z, {
                                        ticket: e,
                                        currencyId: 3,
                                        onPick: function(id) {
                                            return setPickedTicketId(id);
                                        },
                                        pickedId: pickedTicketId
                                    }, e === null || e === void 0 ? void 0 : e.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-payment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    gameId: tour === null || tour === void 0 ? void 0 : tour.gameId,
                                    matterId: tour === null || tour === void 0 ? void 0 : tour.matterId,
                                    setOrderStage: setOrderStage,
                                    participants: participants,
                                    handlePaymentSuccess: function() {
                                        return setOrderStage(Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess);
                                    },
                                    match: match,
                                    setOrderLink: setOrderLink,
                                    initialTourType: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.ticketType,
                                    initialTicketId: pickedTicketId
                                })
                            })
                        ]
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.payment */.t9.payment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "otft-order-frame",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            " back"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Payment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Please enter your payment details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: orderLink
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSuccess/* default */.Z, {
                minimized: true,
                onLinkClick: closeInfoModal
            })
        ]
    });
};
/* harmony default export */ var components_OrderTicketFromTour = ((0,react_router/* withRouter */.EN)(OrderTicketFromTour));

;// CONCATENATED MODULE: ./components/ticketingNew/components/InfoModal.tsx




function InfoModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  max-width: 100%;\n\n  .im-inner-wrap {\n    background: rgba(79, 79, 79, 0.6);\n    color: white;\n    backdrop-filter: blur(150px);\n    border-radius: 20px;\n    padding: 54px 71px;\n    text-align: center;\n\n    .im-inner-warn {\n      font-weight: 400;\n      font-size: 60px;\n      line-height: 90px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-title {\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-message {\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n      margin-bottom: 60px;\n    }\n\n    .im-inner-ok_btn {\n      background-color: #ea475c;\n      border-radius: 12px;\n      color: white;\n      font-weight: 600;\n      font-size: 18px;\n      padding: 15px 34px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n      &:active {\n        opacity: 0.8;\n      }\n\n      i {\n        margin-left: 5px;\n      }\n    }\n  }\n\n  & > .cVideo-modal-videoWrap {\n    width: 100%;\n    height: 100%;\n\n    & > iframe {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .im-redirect-btn {\n    margin-right: 15px;\n  }\n"
    ]);
    InfoModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledModal = (0,styled_components_browser_esm/* default */.ZP)((lib_default())).withConfig({
    displayName: "InfoModal__StyledModal",
    componentId: "sc-a396d503-0"
})(InfoModal_templateObject(), function(props) {
    return props.mode !== EInfoModal.error ? "100%" : "746px";
}, function(props) {
    return props.mode !== EInfoModal.error ? "auto" : "421px";
});
var EInfoModal;
(function(EInfoModal) {
    EInfoModal[EInfoModal["error"] = 0] = "error";
    EInfoModal[EInfoModal["timeIsUp"] = 1] = "timeIsUp";
    EInfoModal[EInfoModal["restrictedArea"] = 2] = "restrictedArea";
})(EInfoModal || (EInfoModal = {}));
var InfoModal = function(props) {
    var root = props.root;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    var handleClose = infoModalData.onRequestClose ? infoModalData.onRequestClose : function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var handleCloseRedirect = function() {
        window.location.href = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.redirectLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        isOpen: infoModalData.isOpen,
        onRequestClose: handleClose,
        mode: infoModalData.mode,
        appElement: root,
        children: [
            infoModalData.mode === EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "im-inner-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-warn",
                        children: "Oops!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-title",
                        children: infoModalData.message || "Ticket not found"
                    }),
                    !infoModalData.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-message",
                        children: "You can find your customer code number on the purchase confirmation Email"
                    }),
                    infoModalData.redirectLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleCloseRedirect,
                        children: "Proceed to needed page"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleClose,
                        children: [
                            "Got it ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-check"
                            })
                        ]
                    })
                ]
            }),
            infoModalData.mode !== EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* default */.Z, {
                transparentBg: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "im-inner-wrap-order",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrderTicketFromTour, {})
                })
            })
        ]
    });
};
/* harmony default export */ var components_InfoModal = ((0,react_router/* withRouter */.EN)(InfoModal));


/***/ }),

/***/ 72225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8667);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59016);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  //margin-top: 18px;\n\n  @media screen and (max-width: 760px) {\n    margin-top: 9px;\n    max-width: 100%;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-top: 5px;\n  text-align: center;\n\n  .bl-card-btn {\n    background: #ffffff;\n    border: 1px solid #000000;\n    box-sizing: border-box;\n    box-shadow: -4px 4px 0px rgba(255, 255, 255, 0.25);\n    border-radius: 12px;\n    padding: 8px 22px;\n\n    &:active {\n      opacity: 0.9;\n    }\n  }\n\n  .bl-btn-hr {\n    width: 65px;\n    top: 0px;\n    border-color: black;\n    position: absolute;\n\n    &.bl-hr-left {\n      left: 20px;\n    }\n\n    &.bl-hr-right {\n      right: 20px;\n    }\n\n    @media screen and (max-width: 760px) {\n      width: 20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var BlCardBarcode = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBarcode",
    componentId: "sc-1aecdbc6-0"
})(_templateObject());
var BlCardBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBtnWrap",
    componentId: "sc-1aecdbc6-1"
})(_templateObject1());
var MoreInfoBtn = function(param) {
    var ticketInfoUlr = param.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _more_info = ref.more_info, more_info = _more_info === void 0 ? "More Info" : _more_info;
    return ticketInfoUlr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBtnWrap, {
        className: "bl-card-btn-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
            href: ticketInfoUlr.includes("http") ? ticketInfoUlr : "http://".concat(ticketInfoUlr),
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "bl-card-btn",
                    children: more_info
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-left"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-right"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBarcode, {
        className: "bl-card-barcode",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: "/ticketing/barcode.png",
            alt: "ticket_barcode"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreInfoBtn);


/***/ }),

/***/ 61749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_OrderDetailsBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/DiscountField.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order-discount {\n    margin-top: 13px;\n    cursor: pointer;\n\n    .bl-ticket-order-discount-text {\n      .fa-ticket-alt {\n        margin-right: 5px;\n      }\n\n      .fa-chevron-down {\n        margin-left: 5px;\n      }\n    }\n\n    .bl-ticket-order-discount-input-activate {\n      display: flex;\n      height: 35px;\n      position: relative;\n\n      .bl-discount-input-wrap {\n        display: flex;\n        position: relative;\n        width: 100%;\n\n        .bl-discount-error-icon {\n          background: #ea475c;\n          width: 14px;\n          height: 14px;\n          position: absolute;\n          right: 10px;\n          border-radius: 50%;\n          color: white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          top: 10px;\n          font-weight: 300;\n          font-size: 12px;\n          ",
        ";\n        }\n\n        .bl-applied-discount-value {\n          position: absolute;\n          font-weight: 300;\n          font-size: 15px;\n          line-height: 21px;\n          display: flex;\n          align-items: center;\n          top: 8px;\n          height: 18px;\n          right: 12px;\n\n          ",
        ";\n\n          .bl-confirmed-icon-wrap {\n            font-weight: 300;\n            line-height: 21px;\n            width: 14px;\n            height: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: #59df76;\n            border-radius: 50%;\n            margin-left: 6px;\n            color: white;\n            font-size: 8px;\n          }\n        }\n      }\n\n      i.fa-ticket-alt {\n        z-index: 1;\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        ",
        ";\n      }\n\n      input {\n        padding-left: 25px;\n        height: 35px;\n        background: #ffffff;\n        /* Dark/Dark 1 */\n\n        border: 1px solid #b2bcca;\n        box-sizing: border-box;\n        border-radius: 8px;\n        ",
        ";\n\n        &:active,\n        &:focus {\n          outline: 2px solid #b2bcca;\n        }\n\n        &.error {\n          border-color: #ea475c;\n\n          &:active,\n          &:focus {\n            outline: 2px solid #ea475c;\n          }\n        }\n      }\n\n      button {\n        margin-left: 18px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #ea475c;\n        background: transparent;\n        border: 2px solid #ea475c;\n        box-sizing: border-box;\n        border-radius: 12px;\n        padding: 0px 35px;\n        ",
        ";\n\n        &:active {\n          background: rgba(234, 71, 92, 0.1);\n        }\n      }\n\n      &.applied {\n        button {\n          color: white;\n          border: none;\n          background-color: #21d349bf;\n\n          &:active {\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n\n    .bl-discount-error-message {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      color: #ea475c;\n      margin-top: 4px;\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var DiscountMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DiscountField__DiscountMainWrap",
    componentId: "sc-eb5405af-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;position: absolute;left: 8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: 15px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 9px;left: initial;right:8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 8px 30px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-right: 18px;margin-left: 0;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align: right;direction: rtl;" : "");
});
var DiscountField = function(props) {
    var tourId = props.tourId, ticketId = props.ticketId, ticketingType = props.ticketingType, currencySign = props.currencySign, onDiscountApply = props.onDiscountApply;
    var ref = (0,react.useState)(false), isAbleToSetDiscount = ref[0], setIsAbleToSetDiscount = ref[1];
    var ref1 = (0,react.useState)(""), discountCode = ref1[0], setDiscountCode = ref1[1];
    var ref2 = (0,react.useState)(false), discountLoading = ref2[0], setDiscountLoading = ref2[1];
    var ref3 = (0,react.useState)({}), appliedDiscount = ref3[0], setAppliedDiscount = ref3[1];
    var ref4 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_gift_card_or_discount_code = ref4.add_a_gift_card_or_discount_code, add_a_gift_card_or_discount_code = _add_a_gift_card_or_discount_code === void 0 ? "Add a gift card or discount code" : _add_a_gift_card_or_discount_code, _apply = ref4.apply, apply = _apply === void 0 ? "Apply" : _apply, _confirmed = ref4.confirmed, confirmed = _confirmed === void 0 ? "Confirmed" : _confirmed, _promocode_not_found = ref4.promocode_not_found, promocode_not_found = _promocode_not_found === void 0 ? "promocode not found" : _promocode_not_found;
    var loadPromocode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var promocodeRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(!(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) && tourId)) {
                            _ctx.next = 7;
                            break;
                        }
                        setDiscountLoading(true);
                        _ctx.next = 5;
                        return TreedisPublicDAO/* default.getTicketingDiscount */.Z.getTicketingDiscount({
                            query: {
                                tourId: tourId,
                                codeName: discountCode,
                                ticketId: ticketId,
                                ticketingType: ticketingType
                            }
                        });
                    case 5:
                        promocodeRes = _ctx.sent;
                        if (promocodeRes && promocodeRes.message.includes("Success")) {
                            setAppliedDiscount(promocodeRes.data);
                            onDiscountApply(promocodeRes.data);
                        } else {
                            setAppliedDiscount({
                                error: promocode_not_found
                            });
                        }
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        setAppliedDiscount({
                            error: _ctx.t0.message
                        });
                    case 12:
                        _ctx.prev = 12;
                        setDiscountLoading(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    12,
                    15
                ]
            ]);
        }));
        return function loadPromocode() {
            return _ref.apply(this, arguments);
        };
    }();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountMainWrap, {
        className: "bl-ticket-order-discount",
        rtl: rtl,
        children: [
            !isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-discount-text",
                onClick: function() {
                    return setIsAbleToSetDiscount(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    " ",
                    add_a_gift_card_or_discount_code,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-chevron-down"
                    })
                ]
            }),
            isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("bl-ticket-order-discount-input-activate", appliedDiscount.amount && "applied"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-discount-input-wrap",
                        children: [
                            appliedDiscount.amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-applied-discount-value",
                                children: [
                                    "-",
                                    appliedDiscount.amount,
                                    appliedDiscount.discountType === "percent" ? "%" : currencySign,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-confirmed-icon-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fal fa-check"
                                        })
                                    })
                                ]
                            }),
                            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-discount-error-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fal fa-times"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: classnames_default()(appliedDiscount.error && "error"),
                                disabled: discountLoading || appliedDiscount.amount,
                                type: "text",
                                value: discountCode,
                                onChange: function(ev) {
                                    return setDiscountCode(ev.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: loadPromocode,
                        children: appliedDiscount.amount ? confirmed : apply
                    })
                ]
            }),
            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-discount-error-message",
                children: [
                    "*",
                    appliedDiscount.error
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DiscountField = (DiscountField);

// EXTERNAL MODULE: ./components/ticketingNew/components/StripePaymentButton/index.tsx + 2 modules
var StripePaymentButton = __webpack_require__(67838);
// EXTERNAL MODULE: ./node_modules/react-paypal-button-v2/lib/index.js
var lib = __webpack_require__(86295);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/types.ts
var types = __webpack_require__(84345);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./components/util/index.ts + 3 modules
var util = __webpack_require__(99351);
// EXTERNAL MODULE: ./components/ticketingNew/static.ts
var ticketingNew_static = __webpack_require__(70712);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order {\n    width: 50%;\n    display: inline-block;\n    background: #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);\n    padding: 26px 50px 0 53px;\n    height: auto;\n    padding-bottom: 34px;\n    align-self: flex-start;\n\n    .bl-ticket-order-title {\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 30px;\n      margin-bottom: 8px;\n    }\n\n    .bl-ticket-order-subTitle {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      color: #828282;\n    }\n\n    .bl-ticket-order-pills {\n      margin-bottom: 15px;\n      display: flex;\n      flex-wrap: wrap;\n\n      .bl-ticket-order-pill {\n        display: flex;\n        align-items: center;\n        border: 0.5px solid #d7d7d7;\n        box-sizing: border-box;\n        box-shadow: 0 0.5px 0 1px rgba(0, 0, 0, 0.16);\n        border-radius: 16px;\n        padding: 4px 18px;\n        margin-right: 7px;\n        margin-bottom: 7px;\n\n        img {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n\n    .bl-ticket-order-private-note-wrap {\n      border: 1px solid #d7d7d7;\n      box-sizing: border-box;\n      border-radius: 3px;\n      padding: 10px 12px 4px 20px;\n      position: relative;\n      margin-bottom: 16px;\n\n      .bl-ticket-order-pnote-header {\n        display: inline-block;\n        position: absolute;\n        top: -10px;\n        background-color: white;\n        color: #828282;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 20px;\n        ",
        ";\n      }\n\n      .bl-ticket-order-pnote-content {\n        font-weight: 300;\n        font-size: 12px;\n        line-height: 21px;\n      }\n    }\n\n    .bl-ticket-order-price {\n      display: flex;\n\n      .bl-ticket-order-price-title {\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        white-space: nowrap;\n      }\n\n      .bl-ticket-order-price-line {\n        border-style: dashed;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n      }\n\n      .bl-ticket-order-price-cost {\n      }\n    }\n\n    .bl-ticket-order-after-disc-line {\n    }\n\n    .bl-ticket-order-gtotal {\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 19px;\n\n      .bl-ticket-order-gtotal-title {\n      }\n\n      .bl-ticket-order-gtotal-price {\n      }\n    }\n\n    .bl-ticket-order-checkboxes {\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: baseline;\n        margin-bottom: 10px;\n\n        input[type='checkbox'] {\n          margin-right: 8px;\n          line-height: 20px;\n          width: 12px;\n          height: 12px;\n          accent-color: #ea475c;\n          border-radius: 2px;\n          ",
        ";\n        }\n      }\n    }\n\n    .bl-ticket-order-pay-btn {\n      background: linear-gradient(137.27deg, #ea475c 19.41%, #ff6175 65.49%);\n      box-shadow: 0px 4px 4px rgba(14, 53, 191, 0.25);\n      border-radius: 12px;\n      color: #f6f6f6;\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n\n      padding: 12px 109px;\n      margin: auto;\n      display: block;\n      margin-top: 29px;\n\n      &:active {\n        opacity: 0.9;\n      }\n\n      &:disabled {\n        background: #8b8b8b;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MainWrap",
    componentId: "sc-84e67df1-0"
})(styles_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: 26px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 8px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx





















var OrderDetailsBlock = function(props) {
    var participants = props.participants, setOrderLink = props.setOrderLink, setOrderStage = props.setOrderStage, handlePaymentSuccess = props.handlePaymentSuccess, match = props.match, tourId = props.tourId, matterId = props.matterId, initialTourType = props.initialTourType, initialTicketId = props.initialTicketId, gameId = props.gameId;
    var ticketing = (0,store/* useRecoilValue */.sJ)(store/* ticketingDataState */.$W);
    var ticketingGeneral = ticketing.ticketingGeneral;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _plane_name = ref.plane_name, plane_name = _plane_name === void 0 ? "Plane name" : _plane_name, _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _private_note = ref.private_note, private_note = _private_note === void 0 ? "private Note" : _private_note, _ticket = ref.ticket, ticket = _ticket === void 0 ? "ticket" : _ticket, _grand_total = ref.grand_total, grand_total = _grand_total === void 0 ? "Grand Total" : _grand_total, _legal_checkbox_2 = ref.legal_checkbox_2, legal_checkbox_2 = _legal_checkbox_2 === void 0 ? "Legal checkbox 2" : _legal_checkbox_2, _legal_checkbox_1 = ref.legal_checkbox_1, legal_checkbox_1 = _legal_checkbox_1 === void 0 ? "*I agree terms & conditions" : _legal_checkbox_1, _proceed_to_payment = ref.proceed_to_payment, proceed_to_payment = _proceed_to_payment === void 0 ? "Proceed to payment" : _proceed_to_payment, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language, _wrong_discount_val = ref.wrong_discount_val, wrong_discount_val = _wrong_discount_val === void 0 ? "wrong discount value" : _wrong_discount_val, _user = ref.user, user = _user === void 0 ? "user" : _user, _email = ref.email, email = _email === void 0 ? "email" : _email, _name = ref.name, name = _name === void 0 ? "name" : _name, _is_required = ref.is_required, is_required = _is_required === void 0 ? "is required" : _is_required, _is_not_valid = ref.is_not_valid, is_not_valid = _is_not_valid === void 0 ? "is not valid" : _is_not_valid, _check_out = ref.check_out, check_out = _check_out === void 0 ? "Check Out" : _check_out, _tickets_order_was_cancelled = ref.tickets_order_was_cancelled, tickets_order_was_cancelled = _tickets_order_was_cancelled === void 0 ? "Tickets order was cancelled" : _tickets_order_was_cancelled, _tickets_order_error = ref.tickets_order_error, tickets_order_error = _tickets_order_error === void 0 ? "Tickets order error." : _tickets_order_error;
    var ref1 = (0,react.useState)(null), appliedDiscount = ref1[0], setAppliedDiscount = ref1[1];
    //----------- order data fields --------------
    var ref2 = (0,react.useState)(false), checkbox1 = ref2[0], setCheckbox1 = ref2[1];
    var ref3 = (0,react.useState)(false), checkbox2 = ref3[0], setCheckbox2 = ref3[1];
    //----------- order data fields end --------------
    var ref4 = (0,react.useState)(false), ticketOrderSent = ref4[0], setTicketOrderSent = ref4[1];
    //ticketType: "gameTour"
    var tourType = match.params.tourType || (initialTourType === null || initialTourType === void 0 ? void 0 : initialTourType.replace("gameTour", "experienceTour"));
    var ticketId = match.params.ticketId || initialTicketId;
    var tourTypeKey = util/* ticketingTypes */.pb === null || util/* ticketingTypes */.pb === void 0 ? void 0 : util/* ticketingTypes.find */.pb.find(function(tt) {
        return tt.tourType === tourType;
    });
    var ticketingType = tourTypeKey.key;
    var currentTicket = ticketId ? ticketing[tourTypeKey === null || tourTypeKey === void 0 ? void 0 : tourTypeKey.key].find(function(ticket) {
        return ticket.id === parseInt(ticketId);
    }) : null;
    var currencySymbol = ticketingNew_static/* initialCurrency.find */.Z.find(function(cur) {
        return cur.id === ticketingGeneral.currencyId;
    });
    var orderId = (0,react.useRef)(null);
    var orderBtn = (0,react.useRef)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref5[0], setInfoModalData = ref5[1];
    var setTicketOrderResult = (0,store/* useSetRecoilState */.Zl)(store/* orderedTicketsState */.jF);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* redirectTicketsState */.Sy), 2), redirectTickets = ref6[0], setRedirectTickets = ref6[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var finishOrderRes, ticketsString, tickets;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!redirectTickets) {
                            _ctx.next = 6;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return TreedisPublicDAO/* default.finishOrderTickets */.Z.finishOrderTickets({
                            /// TODO add transaction to validate
                            orderCode: redirectTickets.orderCode,
                            status: redirectTickets.status,
                            pelecardStatusCode: redirectTickets.PelecardStatusCode,
                            matterId: matterId
                        });
                    case 4:
                        finishOrderRes = _ctx.sent;
                        if (finishOrderRes && finishOrderRes.message.includes("Success")) {
                            if (finishOrderRes.status === "success") {
                                ticketsString = redirectTickets.data;
                                if (ticketsString) {
                                    (0,analytic/* sendToGA */.o$)("event", {
                                        eventCategory: "Ticketing",
                                        eventAction: "purchase",
                                        eventLabel: tourType
                                    });
                                    tickets = JSON.parse(ticketsString);
                                    setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, finishOrderRes === null || finishOrderRes === void 0 ? void 0 : finishOrderRes.order), {
                                        tickets: tickets
                                    }));
                                    handlePaymentSuccess();
                                }
                            } else if (finishOrderRes.status === "cancel") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: tickets_order_was_cancelled,
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            } else if (finishOrderRes.status === "error") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: "".concat(tickets_order_error, " ").concat(redirectTickets.PelecardStatusCode ? "PelecardStatusCode - ".concat(redirectTickets.PelecardStatusCode) : ""),
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            }
                        }
                    case 6:
                        setRedirectTickets(null);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        redirectTickets
    ]);
    (0,react.useEffect)(function() {
        if (!(ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.paymentType)) {
            setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: "Looks like ticketing payment method not set or missing. Please check ticketing -> Payment API on admin panel"
            }));
        }
    }, []);
    var applyDiscounts = function(value) {
        var result = value;
        if (!appliedDiscount) return result;
        if (appliedDiscount.discountType === "currency") {
            if (appliedDiscount.amount > 0) result -= appliedDiscount.amount;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        } else if (appliedDiscount.discountType === "percent") {
            if (appliedDiscount.amount > 0 && appliedDiscount.amount <= 100) result -= result * appliedDiscount.amount / 100;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        }
        if (result < 0) return 0;
        return result;
    };
    var totalPrice = currentTicket ? parseFloat(applyDiscounts(participants.length * currentTicket.ticketPrice).toFixed(2)) : 0;
    var _validateUsers = function() {
        var noToast = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var errors = [];
        if (ticketingGeneral.legalCheckbox1Required && !checkbox1) errors.push("".concat(legal_checkbox_1, " ").concat(is_required));
        if (ticketingGeneral.legalCheckbox2Required && !checkbox2) errors.push("".concat(legal_checkbox_2, " ").concat(is_required));
        participants.forEach(function(ticket, num) {
            if (!ticket.email.length) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_required));
            } else if (!(0,util_all/* validateEmail */.oH)(ticket.email)) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_not_valid));
            }
            if (!ticket.fullName) errors.push("".concat(user, " ").concat(num + 1, " ").concat(name, " ").concat(is_required));
        });
        if (errors.length) {
            if (!noToast) react_toastify_esm/* toast.error */.Am.error(errors.join("\n"));
            return 1;
        }
        return 0;
    };
    var handleProceedPayment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, body, data, order, ticketPayRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        if (!(orderBtn === null || orderBtn === void 0 ? void 0 : (ref = orderBtn.current) === null || ref === void 0 ? void 0 : ref.disabled)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!_validateUsers()) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        setTicketOrderSent(true);
                        body = {
                            paymentType: ticketingGeneral.paymentType,
                            ticketType: tourType.replace("experienceTour", "gameTour"),
                            tourId: tourId,
                            matterId: matterId,
                            participants: participants.map(function(participant) {
                                //fullName: '', email: '', isGift: false
                                var fullName = participant.fullName, email = participant.email, isGift = participant.isGift;
                                if (!fullName && !email && !isGift && participants[0]) {
                                    fullName = participants[0].fullName;
                                    email = participants[0].email;
                                    isGift = participants[0].isGift;
                                }
                                return {
                                    name: fullName,
                                    email: email,
                                    gift: isGift
                                };
                            }),
                            selectedTicketId: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.id,
                            discountCode: appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.codeName,
                            goodUrl: location.origin,
                            cancelUrl: location.origin,
                            errorUrl: location.origin,
                            amount: totalPrice,
                            // notificationGoodMail,
                            // notificationErrorMail,
                            // notificationFailMail,
                            currency: (currencySymbol === null || currencySymbol === void 0 ? void 0 : currencySymbol.code) || "USD"
                        };
                        _ctx.next = 10;
                        return TreedisPublicDAO/* default.createTicketOrder */.Z.createTicketOrder(body);
                    case 10:
                        data = _ctx.sent.data;
                        order = data.order;
                        orderId.current = order === null || order === void 0 ? void 0 : order.id;
                        if (!(ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || Number(totalPrice) === 0)) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 16;
                        return TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType || Order/* TicketPaymentType.NoPayment */.fx.NoPayment, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                            orderId: order.id
                        }));
                    case 16:
                        ticketPayRes = _ctx.sent;
                        if (ticketPayRes && ticketPayRes.message.includes("Success")) {
                            if (ticketPayRes.ticketsWithoutCost) {
                                ;
                                setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                                    gameId: gameId
                                }));
                                handlePaymentSuccess();
                            } else {
                                setOrderLink(ticketPayRes.url);
                                setOrderStage(Order/* OrderStageEnum.payment */.t9.payment);
                            }
                        }
                    case 18:
                        setTicketOrderSent(false);
                        return _ctx.abrupt("return", {
                            ticketOrderId: order.id,
                            name: participants[0].fullName,
                            email: participants[0].email
                        });
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](0);
                        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                            isOpen: true,
                            message: _ctx.t0.message,
                            mode: InfoModal/* EInfoModal.error */.Y.error
                        }));
                    case 25:
                        _ctx.prev = 25;
                        setTicketOrderSent(false);
                        return _ctx.finish(25);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    22,
                    25,
                    28
                ]
            ]);
        }));
        return function handleProceedPayment() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelOrder = function() {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: true,
            message: "Error paypal payment",
            mode: InfoModal/* EInfoModal.error */.Y.error
        }));
    };
    var paypalCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data, actions) {
            var ticketOrderId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleProceedPayment();
                    case 2:
                        ticketOrderId = _ctx.sent.ticketOrderId;
                        ;
                        if (ticketOrderId) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("No order ID");
                    case 6:
                        orderId.current = ticketOrderId;
                        return _ctx.abrupt("return", actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: totalPrice,
                                        currency_code: currencySymbol.code
                                    }
                                }, 
                            ]
                        }));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function paypalCreateOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var paypalApproveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data, actions) {
            var ticketPayRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                            data: {
                                orderId: orderId.current,
                                paymentId: data.orderID
                            }
                        });
                    case 2:
                        ticketPayRes = _ctx.sent;
                        if (ticketPayRes) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                            isOpen: true,
                            message: "Error paypal payment - orderId: ".concat(data.orderID),
                            mode: InfoModal/* EInfoModal.error */.Y.error
                        })));
                    case 5:
                        ;
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function paypalApproveOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var stripeCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ticketOrderId, name, email;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return handleProceedPayment();
                    case 3:
                        ref = _ctx.sent;
                        ticketOrderId = ref.ticketOrderId;
                        name = ref.name;
                        email = ref.email;
                        if (ticketOrderId) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error();
                    case 9:
                        return _ctx.abrupt("return", {
                            id: ticketOrderId,
                            totalPrice: totalPrice,
                            currency: currencySymbol.code,
                            name: name,
                            email: email,
                            tourId: tourId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", null);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function stripeCreateOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var approveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ticketPayRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                            data: {
                                orderId: orderId.current
                            }
                        });
                    case 2:
                        ticketPayRes = _ctx.sent;
                        ;
                        if (ticketPayRes) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function approveOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var ref7 = currentTicket || {}, durationType = ref7.durationType, limitDevices = ref7.limitDevices, duration = ref7.duration, maxParticipants = ref7.maxParticipants, tourLanguage = ref7.tourLanguage, ticketPrice = ref7.ticketPrice;
    var pillsList = [];
    if (durationType) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === types/* DurationType.from_purchase */.q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType"));
    }
    if (limitDevices) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices"));
    }
    if (maxParticipants) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants"));
    }
    if (tourLanguage) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage"));
    }
    if (ticketPrice) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-tag"
                }),
                ticketPrice,
                currencySymbol.symbol
            ]
        }, "ticketPrice"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        className: "bl-ticket-order",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-title",
                children: plane_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-subTitle",
                children: [
                    available_for,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-pills",
                children: pillsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-private-note-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-header",
                        children: private_note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-content",
                        dangerouslySetInnerHTML: {
                            __html: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-price",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-title",
                        children: [
                            participants.length,
                            " ",
                            ticket,
                            " X ",
                            currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice,
                            " ",
                            currencySymbol.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "bl-ticket-order-price-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-cost",
                        children: [
                            participants.length * (currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice) || 0,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            currentTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DiscountField, {
                tourId: tourId,
                ticketId: ticketId,
                ticketingType: ticketingType,
                currencySign: currencySymbol.symbol,
                onDiscountApply: setAppliedDiscount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "bl-ticket-order-after-disc-line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-gtotal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-gtotal-title",
                        children: grand_total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-gtotal-price",
                        children: [
                            totalPrice,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-checkboxes",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox1,
                                onChange: function() {
                                    return setCheckbox1(!checkbox1);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: ticketingGeneral.termsAndConditionsUrl,
                                target: "_blank",
                                children: legal_checkbox_1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox2,
                                onChange: function() {
                                    return setCheckbox2(!checkbox2);
                                }
                            }),
                            legal_checkbox_2
                        ]
                    })
                ]
            }),
            ticketingGeneral && currentTicket && (ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || !ticketingGeneral.paid || totalPrice === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: orderBtn,
                disabled: ticketOrderSent,
                className: "bl-ticket-order-pay-btn",
                onClick: handleProceedPayment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas icon"
                    }),
                    proceed_to_payment
                ]
            }),
            !_validateUsers(true) && ticketingGeneral && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Stripe */.fx.Stripe && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StripePaymentButton/* default */.Z, {
                translation: {
                    check_out: check_out
                },
                createOrder: stripeCreateOrder,
                settings: ticketingGeneral,
                approveOrder: approveOrder
            }),
            !_validateUsers(true) && (ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername) && currencySymbol.code && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Paypal */.fx.Paypal && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* PayPalButton */.q, {
                    shippingPreference: "NO_SHIPPING",
                    currency: currencySymbol.code,
                    options: {
                        clientId: ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername,
                        currency: currencySymbol.code
                    },
                    style: {
                        color: "silver"
                    },
                    createOrder: paypalCreateOrder,
                    onApprove: paypalApproveOrder,
                    onError: cancelOrder
                })
            })
        ]
    });
};
/* harmony default export */ var components_OrderDetailsBlock = (OrderDetailsBlock);


/***/ }),

/***/ 30510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59016);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 38px;\n\n  .bl-steps-wrap {\n    width: 202px;\n    display: flex;\n    justify-content: space-between;\n\n    .step {\n      color: white;\n      width: 48px;\n      height: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #bbbbbb;\n      font-weight: 400;\n      font-size: 32px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      border-radius: 50%;\n      z-index: 2;\n\n      &.active {\n        background-color: #4b4b4b;\n      }\n\n      &.done {\n        background-color: #ea475c;\n      }\n    }\n  }\n\n  hr {\n    position: absolute;\n    top: 10px;\n    width: 172px;\n    border: 1px solid #8e8e8e;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepsBlock__MainWrap",
    componentId: "sc-78f40250-0"
})(_templateObject());
var StepsBlock = function(props) {
    var count = props.count, active = props.active, _done = props.done, done = _done === void 0 ? [] : _done;
    var steps = [];
    for(var i = 0; i < count; i++)steps.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("step", active === i + 1 && "active", done.includes(i + 1) && "done"),
        children: done.includes(i + 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
            className: "fas fa-check"
        }) : i + 1
    }, i));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        className: "bl-steps-widget",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-steps-wrap",
                children: steps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepsBlock);


/***/ }),

/***/ 67838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StripePaymentButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(54465);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./api/TreedisAdminDAO.ts
var TreedisAdminDAO = __webpack_require__(83680);
// EXTERNAL MODULE: ./components/common/CookieConsent.tsx
var CookieConsent = __webpack_require__(72789);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
;// CONCATENATED MODULE: ./components/ticketingNew/components/StripePaymentButton/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 6px;\n  background-color: #fff;\n  margin-bottom: 15px;\n  border: 1px solid #eee;\n  border-radius: 5px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 382px;\n  width: 100%;\n  height: 55px;\n  border-radius: 5px;\n  box-shadow: 0 5px 4px 0 rgba(0, 0, 0, 0.18);\n  background-color: #39a2db;\n  color: white;\n  font-size: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var CardInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__CardInputWrapper",
    componentId: "sc-67b919e4-0"
})(_templateObject());
var BlueButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styled__BlueButton",
    componentId: "sc-67b919e4-1"
})(_templateObject1());

// EXTERNAL MODULE: ./components/ticketingNew/static.ts
var ticketingNew_static = __webpack_require__(70712);
;// CONCATENATED MODULE: ./components/ticketingNew/components/StripePaymentButton/Form.tsx











var inputStyle = {
    base: {
        fontSize: "16px",
        backgroundColor: "#fff",
        fontFamily: '"Heebo", sans-serif',
        fontWeight: "300",
        textIndent: "8px",
        color: "rgb(41, 41, 41, 0.5)",
        ":-webkit-autofill": {
            color: "rgb(41, 41, 41, 0.5)"
        },
        "::placeholder": {
            color: "rgb(41, 41, 41, 0.5)"
        }
    },
    invalid: {
        iconColor: "#ea475c",
        color: "#ea475c"
    }
};
var cookieAcceptButton = {
    maxWidth: "382px",
    width: "100%",
    marginTop: "15px",
    height: "55px",
    boxShadow: "0 5px 4px 0 rgba(0, 0, 0, 0.18)",
    background: "#39a2db",
    color: "#FFF",
    fontSize: "16px",
    borderRadius: "5px"
};
var stripeCookieConsent = {
    display: "flex",
    justifyContent: "center",
    paddingTop: "15px"
};
var CheckoutForm = function(param) {
    var createOrder = param.createOrder, approveOrder = param.approveOrder, translation = param.translation, settings = param.settings;
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var ref = (0,react.useState)({
        status: "initial"
    }), payment = ref[0], setPayment = ref[1];
    var ref1 = (0,react.useState)((0,CookieConsent/* allowUsesCookie */.q7)()), cookiesAllowed = ref1[0], setCookiesAllowed = ref1[1];
    var cookiesAccept = function() {
        return setCookiesAllowed(true);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, order, currency, response, cardElement, ref1, error, paymentIntent, _message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        e.preventDefault();
                        if (cookiesAllowed) {
                            _ctx.next = 5;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("Stripe payment will be available only after accept cookies.");
                        return _ctx.abrupt("return", false);
                    case 5:
                        if (e.currentTarget.reportValidity()) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 7:
                        setPayment({
                            status: "processing"
                        });
                        _ctx.next = 10;
                        return createOrder();
                    case 10:
                        order = _ctx.sent;
                        if (order) {
                            _ctx.next = 15;
                            break;
                        }
                        setPayment({
                            status: "error"
                        });
                        react_toastify_esm/* toast.error */.Am.error("Error create order");
                        return _ctx.abrupt("return", false);
                    case 15:
                        currency = ticketingNew_static/* initialCurrency.find */.Z.find(function(cur) {
                            return settings.currencyId === cur.id;
                        });
                        _ctx.next = 18;
                        return TreedisAdminDAO/* default.createPaymentSecret */.Z.createPaymentSecret({
                            amount: order.totalPrice,
                            currency: currency === null || currency === void 0 ? void 0 : (ref = currency.code) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                            metadata: {
                                ticketing_order_id: order.id
                            },
                            payment_method_types: [
                                "card"
                            ],
                            tourId: order.tourId,
                            type: "tickets"
                        });
                    case 18:
                        response = _ctx.sent;
                        setPayment(response);
                        if (!(response.status === 500)) {
                            _ctx.next = 24;
                            break;
                        }
                        setPayment({
                            status: "error"
                        });
                        react_toastify_esm/* toast.error */.Am.error("Payment order");
                        return _ctx.abrupt("return", false);
                    case 24:
                        cardElement = elements === null || elements === void 0 ? void 0 : elements.getElement(react_stripe_umd.CardNumberElement);
                        _ctx.next = 27;
                        return stripe === null || stripe === void 0 ? void 0 : stripe.confirmCardPayment(response.client_secret, {
                            payment_method: {
                                card: cardElement,
                                billing_details: {
                                    name: "".concat(order.name),
                                    email: order.email
                                }
                            }
                        });
                    case 27:
                        ref1 = _ctx.sent;
                        error = ref1.error;
                        paymentIntent = ref1.paymentIntent;
                        if (error) {
                            setPayment({
                                status: "error"
                            });
                            ;
                            react_toastify_esm/* toast.error */.Am.error((_message = error.message) !== null && _message !== void 0 ? _message : "An unknown error occured");
                        } else if (paymentIntent) {
                            setPayment(paymentIntent);
                            approveOrder();
                        }
                        return _ctx.abrupt("return", true);
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: cookiesAllowed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "width-100",
            onSubmit: handleSubmit,
            id: "payment-form",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row mt-4 mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12 input-c mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Credit card details"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12 input-c",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInputWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardNumberElement, {
                                    options: {
                                        style: inputStyle
                                    },
                                    onChange: function(e) {
                                        if (e.error) {
                                            setPayment({
                                                status: "error"
                                            });
                                            var _message;
                                            react_toastify_esm/* toast.error */.Am.error((_message = e.message) !== null && _message !== void 0 ? _message : "An unknown error occured");
                                        }
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-sm-12 input-c",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInputWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardExpiryElement, {
                                    options: {
                                        style: inputStyle
                                    },
                                    onChange: function(e) {
                                        if (e.error) {
                                            setPayment({
                                                status: "error"
                                            });
                                            var _message;
                                            react_toastify_esm/* toast.error */.Am.error((_message = e.message) !== null && _message !== void 0 ? _message : "An unknown error occured");
                                        }
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-6 col-sm-12 input-c",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInputWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardCvcElement, {
                                    options: {
                                        style: inputStyle
                                    },
                                    onChange: function(e) {
                                        if (e.error) {
                                            setPayment({
                                                status: "error"
                                            });
                                            var _message;
                                            react_toastify_esm/* toast.error */.Am.error((_message = e.message) !== null && _message !== void 0 ? _message : "An unknown error occured");
                                        }
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueButton, {
                    type: "submit",
                    className: "mt-3",
                    disabled: ![
                        "initial",
                        "succeeded",
                        "error"
                    ].includes(payment === null || payment === void 0 ? void 0 : payment.status) || !stripe,
                    children: translation.check_out || "Check Out"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: stripeCookieConsent,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
                cookieName: CookieConsent/* treedisCookieName */.JX,
                disableStyles: true,
                debug: true,
                buttonText: "Accept cookies",
                buttonStyle: cookieAcceptButton,
                onAccept: function() {
                    cookiesAccept();
                },
                children: "Stripe payment will be available only after accept cookies."
            })
        })
    });
};
/* harmony default export */ var Form = (CheckoutForm);

;// CONCATENATED MODULE: ./components/ticketingNew/components/StripePaymentButton/index.tsx




var StripePaymentButton = function(param) {
    var settings = param.settings, createOrder = param.createOrder, approveOrder = param.approveOrder, translation = param.translation;
    var stripePromise = (0,stripe_esm/* loadStripe */.J)(settings.apiKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
        stripe: stripePromise,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
            translation: translation,
            createOrder: createOrder,
            approveOrder: approveOrder,
            settings: settings
        })
    });
};
/* harmony default export */ var components_StripePaymentButton = (StripePaymentButton);


/***/ }),

/***/ 47238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16592);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59016);
/* harmony import */ var _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84345);
/* harmony import */ var _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70712);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8667);
/* harmony import */ var _utils_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14045);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72225);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 15px;\n  min-height: 134px;\n\n  .bl-tm-first {\n    background: #ffffff;\n    border-radius: 0 10px 10px 0;\n    width: 108px;\n    min-width: 108px;\n    padding: 5px;\n    text-align: center;\n    ",
        ";\n\n    .bl-tm-first-title {\n      margin-top: 6px;\n      margin-bottom: 9px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n    }\n\n    .bl-tm-first-price {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 10px;\n    }\n\n    .bl-tm-first-start-btn {\n      background: #ea475c;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n      border-radius: 6px;\n      color: white;\n      width: 89px;\n      height: 28px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n\n      i {\n        margin-left: 7px;\n      }\n\n      &:active {\n        opacity: 0.9;\n      }\n    }\n\n    .tim-radio-pick-wrap {\n      display: flex;\n      height: 23px;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      color: #a5a5a5;\n      font-weight: 600;\n      font-size: 15px;\n\n      &.picked {\n        color: #ea475c;\n      }\n\n      input {\n        width: 17px;\n        height: 17px;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  .bl-tm-second {\n    overflow: hidden;\n    width: 100%;\n    margin-left: 1px;\n    padding: 5px;\n    background: #ffffff;\n    border-radius: 10px 0 0 10px;\n    position: relative;\n    ",
        ";\n\n    .bl-tm-second-desc {\n      min-height: 36px;\n      padding: 8px 10px 0 10px;\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      max-height: 65px;\n\n      text-align: left;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .bl-tm-second-info-title {\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      text-decoration-line: underline;\n      color: #969595;\n      margin-left: 10px;\n      margin-top: 7px;\n    }\n\n    .bl-tm-second-info-wrap {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: left;\n      margin-top: 7px;\n      padding: 0 2px;\n\n      .bl-tm-second-info-item {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #333333;\n        display: flex;\n        align-items: center;\n\n        img {\n          width: 18px;\n          height: 18px;\n          margin-right: 3px;\n        }\n      }\n\n      hr {\n        margin: 0 10px;\n        height: 13px;\n        border: none;\n        border-left: 1px solid black;\n\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n\n    .bl-ticket-ending {\n      position: absolute;\n      height: 134px;\n      right: 0;\n      top: 0;\n      ",
        ";\n\n      .bl-ticket-end-rect {\n        width: 12px;\n        height: 16px;\n        background: #e5e5e5;\n        border-radius: 12px 0 0 12px;\n\n        &.bl-rect-1 {\n          margin-top: 27px;\n        }\n\n        &.bl-rect-2 {\n          margin-top: 15px;\n        }\n\n        &.bl-rect-3 {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TicketItemMobile__MainWrap",
    componentId: "sc-769d7f18-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 10px 0 0 10px;margin-left: 3px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 10px 10px 0;padding-left: 13px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "left: 0;right: initial;transform: scale(-1, 1);" : "");
});
var TicketItemMobile = function(props) {
    var ticket = props.ticket, currencyId = props.currencyId, match = props.match, onPick = props.onPick, pickedId = props.pickedId;
    var durationType = ticket.durationType, limitDevices = ticket.limitDevices, duration = ticket.duration, maxParticipants = ticket.maxParticipants, tourLanguage = ticket.tourLanguage, ticketInfoUlr = ticket.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .translationDataState */ .Jv), _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _start = ref.start, start = _start === void 0 ? "start" : _start, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .tourConfigsState */ .Uq).rtl;
    var tourType = match.params.tourType;
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var currencySymbol = _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__/* .initialCurrency.find */ .Z.find(function(cur) {
        return cur.id === currencyId;
    });
    var infoItems = [];
    if (durationType) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__/* .DurationType.from_purchase */ .q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "durationType_hr"));
    }
    if (limitDevices) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "limitDevices_hr"));
    }
    if (maxParticipants) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "maxParticipants_hr"));
    }
    if (tourLanguage) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "tourLanguage_hr"));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-first",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-first-title",
                        children: ticket.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-first-price",
                        children: [
                            ticket.ticketPrice,
                            currencySymbol.symbol
                        ]
                    }),
                    !onPick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .rU, {
                        to: "".concat(tourType, "/").concat(ticket.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                            className: "bl-tm-first-start-btn",
                            children: [
                                (0,_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .capitalize */ .kC)(start),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "fas fa-chevron-right"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()("tim-radio-pick-wrap", ticket.id === pickedId && "picked"),
                        children: [
                            ticket.id === pickedId ? "Picked" : "Pick",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                type: "radio",
                                onChange: function() {
                                    return onPick(ticket.id);
                                },
                                checked: ticket.id === pickedId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-second",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-desc",
                        dangerouslySetInnerHTML: {
                            __html: ticket.description
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-second-info-title",
                        children: [
                            available_for,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-info-wrap",
                        children: infoItems
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        ticketInfoUlr: ticketInfoUlr
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_11__/* .withRouter */ .EN)(TicketItemMobile));


/***/ }),

/***/ 70883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59016);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8667);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 133px;\n  background-color: #282828;\n  position: relative;\n\n  .bl-minimized-vector {\n    width: 0;\n    height: 0;\n    right: 0;\n    top: 0;\n    position: absolute;\n    border-bottom: 133px solid #ea475c;\n    border-left: 241px solid transparent;\n  }\n\n  .bl-minimized-title {\n    margin: 0;\n    height: 100%;\n    padding: 0 300px 0 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    //margin-top: 38px;\n    //margin-left: 80px;\n    font-weight: 400;\n    font-size: 40px;\n    line-height: 60px;\n    color: white;\n    position: absolute;\n    //max-height: calc(100% - 38px);\n    overflow: hidden;\n\n    @media screen and (max-width: 760px) {\n      width: 100%;\n      text-align: center;\n      margin-left: 0;\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    height: 77px;\n    .bl-minimized-title {\n      padding: inherit;\n      margin: 0;\n\n      text-align: left;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      //margin-top: 20px;\n      //padding-left: 24px;\n      //max-height: calc(100% - 20px);\n    }\n    .bl-minimized-vector {\n      border-right: 84px solid #ea475c;\n      border-bottom: 77px solid transparent;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TourImageDescriptionMinized__MainWrap",
    componentId: "sc-255bc9f8-0"
})(_templateObject());
var TourImageDescriptionMinized = function() {
    var ticketingGeneral = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .ticketingDataState */ .$W).ticketingGeneral;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-vector"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-title",
                dangerouslySetInnerHTML: {
                    __html: ticketingGeneral.title
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TourImageDescriptionMinized);


/***/ }),

/***/ 67020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t9": function() { return /* binding */ OrderStageEnum; },
  "fx": function() { return /* binding */ TicketPaymentType; },
  "ZP": function() { return /* binding */ pages_Order; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./node_modules/react-switch/index.js
var react_switch = __webpack_require__(59936);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/ticketingNew/components/UserCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-item {\n    height: 141px;\n    display: flex;\n    margin-bottom: 11px;\n\n    .bl-ticket-desc {\n      width: 108px;\n      min-width: 108px;\n      background: #ffffff;\n      border-radius: 0 12px 12px 0;\n      margin-right: 3px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      text-align: center;\n      position: relative;\n      ",
        ";\n\n      .bl-ticket-number-text {\n        margin-top: 17px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 21px;\n      }\n\n      .bl-ticket-number {\n        font-weight: 400;\n        font-size: 60px;\n        line-height: 90px;\n      }\n\n      .bl-ticket-triangle {\n        width: 0;\n        height: 0;\n        border-bottom: 29px solid #ea475c;\n        border-right: 49px solid transparent;\n        position: absolute;\n        bottom: 0;\n        ",
        ";\n      }\n    }\n\n    .bl-ticket-data {\n      padding-top: 29px;\n      padding-left: 20px;\n      padding-right: 54px;\n      width: 100%;\n      background: #ffffff;\n      border-radius: 12px 0 0 12px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      ",
        ";\n\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        margin-bottom: 19px;\n        justify-content: space-between;\n\n        span {\n          ",
        ";\n        }\n\n        .bl-text-input {\n          height: 23px;\n          width: 251px;\n          border: 1px solid #c4c4c4;\n          box-sizing: border-box;\n          border-radius: 4px;\n\n          &:active,\n          &:focus {\n            outline-color: #c4c4c4;\n          }\n        }\n      }\n\n      .bl-field-2 {\n        label {\n          margin-bottom: 15px;\n        }\n      }\n\n      .bl-field-3 {\n        label {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 20px;\n          justify-content: space-between;\n          width: 117px;\n          float: right;\n        }\n\n        .bl-field-close {\n          float: left;\n          display: flex;\n          align-items: baseline;\n          cursor: pointer;\n          color: #ea475c;\n          //line-height: 13px;\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 15px;\n\n          .bl-close-circle {\n            width: 13px;\n            height: 13px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #ea475c;\n            margin: 6px;\n            color: white;\n            border-radius: 50%;\n\n            i {\n              font-weight: normal;\n              font-size: 10px;\n            }\n          }\n        }\n      }\n\n      .bl-ticket-ending {\n        position: absolute;\n        height: 141px;\n        right: 0;\n        top: 0;\n        ",
        ";\n\n        .bl-ticket-end-rect {\n          width: 18px;\n          height: 21px;\n          background: #e5e5e5;\n          border-radius: 12px 0 0 12px;\n\n          &.bl-rect-1 {\n            margin-top: 20px;\n          }\n\n          &.bl-rect-2 {\n            margin-top: 19px;\n          }\n\n          &.bl-rect-3 {\n            margin-top: 19px;\n          }\n        }\n      }\n\n      @media screen and (max-width: 760px) {\n        ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var getNumAsText = function(num) {
    var getLiteralLess13 = function(num) {
        switch(num){
            case 1:
                return "one";
            case 2:
                return "two";
            case 3:
                return "three";
            case 4:
                return "four";
            case 5:
                return "five";
            case 6:
                return "six";
            case 7:
                return "seven";
            case 8:
                return "eight";
            case 9:
                return "nine";
            case 10:
                return "ten";
            case 11:
                return "eleven";
            case 12:
                return "twelve";
            //1x teen
            case 13:
                return "thirteen";
        }
    };
    if (num < 13) return getLiteralLess13(num);
    if (num === 13) return "thirteen";
    if (num === 15) return "fifteen";
    if (num > 13 && num < 20) return getLiteralLess13(num - 10) + "teen";
    if (num === 20) return "twenty";
    if (num > 20 && num < 30) return "twenty" + getLiteralLess13(num - 20);
    if (num === 30) return "thirty";
    if (num > 30 && num < 40) return "thirty" + getLiteralLess13(num - 30);
    if (num === 40) return "fourty";
    if (num > 40 && num < 50) return "fourty" + getLiteralLess13(num - 40);
    return num;
};
var TicketItemMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserCard__TicketItemMainWrap",
    componentId: "sc-953b2f2e-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-left: 3px; margin-right: 0; border-radius: 12px 0 0 12px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "transform: scale(-1, 1); right: -1px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 12px 12px 0; padding: 29px 20px 0 54px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right:12px;left:initial!important;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: -2px;transform: scale(-1,1);" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding-left:20px!important;padding-right: 10px!important;" : "");
});
var UserCard = function(props) {
    var ticket = props.ticket, ticketNum = props.ticketNum, setTicketData = props.setTicketData, removeTicket = props.removeTicket;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _user = ref.user, user = _user === void 0 ? "User" : _user, _full_name = ref.full_name, full_name = _full_name === void 0 ? "Full name" : _full_name, _email = ref.email, email = _email === void 0 ? "Email" : _email, _close = ref.close, close = _close === void 0 ? "Close" : _close, _send_as_gift = ref.send_as_gift, send_as_gift = _send_as_gift === void 0 ? "Send as gift" : _send_as_gift;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TicketItemMainWrap, {
        className: "bl-ticket-item",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-desc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-number-text",
                        children: [
                            user,
                            " ",
                            getNumAsText(ticketNum + 1)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-number",
                        children: ticketNum + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-triangle"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-data",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(full_name)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "fullName",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(email)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "email",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-field-3",
                        children: [
                            ticketNum > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-field-close",
                                onClick: function() {
                                    return removeTicket(ticket.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-close-circle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-times"
                                        })
                                    }),
                                    (0,string/* capitalize */.kC)(close)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    send_as_gift,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_switch["default"], {
                                        onColor: "#ea475c",
                                        checked: ticket.isGift,
                                        onChange: function(newIsGift) {
                                            return setTicketData({
                                                id: ticket.id,
                                                target: "isGift",
                                                value: newIsGift
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserCard = (UserCard);

// EXTERNAL MODULE: ./components/ticketingNew/components/BackButton.tsx
var BackButton = __webpack_require__(7710);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .bl-signUp-text {\n    text-align: center;\n    font-weight: 500;\n    font-size: 30px;\n    line-height: 45px;\n    margin-top: 20px;\n    margin-bottom: 88px;\n  }\n\n  .bl-ticket-main-wrap {\n    margin-left: 163px;\n    margin-right: 220px;\n    display: flex;\n\n    .bl-tickets-wrap {\n      margin-right: ",
        ";\n      margin-left: ",
        ";\n      width: calc(50% - 16px);\n      display: inline-block;\n\n      .bl-add-ticket-wrap {\n        margin-top: 15px;\n        display: flex;\n        align-items: baseline;\n        cursor: pointer;\n\n        &:active {\n          opacity: 0.8;\n        }\n\n        .bl-add-plus {\n          width: 21px;\n          height: 21px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: #ea475c;\n          border-radius: 2px;\n          color: white;\n        }\n\n        .bl-add-text {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 18px;\n          margin-left: 10px;\n          ",
        ";\n        }\n      }\n    }\n  }\n\n  .bl-payment-wrap {\n    height: 466px;\n    width: 582px;\n    margin: auto;\n    cursor: pointer;\n  }\n\n  .ch-btn {\n    text-align: center;\n    margin-top: 37px;\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-steps-widget {\n      margin-top: 0;\n    }\n\n    .bl-signUp-text {\n      margin-bottom: 0;\n    }\n\n    .bl-ticket-main-wrap {\n      display: flex;\n      flex-direction: column;\n      margin: 15px 22px;\n\n      .bl-ticket-order {\n        width: 100%;\n        padding: 15px;\n\n        .bl-ticket-order-pills {\n          margin-bottom: 14px;\n\n          .bl-ticket-order-pill {\n            margin-bottom: 8px;\n          }\n        }\n\n        .bl-ticket-order-pay-btn {\n          padding: 12px;\n          width: 100%;\n        }\n      }\n\n      .bl-tickets-wrap {\n        width: 100%;\n        margin-bottom: 20px;\n        margin-right: 0;\n\n        .bl-ticket-item {\n          position: relative;\n          display: flex;\n          width: 100%;\n\n          .bl-ticket-desc {\n            width: 83px;\n            min-width: 83px;\n          }\n\n          .bl-ticket-data {\n            padding: 9px 17px 18px 14px;\n            overflow: hidden;\n            //width: auto;\n            width: 100%;\n            padding-right: 27px;\n\n            .bl-field-1 {\n              margin-top: 12px;\n            }\n\n            .bl-field-2 {\n              margin-top: 21px;\n            }\n\n            .bl-field-1,\n            .bl-field-2 {\n              label {\n                position: relative;\n              }\n\n              span {\n                line-height: 1;\n                position: absolute;\n                background: white;\n                top: -12px;\n                left: 12px;\n              }\n\n              input {\n                height: 30px;\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .bl-payment-wrap {\n      max-width: 100%;\n\n      img {\n        max-width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  @media screen and (min-width: 1057px) and (max-width: 1440px) {\n    .bl-ticket-main-wrap {\n      width: 1057px;\n      margin: auto;\n    }\n  }\n  @media screen and (min-width: 760px) and (max-width: 1057px) {\n    .bl-ticket-main-wrap {\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      width: 519px;\n      margin: auto;\n\n      .bl-tickets-wrap {\n        width: 100%;\n      }\n\n      .bl-ticket-order {\n        width: 100%;\n      }\n    }\n  }\n  @media screen and (min-width: 1440px) {\n    .bl-ticket-main-wrap {\n      max-width: 1080px;\n      margin: auto;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__OrderMainWrap",
    componentId: "sc-88f0c1f1-0"
})(styled_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "16px");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "16px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 10px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/index.tsx














var getInitialTicketData = function() {
    return {
        id: Date.now(),
        fullName: "",
        email: "",
        isGift: false
    };
};
var OrderStageEnum;
(function(OrderStageEnum) {
    OrderStageEnum[OrderStageEnum["order"] = 2] = "order";
    OrderStageEnum[OrderStageEnum["payment"] = 3] = "payment";
    OrderStageEnum[OrderStageEnum["tourOrderOnlySuccess"] = 4] = "tourOrderOnlySuccess";
})(OrderStageEnum || (OrderStageEnum = {}));
var TicketPaymentType;
(function(TicketPaymentType) {
    TicketPaymentType["NoPayment"] = "noPayment";
    TicketPaymentType["Paypal"] = "paypal";
    TicketPaymentType["Stripe"] = "stripe";
    TicketPaymentType["Pelecard"] = "pelecard";
})(TicketPaymentType || (TicketPaymentType = {}));
var Order = function(props) {
    var match = props.match, matterId = props.matterId, tourId = props.tourId, gameId = props.gameId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_ticket = ref.add_a_ticket, add_a_ticket = _add_a_ticket === void 0 ? "Add a ticket" : _add_a_ticket, _sign_up_process = ref.sign_up_process, sign_up_process = _sign_up_process === void 0 ? "Sign up process" : _sign_up_process, _payment = ref.payment, payment = _payment === void 0 ? "Payment" : _payment;
    var history = (0,react_router/* useHistory */.k6)();
    var ref1 = (0,react.useState)(OrderStageEnum.order), orderStage = ref1[0], setOrderStage = ref1[1];
    var ref2 = (0,react.useState)([
        getInitialTicketData()
    ]), participants = ref2[0], setParticipants = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var handleAddTicket = function() {
        return setParticipants((0,_to_consumable_array/* default */.Z)(participants).concat([
            getInitialTicketData()
        ]));
    };
    var handleSetTicketData = function(props) {
        setParticipants(participants.map(function(ticket) {
            if (ticket.id === props.id) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticket), (0,_define_property/* default */.Z)({}, props.target, props.value));
            return ticket;
        }));
    };
    var handleRemoveTicket = function(id) {
        setParticipants(participants.filter(function(ticket) {
            return ticket.id !== id;
        }));
    };
    var handlePaymentSuccess = function() {
        var ref, ref1;
        if (match === null || match === void 0 ? void 0 : (ref = match.params) === null || ref === void 0 ? void 0 : ref.ticketId) history.push("".concat(match === null || match === void 0 ? void 0 : (ref1 = match.params) === null || ref1 === void 0 ? void 0 : ref1.ticketId, "/success"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderMainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                backFunction: orderStage === OrderStageEnum.order ? null : function() {
                    setOrderStage(OrderStageEnum.order);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: orderStage,
                done: orderStage === OrderStageEnum.order ? [
                    1
                ] : [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-signUp-text",
                children: orderStage === OrderStageEnum.order ? sign_up_process : payment
            }),
            orderStage === OrderStageEnum.order ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-main-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-tickets-wrap",
                        children: [
                            participants.map(function(ticket, ticketNum) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserCard, {
                                    ticket: ticket,
                                    ticketNum: ticketNum,
                                    setTicketData: handleSetTicketData,
                                    removeTicket: handleRemoveTicket
                                }, ticket.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-add-ticket-wrap",
                                onClick: handleAddTicket,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-plus",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-plus"
                                        })
                                    }),
                                    participants.length < 50 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-text",
                                        children: add_a_ticket
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                        matterId: matterId,
                        match: match,
                        handlePaymentSuccess: handlePaymentSuccess,
                        participants: participants,
                        setOrderStage: setOrderStage,
                        tourId: tourId,
                        gameId: gameId,
                        setOrderLink: setOrderLink
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-payment-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: orderLink
                })
            })
        ]
    });
};
/* harmony default export */ var pages_Order = ((0,react_router/* withRouter */.EN)(Order));


/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_OrderSuccess; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TicketingButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border: ",
        ";\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n  border-radius: 12px;\n  padding: 16px 30px;\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: initial;\n\n  &:active {\n    ",
        "\n  }\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ETickBtnType;
(function(ETickBtnType) {
    ETickBtnType[ETickBtnType["white"] = 0] = "white";
    ETickBtnType[ETickBtnType["red"] = 1] = "red";
})(ETickBtnType || (ETickBtnType = {}));
var MainWrap = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "TicketingButton__MainWrap",
    componentId: "sc-cf052c43-0"
})(_templateObject(), function(p) {
    return p.type == ETickBtnType.red ? "white" : "#EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "#EA475C" : "white";
}, function(p) {
    return p.type == ETickBtnType.red ? "none" : "2px solid #EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "opacity:0.8;" : "background-color:rgba(234,71,92,0.2);";
}, function(p) {
    return p.type == ETickBtnType.red ? "" : "border:2px solid #EA475C;";
});
var TicketingButton = function(props) {
    var text = props.text, _type = props.type, type = _type === void 0 ? ETickBtnType.red : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainWrap, {
        type: type,
        children: text
    });
};
/* harmony default export */ var components_TicketingButton = (TicketingButton);

// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx

function OrderSuccess_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  .bl-success-block-wrap {\n    background: #ffffff;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n    border-radius: 4px;\n    width: 570px;\n    margin: auto;\n    margin-top: 48px;\n    padding: 71px 37px 38px 37px;\n    position: relative;\n    text-align: center;\n\n    .bl-success-block-triangle {\n      width: 0;\n      height: 0;\n      border-top: 108px solid #ea475c;\n      border-right: 171px solid transparent;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    .bl-success-block-ok-sign {\n      width: 71px;\n      height: 71px;\n      background-color: #ea475c;\n      border-radius: 50%;\n      margin: auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      font-size: 45px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-title {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-text {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 130.3%;\n      margin-bottom: 38px;\n    }\n\n    .bl-success-btns {\n      justify-content: space-between;\n      display: flex;\n      margin: auto;\n      margin-bottom: 40px;\n      width: 426px;\n\n      a {\n        text-decoration: initial;\n      }\n\n      button {\n        min-width: 202px;\n      }\n    }\n\n    .bl-success-block-safety {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      display: flex;\n      align-items: baseline;\n\n      .bl-success-block-safety-icon {\n        margin: 0 10px;\n        border: 1px solid black;\n        border-radius: 50%;\n        width: 28px;\n        height: 28px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-success-block-wrap {\n      display: flex;\n      flex-direction: column;\n      max-width: calc(100% - 30px);\n      margin-left: 15px;\n      margin-right: 15px;\n      padding-top: 36px;\n      padding-bottom: 28px;\n\n      .bl-success-block-triangle {\n        border-top: 73px solid #ea475c;\n        border-right: 116px solid transparent;\n      }\n\n      .bl-success-block-ok-sign {\n        order: 1;\n      }\n\n      .bl-success-block-title {\n        order: 0;\n      }\n\n      .bl-success-block-text {\n        order: 3;\n      }\n\n      .bl-success-block-safety {\n        order: 4;\n      }\n\n      .bl-success-block-safety-icon {\n        min-width: 28px;\n      }\n\n      .bl-success-btns {\n        order: 4;\n        flex-wrap: wrap;\n        justify-content: center;\n\n        button {\n          width: 100%;\n        }\n\n        button:first-child {\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    OrderSuccess_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var OrderSuccess_MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSuccess__MainWrap",
    componentId: "sc-b165c01-0"
})(OrderSuccess_templateObject(), function(p) {
    return p.minimized ? "color:initial;" : "";
});
var OrderSuccess = function(props) {
    var location = props.location, _minimized = props.minimized, minimized = _minimized === void 0 ? false : _minimized, _onLinkClick = props.onLinkClick, onLinkClick = _onLinkClick === void 0 ? function() {} : _onLinkClick;
    var ticketsRes = (0,store/* useRecoilValue */.sJ)(store/* orderedTicketsState */.jF);
    var history = (0,react_router/* useHistory */.k6)();
    ;
    var firstTicket;
    var firstTicketCode;
    if (ticketsRes) {
        var ref;
        firstTicket = ticketsRes === null || ticketsRes === void 0 ? void 0 : (ref = ticketsRes.tickets) === null || ref === void 0 ? void 0 : ref.find(function(t) {
            return t.code;
        });
        firstTicketCode = firstTicket === null || firstTicket === void 0 ? void 0 : firstTicket.code;
    }
    var bookPage = location.pathname.replace(/book.+|book/g, "") + "book";
    if (!firstTicket) {
        react_toastify_esm/* toast.error */.Am.error("No ticket found, redirecting to home page");
        return history.push(bookPage);
    }
    var loginPage = location.pathname.replace(/book.+|book/g, "") + "login?ticket=".concat(firstTicketCode);
    if (firstTicket.type === "gameTour" && ticketsRes.gameId) loginPage.replace("/tour/", "/experience/".concat(ticketsRes.gameId, "/"));
    var ref1 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _payment_confirmed = ref1.payment_confirmed, payment_confirmed = _payment_confirmed === void 0 ? "Payment cofirmed" : _payment_confirmed, _full_transaction_details = ref1.full_transaction_details, full_transaction_details = _full_transaction_details === void 0 ? "The full transaction details will be sending to your Email" : _full_transaction_details, _protect_message = ref1.protect_message, protect_message = _protect_message === void 0 ? "We protect your payment information using encryption to provide bank-level security." : _protect_message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderSuccess_MainWrap, {
        minimized: minimized,
        children: [
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: 3,
                done: [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-success-block-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-triangle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-ok-sign",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-check"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-title",
                        children: payment_confirmed
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-text",
                        children: full_transaction_details
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-btns",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: bookPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: "Book More Tours",
                                    type: ETickBtnType.white
                                })
                            }),
                            firstTicketCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: "Start Tour Now"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-block-safety",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-success-block-safety-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-lock"
                                })
                            }),
                            protect_message
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_OrderSuccess = ((0,react_router/* withRouter */.EN)(OrderSuccess));


/***/ }),

/***/ 70712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getTicketingTypeFromOrderedTicket; },
/* harmony export */   "Z": function() { return /* binding */ initialCurrency; }
/* harmony export */ });
var initialCurrency = [
    {
        id: 1,
        name: "Euro",
        code: "EUR",
        symbol: "\u20AC"
    },
    {
        id: 3,
        name: "US Dollar",
        code: "USD",
        symbol: "$"
    },
    {
        id: 9,
        name: "Israeli New Sheqel",
        code: "ILS",
        symbol: "\u20AA"
    }, 
];
var getTicketingTypeFromOrderedTicket = function(ticketingOrderedTicket) {
    switch(ticketingOrderedTicket.ticketType){
        case "gameTour":
            return "ticketingGameTour";
        case "guidedTour":
            return "ticketingGuidedTour";
        // 'tourByYourself'
        default:
            return "ticketingToursByYourself";
    }
};


/***/ }),

/***/ 84345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DurationType; }
/* harmony export */ });
var DurationType;
(function(DurationType) {
    DurationType["from_login"] = "from_login";
    DurationType["from_purchase"] = "from_purchase";
})(DurationType || (DurationType = {}));


/***/ }),

/***/ 31593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseTour; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var src_inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var src_instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var src_create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.modern.mjs
var index_modern = __webpack_require__(61106);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Sweep.tsx
var Sweep = __webpack_require__(18304);
// EXTERNAL MODULE: ./_models/Tour.tsx + 2 modules
var Tour = __webpack_require__(26978);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/index.ts + 5 modules
var virtualStaging_avatar = __webpack_require__(8267);
;// CONCATENATED MODULE: ./_models/virtualStaging/FRFloor.tsx

var FRFloor = function FRFloor() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,src_class_call_check/* default */.Z)(this, FRFloor);
    this.id = model.id || null;
    this.tourId = model.tourId;
    this.floor = model.floor;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.updatedAt = model.updatedAt;
    this.position = model.position;
    this.sweeps = model.sweeps || [];
};

;// CONCATENATED MODULE: ./_models/virtualStaging/helper.ts
var getAspectRatio = function(src) {
    return new Promise(function(resolve) {
        var img = document.createElement("img");
        img.src = src;
        img.onload = function() {
            img.style.visibility = "hidden";
            document.body.appendChild(img);
            resolve([
                img.clientWidth,
                img.clientHeight
            ]);
            document.body.removeChild(img);
        };
    });
};
/**
 * Calculate x and y in circle's circumference
 * @param {number} r - The circle's radius
 * @param {number} angle - The angle in degrees
 * @param {number} cx - The circle's origin x
 * @param {number} cz - The circle's origin z
 * @returns {Array[number,number]} The calculated x and y
 */ // eslint-disable-next-line class-methods-use-this
var pointsOnCircle2D = function(r, angle, cx, cz) {
    var a = angle * (Math.PI / 180); // convert from degrees to radians
    var x = cx + r * Math.cos(a);
    var z = cz + r * Math.sin(a);
    return [
        x,
        z
    ];
};


// EXTERNAL MODULE: ./_models/virtualStaging/Polygon.tsx
var Polygon = __webpack_require__(59524);
// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./_models/virtualStaging/VideoRenderer.component.tsx









var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var DEFAULT_WIDTH = 1;
// const DEFAULT_RADIUS = 0.1;
var VideoRenderer = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(SceneComponent) {
    "use strict";
    _inherits(VideoRenderer, SceneComponent);
    var _super = _create_super(VideoRenderer);
    function VideoRenderer() {
        _class_call_check(this, VideoRenderer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.plane = null;
        _this.backSidePlane = null;
        _this.playBtn = null;
        _this.muteBtn = null;
        _this.aspect = 1.77;
        _this.aspectHeight = DEFAULT_WIDTH / _this.aspect;
        _this.hasPlayPermission = false;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        _this.destroyButton = function() {};
        _this.inputs = {
            src: null,
            muted: true,
            loop: true,
            autoplay: true,
            visible: true,
            playsInline: true,
            localRotation: {
                x: 0,
                y: 0,
                z: 0
            },
            skipRender: false,
            width: DEFAULT_WIDTH
        };
        _this.outputs = {
            texture: null,
            loadingState: LoadingState.Idle
        };
        var _obj;
        // setting which events are compatible with the component
        _this.events = (_obj = {}, _define_property(_obj, ComponentInteractionType.CLICK, true), _define_property(_obj, ComponentInteractionType.HOVER, true), _define_property(_obj, ComponentInteractionType.DRAG, false), _obj);
        _this.getSize = function() {
            return [
                _this.inputs.width,
                _this.aspectHeight
            ];
        };
        return _this;
    }
    var _proto = VideoRenderer.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.outputs.objectRoot = this.root;
        if (this.inputs.visible) {
            // setting the collider to add the click event
            this.outputs.collider = this.root;
        }
        this.root.add(this.pivot);
    };
    _proto.onInputsUpdated = function onInputsUpdated() {
        try {
            var _this = this;
            if (this.inputs.skipRender) {
                var localRotation = this.inputs.localRotation;
                this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                return;
            }
            this.releaseTexture();
            var THREE = this.context.three;
            if (!this.inputs.src) {
                this.video.src = "";
                this.outputs.loadingState = LoadingState.Idle;
                return;
            }
            this.outputs.loadingState = LoadingState.Loading;
            if (_instanceof(this.inputs.src, HTMLVideoElement)) {
                this.video = this.inputs.src;
            } else {
                this.video = this.createVideoElement();
                if (typeof this.inputs.src === "string") {
                    this.video.src = this.inputs.src;
                } else {
                    this.video.srcObject = this.inputs.src;
                }
                this.video.load();
            }
            var onCanPlay = function() {
                var ref, ref1, ref2;
                var videoElement = _this.video;
                var audioDataNotPresented = (videoElement === null || videoElement === void 0 ? void 0 : videoElement.webkitAudioDecodedByteCount) === 0 || (videoElement === null || videoElement === void 0 ? void 0 : videoElement.mozHasAudio) === false || (videoElement === null || videoElement === void 0 ? void 0 : (ref = videoElement.audioTracks) === null || ref === void 0 ? void 0 : ref.length) === 0;
                if (audioDataNotPresented) {
                    if (_this.destroyButton && typeof _this.destroyButton === "function") {
                        _this.destroyButton();
                    }
                }
                _this.video.removeEventListener("canplaythrough", onCanPlay);
                var _video = _this.video, videoWidth = _video.videoWidth, videoHeight = _video.videoHeight;
                if (!videoWidth || !videoHeight) {
                    // return console.debug('Unable to get video resolution.');
                    throw new Error("Unable to get video resolution.");
                }
                _this.aspect = videoWidth / videoHeight;
                _this.aspectHeight = _this.inputs.width / _this.aspect;
                var geometry = new THREE.PlaneGeometry(_this.inputs.width, _this.aspectHeight);
                // TODO: finish with rounded rectangle
                // https://threejs.org/examples/#webgl_geometry_shapes - rounded rect shape
                // const geometry = this.makeRoundedRect(
                //   0,
                //   0,
                //   this.inputs.width,
                //   this.aspectHeight,
                //   this.inputs.useRadius ? DEFAULT_RADIUS : 0,
                // );
                _this.texture = new THREE.VideoTexture(_this.video);
                _this.texture.encoding = THREE.sRGBEncoding;
                _this.texture.minFilter = THREE.LinearFilter;
                _this.texture.magFilter = THREE.LinearFilter;
                _this.texture.format = THREE.RGBAFormat;
                _this.texture.wrapS = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                _this.texture.wrapT = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                _this.texture.repeat.set(1, 1);
                var material = new THREE.MeshBasicMaterial({
                    map: _this.texture,
                    blending: THREE.NormalBlending,
                    transparent: true,
                    visible: _this.inputs.visible
                });
                var backSideMaterial = new THREE.MeshBasicMaterial({
                    side: THREE.DoubleSide,
                    color: 0x000000,
                    transparent: false,
                    visible: _this.inputs.visible,
                    polygonOffset: true,
                    polygonOffsetUnits: -4
                });
                _this.plane = new THREE.Mesh(geometry, material);
                (ref1 = _this.pivot) === null || ref1 === void 0 ? void 0 : ref1.add(_this.plane);
                // fixing plane the position
                // this.plane.position.set(
                //   -((this.inputs.width * this.aspect) / 2),
                //   -(this.aspectHeight / 2),
                //   0,
                // );
                // this.plane.scale.set(
                //   this.aspect,
                //   1,
                //   1,
                // );
                _this.backSidePlane = new THREE.Mesh(geometry, backSideMaterial);
                _this.backSidePlane.position.set(0, 0, -0.01);
                (ref2 = _this.pivot) === null || ref2 === void 0 ? void 0 : ref2.add(_this.backSidePlane);
                // fixing plane the position
                // this.backSidePlane.position.set(
                //   -((this.inputs.width * this.aspect) / 2),
                //   -(this.aspectHeight / 2),
                //   -0.01,
                // );
                var localRotation = _this.inputs.localRotation;
                _this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                _this.outputs.texture = _this.texture;
                _this.outputs.loadingState = LoadingState.Loaded;
                if (_this.inputs.autoplay) {
                    var _this1 = _this;
                    var interval = setInterval(_async_to_generator(regeneratorRuntime.mark(function _callee() {
                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    _ctx.next = 3;
                                    return _this1.video.play();
                                case 3:
                                    clearInterval(interval);
                                    _ctx.next = 9;
                                    break;
                                case 6:
                                    _ctx.prev = 6;
                                    _ctx.t0 = _ctx["catch"](0);
                                    ;
                                case 9:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                6
                            ]
                        ]);
                    })), 1000);
                }
            };
            var onError = function() {
                _this.video.removeEventListener("error", onError);
                _this.outputs.loadingState = LoadingState.Error;
            };
            this.video.addEventListener("canplaythrough", onCanPlay);
            this.video.addEventListener("error", onError);
            if (DeviceManager.isIOS()) {
                var _this1 = this;
                this.video.addEventListener("pause", function() {
                    // mute and play the video in case the browser stopped it
                    // i.e. Safari stops the video if the other one was unmuted
                    if (_this1.video.paused && _this1.hasPlayPermission) {
                        _this1.toggleMute();
                    }
                }, false);
            }
        } catch (e) {
            ;
            this.outputs.loadingState = LoadingState.Error;
        }
    };
    _proto.onDestroy = function onDestroy() {
        this.releaseTexture();
        if (this.playBtn) {
            var ref;
            (ref = this.playBtn.parent) === null || ref === void 0 ? void 0 : ref.remove(this.playBtn);
            this.playBtn.material.dispose();
            this.playBtn.geometry.dispose();
            this.playBtn = null;
        }
        if (this.muteBtn) {
            var ref1;
            (ref1 = this.muteBtn.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.muteBtn);
            this.muteBtn.material.dispose();
            this.muteBtn.geometry.dispose();
            this.muteBtn = null;
        }
    };
    _proto.isMuted = function isMuted() {
        return this.video.muted;
    };
    _proto.toggleMute = function toggleMute(muted) {
        var value = typeof muted === "boolean" ? muted : !this.video.muted;
        if (!this.video) return;
        this.video.muted = value;
        if (DeviceManager.isIOS() && !value && !this.hasPlayPermission) {
            // Safari support the autoplay unmute only after user interacts with Treedis website (not iframe)
            // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
            var overlay = document.createElement("div");
            overlay.setAttribute("id", "video-overlay");
            overlay.style.width = "100vw";
            overlay.style.height = "100vh";
            overlay.style.zIndex = "9999";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            var _this = this;
            var handler = function() {
                var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                    var hasOverlay;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                hasOverlay = document.getElementById("video-overlay");
                                if (hasOverlay) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 3:
                                document.body.removeChild(overlay);
                                overlay.removeEventListener("click", handler);
                                overlay.removeEventListener("mouseup", handler);
                                overlay.removeEventListener("mousemove", handler);
                                overlay.removeEventListener("touchstart", handler);
                                overlay.removeEventListener("touchmove", handler);
                                _this.hasPlayPermission = true;
                                _ctx.next = 12;
                                return _this.video.play();
                            case 12:
                                // in case with iOS Safari browser, the video is muted at the moment (read the link below)
                                // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
                                //
                                // so, we need to unmute it and display the current state
                                _this.video.muted = false;
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function handler() {
                    return _ref.apply(this, arguments);
                };
            }();
            overlay.addEventListener("click", handler);
            overlay.addEventListener("mousedown", handler);
            overlay.addEventListener("mousemove", handler);
            overlay.addEventListener("touchstart", handler);
            overlay.addEventListener("touchmove", handler);
            document.body.append(overlay);
        } else {
            this.video.play().catch(function(e) {
                ;
            });
        }
    };
    _proto.releaseTexture = function releaseTexture() {
        if (this.texture) {
            this.outputs.texture = null;
            this.outputs.loadingState = LoadingState.Idle;
            this.texture.dispose();
        }
        if (this.video) {
            this.video.pause();
            this.video.src = "";
        }
        if (this.plane) {
            var ref;
            (ref = this.plane.parent) === null || ref === void 0 ? void 0 : ref.remove(this.plane);
            this.plane.material.dispose();
            this.plane.geometry.dispose();
            this.plane = null;
        }
        if (this.backSidePlane) {
            var ref1;
            (ref1 = this.backSidePlane.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.backSidePlane);
            this.backSidePlane.material.dispose();
            this.backSidePlane.geometry.dispose();
            this.backSidePlane = null;
        }
    };
    _proto.createVideoElement = function createVideoElement() {
        var _inputs = this.inputs, muted = _inputs.muted, loop = _inputs.loop, autoplay = _inputs.autoplay, playsInline = _inputs.playsInline;
        var video = document.createElement("video");
        video.crossOrigin = "anonymous";
        video.autoplay = Boolean(autoplay);
        video.muted = Boolean(muted);
        video.loop = Boolean(loop);
        video.playsInline = Boolean(playsInline);
        return video;
    };
    return VideoRenderer;
}(SceneComponent)));
var videoRendererType = "treedis.videoRenderer";
function makeVideoRenderer() {
    return new VideoRenderer();
}

// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
// EXTERNAL MODULE: ./_models/virtualStaging/LoadingQueue.ts + 1 modules
var LoadingQueue = __webpack_require__(44041);
;// CONCATENATED MODULE: ./_models/virtualStaging/VSSettings.tsx

var VSSettings = function VSSettings() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,src_class_call_check/* default */.Z)(this, VSSettings);
    this.id = model.id;
    this.tourId = model.tourId;
    this.ambientLight = model.ambientLight || 9.5;
    this.pointLight = model.pointLight || 33;
    this.lightHeight = model.lightHeight || 15;
    this.shadowIntensity = model.shadowIntensity >= 0 ? model.shadowIntensity : 0.2;
    this.lightAngle = model.lightAngle || 0;
    this.updatedAt = model.updatedAt;
};

;// CONCATENATED MODULE: ./components/util/sdk/mattertag/data.ts



/**
 * Merge tags from matterport and treedis
 * @param matterTags
 * @param treedisTags
 */ var getAllTags = function(matterTags, treedisTags) {
    var allTags = new Map();
    var matterTagsArray = [];
    matterTags.forEach(function(t) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var index = treedisTags.findIndex(function(item) {
            return t.sid === (item === null || item === void 0 ? void 0 : item.sid);
        });
        var found = index === -1 ? null : treedisTags[index];
        var media;
        if (t.media) {
            media = t.media;
        }
        var tag = Object.assign(cloneDeep_default()(found) || {}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: found && found.title && found.title.length ? found.title : t.label,
            positionX: (found === null || found === void 0 ? void 0 : found.positionX) ? found.positionX : t === null || t === void 0 ? void 0 : (ref = t.position) === null || ref === void 0 ? void 0 : ref.x,
            positionY: (found === null || found === void 0 ? void 0 : found.positionY) ? found.positionY : t === null || t === void 0 ? void 0 : (ref1 = t.position) === null || ref1 === void 0 ? void 0 : ref1.y,
            positionZ: (found === null || found === void 0 ? void 0 : found.positionZ) ? found.positionZ : t === null || t === void 0 ? void 0 : (ref2 = t.position) === null || ref2 === void 0 ? void 0 : ref2.z,
            stemVectorX: (found === null || found === void 0 ? void 0 : found.stemVectorX) && (found === null || found === void 0 ? void 0 : found.svXEnabled) ? found.stemVectorX : (t === null || t === void 0 ? void 0 : (ref3 = t.stem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.direction) === null || ref4 === void 0 ? void 0 : ref4.x) || 0,
            stemVectorY: (found === null || found === void 0 ? void 0 : found.stemVectorY) && (found === null || found === void 0 ? void 0 : found.svYEnabled) ? found.stemVectorY : (t === null || t === void 0 ? void 0 : (ref5 = t.stem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.direction) === null || ref6 === void 0 ? void 0 : ref6.y) || 0.3,
            stemVectorZ: (found === null || found === void 0 ? void 0 : found.stemVectorZ) && (found === null || found === void 0 ? void 0 : found.svZEnabled) ? found.stemVectorZ : (t === null || t === void 0 ? void 0 : (ref7 = t.stem) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.direction) === null || ref8 === void 0 ? void 0 : ref8.z) || 0,
            iconColor: found ? found.iconColor : t.color,
            opacity: found ? found.opacity : 100,
            mpTitle: found ? found.mpTitle : true,
            mpTooltip: found ? found.mpTooltip : true,
            mpNavigation: found ? found.mpNavigation : true,
            whiteCircle: found ? found.whiteCircle : false,
            transparentBackground: found ? found.transparentBackground : false,
            id: (found === null || found === void 0 ? void 0 : found.id) || t.sid
        }, t), {
            media: media,
            description: (found === null || found === void 0 ? void 0 : (ref9 = found.description) === null || ref9 === void 0 ? void 0 : ref9.length) ? found.description : t.description,
            enabled: found && typeof found.enabled === "boolean" ? found.enabled : false,
            icon: found ? found.icon : false
        }));
        if (found) {
            tag.modifiedTag = true; //flag that tag has been modified through treedis
        } else {
            matterTagsArray.push(tag);
        }
        treedisTags[index] = tag;
    });
    treedisTags.concat(matterTagsArray).forEach(function(tag) {
        allTags.set(tag.sid, cloneDeep_default()(tag));
    });
    return allTags;
};

;// CONCATENATED MODULE: ./components/util/sdk/mattertag/index.ts


var matterTags = new Map();
var Mattertag = function Mattertag() {
    "use strict";
    (0,src_class_call_check/* default */.Z)(this, Mattertag);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
Mattertag.subscribe = function(param, subscriber) {
    var mpSdk = param.mpSdk, mpTags = param.mpTags, treedisTags = param.treedisTags;
    if (!mpTags) return;
    // eslint-disable-next-line array-callback-return
    Object.keys(mpTags).map(function(idx) {
        matterTags.set(idx, mpTags[idx]);
    });
    var matterportTags = Object.values(mpTags);
    var allTags = getAllTags(matterportTags, treedisTags);
    subscriber(allTags);
// let addedMatterportTags = false;
// mpSdk.Mattertag.data.subscribe({
//   onAdded: (idx, item) => {
//     if (addedMatterportTags) {
//       // Added Transient Tag
//     } else {
//       // Added Matterport Tag
//       matterTags.set(idx, item);
//     }
//   },
//   onCollectionUpdated: (collection) => {
//     if (addedMatterportTags) return;
//     // Matterport tags finished initially adding
//     addedMatterportTags = true;
//     const matterportTags = Object.values(collection);
//     const allTags = getAllTags(matterportTags, treedisTags);
//     subscriber(allTags);
//   },
// });
};
Mattertag.getMatterTags = function() {
    return matterTags;
};

// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
// EXTERNAL MODULE: ./utils/index.ts + 6 modules
var utils = __webpack_require__(9163);
// EXTERNAL MODULE: ./components/common/CookieConsent.tsx
var CookieConsent = __webpack_require__(72789);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
// EXTERNAL MODULE: ./components/util/index.ts + 3 modules
var util = __webpack_require__(99351);
// EXTERNAL MODULE: ./api/TreedisAdminDAO.ts
var TreedisAdminDAO = __webpack_require__(83680);
// EXTERNAL MODULE: ./_models/eCommerce/Product.ts
var Product = __webpack_require__(55348);
;// CONCATENATED MODULE: ./components/tour/preparePolygonResponse.ts


var preparePolygonResponse = function(polygons, products) {
    return (polygons || []).map(function(item) {
        return new Polygon/* Polygon */.mg(item);
    }).filter(function(param) {
        var product = param.product;
        return !product || product && products.some(function(item) {
            return item.id === (product === null || product === void 0 ? void 0 : product.id) && item.status === Product.ProductStatus.ACTIVE;
        });
    });
};

;// CONCATENATED MODULE: ./api/queries.ts










var getFloorPlans = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisPublicDAO/* default.getFloorPlans */.Z.getFloorPlans({
                        id: id
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : res.floorPlans) || []);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFloorPlans(id) {
        return _ref.apply(this, arguments);
    };
}();
var getDuplicates = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(id);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : res.duplicates) || []);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getDuplicates(id) {
        return _ref.apply(this, arguments);
    };
}();
var getPolygons = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(slug) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisAdminDAO/* default.getPolygons */.Z.getPolygons(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPolygons(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweeps = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(matterId, slug) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (matterId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 2:
                    _ctx.next = 4;
                    return TreedisPublicDAO/* default.getSweeps */.Z.getSweeps({
                        matterId: matterId,
                        slug: slug
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : res.sweeps) || []);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSweeps(matterId, slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSObjects = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisAdminDAO/* default.getTourVSObjects */.Z.getTourVSObjects(id);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.tourVSObjects);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSObjects(id) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSImages = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(slug) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisAdminDAO/* default.getTourVSImages */.Z.getTourVSImages(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.tourVSImages);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSImages(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSVideos = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(slug) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisAdminDAO/* default.getTourVSVideos */.Z.getTourVSVideos(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSVideos(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSSettings = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return TreedisAdminDAO/* default.getVSSettings */.Z.getVSSettings(id);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.vsSettings);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSSettings(id) {
        return _ref.apply(this, arguments);
    };
}();
var getProducts = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tourId, userId) {
        var Product, ref, productsResponse, variantsResponse, mediasResponse, variants, medias;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55348)).then(function(res) {
                        return res.Product;
                    });
                case 2:
                    Product = _ctx.sent;
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 6;
                    return Promise.all([
                        TreedisPublicDAO/* default.getProducts */.Z.getProducts({
                            query: {
                                tourId: tourId
                            }
                        }),
                        TreedisPublicDAO/* default.getVariantsByTour */.Z.getVariantsByTour({
                            query: {
                                userId: userId,
                                tourId: tourId
                            }
                        }),
                        TreedisPublicDAO/* default.getMediaByTour */.Z.getMediaByTour({
                            query: {
                                userId: userId,
                                tourId: tourId
                            }
                        }), 
                    ]);
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    productsResponse = ref[0];
                    variantsResponse = ref[1];
                    mediasResponse = ref[2];
                    if (!((productsResponse === null || productsResponse === void 0 ? void 0 : productsResponse.status) !== 200)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 13:
                    variants = (variantsResponse === null || variantsResponse === void 0 ? void 0 : variantsResponse.status) === 200 ? variantsResponse.data : {};
                    medias = (mediasResponse === null || mediasResponse === void 0 ? void 0 : mediasResponse.status) === 200 ? mediasResponse.data : {};
                    return _ctx.abrupt("return", ((productsResponse === null || productsResponse === void 0 ? void 0 : productsResponse.data) || []).map(function(product) {
                        return new Product((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                            variants: Object.keys(variants).length && variants[product.id] ? variants[product.id] : [],
                            media: Object.keys(medias).length && medias[product.id] ? medias[product.id] : []
                        }));
                    }));
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getProducts(tourId, userId) {
        return _ref.apply(this, arguments);
    };
}();
var getVSItems = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isMatterportLink, param) {
        var slug, id, userId, tourType, ref, polygons, vsObjectsRes, vsImages, vsSettings, tourVideosData, products, tourVideos, tourImages, vsObjects;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    slug = param.slug, id = param.id, userId = param.userId, tourType = param.tourType;
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 4;
                    return Promise.all([
                        !isMatterportLink ? getPolygons(slug) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSObjects(id) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSImages(slug) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSSettings(id) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSVideos(slug) : Promise.resolve(null),
                        tourType === "ecommerce" ? getProducts(id, userId) : []
                    ]);
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 6);
                    polygons = ref[0];
                    vsObjectsRes = ref[1];
                    vsImages = ref[2];
                    vsSettings = ref[3];
                    tourVideosData = ref[4];
                    products = ref[5];
                    tourVideos = (tourVideosData || []).map(function(item) {
                        return new VSObject/* TourVideo */.Up(item);
                    });
                    tourImages = (vsImages === null || vsImages === void 0 ? void 0 : vsImages.map(function(item) {
                        return new VSObject/* TourImage */.oP(item);
                    })) || [];
                    vsObjects = (vsObjectsRes || []).map(function(item) {
                        return new VSObject/* TourObject */.zB(item);
                    }).concat(tourImages).concat(tourVideos);
                    return _ctx.abrupt("return", {
                        polygons: polygons ? preparePolygonResponse(polygons, products) : [],
                        products: products,
                        vsSettings: new VSSettings(vsSettings || {}),
                        vsObjects: vsObjects
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getVSItems(isMatterportLink, _) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./units/index.ts + 33 modules
var units = __webpack_require__(85591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(62087);
;// CONCATENATED MODULE: ./units/Icon/Sketchfab.tsx




var Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.296387",
                width: "16",
                height: "16",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            href: "#image0_1713_109817",
                            transform: "scale(0.0005)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1713_109817",
                        width: "2000",
                        height: "2000",
                        href: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Sketchfab = (Icon);

// EXTERNAL MODULE: ./components/tour/regular/bottomBar/SoundVolumeControls.tsx
var SoundVolumeControls = __webpack_require__(27096);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/ReelVideo/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  video {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    object-fit: cover;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  z-index: 1;\n\n  p {\n    font-size: 18px;\n    color: #fff;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Root",
    componentId: "sc-b9315996-0"
})(_templateObject());
var NameContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__NameContainer",
    componentId: "sc-b9315996-1"
})(_templateObject1());
var Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    displayName: "styles__Video",
    componentId: "sc-b9315996-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/ReelVideo/index.tsx



function ReelVideo(param) {
    var track = param.track, name = param.name, enabled = param.enabled;
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        try {
            var el = ref.current;
            if (el && !el.src && track && typeof track.attach === "function") {
                //attach only if no media is attached, don't reattach. Find better way to handle it
                el.muted = true;
                ;
                track.attach(el);
            }
            return function() {
                ;
                if (track && typeof track.detach === "function") {
                    track.detach(el);
                }
            };
        } catch (err) {
            ;
        }
    }, [
        track
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                ref: ref,
                style: {
                    visibility: enabled ? "visible" : "hidden"
                }
            }),
            !enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(NameContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: name
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  position: absolute;\n  left: 0;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n  overflow-y: hidden;\n  z-index: 1000;\n  padding: 12px 6px;\n\n  ",
        "\n\n  &::-webkit-scrollbar-track {\n    background: var(--color-primary);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    background: var(--color-secondary);\n  }\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: var(--scroll-bar-size);\n    background: var(--color-primary);\n  }\n\n  @media screen and (max-width: 768px) {\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 160px;\n  height: 100%;\n  margin: 0 6px;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #000;\n  background-color: rgba(0, 0, 0, 0.7);\n\n  .loader {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: #fff;\n    z-index: 0;\n\n    span {\n      background: none;\n      animation: rotate 1s linear infinite;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n    }\n    p {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      padding-top: 20px;\n      text-align: center;\n    }\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n  padding: 4px 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n\n  span {\n    width: 100%;\n    font-size: 12px;\n    text-align: start;\n    margin-left: 5px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  i {\n    font-size: 11px;\n    cursor: pointer;\n    margin: 0 2px;\n    min-width: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Root",
    componentId: "sc-999e4be3-0"
})(styles_templateObject(), function(param) {
    var show = param.show;
    return show ? "\n        height: 150px;\n        top: 0;\n        transition: top, height 0.3s ease;\n      " : "\n        height: 0;\n        top: 150px;\n        transition: top 0s ease 0.3s, height 0.3s ease;\n      ";
});
var Reels = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Reels",
    componentId: "sc-999e4be3-1"
})(styles_templateObject1());
var Reel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Reel",
    componentId: "sc-999e4be3-2"
})(styles_templateObject2());
var Bar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Bar",
    componentId: "sc-999e4be3-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/index.tsx




var ReelVideoBar = function(props) {
    var show = props.show, videos = props.videos, host = props.host, onMuteClick = props.onMuteClick, onFullscreenClick = props.onFullscreenClick, onPinClick = props.onPinClick;
    var reelRef = (0,react.useRef)(null);
    var ref = (0,react.useState)([]), reel = ref[0], setReel = ref[1];
    var scrollHorizontally = (0,react.useCallback)(function(e) {
        if (reelRef === null || reelRef === void 0 ? void 0 : reelRef.current) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
            reelRef.current.scrollLeft -= delta * 10;
            e.preventDefault();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (videos !== reel) {
            setReel(videos);
        }
    }, [
        reel,
        videos
    ]);
    (0,react.useEffect)(function() {
        var ref = reelRef === null || reelRef === void 0 ? void 0 : reelRef.current;
        if (ref) {
            ref.addEventListener("DOMMouseScroll", scrollHorizontally, false);
            ref.addEventListener("mousewheel", scrollHorizontally, false);
        }
        return function() {
            if (ref) {
                ref.removeEventListener("DOMMouseScroll", scrollHorizontally);
                ref.removeEventListener("mousewheel", scrollHorizontally);
            }
        };
    }, [
        scrollHorizontally
    ]);
    var handleMuteClick = (0,react.useCallback)(function(item) {
        return function() {
            if (host) {
                onMuteClick(item.sid);
            }
        };
    }, [
        onMuteClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Root, {
        show: show,
        ref: reelRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reels, {
            children: reel.map(function(item, i) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Reel, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelVideo, {
                            track: item.track,
                            enabled: item.enabled,
                            name: item.name
                        }, ((ref = item.track) === null || ref === void 0 ? void 0 : ref.id) || item.sid),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.enabled || item.joining ? item.name : ""
                                }),
                                !item.self && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: item.muted ? "fas fa-microphone-slash microphone off" : "fas fa-microphone microphone on",
                                    onClick: handleMuteClick(item)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: item.fullscreen ? "fas fa-compress" : "fas fa-expand",
                                    onClick: function() {
                                        onFullscreenClick(item);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "far fa-circle",
                                    onClick: function() {
                                        return onPinClick(item);
                                    }
                                })
                            ]
                        })
                    ]
                }, item.sid);
            })
        })
    });
};
/* harmony default export */ var bottomBar_ReelVideoBar = (ReelVideoBar);

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/CustomReel.tsx







var CustomReel = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(CustomReel, Component);
    var _super = (0,src_create_super/* default */.Z)(CustomReel);
    function CustomReel(props) {
        (0,src_class_call_check/* default */.Z)(this, CustomReel);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            reelStep: -1,
            reel: []
        };
        _this.scrollHorizontally = _this.scrollHorizontally.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = CustomReel.prototype;
    _proto.scrollHorizontally = function scrollHorizontally(e) {
        if (this.reel) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
            this.reel.scrollLeft -= delta * 10; // Multiplied by 40
            e.preventDefault();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.reel) {
            this.reel.addEventListener("DOMMouseScroll", this.scrollHorizontally, false);
            this.reel.addEventListener("mousewheel", this.scrollHorizontally, false);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _state = this.state, reelStep = _state.reelStep, reel = _state.reel;
        var _props = this.props, loadModel = _props.loadModel, tourId = _props.tourId, _isBlackBackground = _props.isBlackBackground, isBlackBackground = _isBlackBackground === void 0 ? true : _isBlackBackground;
        var filteredReel = reel.filter(function(r) {
            return !r.hide;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "reel-bar",
            ref: function(e) {
                _this.reel = e;
            },
            className: classnames_default()({
                white: !isBlackBackground
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "scroll-div reels-block",
                style: {
                    width: "".concat(170 * filteredReel.length, "px")
                },
                children: filteredReel.map(function(p, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: function() {
                            if (p.url || p.tag || p.panoramaId) loadModel(p.title, p.url, p.type, p.tag, p.panoramaId);
                            _this.setState({
                                reelStep: i
                            });
                        },
                        className: reelStep === i ? "preview active" : "preview",
                        style: p.imageId ? {
                            backgroundImage: "url(".concat("https://cdn.treedis.com", "/tours/").concat(tourId, "/images/").concat(p.image.url, ")")
                        } : {},
                        children: [
                            p.type === "matterport" || p.type === "matterport-instant" || p.type === "treedis" && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-walking"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: p.title
                            })
                        ]
                    }, i);
                })
            })
        });
    };
    CustomReel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.reel !== prevState.reel) {
            return {
                reelStep: -1,
                reel: nextProps.reel
            };
        }
        return {};
    };
    return CustomReel;
}(react.Component);


// EXTERNAL MODULE: ./components/tour/regular/bottomBar/Reel.tsx
var bottomBar_Reel = __webpack_require__(18621);
;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/BottomBar.tsx











// eslint-disable-next-line no-use-before-define















var MReelVideoBar = /*#__PURE__*/ (0,react.memo)(bottomBar_ReelVideoBar);
var BottomBar = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(BottomBar, Component);
    var _super = (0,src_create_super/* default */.Z)(BottomBar);
    function BottomBar(props) {
        (0,src_class_call_check/* default */.Z)(this, BottomBar);
        var _this;
        _this = _super.call(this, props);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getSetting = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(setting) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return _this1.props.showcase.Settings.get(setting);
                        case 3:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                        case 9:
                            return _ctx.abrupt("return", null);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(setting) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeFloor = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(index) {
                var _all, changeFloor, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _all = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            try {
                                changeFloor = _this2.props.changeFloor;
                                changeFloor(index, _all);
                                _this2.setState({
                                    showFloorsModal: false
                                });
                            } catch (err) {
                                ;
                            }
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(index) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.filterReel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(categoryId) {
                var reels;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            reels = _this3.state.reels;
                            reels = reels.map(function(r) {
                                r.hide = false;
                                if (r.categoryId !== categoryId && _this3.state.activeCategory !== categoryId) {
                                    r.hide = true;
                                }
                                return r;
                            });
                            _this3.setState({
                                reels: reels,
                                activeCategory: _this3.state.activeCategory !== categoryId ? categoryId : null
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(categoryId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.createLockScreen = function() {
            var lock = document.createElement("div");
            lock.id = "video-lock-screen";
            lock.setAttribute("style", "position: fixed; height: 100vh; width: 100vw; top: 0; left: 0; z-index: 1000");
            document.body.append(lock);
        };
        _this.removeLockScreen = function() {
            if (document.getElementById("video-lock-screen")) {
                document.getElementById("video-lock-screen").remove();
            }
        };
        _this.videoInit = function() {
            var tour = _this.state.tour;
            if (tour.videoUrl && tour.autoplayVideo) {
                _this.createLockScreen();
                _this.playVideo();
                if (deviceManager["default"].supportsTouch()) {
                    _this.videoEventListener = document.addEventListener("touchstart", function() {
                        _this.playVideo();
                        _this.removeLockScreen();
                    }, {
                        once: true
                    });
                } else {
                    _this.videoEventListener = document.addEventListener("click", function() {
                        _this.playVideo();
                        _this.removeLockScreen();
                    }, {
                        once: true
                    });
                }
            }
        };
        _this.capitalizeFirstLetter = function(str) {
            if (!str) return null;
            return str.charAt(0).toUpperCase() + str.slice(1);
        };
        _this.playVideo = function() {
            _this.props.onStartVideo();
            _this.setState({
                youtubeOn: true
            });
        };
        _this.showVolumeControls = function() {
            var showVolumeControls = _this.state.showVolumeControls;
            _this.setState({
                showVolumeControls: !showVolumeControls
            });
        };
        _this.updatePlayOrPause = function() {
            var mainPlaying = _this.state.mainPlaying;
            _this.setState({
                mainPlaying: !mainPlaying
            });
        };
        var _props = _this.props, tour = _props.tour, mainPlaying = _props.mainPlaying;
        _this.state = {
            tour: tour,
            floorplan: false,
            dollhouse: false,
            measurements: false,
            activeCategory: null,
            floorPlans: [],
            reels: [],
            reelCategories: [],
            reelOpen: false,
            showActionsModal: tour.autoplayVideo || tour.autoplayMusic && tour.music,
            showFloorsModal: false,
            duplicates: [],
            showLanguagesModal: false,
            showVolumeControls: false,
            showVideoReel: false,
            mainPlaying: mainPlaying,
            pdfList: false,
            cameraList: false,
            youtubeOn: false,
            restrictedReels: [],
            minimapVisible: tour.minimap && tour.minimapVisible && !props.room && window.innerWidth > 768
        };
        return _this;
    }
    var _proto = BottomBar.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, _props, tour, allowedTours, measurements, dollhouse, floorplan, reelOpen, floorPlans, initialDuplicates, reelsRes, duplicates, reels, newrestrictedReels;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _props = _this.props, tour = _props.tour, allowedTours = _props.allowedTours;
                        _ctx.next = 4;
                        return _this.getSetting("measurements");
                    case 4:
                        measurements = _ctx.sent;
                        _ctx.t0 = tour.addon_dh;
                        if (!_ctx.t0) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 9;
                        return _this.getSetting("dollhouse");
                    case 9:
                        _ctx.t0 = _ctx.sent;
                    case 10:
                        dollhouse = _ctx.t0;
                        _ctx.next = 13;
                        return _this.getSetting("floor_plan");
                    case 13:
                        floorplan = _ctx.sent;
                        reelOpen = false;
                        if (tour.addon_hl === 0 || tour.addon_hl === 1) reelOpen = true;
                        if (!tour.floorPlansEnabled) {
                            _ctx.next = 21;
                            break;
                        }
                        _ctx.next = 19;
                        return getFloorPlans(_this.props.tour.id);
                    case 19:
                        floorPlans = _ctx.sent;
                        _this.setState({
                            floorPlans: floorPlans
                        });
                    case 21:
                        _ctx.t1 = (ref = _this.props) === null || ref === void 0 ? void 0 : ref.initialDuplicates;
                        if (_ctx.t1) {
                            _ctx.next = 26;
                            break;
                        }
                        _ctx.next = 25;
                        return getDuplicates(tour.parentId || tour.id);
                    case 25:
                        _ctx.t1 = _ctx.sent;
                    case 26:
                        initialDuplicates = _ctx.t1;
                        ;
                        if (!tour.reel) {
                            _ctx.next = 32;
                            break;
                        }
                        _ctx.next = 31;
                        return TreedisPublicDAO/* default.getReels */.Z.getReels(tour.id);
                    case 31:
                        reelsRes = _ctx.sent;
                    case 32:
                        duplicates = initialDuplicates.filter(function(d) {
                            return d === null || d === void 0 ? void 0 : d.language;
                        });
                        reels = (reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.reels) || [];
                        newrestrictedReels = [];
                        reelsRes = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reelsRes), {
                            reels: tour.ticket === true ? reels.filter(function(reel) {
                                if (reel.type !== "treedis" || reel.url == null) return true;
                                var reelURL = new URL(reel.url);
                                var splittedPath = reelURL.pathname.split("/");
                                if (splittedPath[1] === "tour") {
                                    if (Array.isArray(allowedTours) && (0,_to_consumable_array/* default */.Z)(allowedTours).concat([
                                        tour.slug
                                    ]).includes(splittedPath[2])) return true;
                                    newrestrictedReels.push(reel);
                                } else return true;
                                return false;
                            }) : reels
                        });
                        _this.setState({
                            duplicates: duplicates,
                            measurements: measurements,
                            dollhouse: dollhouse,
                            floorplan: floorplan,
                            reelOpen: reelOpen,
                            restrictedReels: newrestrictedReels,
                            reels: reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.reels,
                            reelCategories: reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.categories
                        }, function() {
                            if (tour.addon_hl === 0) {
                                _this.videoInitTimeout = setTimeout(function() {
                                    _this.setState({
                                        reelOpen: false
                                    });
                                }, 4000);
                            }
                            _this.videoInit();
                        });
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var ref, ref1, ref2;
        var _props = this.props, mainPlaying = _props.mainPlaying, otherPlaying = _props.otherPlaying;
        if (prevProps.mainPlaying !== mainPlaying || prevProps.otherPlaying !== otherPlaying) {
            if (mainPlaying || otherPlaying) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    youtubeOn: false
                });
            }
        }
        var minimap = document.getElementById("minimap");
        var tourHasAReel = this.state.tour.reel || this.state.tour.mpReel;
        if (tourHasAReel && minimap && prevState.reelOpen !== this.state.reelOpen) {
            if (this.state.reelOpen) {
                minimap.classList.add("reel-open");
            } else minimap.classList.remove("reel-open");
        }
        if (!this.state.showVideoReel && !prevState.reelVideos && ((ref = this.props.reelVideos) === null || ref === void 0 ? void 0 : ref.length) > 0 || !this.state.showVideoReel && prevState.reelVideos && prevState.reelVideos.length !== ((ref1 = this.props.reelVideos) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                reelVideos: this.props.reelVideos,
                reelOpen: true,
                showVideoReel: true
            });
            if (this.videoInitTimeout) {
                clearTimeout(this.videoInitTimeout);
            }
        }
        if (this.state.showVideoReel && this.state.reelOpen && ((ref2 = this.props.reelVideos) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
            this.setState({
                showVideoReel: false,
                reelOpen: false,
                reelVideos: []
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("touchstart", this.videoEventListener);
        document.removeEventListener("click", this.videoEventListener);
        clearInterval(this.videoInitTimeout);
    };
    _proto.render = function render() {
        var _this = this;
        var ref;
        var _state = this.state, showActionsModal = _state.showActionsModal, showFloorsModal = _state.showFloorsModal, showLanguagesModal = _state.showLanguagesModal, floorPlans = _state.floorPlans, minimapVisible = _state.minimapVisible, dollhouse = _state.dollhouse, floorplan = _state.floorplan, measurements = _state.measurements, tour = _state.tour, duplicates = _state.duplicates, reels = _state.reels, reelCategories = _state.reelCategories, showVolumeControls = _state.showVolumeControls, restrictedReels = _state.restrictedReels, showVideoReel = _state.showVideoReel;
        var _props = this.props, mainPlaying = _props.mainPlaying, reelStep = _props.reelStep, onHelpClick = _props.onHelpClick, onTermsClick = _props.onTermsClick, openShare = _props.openShare, changeFull = _props.changeFull, moveToStep = _props.moveToStep, tourPlaying = _props.tourPlaying, sharePopupOn = _props.sharePopupOn, changeViewMode = _props.changeViewMode, measurementsMode = _props.measurementsMode, showPanorama = _props.showPanorama, showMinimapClick = _props.showMinimapClick, showPanoramaClick = _props.showPanoramaClick, loadModel = _props.loadModel, playTour = _props.playTour, mesurementsOn = _props.mesurementsOn, panoramaOn = _props.panoramaOn, reel = _props.reel, whitelabel = _props.whitelabel, translation = _props.translation, vsObjects = _props.vsObjects, toggleVS = _props.toggleVS, openVR = _props.openVR, audio = _props.audio, currentFloor = _props.currentFloor, isVSEnabled = _props.isVSEnabled, showTicketRestrictedAreaPopup = _props.showTicketRestrictedAreaPopup, mpFloors = _props.mpFloors, host = _props.host, onMuteClick = _props.onMuteClick, onFullscreenClick = _props.onFullscreenClick, toggleSketchfabPopup = _props.toggleSketchfabPopup, onPinClick = _props.onPinClick;
        var hasVideos = Boolean((ref = this.props.reelVideos) === null || ref === void 0 ? void 0 : ref.length);
        var reelOpen = showVideoReel || this.state.reelOpen && !mesurementsOn && (reel && reel.length > 0 && tour.mpReel || tour && tour.reel && reels.length > 0);
        var isHasFloorMusic = tour.musics.find(function(item) {
            return item.floor === currentFloor + 1;
        });
        var showMore = floorPlans.length > 0 || tour.droneUrl || tour.videoUrl || tour.screenshotEnabled && !panoramaOn || tour.music || isHasFloorMusic;
        // hide the copyright button if sketchfab models are present
        var hasSFModels = vsObjects.some(function(item) {
            var ref;
            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (item === null || item === void 0 ? void 0 : (ref = item.details) === null || ref === void 0 ? void 0 : ref.copyright);
        });
        var showReelIcon = tour.reel || reel && reel.length > 0 && tour.mpReel;
        var showPlayIcon = tour.mpPlay && reel && reel.length > 0;
        var showFloorsIcon = mpFloors && mpFloors.length > 1 && tour.addon_f;
        var showVSIcon = tour.enableVS && (vsObjects === null || vsObjects === void 0 ? void 0 : vsObjects.length) > 0;
        var showPanoIcon = showPanorama && tour.id !== 4450;
        var showLangIcon = duplicates.length > 1;
        var iconsEnabled = [
            showReelIcon,
            showPlayIcon,
            dollhouse,
            floorplan,
            measurements,
            showFloorsIcon,
            showVSIcon,
            tour.minimap,
            showPanoIcon,
            showLangIcon,
            hasVideos
        ];
        var smallIconsEnabled = iconsEnabled.filter(Boolean).length > 4 && deviceManager["default"].isMobile();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "bottom-bar",
            className: classnames_default()({
                open: reelOpen,
                smallIcons: smallIconsEnabled
            }),
            children: [
                showMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("more-bar", {
                        categoriesOn: tour.reel && reelOpen && reelCategories.length > 0
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "data-balloon",
                            "data-balloon": translation && translation.moreTooltip,
                            "data-balloon-pos": "right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: showActionsModal ? "more-btn btn active" : "more-btn btn",
                                onClick: function() {
                                    _this.setState({
                                        showActionsModal: !showActionsModal
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-ellipsis-h"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("action-icons left more", {
                                active: showActionsModal
                            }),
                            children: [
                                !deviceManager["default"].isMobile() && mainPlaying && showVolumeControls && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundVolumeControls/* default */.Z, {
                                    audio: audio
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "more-menu",
                                    children: [
                                        !deviceManager["default"].isMobile() && mainPlaying && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": (translation === null || translation === void 0 ? void 0 : translation.volume) || "Volume",
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("action-icon music", showVolumeControls && "active"),
                                                onClick: function() {
                                                    _this.showVolumeControls();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: classnames_default()("fas music-status fa-music")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-volume"
                                                    })
                                                ]
                                            })
                                        }),
                                        (tour.music || isHasFloorMusic) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.musicTooltip,
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("action-icon music", mainPlaying && "active"),
                                                onClick: function() {
                                                    _this.props.handleToggleMusic();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: classnames_default()("fas music-status fa-music")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: mainPlaying ? "fas fa-pause" : "fas fa-play"
                                                    })
                                                ]
                                            })
                                        }),
                                        tour.droneUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.droneViewTooltip,
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "action-icon drone",
                                                onClick: this.props.toggleExternalPopup.bind(this, tour.droneUrl),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fad fa-drone"
                                                })
                                            })
                                        }),
                                        tour.screenshotEnabled && !panoramaOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.screenshotTooltip,
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: this.state.cameraList ? "action-icon screenshot active" : "action-icon screenshot",
                                                onClick: function() {
                                                    _this.setState({
                                                        cameraList: !_this.state.cameraList,
                                                        pdfList: false,
                                                        youtubeOn: false
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-camera"
                                                })
                                            })
                                        }),
                                        floorPlans.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.floorPlanTooltip,
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                id: "pdf-list",
                                                className: "action-icon floors",
                                                onClick: function() {
                                                    return (0,util_all/* downloadFloorPlan */.fg)("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/floorplans/").concat(floorPlans[0].url), floorPlans[0]);
                                                },
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-file-pdf"
                                                })
                                            })
                                        }),
                                        floorPlans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.floorPlansTooltip,
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: this.state.pdfList ? "action-icon floors active" : "action-icon floors",
                                                onClick: function() {
                                                    _this.setState({
                                                        pdfList: !_this.state.pdfList,
                                                        youtubeOn: false,
                                                        cameraList: false
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-file-pdf"
                                                })
                                            })
                                        }),
                                        tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.videoTooltip,
                                            "data-balloon-pos": "right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: this.state.youtubeOn ? "action-icon video active" : "action-icon video",
                                                onClick: function() {
                                                    if (!_this.state.youtubeOn) {
                                                        _this.props.onStartVideo();
                                                    } else {
                                                        _this.props.onStopVideo();
                                                    }
                                                    _this.setState({
                                                        youtubeOn: !_this.state.youtubeOn,
                                                        pdfList: false,
                                                        cameraList: false
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-video"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                this.state.cameraList && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdf-list wide",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 4096,
                                                height: 3072
                                            }),
                                            children: "4:3 @ 4096x3072 (High)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 1920,
                                                height: 1440
                                            }),
                                            children: "4:3 @ 1920x1440 (Medium)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 1280,
                                                height: 960
                                            }),
                                            children: "4:3 @ 1280x960 (Web)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 1024,
                                                height: 768
                                            }),
                                            children: "4:3 @ 1024x768 (MLS)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 4096,
                                                height: 2034
                                            }),
                                            children: "16:9 @ 4096x2304 (Wide/HQ)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 3840,
                                                height: 2160
                                            }),
                                            children: "16:9 @ 3840x2160 (Wide/4K)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 1920,
                                                height: 1080
                                            }),
                                            children: "16:9 @ 1920x1080 (Wide/1080p)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 1280,
                                                height: 720
                                            }),
                                            children: "16:9 @ 1280x720 (Wide/720p)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takeScreenshot.bind(this, {
                                                width: 1024,
                                                height: 576
                                            }),
                                            children: "16:9 @ 1024x576 (MLS)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.props.takePano.bind(this),
                                            children: "Pano @ 4096x2048"
                                        })
                                    ]
                                }),
                                this.state.pdfList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdf-list",
                                    children: floorPlans.map(function(plan, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                (0,util_all/* downloadFloorPlan */.fg)("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/floorplans/").concat(plan.url), plan);
                                            },
                                            className: "pdf_inner_link",
                                            target: "_blank",
                                            children: plan.name
                                        }, i);
                                    })
                                }),
                                tour.videoUrl && this.state.youtubeOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(units.VideoBox.Container, {
                                    width: tour.videoWidth,
                                    height: tour.videoHeight,
                                    isMobile: deviceManager["default"].isMobile() && !deviceManager["default"].isTablet(),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(units.VideoBox.Icon, {
                                            className: "fas fa-times",
                                            onClick: function() {
                                                _this.setState({
                                                    youtubeOn: false
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(units.VideoBox.Iframe, {
                                            ref: function(elem) {
                                                _this.videoFrame = elem;
                                            },
                                            id: "ytplayer",
                                            allowFullScreen: true,
                                            allow: "autoplay; fullscreen",
                                            src: util_all/* getVideoLink */.rp(tour.videoUrl, {
                                                mute: tour.noAudioMode || tour.autoplayVideo
                                            }),
                                            frameBorder: "0"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("action-icons right", {
                        categoriesOn: tour.reel && reelOpen && reelCategories.length > 0
                    }),
                    children: [
                        tour.share && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "data-balloon",
                            "data-balloon": translation && translation.shareTooltip,
                            "data-balloon-pos": "up",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action-icon ".concat(sharePopupOn ? "active" : ""),
                                role: "button",
                                tabIndex: 0,
                                onKeyPress: function() {
                                    return null;
                                },
                                onClick: openShare,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-share-alt"
                                })
                            })
                        }),
                        !deviceManager["default"].isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "data-balloon",
                            "data-balloon": translation && translation.fullScreenTooltip,
                            "data-balloon-pos": "up",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action-icon",
                                onClick: function() {
                                    return changeFull();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: this.props.isFull ? "fas fa-compress" : "fas fa-expand"
                                })
                            })
                        }),
                        tour.addon_vr && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "data-balloon",
                            "data-balloon": translation && translation.vrTooltip,
                            "data-balloon-pos": "up",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action-icon",
                                role: "button",
                                tabIndex: 0,
                                onClick: openVR,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-vr-cardboard"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "bottom-bar-help",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn",
                            onClick: function() {
                                if (translation && translation.termFile) {
                                    window.open("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/termFile.pdf").concat((0,util_all/* getVersion */.bo)(new Date())));
                                } else {
                                    onTermsClick();
                                }
                            },
                            children: translation && translation.terms
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn",
                            onClick: onHelpClick,
                            children: translation && translation.help
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://matterport.com",
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mp-logo",
                                src: "/matterport.svg",
                                alt: "matterport"
                            })
                        }),
                        hasSFModels && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn",
                            onClick: toggleSketchfabPopup(true),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sketchfab, {
                                style: {
                                    width: "16px",
                                    height: "16px"
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("actions-bar"),
                    style: {
                        overflow: "visible"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                overflow: "visible"
                            },
                            className: classnames_default()("main-icons", {
                                categoriesOn: tour.reel && reelOpen && reelCategories.length > 0
                            }),
                            children: [
                                showReelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.highlightsTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: reelOpen ? "actions-btn btn active reel" : "actions-btn btn reel",
                                        onClick: function() {
                                            var _this1 = _this;
                                            _this.setState({
                                                reelOpen: !reelOpen
                                            }, function() {
                                                var _this = _this1;
                                                setTimeout(function() {
                                                    _this.setState({
                                                        showVideoReel: false
                                                    });
                                                }, 300);
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-angle-up"
                                        })
                                    })
                                }),
                                showPlayIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.playTourTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: tourPlaying ? "btn active" : "btn",
                                        onClick: function() {
                                            playTour();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: tourPlaying ? "fas fa-pause-circle" : "fas fa-play-circle"
                                        })
                                    })
                                }),
                                dollhouse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.dollhouseTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn",
                                        onClick: function() {
                                            return changeViewMode(Tour/* TourMode.DOLLHOUSE */.zz.DOLLHOUSE);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mp-dollhouse"
                                        })
                                    })
                                }),
                                floorplan && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.floorPlanTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn",
                                        onClick: function() {
                                            return changeViewMode(Tour/* TourMode.FLOORPLAN */.zz.FLOORPLAN);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mp-floorplan"
                                        })
                                    })
                                }),
                                measurements && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.measurementsTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn",
                                        onClick: function() {
                                            if (panoramaOn) showPanoramaClick();
                                            measurementsMode();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-ruler"
                                        })
                                    })
                                }),
                                showFloorsIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "data-balloon",
                                    style: {
                                        overflow: "visible"
                                    },
                                    "data-balloon": translation && translation.floorsTooltip,
                                    "data-balloon-pos": "up",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn",
                                            onClick: function() {
                                                _this.setState({
                                                    showFloorsModal: !showFloorsModal
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-layer-group"
                                            })
                                        }),
                                        showFloorsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "floors-modal",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        onClick: function() {
                                                            return _this.changeFloor(0, true);
                                                        },
                                                        children: (translation === null || translation === void 0 ? void 0 : translation.floorAll) || "All"
                                                    }),
                                                    mpFloors.map(function(floor, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            onClick: function() {
                                                                return _this.changeFloor(index);
                                                            },
                                                            children: floor.name
                                                        }, "".concat(floor.id, "-").concat(floor.name));
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                showVSIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.hideVSTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: classnames_default()("btn", isVSEnabled && "active"),
                                        onClick: toggleVS,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-couch"
                                        })
                                    })
                                }),
                                tour.minimap && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.minimapTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: minimapVisible ? "btn active" : "btn",
                                        onClick: function() {
                                            _this.setState({
                                                minimapVisible: !minimapVisible
                                            });
                                            showMinimapClick();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-map-marked"
                                        })
                                    })
                                }),
                                showPanoIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.panoramaTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: panoramaOn ? "btn active" : "btn",
                                        onClick: showPanoramaClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "panorama-icon",
                                            src: "/panorama.png",
                                            alt: "panorama"
                                        })
                                    })
                                }),
                                showLangIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.languagesTooltip,
                                    "data-balloon-pos": "up",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn",
                                            onClick: function() {
                                                _this.setState({
                                                    showLanguagesModal: !showLanguagesModal
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-language"
                                            })
                                        }),
                                        showLanguagesModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "languages-modal",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: duplicates.map(function(duplicate) {
                                                    var _this1 = _this;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                        className: tour.id === duplicate.id ? "active" : "",
                                                        onClick: function() {
                                                            return _this1.setState({
                                                                showLanguagesModal: false
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/tour/".concat(duplicate.slug),
                                                            children: _this.capitalizeFirstLetter(duplicate === null || duplicate === void 0 ? void 0 : duplicate.language)
                                                        })
                                                    }, duplicate.slug);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                hasVideos && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.participantsTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: showVideoReel ? "btn active" : "btn",
                                        onClick: function() {
                                            if (!showVideoReel) {
                                                _this.setState({
                                                    reelOpen: true,
                                                    showVideoReel: true
                                                });
                                            } else {
                                                var _this1 = _this;
                                                _this.setState({
                                                    reelOpen: false
                                                }, function() {
                                                    var _this = _this1;
                                                    setTimeout(function() {
                                                        _this.setState({
                                                            showVideoReel: false
                                                        });
                                                    }, 300);
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-users"
                                        })
                                    })
                                })
                            ]
                        }),
                        tour.reel && reelOpen && !showVideoReel && (reelCategories === null || reelCategories === void 0 ? void 0 : reelCategories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "reel-categories",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scroll-div d-flex",
                                children: reelCategories.map(function(c, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: _this.state.activeCategory === c.id ? "active" : "",
                                        onClick: _this.filterReel.bind(_this, c.id),
                                        children: c.title
                                    }, i);
                                })
                            })
                        })
                    ]
                }),
                tour.mpReel && reel && reel.length > 0 && !tour.reel && !showVideoReel && /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_Reel/* default */.Z, {
                    reel: reel,
                    reelStep: reelStep,
                    move: moveToStep
                }),
                tour.reel && !showVideoReel && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomReel, {
                    reel: reels,
                    tourId: tour.id,
                    loadModel: loadModel,
                    restrictedReels: restrictedReels,
                    showTicketRestrictedAreaPopup: showTicketRestrictedAreaPopup,
                    onTicketingReel: this.props.onTicketingReel
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MReelVideoBar, {
                    show: showVideoReel && hasVideos,
                    host: host,
                    videos: this.props.reelVideos,
                    onMuteClick: onMuteClick,
                    onFullscreenClick: onFullscreenClick,
                    onPinClick: onPinClick
                })
            ]
        });
    };
    return BottomBar;
}(react.Component);


// EXTERNAL MODULE: ./components/tour/regular/bottomBar/SoundControls.tsx
var SoundControls = __webpack_require__(67644);
// EXTERNAL MODULE: ./components/tour/regular/fullScreen/FullScreen.tsx
var FullScreen = __webpack_require__(44);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
;// CONCATENATED MODULE: ./components/tour/components/SetDataToRecoil.tsx





var SetDataToRecoil = function(props) {
    var translation = props.translation, rtl = props.rtl;
    var ref = (0,react.useState)(false), inited = ref[0], setInited = ref[1];
    var setTranslation = (0,store/* useSetRecoilState */.Zl)(store/* translationDataState */.Jv);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* tourConfigsState */.Uq), 2), tourConfigs = ref1[0], setTourConfigs = ref1[1];
    (0,react.useEffect)(function() {
        if (!inited) {
            if (translation && Object.keys(translation).length > 0) {
                setTranslation(translation);
                setTourConfigs((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tourConfigs), {
                    rtl: rtl
                }));
                setInited(true);
            }
        }
    }, [
        translation
    ]);
    return null;
};
/* harmony default export */ var components_SetDataToRecoil = (SetDataToRecoil);

// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
;// CONCATENATED MODULE: ./_models/game/GameAnalytic.ts


var GameAnalytic = function GameAnalytic(model) {
    "use strict";
    (0,src_class_call_check/* default */.Z)(this, GameAnalytic);
    this.id = model.id || null;
    this.name = model.name || null;
    this.startDateTime = model.startDateTime || null;
    this.country = model.country || null;
    this.point = !isNil_default()(model.point) ? model.point : null;
    this.time = !isNil_default()(model.time) ? model.time : null;
    this.completed = model.completed || false;
    this.gameId = model.gameId || null;
    this.rating = !isNil_default()(model.rating) ? model.rating : null;
};

;// CONCATENATED MODULE: ./components/tour/game/services/GameAnalyticService.ts






var GameAnalyticService = /*#__PURE__*/ function() {
    "use strict";
    function GameAnalyticService(gameId) {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, GameAnalyticService);
        this.analytic = new GameAnalytic({
            gameId: gameId,
            country: "",
            startDateTime: new Date()
        });
        window.addEventListener("beforeunload", function() {
            return _this.update();
        });
    }
    var _proto = GameAnalyticService.prototype;
    _proto.getTime = function getTime() {
        return this.analytic.time;
    };
    _proto.setTime = function setTime(time) {
        this.analytic.time = time;
    };
    _proto.getPoint = function getPoint() {
        return this.analytic.point;
    };
    _proto.setPoint = function setPoint(point) {
        this.analytic.point = point;
    };
    _proto.update = function update() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var obj, newAnalytic, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        obj = (0,_object_spread/* default */.Z)({}, data);
                        if (obj.id) delete obj.id;
                        newAnalytic = new GameAnalytic((0,_object_spread/* default */.Z)({}, _this.analytic, obj));
                        if (data === null || data === void 0 ? void 0 : data.country_name) newAnalytic.country = data === null || data === void 0 ? void 0 : data.country_name;
                        _ctx.next = 6;
                        return _this.saveAnalytics(newAnalytic);
                    case 6:
                        res = _ctx.sent;
                        if (res) {
                            _this.analytic = new GameAnalytic(res.data);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.saveAnalytics = function saveAnalytics(analytic) {
        return TreedisAdminDAO/* default.saveAnalytics */.Z.saveAnalytics(analytic);
    };
    return GameAnalyticService;
}();


;// CONCATENATED MODULE: ./components/tour/regular/loadTourIframe/LoadTourIframe.tsx




var LoadTourIframe = function(param) {
    var mesurementsOn = param.mesurementsOn, iframeStyle = param.iframeStyle, iframeUrl = param.iframeUrl, isFullScreen = param.isFullScreen, iframeId = param.iframeId, cb = param.cb;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Frame */.RQ, {
        elementId: iframeId,
        iframeUrl: iframeUrl,
        className: classnames_default()("showcase", deviceManager["default"].isMobile() && !isFullScreen && mesurementsOn && "mesurements-mobile-not-fullscreen"),
        style: iframeStyle,
        handleRef: cb
    });
};
/* harmony default export */ var loadTourIframe_LoadTourIframe = (LoadTourIframe);

;// CONCATENATED MODULE: ./components/tour/afterSweepInit.ts







var afterSweepsInit = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var sweeps, matterId, slug, iframeUrl, setData, cb, floors, isMatterportLink, frFloorsRes, actualMatterId, deprecatedSweeps;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sweeps = param.sweeps, matterId = param.matterId, slug = param.slug, iframeUrl = param.iframeUrl, setData = param.setData, cb = param.cb;
                    if (!(sweeps === null || sweeps === void 0 ? void 0 : sweeps.length)) {
                        _ctx.next = 18;
                        break;
                    }
                    floors = [];
                    isMatterportLink = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m") !== matterId;
                    if (isMatterportLink) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 7;
                    return TreedisAdminDAO/* default.getFRFloors */.Z.getFRFloors(slug);
                case 7:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 11;
                    break;
                case 10:
                    _ctx.t0 = {
                        data: []
                    };
                case 11:
                    frFloorsRes = _ctx.t0;
                    // using sweep.floor_position to get the floor height position
                    sweeps.forEach(function(sweep) {
                        var ref;
                        if (!floors[sweep.floor_index]) {
                            var frFloor = frFloorsRes === null || frFloorsRes === void 0 ? void 0 : frFloorsRes.data.find(function(i) {
                                return i.floor === sweep.floor_index;
                            });
                            var floor = {
                                floor: sweep.floor_index,
                                position: sweep.floor_position
                            };
                            floors[sweep.floor_index] = frFloor ? new FRFloor((0,_object_spread/* default */.Z)({}, frFloor, floor)) : new FRFloor(floor);
                        }
                        (ref = floors[sweep.floor_index].sweeps) === null || ref === void 0 ? void 0 : ref.push(sweep);
                    });
                    actualMatterId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m") || matterId;
                    _ctx.next = 16;
                    return getSweeps(String(actualMatterId), slug);
                case 16:
                    deprecatedSweeps = _ctx.sent;
                    setData({
                        floors: floors,
                        deprecatedSweeps: deprecatedSweeps
                    });
                case 18:
                    cb();
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function afterSweepsInit(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/calculateLocation.ts
function calculateLocation() {
    if (this.state.panoramaOn) return false;
    var px = this.state.mapWalkerX;
    var py = this.state.mapWalkerY;
    var minimaps = this.state.minimaps;
    var selectedMinimap = this.state.selectedMinimap;
    var tour = this.state.tour;
    if (tour.minimap && minimaps.length > 0 && minimaps[selectedMinimap] && tour.originX != null && tour.originY != null && tour.width != null && tour.height != null && tour.ppm != null) {
        var _selectedMinimap = minimaps[selectedMinimap], hotspots = _selectedMinimap.hotspots, custom = _selectedMinimap.custom;
        var foundHotspot = null;
        var poseSweep = this.pose.sweep;
        hotspots.forEach(function(hotspot) {
            if (hotspot.scanId === poseSweep) {
                hotspot.active = true;
                foundHotspot = hotspot;
            } else {
                hotspot.active = false;
            }
        });
        if (foundHotspot) {
            px = foundHotspot.x;
            py = foundHotspot.y;
        } else if (!custom) {
            px = (this.pose.position.x + tour.originX * -1) * tour.ppm / tour.width * 100;
            py = 100 + (this.pose.position.z + tour.originY) * tour.ppm / tour.height * 100;
        }
    }
    return {
        px: px,
        py: py,
        minimaps: minimaps
    };
}

;// CONCATENATED MODULE: ./components/tour/renderButtonBg.tsx





function renderButtonBg() {
    var _state = this.state, tour = _state.tour, room = _state.room, menuOpen = _state.menuOpen, host = _state.host, translation = _state.translation, tourEmail = _state.tourEmail, tourType = _state.tourType, MenuHintOn = _state.MenuHintOn, getInTouchHintOn = _state.getInTouchHintOn, appointmentsHintOn = _state.appointmentsHintOn;
    var menuOpenForDevice = !!(deviceManager["default"].isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
    var showExpand = !this.state.menuOpened && !tour.menuOnStart;
    var showCustomButton = tour.customButton && tour.customButtonIcon && tourType === Tour/* TourType.Regular */.v.Regular;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* ButtonBg */.g2, {
                chatToken: room,
                menu: {
                    menuEnabled: tour.menuEnabled
                },
                toggleNav: this.toggleNav.bind(this),
                handleCustomButton: this.handleCustomButton,
                showExpand: showExpand,
                toggleAppointmentsModal: this.toggleAppointmentsModal,
                appointmentsHintOn: appointmentsHintOn,
                toggleContactPopup: util/* toggleContactPopup.bind */.OZ.bind(this),
                tourEmail: tourEmail,
                getInTouchHintOn: getInTouchHintOn,
                MenuHintOn: MenuHintOn,
                showCustomButton: showCustomButton,
                translation: translation,
                tourType: tourType,
                menuOpen: menuOpen,
                tour: tour,
                host: host,
                menuOpenForDevice: menuOpenForDevice
            }),
            this.injectBottomBg()
        ]
    });
}

;// CONCATENATED MODULE: ./utils/randomNumberId.ts
var randomNumberId = function() {
    var nr = String(Math.random()).split(".")[1];
    if (Number(nr)) {
        return Number(nr);
    }
    return Math.random();
};

;// CONCATENATED MODULE: ./components/tour/getIframeStyle.ts
var getIframeStyle = function(param) {
    var tour = param.tour, activeSweepGroup = param.activeSweepGroup, sweepGroups = param.sweepGroups;
    var iframeStyle = {};
    if (tour) {
        var brightness = tour.brightness === 1 ? "" : "brightness(".concat(tour.brightness, ")");
        var saturation = tour.saturation === 1 ? "" : "saturate(".concat(tour.saturation, ")");
        var contrast = tour.contrast === 1 ? "" : "contrast(".concat(tour.contrast, ")");
        iframeStyle = {
            filter: "".concat(brightness, " ").concat(saturation, " ").concat(contrast)
        };
        if (activeSweepGroup) {
            var sweepGroup = sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            });
            if (sweepGroup) {
                var hasColorSettings = sweepGroup.brightness !== 1 || sweepGroup.saturation !== 1 || sweepGroup.contrast !== 1;
                if (hasColorSettings) {
                    var sweepBrightness = sweepGroup.brightness === 1 ? "" : "brightness(".concat(sweepGroup.brightness, ")");
                    var sweepSaturation = sweepGroup.saturation === 1 ? "" : "saturate(".concat(sweepGroup.saturation, ")");
                    var sweepContrast = sweepGroup.contrast === 1 ? "" : "contrast(".concat(sweepGroup.contrast, ")");
                    iframeStyle = {
                        filter: "".concat(sweepBrightness, " ").concat(sweepSaturation, " ").concat(sweepContrast)
                    };
                }
            }
        }
    }
    return iframeStyle;
};

;// CONCATENATED MODULE: ./components/tour/logoutHandler.ts




var logoutHandler = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var ticket, ticketingOrderedTicket;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ticket = param.ticket, ticketingOrderedTicket = param.ticketingOrderedTicket;
                    if (!(ticket && ticketingOrderedTicket && ticketingOrderedTicket.ticketType === "tourByYourself")) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 4;
                    return TreedisPublicDAO/* default.logoutTicket */.Z.logoutTicket({
                        ticketId: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.id,
                        deviceId: (0,utils/* getDeviceFingerprint */.UI)()
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function logoutHandler(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/stopApp.ts
var stopApp = function() {
    ;
    window.location.reload();
};

;// CONCATENATED MODULE: ./components/tour/getUrlVariables.ts

var getUrlVariables = function(url, iframeUrl) {
    var id = (0,util/* getQueryVariable */.Dv)(url, "m");
    var iframeId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m");
    var start = (0,util/* getQueryVariable */.Dv)(url, "start");
    // normal
    var sr = (0,util/* getQueryVariable */.Dv)(url, "sr"); // rotation
    var ss = (0,util/* getQueryVariable */.Dv)(url, "ss"); // sweep
    // floor plan or dollhouse
    var sm = (0,util/* getQueryVariable */.Dv)(url, "sm"); // mode
    var sz = (0,util/* getQueryVariable */.Dv)(url, "sz"); // zoom
    var sp = (0,util/* getQueryVariable */.Dv)(url, "sp"); // position
    var linkData = start ? JSON.parse(String(start)) : false;
    var rand = Math.floor(Math.random() * 1000000 + 1);
    var linkDataShort = sr && ss ? {
        sr: sr.split(","),
        ss: parseInt(String(ss), 10)
    } : false;
    if (!linkDataShort) linkDataShort = sp && sr && sm ? {
        sm: parseInt(sm, 10),
        sr: sr.split(","),
        sp: sp.split(","),
        sz: sz ? parseFloat(String(sz)) : null
    } : false;
    return {
        id: id,
        iframeId: iframeId,
        linkData: linkData,
        rand: rand,
        linkDataShort: linkDataShort
    };
};

;// CONCATENATED MODULE: ./components/tour/addPinnedVideoFunc.ts

var addPinnedVideoFunc = function(p, pinnedVideosData, cb) {
    try {
        var ref;
        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
            var pinnedVideos = (0,_to_consumable_array/* default */.Z)(pinnedVideosData);
            var index = pinnedVideos.findIndex(function(i) {
                return i.sid === p.sid;
            });
            var dominantIndex = pinnedVideos.findIndex(function(i) {
                return i.pinned === true;
            });
            if (dominantIndex >= 0) {
                var dominantSpeaker = pinnedVideos[dominantIndex];
                // replace the dominant speaker, first remove it
                if (dominantSpeaker.sid !== p.sid) {
                    pinnedVideos.splice(dominantIndex, 1);
                }
            }
            if (index >= 0) {
                pinnedVideos[index] = p;
            } else {
                pinnedVideos.push(p);
            }
            cb(pinnedVideos);
        }
    } catch (e) {
        ;
    }
};

;// CONCATENATED MODULE: ./components/tour/takePositionData.ts


var takePositionData = function(param) {
    var slug = param.slug, matterId = param.matterId, sweep = param.sweep, rotation = param.rotation;
    var segmants = window.location.href.split("/");
    var id = segmants[segmants.length - 1].split("?")[0];
    if (slug === id || matterId === id) {
        (0,util_all/* copyToClipboard */.vQ)((0,util_all/* buildLink */.DF)(sweep, rotation));
        react_toastify_esm/* toast.success */.Am.success("Copied current position");
    } else {
        react_toastify_esm/* toast.error */.Am.error("Cannot copy position in a tour that was reached through the menu, please go to this tour page directly and copy positions from there using CTRL+Y");
    }
};

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  font-family: 'Roboto';\n  color: black;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  z-index: 999;\n  position: absolute;\n  background: white;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  ",
        "\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url('/try-again.svg');\n  background-size: cover;\n  height: 200px;\n  width: 300px;\n  ",
        "\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  margin: 50px auto 0 auto;\n  width: 960px;\n  text-align: center;\n  ",
        "\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 34px;\n  font-weight: bold;\n  padding: 0 50px;\n  margin-bottom: 30px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  font-size: 16px;\n  padding: 0 50px;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: var(--color-secondary);\n  color: white;\n  font-size: 15px;\n  height: 40px;\n  padding: 0 35px;\n  border: 1px solid white;\n  margin: 0 10px;\n\n  &:hover {\n    color: var(--color-secondary);\n    background: white;\n    outline: none;\n    border: 1px solid;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: var(--color-secondary);\n  color: white;\n  font-size: 15px;\n  height: 40px;\n  padding: 0 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  i {\n    margin-left: 13px;\n    font-size: 21px;\n  }\n  margin: 0 10px;\n\n  &:hover {\n    color: var(--color-secondary);\n    background: white;\n    outline: none;\n    border: 1px solid;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-adb58ee3-0"
})(styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    height: calc(var(--vh, 1vh) * 100);\n  ";
});
var ImageBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ImageBlock",
    componentId: "sc-adb58ee3-1"
})(styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    height: 100px;\n    width: 150px;\n  ";
});
var TextBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TextBlockWrap",
    componentId: "sc-adb58ee3-2"
})(styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      margin-top: 20px;\n    ";
});
var TitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TitleText",
    componentId: "sc-adb58ee3-3"
})(styled_templateObject3());
var DescriptionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__DescriptionText",
    componentId: "sc-adb58ee3-4"
})(_templateObject4());
var ButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ButtonWrap",
    componentId: "sc-adb58ee3-5"
})(_templateObject5());
var RedCornerBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styled__RedCornerBtn",
    componentId: "sc-adb58ee3-6"
})(_templateObject6());
var RedBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styled__RedBtn",
    componentId: "sc-adb58ee3-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/index.tsx


var defaultTranslation = {
    crashScreenTitle: "Seems like something isn't working",
    crashScreenDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    crashScreenRestoreBtn: "Reload page",
    crashScreenRefreshBtn: "Start again"
};
var CrashScreen = function(param) {
    var show = param.show, onRestore = param.onRestore, backgroundImage = param.backgroundImage;
    var refresh = function() {
        window.location.reload();
    };
    if (!show) return null;
    var crashScreenTitle = defaultTranslation.crashScreenTitle, crashScreenRestoreBtn = defaultTranslation.crashScreenRestoreBtn, crashScreenRefreshBtn = defaultTranslation.crashScreenRefreshBtn, crashScreenDescription = defaultTranslation.crashScreenDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "game-intro-modal",
        style: {
            background: "url(".concat(backgroundImage, ")")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBlockWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        className: "titleText",
                        children: crashScreenTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionText, {
                        children: crashScreenDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrap, {
                children: [
                    onRestore && /*#__PURE__*/ (0,jsx_runtime.jsx)(RedCornerBtn, {
                        className: "mb-2",
                        onClick: onRestore,
                        children: crashScreenRestoreBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RedBtn, {
                        className: "mb-2",
                        onClick: refresh,
                        children: crashScreenRefreshBtn
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CrashScreen = (CrashScreen);

// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./components/common/LoadingProgress/index.tsx + 1 modules
var LoadingProgress = __webpack_require__(3403);
// EXTERNAL MODULE: ./components/tour/game/ClipScreen/index.tsx + 2 modules
var ClipScreen = __webpack_require__(82107);
;// CONCATENATED MODULE: ./components/tour/game/Paths/fetch.tsx





var useLockPath = function(gameId) {
    var ref = (0,react.useState)(), lockPath = ref[0], setLockPath = ref[1];
    (0,react.useEffect)(function() {
        var fetchPath = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return TreedisPublicDAO/* default.getLockByType */.Z.getLockByType({
                                type: Game/* LockType.Path */.Gn.Path,
                                gameId: gameId
                            });
                        case 2:
                            res = _ctx.sent;
                            if (res.lock) {
                                setLockPath(new Game/* GameLock */.$u(res.lock));
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchPath() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPath();
    }, [
        gameId
    ]);
    return {
        lockPath: lockPath
    };
};

// EXTERNAL MODULE: ./hooks/index.ts + 2 modules
var hooks = __webpack_require__(91950);
;// CONCATENATED MODULE: ./components/tour/game/Paths/index.tsx

















var RegularPaths = function(param) {
    var showcase = param.showcase, gameId = param.gameId, allTags = param.allTags, polygons = param.polygons, vsObjects = param.vsObjects, sweeps = param.sweeps, clickedElement = param.clickedElement;
    var ref;
    var currentPathStep = (0,react.useRef)(null);
    var paths = (0,react.useRef)(new Map());
    var ref1 = (0,react.useState)(false), isFinish = ref1[0], setIsFinish = ref1[1];
    var isMobile = deviceManager["default"].isMobile();
    var lockPath = useLockPath(gameId).lockPath;
    (0,hooks/* useGlobalDOMEvents */.A)({
        keyup: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ev) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(ev.code === "Space")) {
                                _ctx.next = 3;
                                break;
                            }
                            _ctx.next = 3;
                            return handleNextStep();
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(ev) {
                return _ref.apply(this, arguments);
            };
        }()
    }, [
        vsObjects,
        allTags
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var goToNextStep = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, nextStepId, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        nextStepId = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : (ref1 = ref.next) === null || ref1 === void 0 ? void 0 : ref1.id;
                        if (nextStepId && paths.current.has(nextStepId)) {
                            ;
                            currentPathStep.current = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(nextStepId);
                        } else {
                            setIsFinish(true);
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function goToNextStep() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (clickedElement && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationItem.toString()) === clickedElement.id.toString() && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationType) === clickedElement.type) {
            goToNextStep();
        }
    }, [
        clickedElement,
        goToNextStep
    ]);
    var createPath = function(items, triggerType, triggerItem) {
        var ref;
        var step = lockPath === null || lockPath === void 0 ? void 0 : (ref = lockPath.paths) === null || ref === void 0 ? void 0 : ref.find(function(path) {
            return path.triggerType === triggerType && path.triggerItem === triggerItem;
        });
        if (!step) return items;
        var next = lockPath.paths.find(function(path) {
            return path.triggerType === step.locationType && path.triggerItem === step.locationItem;
        });
        var prev = lockPath.paths.find(function(path) {
            return path.locationType === step.triggerType && path.locationItem === step.triggerItem;
        });
        if (!triggerType) {
            currentPathStep.current = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
                prev: prev || null,
                next: next && next.id !== step.id ? next : null
            });
        }
        items.set(step.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
            prev: prev || null,
            next: next && next.id !== step.id ? next : null
        }));
        return next && !items.get(next.id) ? createPath(items, next.triggerType, next.triggerItem) : items;
    };
    var rotateCameraTo = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(t) {
            var THREE, l, d, a, r, o, s, u, f, p, m, b, h, g;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        THREE = index_modern/* ThreeInstance.get */.ur.get();
                        l = function(value) {
                            return value * Math.PI / 180;
                        };
                        d = new THREE.Vector3(0, 0, -1);
                        _ctx.next = 6;
                        return showcase.mpSDK.Camera.getPose();
                    case 6:
                        a = _ctx.sent;
                        r = new THREE.Euler(l(a.rotation.x), l(a.rotation.y), 0, "XYZ");
                        o = d.clone().applyEuler(r);
                        s = new THREE.Vector3(a.position.x, a.position.y, a.position.z);
                        u = t.clone();
                        f = o.clone().normalize();
                        p = u.clone().sub(s).normalize();
                        m = new THREE.Vector3(f.x, 0, f.z);
                        b = new THREE.Vector3(p.x, 0, p.z);
                        h = m.angleTo(b);
                        g = f.x * p.z - f.z * p.x < 0 ? -1 : 1;
                        _ctx.next = 19;
                        return showcase.mpSDK.Camera.rotate(180 * h / Math.PI * g);
                    case 19:
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function rotateCameraTo(t) {
            return _ref.apply(this, arguments);
        };
    }();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var moveToPathStepElement = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type, value) {
            var pathSweep, obj, allTagsArray, ref, THREE, transitionType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pathSweep = sweeps.find(function(sweep) {
                            var ref;
                            return (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.sweepUuid) === sweep.uuid;
                        });
                        ;
                        _ctx.t0 = type;
                        _ctx.next = _ctx.t0 === GameBook/* ChapterType.Tag */._U.Tag ? 5 : _ctx.t0 === GameBook/* ChapterType.Polygon */._U.Polygon ? 8 : _ctx.t0 === GameBook/* ChapterType.VSImage */._U.VSImage ? 10 : _ctx.t0 === GameBook/* ChapterType.VSVideo */._U.VSVideo ? 12 : _ctx.t0 === GameBook/* ChapterType.VSItem */._U.VSItem ? 14 : 16;
                        break;
                    case 5:
                        allTagsArray = Array.from(allTags, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
                            return v;
                        });
                        obj = allTagsArray.find(function(item) {
                            return value === (item === null || item === void 0 ? void 0 : item.id) || value === (item === null || item === void 0 ? void 0 : item.defaultSid) || value === (item === null || item === void 0 ? void 0 : item.sid);
                        });
                        return _ctx.abrupt("break", 17);
                    case 8:
                        obj = polygons.find(function(item) {
                            return value === item.id;
                        });
                        return _ctx.abrupt("break", 17);
                    case 10:
                        obj = vsObjects.find(function(item) {
                            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && value === item.vsImageId;
                        });
                        return _ctx.abrupt("break", 17);
                    case 12:
                        obj = vsObjects.find(function(item) {
                            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && value === item.vsVideoId;
                        });
                        return _ctx.abrupt("break", 17);
                    case 14:
                        obj = vsObjects.find(function(item) {
                            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && value === item.vsObjectId;
                        });
                        return _ctx.abrupt("break", 17);
                    case 16:
                        return _ctx.abrupt("break", 17);
                    case 17:
                        if (!(obj && pathSweep)) {
                            _ctx.next = 25;
                            break;
                        }
                        ;
                        THREE = index_modern/* ThreeInstance.get */.ur.get();
                        transitionType = (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.transitionType) || Game/* GameLockPathTransitionType.INSTANT */.KO.INSTANT;
                        _ctx.next = 23;
                        return showcase.mpSDK.Sweep.moveTo(pathSweep.uuid, {
                            transition: showcase.mpSDK.Sweep.Transition[transitionType === null || transitionType === void 0 ? void 0 : transitionType.toUpperCase()]
                        });
                    case 23:
                        _ctx.next = 25;
                        return rotateCameraTo(new THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ));
                    case 25:
                        return _ctx.abrupt("return", obj);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToPathStepElement(type, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextStep = (0,react.useCallback)((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        moveToPathStepElement
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (lockPath && !((ref = paths.current) === null || ref === void 0 ? void 0 : ref.size)) {
            paths.current = createPath(new Map(), null, -1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lockPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current) && !isFinish && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("path-lock-panel", isMobile && "mobile"),
            style: {
                background: utils/* color.hexToRgbA */.$_.hexToRgbA(lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.colorBackground, lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.opacityBackground)
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "path-lock-description",
                    dangerouslySetInnerHTML: {
                        __html: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.description
                    },
                    style: {
                        color: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.colorText,
                        opacity: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.opacityText
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "next-btn",
                    onClick: handleNextStep,
                    style: {
                        background: (lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.colorButton) || "none",
                        opacity: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.opacityButton
                    },
                    children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "btn-text",
                        style: {
                            color: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.colorButtonText,
                            opacity: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.opacityButtonText
                        },
                        children: "Go"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "btn-text",
                        style: {
                            color: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.colorButtonText,
                            opacity: lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting.opacityButtonText
                        },
                        children: [
                            "Go Now ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-running"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/tour/game/GameBookHandle/index.tsx + 41 modules
var GameBookHandle = __webpack_require__(17098);
;// CONCATENATED MODULE: ./components/tour/BaseTour.tsx













/* eslint-disable no-return-await */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable class-methods-use-this */ /* eslint-disable no-unused-expressions */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable radix */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-empty */ /* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable no-console */ /* eslint-disable react/no-unused-state */ 








//import { storage } from '@/_helpers/storage';





















































var ExperiencePopUp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5251).then(__webpack_require__.bind(__webpack_require__, 63173));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63173)
            ];
        }
    },
    ssr: false
});
var Qualtrics = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7749).then(__webpack_require__.bind(__webpack_require__, 27749));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27749)
            ];
        }
    },
    ssr: false
});
var IntroScreen = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6663)]).then(__webpack_require__.bind(__webpack_require__, 36663));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36663)
            ];
        }
    },
    ssr: false
});
var BaseTour_Sweep = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(1224)]).then(__webpack_require__.bind(__webpack_require__, 71224));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71224)
            ];
        }
    },
    ssr: false
});
var Share = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8228).then(__webpack_require__.bind(__webpack_require__, 48228));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48228)
            ];
        }
    },
    ssr: false
});
var Login = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4207).then(__webpack_require__.bind(__webpack_require__, 14207));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14207)
            ];
        }
    },
    ssr: false
});
var Terms = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 117).then(__webpack_require__.bind(__webpack_require__, 90117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90117)
            ];
        }
    },
    ssr: false
});
var Help = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9493).then(__webpack_require__.bind(__webpack_require__, 49493));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49493)
            ];
        }
    },
    ssr: false
});
var Ad = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5579).then(__webpack_require__.bind(__webpack_require__, 15579));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15579)
            ];
        }
    },
    ssr: false
});
var CollectLeadsForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5137).then(__webpack_require__.bind(__webpack_require__, 45137));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45137)
            ];
        }
    },
    ssr: false
});
var RenderTicketingContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1449).then(__webpack_require__.bind(__webpack_require__, 31449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31449)
            ];
        }
    },
    ssr: false
});
var IntroPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4261).then(__webpack_require__.bind(__webpack_require__, 74261)).then(function(res) {
        return res.IntroPopup;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74261)
            ];
        }
    },
    ssr: false
});
var TicketingRouter = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5804), __webpack_require__.e(4762), __webpack_require__.e(7361)]).then(__webpack_require__.bind(__webpack_require__, 17361));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17361)
            ];
        }
    },
    ssr: false
});
var Watermark = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85591)).then(function(res) {
        return res.Watermark;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85591)
            ];
        }
    },
    ssr: false
});
var SketchfabPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7441), __webpack_require__.e(378)]).then(__webpack_require__.bind(__webpack_require__, 10378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10378)
            ];
        }
    },
    ssr: false
});
var BaseTour_Menu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3168).then(__webpack_require__.bind(__webpack_require__, 13168));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13168)
            ];
        }
    },
    ssr: false
});
var Minimap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4765), __webpack_require__.e(7268)]).then(__webpack_require__.bind(__webpack_require__, 7268));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7268)
            ];
        }
    },
    ssr: false
});
var Panorama = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9991).then(__webpack_require__.bind(__webpack_require__, 29991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29991)
            ];
        }
    },
    ssr: false
});
var ContactPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1055).then(__webpack_require__.bind(__webpack_require__, 11055));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11055)
            ];
        }
    },
    ssr: false
});
var ExternalPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3777).then(__webpack_require__.bind(__webpack_require__, 93777));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93777)
            ];
        }
    },
    ssr: false
});
var PanoPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6484).then(__webpack_require__.bind(__webpack_require__, 66484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66484)
            ];
        }
    },
    ssr: false
});
var PathFinderPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4889).then(__webpack_require__.bind(__webpack_require__, 4889));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4889)
            ];
        }
    },
    ssr: false
});
var TagsPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(6099)]).then(__webpack_require__.bind(__webpack_require__, 56099));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56099)
            ];
        }
    },
    ssr: false
});
var VSActionsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7691).then(__webpack_require__.bind(__webpack_require__, 67691));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67691)
            ];
        }
    },
    ssr: false
});
var Countdown = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5360).then(__webpack_require__.bind(__webpack_require__, 45360));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45360)
            ];
        }
    },
    ssr: false
});
var MessengerCustomerChat = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9538).then(__webpack_require__.bind(__webpack_require__, 89538));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89538)
            ];
        }
    },
    ssr: false
});
var MemoizedVideo = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5804), __webpack_require__.e(8445), __webpack_require__.e(3924)]).then(__webpack_require__.bind(__webpack_require__, 83924));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83924)
            ];
        }
    },
    ssr: false
});
var Appointment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5391).then(__webpack_require__.bind(__webpack_require__, 75391));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75391)
            ];
        }
    },
    ssr: false
});
var DEFAULT_VS_SENSOR_RADIUS = 25;
var BaseTour = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(BaseTour, Component);
    var _super = (0,src_create_super/* default */.Z)(BaseTour);
    function BaseTour(props, tourType) {
        (0,src_class_call_check/* default */.Z)(this, BaseTour);
        var _this;
        _this = _super.call(this, props);
        _this.ticketValidSweepsHistory = [];
        _this.ticketTimeout = null;
        _this.messengerQ = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "messenger");
        _this.avatarNodes = new Map();
        _this.pose = {};
        _this.floor = new FRFloor({
            floor: 0,
            position: null
        });
        _this.messenger = parseInt(_this.messengerQ === false ? "1" : _this.messengerQ, 10);
        _this.visibleTags = {};
        _this.hiddenTags = {};
        _this.modelNodes = [];
        _this.vsObjects = [];
        _this.isMobile = deviceManager["default"].isMobile();
        _this.avatarDegree = 0;
        _this.camera = null;
        _this.isShadowEnabled = false;
        _this.gameAnalytic = null;
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getCameraRotation = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        return _ctx.abrupt("return", {
                            rotation: (ref = _this1.camera) === null || ref === void 0 ? void 0 : ref.camera.rotation,
                            quaternion: (ref1 = _this1.camera) === null || ref1 === void 0 ? void 0 : ref1.camera.quaternion
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.renderCrashScreen = function() {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_CrashScreen, {
                show: _this.state.crashScreen,
                backgroundImage: "".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/images/").concat((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.mainImage)
            });
        };
        _this.showTicketTimeIsOutPopup = function() {
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.timeIsUp */.Y.timeIsUp,
                    onRequestClose: function() {
                        stopApp();
                    }
                }
            });
        };
        _this.showTicketRestrictedAreaPopup = function(param) {
            var sweepThatCauseTicketRestriction = param.sweepThatCauseTicketRestriction, reelThatCauseTicketRestriction = param.reelThatCauseTicketRestriction;
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.restrictedArea */.Y.restrictedArea,
                    onRequestClose: function() {
                        if (sweepThatCauseTicketRestriction) _this.goToPreviousValidSweep();
                    },
                    sweepThatCauseTicketRestriction: sweepThatCauseTicketRestriction,
                    reelThatCauseTicketRestriction: reelThatCauseTicketRestriction
                }
            });
        };
        _this.ticketUpdateSweepLoc = function(nextSweep) {
            var ref, ref1, ref2, ref3;
            if (((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.ticket) && ((ref1 = _this.state) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticketing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketingOrderedTicket) === null || ref3 === void 0 ? void 0 : ref3.ticketType) === "tourByYourself") {
                var ref4;
                var ticketingTourTicket = _this.state.ticketing.ticketingTourTicket;
                var allowedSweeps = ticketingTourTicket.selectedSweeps ? ticketingTourTicket.selectedSweeps[(ref4 = _this.state.tour) === null || ref4 === void 0 ? void 0 : ref4.slug] : [];
                if (allowedSweeps.includes(nextSweep)) {
                    _this.ticketValidSweepsHistory.push(nextSweep);
                } else {
                    _this.showTicketRestrictedAreaPopup({
                        sweepThatCauseTicketRestriction: nextSweep
                    });
                }
            }
        };
        _this.onPlayClick = function() {
            var _state = _this.state, tour = _state.tour, showIntro = _state.showIntro;
            // experience doesn't trigger showcaseLoaded
            // if (!showcaseLoaded) return;
            _this.tourAudio = null;
            if (showIntro) {
                _this.setState({
                    showIntroScreen: false
                });
            } else {
                _this.setState({
                    showIntroScreen: false,
                    forcePlayGameIntro: true
                }, function() {
                    _this.processTourMusic(tour);
                });
            }
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "IntroScreen",
                eventAction: "click",
                eventLabel: "introButton"
            });
        };
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleCollectLeadsSubmit = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var _state, tour, tourEmail;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _state = _this2.state, tour = _state.tour, tourEmail = _state.tourEmail;
                            _ctx.next = 3;
                            return TreedisPublicDAO/* default.sendEmail */.Z.sendEmail({
                                data: {
                                    to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                    params: Object.assign(data, {
                                        tour: tour.title,
                                        userId: tour.userId,
                                        link: window.location.href
                                    })
                                }
                            });
                        case 3:
                            _this2.loadData(tour);
                            _this2.setState({
                                showCollectLeadsModal: false
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onTicketLoginSuccess = function(tour, ticketing) {
            var ticketingOrderedTicket = ticketing.ticketingOrderedTicket, ticketingTourTicket = ticketing.ticketingTourTicket;
            var ticketLimitMs = ticketingTourTicket.duration * 60 * 1000;
            var ticketSpentFromLogin = Number(new Date(ticketingOrderedTicket.loginDate)) ? Date.now() - Number(new Date(ticketingOrderedTicket.loginDate)) : 0;
            var ticketTimeLeft = ticketLimitMs - ticketSpentFromLogin;
            // set time is up timeout with popup
            if (ticketTimeLeft > 0) {
                react_toastify_esm/* toast.success */.Am.success("logged in");
                setTimeout(_this.showTicketTimeIsOutPopup, ticketTimeLeft);
                _this.setState({
                    ticketTimeLeftMs: ticketTimeLeft,
                    ticketingOpen: false,
                    tour: tour,
                    ticketing: ticketing
                });
                _this.loadData(tour);
                _this.setWhiteLabel(tour);
                socket/* default.emit */.Z.emit("ticketing_login", {
                    ticketingOrderedTicket: ticketingOrderedTicket,
                    deviceId: (0,utils/* getDeviceFingerprint */.UI)(),
                    reel: tour.slug
                });
            } else {
                react_toastify_esm/* toast.error */.Am.error("wrong ticket time left");
                _this.showTicketTimeIsOutPopup();
            }
        };
        _this.handleTicketingReel = function(reel) {
            try {
                if (_this.state.ticketing && reel.type === "treedis") {
                    var url = new URL(reel.url);
                    var urlPathnameArr = url.pathname.split("/");
                    if (urlPathnameArr[1] === "tour") socket/* default.emit */.Z.emit("ticketing_reel", {
                        reel: urlPathnameArr[2]
                    });
                }
            } catch (err) {
                ;
            }
        };
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getTour = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var id, _changeMenu, changeMenu, _changeMinimap, changeMinimap, _changePanorama, changePanorama, _url, url, _hideIntroScreen, hideIntroScreen, tourData, data, ref, tour, tGen, tour1, ticket, iframeId, s, x, y, menuOpenForDevice;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            id = param.id, _changeMenu = param.changeMenu, changeMenu = _changeMenu === void 0 ? true : _changeMenu, _changeMinimap = param.changeMinimap, changeMinimap = _changeMinimap === void 0 ? true : _changeMinimap, _changePanorama = param.changePanorama, changePanorama = _changePanorama === void 0 ? true : _changePanorama, _url = param.url, url = _url === void 0 ? null : _url, _hideIntroScreen = param.hideIntroScreen, hideIntroScreen = _hideIntroScreen === void 0 ? false : _hideIntroScreen, tourData = param.tourData;
                            _this3.setState({
                                showcaseLoaded: !changeMenu
                            });
                            _ctx.prev = 2;
                            _this3.loadingQueue.setLoadingQueueProgress(90, 100);
                            _ctx.t0 = tourData;
                            if (_ctx.t0) {
                                _ctx.next = 9;
                                break;
                            }
                            _ctx.next = 8;
                            return TreedisPublicDAO/* default.getTour */.Z.getTour({
                                data: {
                                    id: id,
                                    mode: _this3.state.tourType,
                                    excludeTranslation: true
                                }
                            });
                        case 8:
                            _ctx.t0 = _ctx.sent;
                        case 9:
                            data = _ctx.t0;
                            _this3.loadingQueue.setLoadingQueueProgress(85, 100);
                            if (data.tour) {
                                _ctx.next = 14;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Couldn't find this tour in our databases");
                            return _ctx.abrupt("return");
                        case 14:
                            _this3.setWhiteLabel(data.tour);
                            _this3.initTourInfo(data.tour.id);
                            if (!(data.ticketing && !_this3.state.iframeUrl)) {
                                _ctx.next = 20;
                                break;
                            }
                            {
                                ;
                                tour = new Tour/* Tour */.Oj(data.tour);
                                tGen = data === null || data === void 0 ? void 0 : (ref = data.ticketing) === null || ref === void 0 ? void 0 : ref.ticketingGeneral;
                                // if (this.state.game) this.loadData(data.tour);
                                _this3.setState({
                                    tour: tour,
                                    ticketingOpen: true,
                                    ticketing: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.ticketing), {
                                        ticketingGeneral: (tGen === null || tGen === void 0 ? void 0 : tGen.length) ? tGen[0] : tGen
                                    }),
                                    tourLoaded: true
                                });
                            }
                            _ctx.next = 40;
                            break;
                        case 20:
                            if (!(data.tour.collectLeads && !_this3.state.iframeUrl)) {
                                _ctx.next = 24;
                                break;
                            }
                            {
                                tour1 = new Tour/* Tour */.Oj(data.tour);
                                _this3.setState({
                                    tour: tour1,
                                    showCollectLeadsModal: true
                                });
                            }
                            _ctx.next = 40;
                            break;
                        case 24:
                            if (!url) {
                                _ctx.next = 39;
                                break;
                            }
                            if (data.ticketing && _this3.state.iframeUrl) {
                                ticket = new URLSearchParams(window.location.search).get("ticket");
                                if (!ticket || ticket.length === 0) window.location.href = window.location.href.replace(/tour.*/, "tour/".concat(data.tour.slug));
                            }
                            iframeId = (0,util_all/* getQueryVariable */.Dv)(_this3.state.iframeUrl, "m");
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            if (!(iframeId == data.tour.matterId && s && x && y)) {
                                _ctx.next = 37;
                                break;
                            }
                            menuOpenForDevice = _this3.state.tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager["default"].isMobile() ? data.tour.menuAlwaysOpenMobile : data.tour.menuAlwaysOpenDesktop);
                            _this3.setState({
                                menuOpen: changeMenu ? menuOpenForDevice : _this3.state.menuOpen,
                                showcaseLoaded: true
                            });
                            if (!_this3.showcase.App.Phase.PLAYING.includes(_this3.state.appState)) {
                                _ctx.next = 36;
                                break;
                            }
                            _ctx.next = 36;
                            return _this3.moveToSweep(String(s), {
                                x: parseFloat(x),
                                y: parseFloat(y)
                            });
                        case 36:
                            return _ctx.abrupt("return");
                        case 37:
                            if (iframeId !== data.tour.matterId) {
                                _this3.setState({
                                    isChangeIframe: true
                                });
                            }
                            if (hideIntroScreen) {
                                data.tour.introScreen = null;
                            }
                        case 39:
                            _this3.loadData(data.tour, changeMenu, changeMinimap, changePanorama, url);
                        case 40:
                            _ctx.next = 45;
                            break;
                        case 42:
                            _ctx.prev = 42;
                            _ctx.t1 = _ctx["catch"](2);
                            ;
                        case 45:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        42
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.initTourInfo = function(id) {
            (0,util_all/* fetchData */.rQ)("public/getTranslations/".concat(id), "GET").then(function(data) {
                _this.setState({
                    translation: data.translations
                });
            }).catch(function(err) {
                ;
            });
            (0,util_all/* fetchData */.rQ)("public/getEmails/".concat(id), "GET").then(function(data) {
                _this.setState({
                    tourEmail: data.emails
                });
            }).catch(function(err) {
                ;
            });
        };
        _this.getTagIconId = function(tag) {
            var iconName = tag.iconFile || tag.icon;
            var iconSid = tag.sid;
            if (iconName && iconSid) {
                return "".concat(iconName, "_").concat(iconSid);
            }
            return null;
        };
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addMattertag = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                var sid, media, rgb, addDetails, addRes;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            sid = null;
                            _ctx.prev = 1;
                            ;
                            if (tag.media) {
                                media = {
                                    src: tag.media.src,
                                    type: "mattertag.media.".concat(tag.media.type.toLowerCase())
                                };
                            }
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            addDetails = {
                                label: tag.title,
                                description: tag.description,
                                anchorPosition: {
                                    x: tag.positionX,
                                    y: tag.positionY,
                                    z: tag.positionZ
                                },
                                stemVector: {
                                    x: tag.stemVectorX,
                                    y: tag.stemVectorY,
                                    z: tag.stemVectorZ
                                },
                                color: {
                                    r: rgb.r / 255,
                                    g: rgb.g / 255,
                                    b: rgb.b / 255
                                },
                                iconId: _this4.getTagIconId(tag),
                                media: media
                            };
                            _ctx.next = 8;
                            return _this4.showcase.Mattertag.add(addDetails).catch(function(e) {
                                ;
                            });
                        case 8:
                            addRes = _ctx.sent;
                            if (!(addRes && addRes[0])) {
                                _ctx.next = 14;
                                break;
                            }
                            // eslint-disable-next-line prefer-destructuring
                            tag.sid = addRes[0];
                            _ctx.next = 13;
                            return _this4.editTagMedia(tag);
                        case 13:
                            return _ctx.abrupt("return", tag.sid);
                        case 14:
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                        case 19:
                            return _ctx.abrupt("return", sid);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        16
                    ]
                ]);
            }));
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.registerIcon = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var iconId, url;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            iconId = param.iconId, url = param.url;
                            _ctx.next = 3;
                            return _this5.showcase.Mattertag.registerIcon(iconId, url).catch(function(e) {
                                ;
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editTagMedia = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                var tour, label, description, media, size;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            tour = _this6.state.tour;
                            if (tag) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            if (!(tag.opacity !== null && typeof tag.opacity === "number")) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 6;
                            return _this6.showcase.Mattertag.editOpacity(tag.sid, tag.opacity / 100).catch(function(e) {
                                ;
                            });
                        case 6:
                            label = tag.mpTitle ? tag.title : "";
                            description = tag.description;
                            if (!(tag.embedMedia && tag.enabled)) {
                                _ctx.next = 20;
                                break;
                            }
                            media = null;
                            size = _this6.isMobile ? {
                                w: tag.widthMobile || 300,
                                h: tag.heightMobile || 400
                            } : {
                                w: tag.width || 700,
                                h: tag.height || 500
                            };
                            if (tag.type === Tag/* TagType.Image */.Qy.Image) {
                                media = {
                                    type: _this6.showcase.Mattertag.MediaType.PHOTO,
                                    src: "".concat("https://cdn.treedis.com", "/tours/").concat(tour === null || tour === void 0 ? void 0 : tour.id, "/tags/").concat(tag.url)
                                };
                            }
                            if (tag.type === Tag/* TagType.Gallery */.Qy.Gallery) {
                            // TODO
                            }
                            if (tag.type === Tag/* TagType.Video */.Qy.Video) {
                                media = {
                                    type: _this6.showcase.Mattertag.MediaType.VIDEO,
                                    src: tag.url
                                };
                            }
                            if (tag.type === Tag/* TagType.Iframe */.Qy.Iframe) {
                                _this6.showcase.Mattertag.injectHTML(tag.sid, "<iframe src=".concat(tag.url, ' style="width: 100%; height: 100vh"></iframe>'), {
                                    size: size
                                });
                            }
                            if (tag.type === Tag/* TagType.Text */.Qy.Text) {
                                _this6.showcase.Mattertag.injectHTML(tag.sid, "<div>".concat(tag.text, "</div>"), {
                                    size: size
                                });
                            }
                            _ctx.next = 18;
                            return _this6.showcase.Mattertag.editBillboard(tag.sid, {
                                label: label,
                                description: description,
                                media: media
                            }).catch(console.error);
                        case 18:
                            _ctx.next = 22;
                            break;
                        case 20:
                            _ctx.next = 22;
                            return _this6.showcase.Mattertag.editBillboard(tag.sid, {
                                label: label,
                                description: description
                            }).catch(console.error);
                        case 22:
                            _ctx.next = 24;
                            return _this6.showcase.Mattertag.preventAction(tag.sid, {
                                // prevent opening: true/false
                                opening: !tag.mpTooltip,
                                navigating: !tag.mpNavigation
                            }).catch(console.error);
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editMattertag = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                var iconId, rgb;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            iconId = _this7.getTagIconId(tag);
                            if (!iconId) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 5;
                            return _this7.showcase.Mattertag.editIcon(tag.sid, iconId).catch(function(e) {
                                ;
                            });
                        case 5:
                            _ctx.next = 9;
                            break;
                        case 7:
                            _ctx.next = 9;
                            return _this7.showcase.Mattertag.resetIcon(tag.sid).catch(function(e) {
                                ;
                            });
                        case 9:
                            if (!(tag.iconColor && /#\w*/i.test(tag.iconColor))) {
                                _ctx.next = 13;
                                break;
                            }
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            _ctx.next = 13;
                            return _this7.showcase.Mattertag.editColor(tag.sid, {
                                r: rgb.r / 255,
                                g: rgb.g / 255,
                                b: rgb.b / 255
                            }).catch(console.error);
                        case 13:
                            _ctx.next = 15;
                            return _this7.editTagMedia(tag);
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }));
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initTags = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_tags) {
                var _loop, allTags, loadedMattertags, tagsSize, i, registerIconsPromises, processTags, tagsTimeout, tagsLoop;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _loop = function(i) {
                                var tag = _tags[i];
                                var iconId = _this8.getTagIconId(tag);
                                if (iconId && !_this8.tagIcons.some(function(icon) {
                                    return (icon === null || icon === void 0 ? void 0 : icon.iconId) === iconId;
                                })) {
                                    var tagIconUrl = void 0;
                                    if (tag.iconFile) {
                                        if (tag.iconFile.startsWith("http")) {
                                            tagIconUrl = "".concat(tag.iconFile);
                                        } else {
                                            tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(tag.tourId, "/tags/icons/").concat(tag.iconFile);
                                        }
                                    } else if (tag.icon) {
                                        tagIconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.icon, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle);
                                    }
                                    _this8.tagIcons.push({
                                        iconId: iconId,
                                        url: tagIconUrl
                                    });
                                }
                            };
                            if (_tags.length) {
                                _ctx.next = 5;
                                break;
                            }
                            _this8.setState({
                                loadingTags: false
                            });
                            return _ctx.abrupt("return", _tags);
                        case 5:
                            allTags = _this8.state.allTags;
                            loadedMattertags = Mattertag.getMatterTags();
                            tagsSize = _tags.length;
                            _this8.tagIcons = [];
                            for(i = 0; i < tagsSize; i += 1)_loop(i);
                            registerIconsPromises = _this8.tagIcons.map(_this8.registerIcon);
                            _ctx.next = 13;
                            return Promise.all(registerIconsPromises);
                        case 13:
                            processTags = function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                                    var editedTag, foundAddTag;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                editedTag = (0,_object_spread/* default */.Z)({}, tag);
                                                if (!(editedTag.modifiedTag && loadedMattertags.has(tag.sid))) {
                                                    _ctx.next = 6;
                                                    break;
                                                }
                                                _ctx.next = 4;
                                                return _this8.editMattertag(editedTag);
                                            case 4:
                                                allTags.set(editedTag.sid, editedTag);
                                                return _ctx.abrupt("return");
                                            case 6:
                                                if (!(!editedTag.modifiedTag && !loadedMattertags.has(tag.sid))) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                foundAddTag = Array.from(allTags, function(param) {
                                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                                    return value;
                                                }).find(function(item) {
                                                    return item.id === tag.id && item.added;
                                                });
                                                if (foundAddTag) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                editedTag.defaultSid = editedTag.sid;
                                                allTags.delete(editedTag.sid);
                                                _ctx.next = 13;
                                                return _this8.addMattertag(editedTag);
                                            case 13:
                                                editedTag.sid = _ctx.sent;
                                                editedTag.added = true;
                                            case 15:
                                                allTags.set(editedTag.sid, editedTag);
                                            case 16:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function processTags(tag) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            tagsTimeout = function(t) {
                                return new Promise(function(resolve) {
                                    setTimeout((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return processTags(t);
                                                case 2:
                                                    resolve();
                                                case 3:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    })), 1);
                                });
                            };
                            tagsLoop = function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    var i, t;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                i = 0;
                                            case 1:
                                                if (!(i < _tags.length)) {
                                                    _ctx.next = 8;
                                                    break;
                                                }
                                                t = _tags[i];
                                                _ctx.next = 5;
                                                return tagsTimeout(t);
                                            case 5:
                                                i += 1;
                                                _ctx.next = 1;
                                                break;
                                            case 8:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function tagsLoop() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            _ctx.next = 18;
                            return tagsLoop();
                        case 18:
                            return _ctx.abrupt("return", allTags);
                        case 21:
                            _ctx.prev = 21;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        21
                    ]
                ]);
            }));
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleVisibleTags = function(tags, isVisible) {
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            tags.forEach(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_tag) {
                    var sid, mpTooltip, mpNavigation, src, preventOpening, preventNavigating;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                sid = _tag.sid, mpTooltip = _tag.mpTooltip, mpNavigation = _tag.mpNavigation;
                                if (!(isVisible && _this1.visibleTags[sid])) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 3:
                                if (isVisible) _this1.visibleTags[sid] = true;
                                else _this1.visibleTags[sid] = false;
                                if (!(!isVisible && _this1.hiddenTags[sid])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 6:
                                if (!isVisible) _this1.hiddenTags[sid] = true;
                                else _this1.hiddenTags[sid] = false;
                                if (_tag.type === Tag/* TagType.Music */.Qy.Music && !isVisible) {
                                    src = "".concat("https://cdn.treedis.com", "/tours/").concat(_this1.state.tour.id, "/tags/").concat(_tag.url);
                                    if (_this1.tagAudio && _this1.tagAudio.src === src) {
                                        _this1.tagAudio.pause();
                                        _this1.tagAudio.src = "";
                                    }
                                }
                                _ctx.next = 10;
                                return _this1.showcase.Mattertag.editOpacity(sid, isVisible ? _tag.opacity / 100 : 0).catch(function(e) {
                                    return console.error(e);
                                });
                            case 10:
                                _ctx.next = 12;
                                return _this1.showcase.Mattertag.editPosition(sid, {
                                    anchorPosition: {
                                        x: _tag.positionX,
                                        y: _tag.positionY,
                                        z: _tag.positionZ
                                    },
                                    stemVector: {
                                        x: isVisible ? _tag.stemVectorX : 0,
                                        y: isVisible ? _tag.stemVectorY : 0,
                                        z: isVisible ? _tag.stemVectorZ : 0
                                    },
                                    floorIndex: _tag.floor
                                }).catch(function(e) {
                                    return console.error(e);
                                });
                            case 12:
                                preventOpening = isVisible ? !mpTooltip : true;
                                preventNavigating = isVisible ? !mpNavigation : true;
                                _ctx.next = 16;
                                return _this1.showcase.Mattertag.preventAction(sid, {
                                    opening: preventOpening,
                                    navigating: preventNavigating
                                }).catch(function(e) {
                                    return console.error(e);
                                });
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(_tag) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        _this.filterTags = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, allTags = _state.allTags, _$tourType = _state.tourType, loadingTags = _state.loadingTags;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return; // we skip filtering if it's game
            if (loadingTags) return;
            var activeGroup = Array.isArray(sweepGroups) ? sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup && sg.hideTags;
            }) : false;
            var tagsToRemove = [];
            var tagsToInit = [];
            if (allTags && allTags.size) {
                allTags.forEach(function(tag) {
                    var ref;
                    var found = activeGroup === null || activeGroup === void 0 ? void 0 : (ref = activeGroup.tags) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return item.tagSid === tag.sid || item.tagSid === tag.defaultSid;
                    });
                    if (found || !activeGroup) {
                        tagsToInit.push(tag);
                    } else {
                        tagsToRemove.push(tag);
                    }
                });
            }
            _this.toggleVisibleTags(tagsToRemove, false);
            _this.toggleVisibleTags(tagsToInit, true);
        };
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleToggleMusic = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var forceMusicPause, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        forceMusicPause = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        _ctx.prev = 1;
                        if (!_this9.tourAudio) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 5;
                        return _this9.pauseAllAudio("tourAudio");
                    case 5:
                        if (!_this9.tourAudio.paused) {
                            _ctx.next = 12;
                            break;
                        }
                        if (_this9.state.vsAudio) {
                            _this9.state.vsAudio.component.toggleMute();
                            _this9.state.vsAudio.btn.setActive(true);
                            _this9.setState({
                                vsAudio: null
                            });
                        }
                        _ctx.next = 9;
                        return _this9.tourAudio.play();
                    case 9:
                        _this9.setState({
                            mainPlaying: true,
                            otherPlaying: false,
                            forceMusicPause: false
                        });
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.next = 14;
                        return _this9.tourAudio.pause();
                    case 14:
                        _this9.setState({
                            mainPlaying: false,
                            otherPlaying: false,
                            forceMusicPause: forceMusicPause
                        });
                    case 15:
                        _ctx.next = 19;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        var _this10 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeFloor = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(floorIndex) {
                var _$all, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _$all = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            _ctx.prev = 1;
                            _this10.setState({
                                panoramaOn: false
                            });
                            _ctx.next = 5;
                            return _this10.showCaseTemp.floor.changeFloor(floorIndex, _this10.state.tourPlaying, _$all);
                        case 5:
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function(floorIndex) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playTour = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _this11.setState({
                            panoramaOn: false
                        });
                        _ctx.next = 4;
                        return _this11.showCaseTemp.tour.playTour(_this11.state.tourPlaying, _this11.state.reelStep);
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        var _this12 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeViewMode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(mode) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _this12.setState({
                                panoramaOn: false
                            });
                            _ctx.next = 4;
                            return _this12.showCaseTemp.tour.changeViewMode(mode, _this12.state.tourPlaying);
                        case 4:
                            _ctx.next = 9;
                            break;
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(mode) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this13 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.measurementsMode = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this13.showCaseTemp.tour.measurementsMode(_this13.state.tourPlaying);
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        _this.takePosition = function(event) {
            // ctrl+y
            if (event.ctrlKey && event.keyCode === 89) {
                var _state = _this.state, _tour = _state.tour, slug = _tour.slug, matterId = _tour.matterId;
                takePositionData({
                    slug: slug,
                    matterId: matterId,
                    sweep: _this.pose.sweep,
                    rotation: _this.pose.rotation
                });
            }
        };
        var _this14 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.closeTagPop = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, showcaseLoaded, host, room;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this14.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("close-tag");
                        }
                        _ctx.next = 4;
                        return _this14.resumeTourMusic();
                    case 4:
                        _this14.setState({
                            tagPopOn: false,
                            openedTag: null,
                            closedElementPopup: true
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.closeConditionPopUp = function() {
            _this.setState({
                conditionPopUp: null
            });
        };
        _this.closeGameLockPop = function(isCorrect) {};
        var _this15 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeTagIconAndColor = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag, icon, color) {
                var iconId, iconUrl;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            iconId = "".concat(icon, "__").concat(Math.random());
                            iconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(icon, "?hex=").concat(encodeURIComponent(color));
                            _ctx.next = 4;
                            return _this15.showcase.Mattertag.registerIcon(iconId, iconUrl).catch(function(e) {
                                ;
                            });
                        case 4:
                            _ctx.next = 6;
                            return _this15.showcase.Mattertag.editIcon(tag.sid, iconId).catch(function(e) {
                                ;
                            });
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tag, icon, color) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closePanoPop = function() {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("close-pano-pop");
            }
            _this.setState({
                panoPopOn: false,
                openedPanoHotspot: null
            });
        };
        _this.closeActionPop = function() {
            if (_this.state.tourType === Tour/* TourType.Game */.v.Game) {
                _this.resumeTourMusic();
            }
            _this.setState({
                vsActionPopOn: false,
                closedElementPopup: true
            });
        };
        _this.closePathFinderPop = function() {
            _this.setState({
                showPathFinderPopup: false
            });
        };
        _this.showcaseLoad = function() {
            var ref, ref1;
            _this.showcaseLoader((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK);
        };
        var _this16 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveModel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url) {
                var keepRotation, instant, THREE, ref, id, iframeId, linkData, rand, linkDataShort, q, quaternion, rotation, xr, yr, zr, mode, position, rotation1, scanId, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            keepRotation = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false, instant = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false;
                            _ctx.prev = 1;
                            THREE = index_modern/* ThreeInstance.get */.ur.get();
                            ref = getUrlVariables(url, _this16.state.iframeUrl), id = ref.id, iframeId = ref.iframeId, linkData = ref.linkData, rand = ref.rand, linkDataShort = ref.linkDataShort;
                            if (!linkData) {
                                _ctx.next = 17;
                                break;
                            }
                            q = linkData.camera_quaternion;
                            quaternion = new THREE.Quaternion(q.x, q.y, q.z, q.w);
                            rotation = new THREE.Euler().setFromQuaternion(quaternion, "YXZ") // @ts-ignore
                            .toVector3().multiplyScalar(180 / Math.PI);
                            if (keepRotation || linkData.showcase_sweep) {
                                rotation = _this16.pose.rotation;
                            }
                            if (!(id && iframeId && (id === null || id === void 0 ? void 0 : id.toLowerCase()) != (iframeId === null || iframeId === void 0 ? void 0 : iframeId.toLowerCase()))) {
                                _ctx.next = 13;
                                break;
                            }
                            {
                                _this16.iframe.removeEventListener("load", _this16.showcaseLoad);
                                _this16.iframe.addEventListener("load", _this16.showcaseLoad, {
                                    once: true
                                });
                                _this16.setState({
                                    iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&play=1&refreshid=").concat(rand),
                                    panoramaOn: false
                                }, function() {
                                    if (_this16.state.room && _this16.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.next = 15;
                            return _this16.moveToSweep(linkData.scan_id, rotation, instant ? "INSTANT" : "FLY");
                        case 15:
                            _ctx.next = 43;
                            break;
                        case 17:
                            if (!linkDataShort) {
                                _ctx.next = 42;
                                break;
                            }
                            xr = parseFloat(linkDataShort.sr[0] || "0");
                            yr = parseFloat(linkDataShort.sr[1] || "0");
                            zr = parseFloat(linkDataShort.sr[2] || "0");
                            mode = linkDataShort.sm === 2 ? _this16.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE : linkDataShort.sm === 3 ? _this16.showCaseTemp.showcase.Mode.Mode.FLOORPLAN : null;
                            position = null;
                            if (linkDataShort.sp) {
                                position = {
                                    x: parseFloat(linkDataShort.sp[0] || "0"),
                                    y: parseFloat(linkDataShort.sp[1] || "0"),
                                    z: parseFloat(linkDataShort.sp[2] || "0")
                                };
                            }
                            rotation1 = new THREE.Euler().set(xr, yr, zr, "XYZ").reorder("YXZ").toVector3().multiplyScalar(180 / Math.PI);
                            rotation1.z = 0;
                            if (keepRotation) rotation1 = _this16.pose.rotation;
                            if (!(id && iframeId && id.toLowerCase() != iframeId.toLowerCase())) {
                                _ctx.next = 31;
                                break;
                            }
                            {
                                _this16.iframe.removeEventListener("load", _this16.showcaseLoad);
                                _this16.iframe.addEventListener("load", _this16.showcaseLoad, {
                                    once: true
                                });
                                _this16.setState({
                                    iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&play=1&refreshid=").concat(rand),
                                    panoramaOn: false,
                                    activePano: null
                                }, function() {
                                    if (_this16.state.room && _this16.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                            _ctx.next = 40;
                            break;
                        case 31:
                            if (!linkDataShort.ss) {
                                _ctx.next = 37;
                                break;
                            }
                            scanId = _this16.state.deprecatedSweeps[linkDataShort.ss - 1].sweep_uuid.replace(/-/g, "");
                            _ctx.next = 35;
                            return _this16.moveToSweep(scanId, rotation1, instant ? "INSTANT" : "FLY");
                        case 35:
                            _ctx.next = 40;
                            break;
                        case 37:
                            if (!(linkDataShort.sm && position)) {
                                _ctx.next = 40;
                                break;
                            }
                            _ctx.next = 40;
                            return _this16.showCaseTemp.showcase.Mode.moveTo(mode, (0,_object_spread/* default */.Z)({
                                position: position,
                                rotation: rotation1,
                                transition: instant ? _this16.showCaseTemp.showcase.Mode.TransitionType.INSTANT : _this16.showCaseTemp.showcase.Mode.TransitionType.FLY
                            }, linkDataShort.sz && {
                                zoom: linkDataShort.sz
                            }));
                        case 40:
                            _ctx.next = 43;
                            break;
                        case 42:
                            if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
                                _this16.iframe.removeEventListener("load", _this16.showcaseLoad);
                                _this16.iframe.addEventListener("load", _this16.showcaseLoad, {
                                    once: true
                                });
                                // for no link data, just simple links
                                _this16.setState({
                                    iframeUrl: "".concat(url, "&qs=1&play=1&refreshid=").concat(rand),
                                    panoramaOn: false,
                                    activePano: null
                                }, function() {
                                    if (_this16.state.room && _this16.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                        case 43:
                            _this16.setState({
                                overlayOn: false,
                                markerPopupOn: false,
                                panoramaOn: false
                            });
                            _ctx.next = 49;
                            break;
                        case 46:
                            _ctx.prev = 46;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                        case 49:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        46
                    ]
                ]);
            }));
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.markerClick = function(hotspot) {
            _this.setState({
                minimapOn: false
            }, function() {
                if (hotspot.type === "panorama") {
                    var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
                    minimaps[selectedMinimap].hotspots.map(function(h) {
                        hotspot.active = h.id === hotspot.id;
                        return hotspot;
                    });
                    _this.setState({
                        panoramaOn: true,
                        minimaps: minimaps,
                        activePano: hotspot.panoramaId,
                        mapWalkerX: hotspot.x,
                        mapWalkerY: hotspot.y
                    });
                    return;
                }
                if (!hotspot.external) {
                    _this.setState({
                        overlayOn: false
                    });
                    if (hotspot.url) {
                        var whiteLabelData = _this.state.whiteLabelData;
                        var type = hotspot.url.includes("my.treedis.com") || hotspot.url.includes(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.domainUrl) || hotspot.url.includes("localhost:5000") ? Menu/* MenuType.Treedis */.o.Treedis : Menu/* MenuType.Matterport */.o.Matterport;
                        _this.loadModel(null, hotspot.url, type);
                    } else {
                        var ref, ref1;
                        var start = encodeURIComponent(JSON.stringify({
                            camera_mode: 1,
                            scan_id: hotspot.scanId,
                            showcase_sweep: hotspot.showcaseSweep,
                            camera_position: {
                                x: hotspot.positionX,
                                y: hotspot.positionY,
                                z: hotspot.positionZ
                            },
                            camera_quaternion: {
                                x: hotspot.rotationX,
                                y: hotspot.rotationY,
                                z: hotspot.rotationZ,
                                w: hotspot.rotationW
                            }
                        }));
                        _this.moveModel("/mp-sdk/".concat("3.1.63", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(_this.state.tour.matterId, "&start=").concat(start));
                    }
                } else {
                    _this.setState({
                        selectedMarker: {
                            url: hotspot.url,
                            external: hotspot.external
                        },
                        markerPopupOn: true,
                        overlayOn: true
                    });
                }
            });
        };
        _this.releaseLock = function() {
            _this.setState({
                lock: false
            });
        };
        _this.toggleAppointmentsModal = function() {
            _this.setState({
                appointmentsModal: !_this.state.appointmentsModal,
                appointmentsHintOn: false
            });
            _this.toggleExternalPopup();
        };
        _this.handleCustomButton = function() {
            var _state = _this.state, tour = _state.tour, externalPopupOn = _state.externalPopupOn;
            if (tour.customButtonOpenAs === Tour/* CustomButtonTypeOpenAsType.Tab */.Bg.Tab) {
                window.open(tour.customButtonUrl, "_blank");
                return;
            }
            if (externalPopupOn) return;
            _this.setState({
                externalPopupUrl: tour.customButtonUrl,
                externalPopupOn: true
            });
        };
        _this.toggleNav = function() {
            var _state = _this.state, menuOpen = _state.menuOpen, _tour = _state.tour, menuAlwaysOpenMobile = _tour.menuAlwaysOpenMobile, menuAlwaysOpenDesktop = _tour.menuAlwaysOpenDesktop, _$tourType = _state.tourType;
            var menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager["default"].isMobile() ? menuAlwaysOpenMobile : menuAlwaysOpenDesktop);
            _this.setState({
                menuOpen: menuOpenForDevice || !menuOpen,
                menuOpened: true,
                activeMenu: null,
                MenuHintOn: false
            });
        };
        _this.disableContext = function(e) {
            e.preventDefault();
        };
        var _this17 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTourMusic = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tour) {
                var currentFloor, isTourMusic, music, ref, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            currentFloor = _this17.state.currentFloor;
                            isTourMusic = false;
                            music = tour.musics.find(function(item) {
                                return item.floor === currentFloor + 1;
                            });
                            if (!music && tour.music) {
                                ;
                                music = {
                                    autoplay: tour.autoplayMusic,
                                    url: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/music.mp3").concat(util_all/* getVersion */.bo(tour.updatedAt))
                                };
                                isTourMusic = music.url === ((ref = _this17.tourAudio) === null || ref === void 0 ? void 0 : ref.src);
                            }
                            _this17.setState({
                                interacted: true
                            });
                            if (!music) {
                                _ctx.next = 15;
                                break;
                            }
                            ;
                            if (!(((ref1 = _this17.tourAudio) === null || ref1 === void 0 ? void 0 : ref1.src) && isTourMusic)) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 9:
                            _ctx.next = 11;
                            return _this17.pauseAllAudio("tourAudio");
                        case 11:
                            _this17.createAudioStream("tourAudio", music.url, true);
                            if (music.autoplay && !(tour.noAudioMode && _this17.state.room) && // in case of Intro Screen is enables, the music
                            // should play after user clicks on play button
                            !_this17.state.showIntroScreen) {
                                if (deviceManager["default"].supportsTouch()) {
                                    _this17.setState({
                                        interacted: false
                                    });
                                    document.addEventListener("touchstart", function() {
                                        _this17.setState({
                                            interacted: true
                                        });
                                        _this17.playAudio();
                                    }, {
                                        once: true
                                    });
                                } else if (deviceManager["default"].isSafari() && !deviceManager["default"].isChrome()) {
                                    _this17.setState({
                                        interacted: false
                                    });
                                    document.addEventListener("click", function() {
                                        _this17.setState({
                                            interacted: true
                                        });
                                        _this17.playAudio();
                                    }, {
                                        once: true
                                    });
                                } else {
                                    _this17.playAudio();
                                }
                            }
                            _ctx.next = 20;
                            break;
                        case 15:
                            if (_this17.sweepAudio) {
                                _ctx.next = 18;
                                break;
                            }
                            _ctx.next = 18;
                            return _this17.pauseAllAudio();
                        case 18:
                            _this17.tagAudio = null;
                            _this17.setState({
                                mainPlaying: false,
                                otherPlaying: !!_this17.sweepAudio
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tour) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this18 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.pauseTourMusic = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(_this18.tourAudio && !_this18.tourAudio.ended && !_this18.tourAudio.paused)) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return _this18.handleToggleMusic(false);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this19 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.resumeTourMusic = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, forceMusicPause, vsAudio;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this19.state, forceMusicPause = _state.forceMusicPause, vsAudio = _state.vsAudio;
                        ;
                        if (!(_this19.tourAudio && _this19.tourAudio.paused && !_this19.tourAudio.ended && _this19.tourAudio.currentTime > 0 && !forceMusicPause && !vsAudio)) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return _this19.handleToggleMusic();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this20 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.loadData = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tourData) {
                var changeMenu, changeMinimap, changePanorama, url, ref, ref1, tour, stateTour, _$tourType, s, x, y, m, matterId, addons, menuOpenForDevice, initialDuplicates, menuOpen, china, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            changeMenu = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true, changeMinimap = _args.length > 2 && _args[2] !== void 0 ? _args[2] : true, changePanorama = _args.length > 3 && _args[3] !== void 0 ? _args[3] : true, url = _args.length > 4 && _args[4] !== void 0 ? _args[4] : null;
                            ;
                            tour = new Tour/* Tour */.Oj(tourData);
                            stateTour = _this20.state.tour;
                            _$tourType = _this20.state.tourType;
                            if (url) {
                                s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                                x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                                y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                                if (s && x && y) {
                                    window.history.replaceState(null, "", _this20.buildLink(s, {
                                        x: x,
                                        y: y
                                    }));
                                }
                            }
                            if (!changeMenu && stateTour) {
                                tour.reel = stateTour.reel;
                                tour.menuEnabled = stateTour.menuEnabled;
                                tour.menuAlwaysOpenMobile = stateTour.menuAlwaysOpenMobile;
                                tour.menuAlwaysOpenDesktop = stateTour.menuAlwaysOpenDesktop;
                            }
                            if (!changePanorama && stateTour) tour.panorama = stateTour.panorama;
                            if (!changeMinimap && stateTour) {
                                tour.originX = stateTour.originX;
                                tour.originY = stateTour.originY;
                                tour.height = stateTour.height;
                                tour.width = stateTour.width;
                                tour.ppm = stateTour.ppm;
                                tour.customMinimap = stateTour.customMinimap;
                                tour.minimap = true;
                            }
                            m = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "m");
                            matterId = m ? atob(decodeURIComponent(String(m))) : tour.matterId;
                            if (_this20.state.room) {
                                if (_this20.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: matterId,
                                        mp: false
                                    });
                                } else if (matterId !== tour.matterId) {
                                    // if host uses a Tour Link, matterId should be updated with id of next tour
                                    matterId = tour.matterId;
                                }
                            }
                            addons = tour.getAddonsUrl();
                            if (tour.introScreen) {
                                addons = addons.replace(/qs=0/g, "qs=1");
                            }
                            menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager["default"].isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
                            if (!(tourData === null || tourData === void 0 ? void 0 : tourData.initialDuplicates)) {
                                _ctx.next = 19;
                                break;
                            }
                            _ctx.t0 = tourData.initialDuplicates;
                            _ctx.next = 22;
                            break;
                        case 19:
                            _ctx.next = 21;
                            return (ref = TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tour.parentId || tour.id)) === null || ref === void 0 ? void 0 : ref.duplicates;
                        case 21:
                            _ctx.t0 = _ctx.sent;
                        case 22:
                            initialDuplicates = _ctx.t0;
                            menuOpen = changeMenu ? _this20.state.room && !_this20.state.host ? false : tour.menuOnStart || menuOpenForDevice || false : _this20.state.menuOpen;
                            china = util_all/* getQueryVariable */.Dv(window.location.href, "china");
                            _this20.setState({
                                initialDuplicates: initialDuplicates,
                                menuOpen: menuOpen,
                                changeMenu: changeMenu,
                                tour: tour,
                                isVSEnabled: tour.enableVS,
                                allowGuestBeforeHost: tour.allowGuestBeforeHost,
                                showIntroScreen: !isEmpty_default()(tour.introScreen) && !tour.matterPassword,
                                minimapVisible: tour.minimapVisible && !_this20.state.room && window.innerWidth > 768,
                                iframeUrl: "/mp-sdk/".concat("3.1.63", "/showcase").concat(china ? "-china" : "", ".html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref1 = tour.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(matterId).concat(addons, "&gl2=1"),
                                appointmentsHintOn: tour.appointmentTooltipOn
                            }, function() {
                                if (_this20.iframe) {
                                    _this20.iframe.addEventListener("load", _this20.showcaseLoad, {
                                        once: true
                                    });
                                }
                                if (tour.disableContext) {
                                    document.addEventListener("contextmenu", _this20.disableContext);
                                }
                                (0,util_all/* fetchData */.rQ)("public/getAgentsContactForm/".concat(tour.id), "GET").then(function(data) {
                                    var agents = data.agents.map(function(a) {
                                        return new Agent/* Agent */.P(a.agent);
                                    });
                                    _this20.setState({
                                        agents: agents
                                    });
                                }).catch(function(err) {
                                    ;
                                });
                                if (tour.minimap && changeMinimap) {
                                    (0,util_all/* fetchData */.rQ)("public/getMinimaps", "POST", {
                                        id: tour.id
                                    }).then(function(data) {
                                        var minimaps = data.minimaps;
                                        _this20.setState({
                                            minimaps: minimaps
                                        });
                                    }).catch(function(err) {
                                        ;
                                    });
                                }
                                if (tour.panorama && changePanorama) {
                                    (0,util_all/* fetchData */.rQ)("public/getPanoramas", "POST", {
                                        id: tour.id
                                    }).then(function(data) {
                                        var panoramas = data.panoramas;
                                        var pano = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "pano");
                                        var pitch = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoPitch"))) || 0;
                                        var yaw = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoYaw"))) || 0;
                                        var hfov = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoHfov"))) || 0;
                                        _this20.setState({
                                            panoramas: panoramas,
                                            activePano: pano && parseInt(String(pano)),
                                            panoramaOn: tour.panoramaStart || Boolean(pano),
                                            panoPose: {
                                                pitch: pitch,
                                                yaw: yaw,
                                                hfov: hfov
                                            }
                                        });
                                    }).catch(function(err) {
                                        ;
                                    });
                                }
                                TreedisPublicDAO/* default.getGroups */.Z.getGroups({
                                    id: tour.id
                                }).then(function(groupsData) {
                                    _this20.setState({
                                        sweepGroups: (groupsData === null || groupsData === void 0 ? void 0 : groupsData.groups) || []
                                    });
                                });
                                if (tour.gameId) {
                                    (0,util_all/* fetchData */.rQ)("public/getGame", "POST", {
                                        id: tour.gameId
                                    }).then(function(data) {
                                        var ref;
                                        var game = new Game/* Game */.lA(data === null || data === void 0 ? void 0 : data.game);
                                        _this20.gameAnalytic = new GameAnalyticService(game.id);
                                        _this20.setState({
                                            showIntro: game.introClip && game.introClipUrl,
                                            gameLoaded: true,
                                            game: game,
                                            showBook: game === null || game === void 0 ? void 0 : (ref = game.book) === null || ref === void 0 ? void 0 : ref.openByDefault
                                        });
                                    }).catch(function(err) {
                                        var ref, ref1, ref2, ref3, ref4;
                                        if (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.message) === null || ref2 === void 0 ? void 0 : ref2.includes("trial")) _this20.setState({
                                            gameTrialErr: err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message
                                        });
                                        ;
                                    });
                                }
                            });
                        case 26:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tourData) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getProducts = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tourId, userId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", []);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tourId, userId) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this21 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.showcaseLoader = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(applicationKey) {
                var showcase, starting;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (_this21.iframe.contentWindow.MP_SDK) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.next = 5;
                            return _this21.iframe.contentWindow.document.addEventListener("keydown", _this21.takePosition);
                        case 5:
                            _ctx.next = 7;
                            return (0,index_modern/* GetSDK */.xe)(_this21.iframe, {
                                applicationKey: applicationKey || "295ba0c0f04541318359a8e75af33043",
                                appDomain: "https://api.treedis.com" || 0,
                                version: "3.1.63",
                                logoUrl: null,
                                appAws: "https://cdn.treedis.com"
                            });
                        case 7:
                            showcase = _ctx.sent;
                            _this21.showcase = showcase.showcase;
                            _this21.showCaseTemp = showcase;
                            _this21.loadedShowcaseHandler();
                            _this21.showCaseTemp.on(index_modern/* TourLoaderEventsType.LOADING */.$D.LOADING, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _this21.loadingQueue.setLoadingQueueProgress(80, 100);
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            starting = false;
                            _this21.showCaseTemp.on(index_modern/* TourLoaderEventsType.STARTING */.$D.STARTING, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var models;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            starting = true;
                                            _ctx.next = 3;
                                            return _this21.showCaseTemp.showcase.Scene.query([
                                                "model"
                                            ]);
                                        case 3:
                                            models = _ctx.sent;
                                            _this21.camera = models[0].parent.children[0];
                                            _ctx.next = 7;
                                            return _this21.showCaseTemp.scene.configureThreeInstance();
                                        case 7:
                                            _this21.initStarting();
                                        case 8:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            _this21.showCaseTemp.on(index_modern/* TourLoaderEventsType.PLAYING */.$D.PLAYING, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var models, watchErrorElem;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (starting) {
                                                _ctx.next = 9;
                                                break;
                                            }
                                            _ctx.next = 3;
                                            return _this21.showCaseTemp.showcase.Scene.query([
                                                "model"
                                            ]);
                                        case 3:
                                            models = _ctx.sent;
                                            _this21.camera = models[0].parent.children[0];
                                            _ctx.next = 7;
                                            return _this21.showCaseTemp.scene.configureThreeInstance();
                                        case 7:
                                            _ctx.next = 9;
                                            return _this21.initStarting();
                                        case 9:
                                            _this21.initPlaying();
                                            _this21.initScene();
                                            _this21.initSweep();
                                            watchErrorElem = _this21.iframe.contentWindow.document.body.querySelector("#error-container");
                                            (0,util/* setErrorObserver */.D2)(watchErrorElem, function(pageCrashed, observer) {
                                                _this21.setState({
                                                    crashScreen: pageCrashed
                                                });
                                                observer.disconnect();
                                            });
                                        case 14:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }));
            return function(applicationKey) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.adjustVSToTourMode = function() {
            var _state = _this.state, tourMode = _state.tourMode, _$tourType = _state.tourType;
            var outside = _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE;
            if (_$tourType === Tour/* TourType.Game */.v.Game) return;
            if (tourMode !== _this.pose.mode) {
                // mode changing
                if (_this.pose.mode === outside) {
                    // going outside, disable vs
                    _this.stopVS();
                } else if (tourMode === outside && _this.pose.mode !== outside) {
                    // going from outside to inside, init VS
                    _this.initVS();
                }
                _this.setState({
                    tourMode: _this.pose.mode
                });
            }
        };
        var _this22 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPlaying = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, loadedOnce, iframeUrl, matterId, url, s, x, y;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this22.state, tour = _state.tour, loadedOnce = _state.loadedOnce, iframeUrl = _state.iframeUrl;
                        _this22.setState({
                            appState: "playing"
                        });
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        url = window.location.href;
                        s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                        x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                        y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                        if (s && x && y) {
                            // We move inside the tour
                            _this22.moveToSweep(String(s), {
                                x: parseFloat(x),
                                y: parseFloat(y)
                            });
                        }
                        if (!loadedOnce) {
                            (0,analytic/* startGA */.Rj)(tour, true);
                        }
                        // TODO:: Remove when Matterport will fix problem with current floor
                        if (matterId === "VE4rJCNFfba") {
                            _this22.floor.floor = 2;
                        }
                        _this22.setState({
                            loadedOnce: true
                        }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var ref, hash, polygons, ref1;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (tour.addon_ts >= 0 && tour.mpPlay) {
                                            setTimeout(function() {
                                                _this22.playTour();
                                            }, tour.addon_ts * 1000);
                                        }
                                        _ctx.prev = 1;
                                        ;
                                        hash = window.location.hash.substring(1);
                                        if (hash) {
                                            _this22.loadModel(null, null, Menu/* MenuType.Product */.o.Product, hash, null);
                                        }
                                        _this22.processTourMusic(tour);
                                        polygons = _this22.state.polygons;
                                        _ctx.next = 9;
                                        return _this22.showCaseTemp.scene.configureScene({
                                            settings: _this22.state.vsSettings,
                                            onShadowEnabled: function(value) {
                                                _this22.isShadowEnabled = value;
                                            },
                                            onShadowNodeCreated: function(shadowNode) {
                                                _this22.shadowNode = shadowNode;
                                            },
                                            cb: function() {
                                                _this22.setState({
                                                    isVSReady: true
                                                });
                                            }
                                        });
                                    case 9:
                                        _ctx.next = 11;
                                        return _this22.showCaseTemp.showcase.Scene.register(virtualStaging_avatar/* avatarComponentType */.bB, virtualStaging_avatar/* makeAvatarComponent */.Sr);
                                    case 11:
                                        if (!((polygons === null || polygons === void 0 ? void 0 : polygons.length) || ((ref = _this22.vsObjects) === null || ref === void 0 ? void 0 : ref.length))) {
                                            _ctx.next = 19;
                                            break;
                                        }
                                        ;
                                        if (!(polygons === null || polygons === void 0 ? void 0 : polygons.length)) {
                                            _ctx.next = 16;
                                            break;
                                        }
                                        _ctx.next = 16;
                                        return _this22.initPolygons();
                                    case 16:
                                        if (!((ref1 = _this22.vsObjects) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                                            _ctx.next = 19;
                                            break;
                                        }
                                        _ctx.next = 19;
                                        return _this22.initVS();
                                    case 19:
                                        _ctx.next = 21;
                                        return _this22.initAvatar();
                                    case 21:
                                        _ctx.next = 26;
                                        break;
                                    case 23:
                                        _ctx.prev = 23;
                                        _ctx.t0 = _ctx["catch"](1);
                                        ;
                                    case 26:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    1,
                                    23
                                ]
                            ]);
                        })));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this23 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initStarting = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, _$tourType, showcaseLoaded, isChangeIframe, iframeUrl, showIntroScreen, condition, matterId, tagsRes, mpTags, treedisTags, isMatterportLink, ref, polygons, vsObjects, vsSettings, products, ref1, THREE, pose, isVisibleAsset;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _this23.setState({
                            appState: "starting"
                        });
                        _state = _this23.state, tour = _state.tour, _$tourType = _state.tourType, showcaseLoaded = _state.showcaseLoaded, isChangeIframe = _state.isChangeIframe, iframeUrl = _state.iframeUrl, showIntroScreen = _state.showIntroScreen;
                        condition = _$tourType === Tour/* TourType.Game */.v.Game ? true : !showcaseLoaded || isChangeIframe;
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        if (condition) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        _this23.loadingQueue.setLoadingQueueProgress(70, 100);
                        _ctx.next = 10;
                        return TreedisPublicDAO/* default.getTags */.Z.getTags({
                            matterId: matterId,
                            slug: matterId === tour.matterId ? tour.slug : null
                        });
                    case 10:
                        tagsRes = _ctx.sent;
                        mpTags = tagsRes.matterTags;
                        treedisTags = tagsRes.tags;
                        _this23.loadingQueue.setLoadingQueueProgress(60, 100);
                        isMatterportLink = (0,util_all/* getQueryVariable */.Dv)(_this23.state.iframeUrl, "m") !== tour.matterId;
                        _ctx.next = 17;
                        return getVSItems(isMatterportLink, {
                            slug: tour.slug,
                            userId: tour.userId,
                            id: tour.id,
                            tourType: _$tourType
                        });
                    case 17:
                        ref = _ctx.sent;
                        polygons = ref.polygons;
                        vsObjects = ref.vsObjects;
                        vsSettings = ref.vsSettings;
                        products = ref.products;
                        _this23.loadingQueue.setLoadingQueueProgress(50, 100);
                        _this23.vsObjects = vsObjects.filter(function(obj) {
                            return obj.active;
                        }); // TODO: move to backend..
                        // if no VS objects, Media Images of Media Videos found - loadingQueueProgress is set to 100%
                        // to do not display the loading indicator for VS
                        if (!_this23.vsObjects.length || !showIntroScreen) {
                            //if there is no intro screen, we don't wait for VS!
                            _this23.loadingQueue.setFullLoadingQueueProgress();
                        } else if (_this23.pose) {
                            ;
                            THREE = index_modern/* ThreeInstance.get */.ur.get();
                            pose = new THREE.Vector3((ref1 = _this23.pose) === null || ref1 === void 0 ? void 0 : ref1.position.x, _this23.pose.position.y, _this23.pose.position.z);
                            isVisibleAsset = _this23.vsObjects.find(function(asset) {
                                var assetPose = new THREE.Vector3(asset.positionX, asset.positionY, asset.positionZ);
                                var distance = pose.distanceTo(assetPose);
                                return distance <= DEFAULT_VS_SENSOR_RADIUS;
                            });
                            if (!isVisibleAsset) {
                                _this23.loadingQueue.setFullLoadingQueueProgress();
                            }
                        }
                        _this23.setState({
                            allTags: new Map(),
                            polygons: polygons,
                            products: products,
                            vsSettings: vsSettings,
                            isProductsLoaded: true
                        }, function() {
                            Mattertag.subscribe({
                                mpSdk: _this23.showCaseTemp.showcase,
                                mpTags: mpTags,
                                treedisTags: treedisTags
                            }, function(allTags) {
                                _this23.setState({
                                    allTags: allTags
                                }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    var _$allTags, tags;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _$allTags = _this23.state.allTags;
                                                _ctx.next = 3;
                                                return _this23.initTags(Array.from(_$allTags.values()));
                                            case 3:
                                                tags = _ctx.sent;
                                                _this23.setState({
                                                    loadingTags: false,
                                                    allTags: tags
                                                }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                try {
                                                                    _this23.hiddenTags = {};
                                                                    _this23.visibleTags = {};
                                                                    _this23.filterTags();
                                                                } catch (err) {
                                                                    ;
                                                                }
                                                            case 1:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })));
                                            case 5:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })));
                            });
                            _this23.setState({
                                showcaseLoaded: true,
                                isChangeIframe: false
                            });
                        });
                        _ctx.next = 31;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    28
                ]
            ]);
        }));
        var _this24 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initSweep = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this24.showCaseTemp.sweep.subscribe(function(sweeps) {
                            _this24.setState({
                                sweeps: sweeps,
                                sweepsLoaded: true
                            }, function() {
                                return afterSweepsInit({
                                    sweeps: _this24.state.sweeps,
                                    matterId: _this24.state.tour.matterId,
                                    slug: _this24.state.tour.slug,
                                    iframeUrl: _this24.state.iframeUrl,
                                    setData: function(data) {
                                        _this24.setState(data);
                                    },
                                    cb: function() {
                                        var s = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "s");
                                        var x = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "x");
                                        var y = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "y");
                                        if (_this24.pose.mode === _this24.showCaseTemp.showcase.Mode.Mode.INSIDE && s && x && y) {
                                            if (_this24.state.sweeps.some(function(sweep) {
                                                return s === sweep.uuid;
                                            })) {
                                                _this24.moveToSweep(String(s), {
                                                    x: parseFloat(x),
                                                    y: parseFloat(y)
                                                });
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this25 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initScene = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this25.showCaseTemp.tag.on(index_modern/* TagEventsType.OpenTagIframe */.Gc.OpenTagIframe, function(param) {
                            var event = param.event, tagId = param.tagId;
                            if (event === _this25.showCaseTemp.tags.matterTag.Event.CLICK) {
                                _this25.setState({
                                    clickedElement: {
                                        id: tagId,
                                        type: Game/* EntityType.Tag */.py.Tag
                                    }
                                });
                            }
                        });
                        _this25.showCaseTemp.scene.sceneObject.on(index_modern/* NodeEventsTypes.OBJECT_CLICK */.cA.OBJECT_CLICK, function(param) {
                            var data = param.data;
                            if (_this25.state.tourType === Tour/* TourType.Game */.v.Game) {
                                _this25.openVsObjectIframe(data);
                            }
                            _this25.setState({
                                clickedElement: {
                                    id: data.details.id,
                                    type: Game/* EntityType.VSItem */.py.VSItem
                                }
                            });
                        });
                        _this25.showCaseTemp.scene.sceneImage.on(index_modern/* NodeEventsTypes.IMAGE_HOVER */.cA.IMAGE_HOVER, function(param) {
                            var eventData = param.eventData, data = param.data;
                            if (data.actionType === VSObject/* TourImageActionType.None */.rx.None) {
                                return;
                            }
                            _this25.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                            if (data.action === VSObject/* TourImageAction.Hover */.Z5.Hover && eventData.hover) {
                                _this25.handleImageAction(data);
                            }
                        });
                        _this25.showCaseTemp.scene.sceneImage.on(index_modern/* NodeEventsTypes.IMAGE_CLICK */.cA.IMAGE_CLICK, function(param) {
                            var eventData = param.eventData, data = param.data;
                            if (_this25.state.tourType === Tour/* TourType.Game */.v.Game) {
                                _this25.openVsImageIframe(data);
                            }
                            if (data.actionType === VSObject/* TourImageActionType.None */.rx.None) {
                                return;
                            }
                            if (data.action === VSObject/* TourImageAction.Click */.Z5.Click) {
                                _this25.handleImageAction(data);
                            }
                            _this25.setState({
                                clickedElement: {
                                    id: data.details.id,
                                    type: Game/* EntityType.VSImage */.py.VSImage
                                }
                            });
                        });
                        _this25.showCaseTemp.scene.sceneImage.on(index_modern/* NodeEventsTypes.AVATAR_BUTTON_HOVER */.cA.AVATAR_BUTTON_HOVER, function(param) {
                            var eventData = param.eventData;
                            _this25.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                        });
                        _this25.showCaseTemp.scene.scenePolygon.on(index_modern/* NodeEventsTypes.POLYGON_EVENTS */.cA.POLYGON_EVENTS, function(param) {
                            var type = param.type, component = param.component, eventData = param.eventData, data = param.data;
                            var handleAction = function(action, eventType, eventData) {
                                if (!action) {
                                    return;
                                }
                                if (action.type === Polygon/* PolygonActionType.None */.zS.None) {
                                    return;
                                }
                                if (action.action === Polygon/* PolygonActionAction.Hover */.IW.Hover && eventType === VSObject/* VSInteractionType.HOVER */.IG.HOVER && eventData.hover) {
                                    _this25.handlePolygonAction(action);
                                }
                                if (action.action === Polygon/* PolygonActionAction.Click */.IW.Click && eventType === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                    _this25.handlePolygonAction(action);
                                }
                            };
                            var isGameTour = _this25.state.tourType === Tour/* TourType.Game */.v.Game && _this25.state.tour.gameId;
                            var isECommerceTour = _this25.state.tourType === Tour/* TourType.ECommerce */.v.ECommerce;
                            if (type === VSObject/* VSInteractionType.HOVER */.IG.HOVER) {
                                _this25.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                            }
                            if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                var ref;
                                _this25.setState({
                                    clickedElement: {
                                        id: (data === null || data === void 0 ? void 0 : (ref = data.details) === null || ref === void 0 ? void 0 : ref.id) || (data === null || data === void 0 ? void 0 : data.id),
                                        type: Game/* EntityType.Polygon */.py.Polygon
                                    }
                                });
                            }
                            if (isGameTour) {
                                if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                    // @ts-ignore
                                    var result = _this25.handlePolygonLock && _this25.handlePolygonLock(data.id);
                                    _this25.unlockChapter && _this25.unlockChapter(data, GameBook/* ChapterType.Polygon */._U.Polygon);
                                    if (result) {
                                        var action = data.polygonsActions.find(function(i) {
                                            return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                                        });
                                        var polygonAction = new Polygon/* PolygonAction */.fD(action);
                                        handleAction(polygonAction, type, eventData);
                                        if (polygonAction.gameBackpack && !_this25.state.polygonsBackpack.find(function(param) {
                                            var id = param.id;
                                            return data.id === id;
                                        })) {
                                            _this25.setState({
                                                polygonsBackpack: [
                                                    data
                                                ].concat((0,_to_consumable_array/* default */.Z)(_this25.state.polygonsBackpack))
                                            });
                                        }
                                    } else if (result === undefined) {
                                        component.setSelection();
                                    }
                                }
                            } else if (isECommerceTour && data.products.length && type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                _this25.handlePolygonProduct && _this25.handlePolygonProduct(data);
                            } else {
                                var action1 = data.polygonsActions.find(function(i) {
                                    return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                                });
                                handleAction(new Polygon/* PolygonAction */.fD(action1), type, eventData);
                            }
                        });
                        _this25.showCaseTemp.scene.sceneVideo.on(index_modern/* NodeEventsTypes.VIDEO_HOVER */.cA.VIDEO_HOVER, function(param) {
                            var data = param.data;
                        });
                        _this25.showCaseTemp.scene.sceneVideo.on(index_modern/* NodeEventsTypes.VIDEO_CLICK */.cA.VIDEO_CLICK, function(param) {
                            var data = param.data;
                            if (_this25.state.tourType === Tour/* TourType.Game */.v.Game) {
                                _this25.openVsVideoIframe(data);
                            }
                            _this25.setState({
                                clickedElement: {
                                    id: data.details.id,
                                    type: Game/* EntityType.VSVideo */.py.VSVideo
                                }
                            });
                        });
                        _this25.showCaseTemp.scene.sceneVideo.on(index_modern/* NodeEventsTypes.VIDEO_BUTTON_HOVER */.cA.VIDEO_BUTTON_HOVER, function(param) {
                            var eventData = param.eventData, data = param.data;
                            _this25.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                        });
                        _this25.showCaseTemp.scene.sceneVideo.on(index_modern/* NodeEventsTypes.VIDEO_BUTTON_CLICK */.cA.VIDEO_BUTTON_CLICK, function(param) {
                            var eventData = param.eventData, data = param.data, component = param.component, muteBtnComponent = param.muteBtnComponent;
                            if (component.isMuted()) {
                                var audio = _this25.getOtherAudio();
                                if (audio) {
                                    _this25.setState({
                                        restoreAudio: audio
                                    });
                                }
                                _this25.setState({
                                    vsAudio: {
                                        component: component,
                                        btn: muteBtnComponent
                                    }
                                }, function() {
                                    return _this25.pauseAllAudio("", false);
                                });
                            } else if (_this25.state.restoreAudio) {
                                _this25.state.restoreAudio.play();
                                _this25.setState({
                                    restoreAudio: null,
                                    otherPlaying: true
                                });
                            } else {
                                _this25.setState({
                                    vsAudio: null
                                }, function() {
                                    return _this25.resumeTourMusic();
                                });
                            }
                            if (muteBtnComponent.isActive()) {
                                var ref;
                                var vsVideos = (ref = _this25.vsObjects) === null || ref === void 0 ? void 0 : ref.filter(function(obj) {
                                    var ref, ref1, ref2, ref3;
                                    return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components) && ((ref2 = (ref1 = obj.node) === null || ref1 === void 0 ? void 0 : ref1.components[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.instance) === null || ref3 === void 0 ? void 0 : ref3.componentType) === videoRendererType;
                                });
                                vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                                    var ref;
                                    var ref1 = (0,_sliced_to_array/* default */.Z)((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components, 2), vsVideo = ref1[0], muteBtn = ref1[1];
                                    if (!muteBtn.instance.active) {
                                        vsVideo.instance.video.muted = true;
                                        muteBtn.instance.active = true;
                                        muteBtn.instance.makeBtn(muteBtn.instance.inputs.src);
                                    }
                                });
                            }
                            component.toggleMute();
                            muteBtnComponent.setActive(!muteBtnComponent.isActive());
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this26 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initObjectNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(asset) {
                var node;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (!(0,src_instanceof/* default */.Z)(asset, VSObject/* TourImage */.oP)) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 4;
                            return _this26.initImageNode(asset);
                        case 4:
                            node = _ctx.sent;
                            _ctx.next = 16;
                            break;
                        case 7:
                            if (!(0,src_instanceof/* default */.Z)(asset, VSObject/* TourVideo */.Up)) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.next = 10;
                            return _this26.initVideoNode(asset);
                        case 10:
                            node = _ctx.sent;
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.next = 15;
                            return _this26.initNode(asset);
                        case 15:
                            node = _ctx.sent;
                        case 16:
                            if (!(node === null || node === void 0 ? void 0 : node[0])) {
                                _ctx.next = 18;
                                break;
                            }
                            return _ctx.abrupt("return", node[0]);
                        case 18:
                            return _ctx.abrupt("return", null);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this27 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setVSVisible = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(vsObject, visible) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(visible && !vsObject.started)) {
                                _ctx.next = 7;
                                break;
                            }
                            vsObject.started = true; // we do it here because initObjectNode can take time
                            _ctx.next = 4;
                            return _this27.initObjectNode(vsObject);
                        case 4:
                            vsObject.node = _ctx.sent;
                            _ctx.next = 8;
                            break;
                        case 7:
                            if (!visible && vsObject.started && vsObject.node) {
                                vsObject.started = false;
                                vsObject.node.stop();
                            }
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(vsObject, visible) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this28 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVS = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _sensor, ref, isVSReady, isGameTour, isMPPano, handleSensorChange, sources;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ;
                        isVSReady = _this28.state.isVSReady;
                        isGameTour = _this28.state.tourType === Tour/* TourType.Game */.v.Game && _this28.state.tour.gameId;
                        if (isVSReady) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return _this28.isMPPano();
                    case 8:
                        isMPPano = _ctx.sent;
                        if (!isMPPano) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        (ref = _this28.sensor) === null || ref === void 0 ? void 0 : ref.dispose();
                        if (!isGameTour) {
                            _ctx.next = 15;
                            break;
                        }
                        _this28.vsObjects.forEach(function(obj) {
                            _this28.loadingQueue.enqueue((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return _this28.setVSVisible(obj, true);
                                        case 2:
                                            _this28.loadingQueue.dequeue();
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                        });
                        return _ctx.abrupt("return");
                    case 15:
                        _ctx.next = 17;
                        return _this28.showCaseTemp.showcase.Sensor.createSensor(_this28.showCaseTemp.showcase.Sensor.SensorType.CAMERA);
                    case 17:
                        // https://matterport.github.io/showcase-sdk/docs/sdkbundle/reference/current/modules/sensor.html
                        _this28.sensor = _ctx.sent;
                        handleSensorChange = function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(source, reading) {
                                var index, vsObject;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            index = _this28.vsObjects.findIndex(function(item) {
                                                return item.id === source.userData.id;
                                            });
                                            if (!(index < 0)) {
                                                _ctx.next = 3;
                                                break;
                                            }
                                            return _ctx.abrupt("return");
                                        case 3:
                                            vsObject = _this28.vsObjects[index];
                                            if (!reading.inRange) {
                                                _ctx.next = 8;
                                                break;
                                            }
                                            {
                                                _this28.loadingQueue.enqueue((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                _ctx.next = 2;
                                                                return _this28.setVSVisible(vsObject, true);
                                                            case 2:
                                                                _this28.loadingQueue.dequeue();
                                                            case 3:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })));
                                            }
                                            _ctx.next = 11;
                                            break;
                                        case 8:
                                            if (!vsObject.node) {
                                                _ctx.next = 11;
                                                break;
                                            }
                                            _ctx.next = 11;
                                            return _this28.setVSVisible(vsObject, false);
                                        case 11:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function handleSensorChange(source, reading) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        // start listening for changes to the sensor's readings, when not in game!
                        _this28.sensor.readings.subscribe({
                            onAdded: handleSensorChange,
                            onUpdated: handleSensorChange
                        });
                        _ctx.next = 22;
                        return Promise.all(_this28.vsObjects.map(function(asset) {
                            // @ts-ignore
                            var vsIdentifiers = {
                                isVSImage: Boolean(asset.isVSImage),
                                isVSVideo: Boolean(asset.isVSVideo)
                            };
                            return _this28.showCaseTemp.showcase.Sensor.createSource(_this28.showCaseTemp.showcase.Sensor.SourceType.SPHERE, {
                                origin: {
                                    x: asset.positionX,
                                    y: asset.positionY + 0.1,
                                    z: asset.positionZ
                                },
                                radius: DEFAULT_VS_SENSOR_RADIUS,
                                userData: (0,_object_spread/* default */.Z)({
                                    id: asset.id,
                                    uuid: asset.uuid
                                }, vsIdentifiers)
                            });
                        }));
                    case 22:
                        sources = _ctx.sent;
                        (_sensor = _this28.sensor).addSource.apply(_sensor, (0,_to_consumable_array/* default */.Z)(sources));
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this29 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopVS = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        try {
                            ;
                            _this29.vsObjects.map(function(asset) {
                                _this29.setVSVisible(asset, false);
                            });
                            (ref = _this29.sensor) === null || ref === void 0 ? void 0 : ref.dispose();
                        } catch (e) {
                            ;
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this30 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygons = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var promises;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        promises = _this30.state.polygons.map(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                var node;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (item.active) {
                                                _ctx.next = 2;
                                                break;
                                            }
                                            return _ctx.abrupt("return", item);
                                        case 2:
                                            if (item.uuid) {
                                                _ctx.next = 9;
                                                break;
                                            }
                                            _ctx.next = 5;
                                            return _this30.initPolygonNode(item);
                                        case 5:
                                            node = _ctx.sent;
                                            _this30.modelNodes.push(node);
                                            item.uuid = node[0].obj3D.uuid;
                                            return _ctx.abrupt("return", item);
                                        case 9:
                                            return _ctx.abrupt("return", item);
                                        case 10:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx.t0 = _this30;
                        _ctx.next = 4;
                        return Promise.all(promises);
                    case 4:
                        _ctx.t1 = _ctx.sent;
                        _ctx.t2 = {
                            polygons: _ctx.t1
                        };
                        _ctx.t0.setState.call(_ctx.t0, _ctx.t2);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this31 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this31.showCaseTemp.scene.sceneObject.create(data);
                        case 2:
                            res = _ctx.sent;
                            if (res.length) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 5:
                            return _ctx.abrupt("return", res);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this32 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initImageNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this32.showCaseTemp.scene.sceneImage.create(data);
                        case 2:
                            res = _ctx.sent;
                            if (res.length) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 5:
                            return _ctx.abrupt("return", res);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this33 = (0,_assert_this_initialized/* default */.Z)(_this);
        /*

  */ _this.initVideoNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var options, elementType, VimeoVideo, vimeoVideo, res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            options = {
                                vimeoURL: "",
                                withButton: {
                                    mute: "/images/mute_icon.png",
                                    unMute: "/images/unmute_icon.png"
                                }
                            };
                            elementType = data.details.type;
                            if (!(elementType === VSObject/* VSVideoType.Vimeo */.OV.Vimeo && _this33.state.tour.clientId)) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 5;
                            return __webpack_require__.e(/* import() */ 1023).then(__webpack_require__.bind(__webpack_require__, 11023)).then(function(res) {
                                return res.default;
                            });
                        case 5:
                            VimeoVideo = _ctx.sent;
                            vimeoVideo = new VimeoVideo(VimeoVideo.parseVideoId(data.getVideoURL()));
                            _ctx.next = 9;
                            return vimeoVideo.loadFromVideoId(_this33.state.tour.clientId);
                        case 9:
                            _ctx.next = 11;
                            return TreedisPublicDAO/* default.getVimeoVideoUrl */.Z.getVimeoVideoUrl(vimeoVideo.getFileURL());
                        case 11:
                            options.vimeoURL = _ctx.sent;
                        case 12:
                            _ctx.next = 14;
                            return _this33.showCaseTemp.scene.sceneVideo.create(data, options);
                        case 14:
                            res = _ctx.sent;
                            if (!(!res.length || res.length === 1)) {
                                _ctx.next = 17;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 17:
                            return _ctx.abrupt("return", res);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this34 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.isMPPano = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", _this34.pose.mode === _this34.showCaseTemp.showcase.Mode.Mode.OUTSIDE);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this35 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygonNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this35.showCaseTemp.scene.scenePolygon.create(data);
                        case 2:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this36 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatarNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this36.showCaseTemp.scene.sceneAvatar.create(data, {
                                host: _this36.state.host,
                                withButton: {
                                    mute: "/images/mute_icon.png",
                                    unMute: "/images/unmute_icon.png"
                                }
                            });
                        case 2:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this37 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleImageAction = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var _tour, noAudioMode, tourId, src, segments, id, tour, changeMinimap, ref, tourMusicWasPaused;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _tour = _this37.state.tour, noAudioMode = _tour.noAudioMode, tourId = _tour.id;
                            _ctx.t0 = data.actionType;
                            _ctx.next = _ctx.t0 === VSObject/* TourImageActionType.Tab */.rx.Tab ? 4 : _ctx.t0 === VSObject/* TourImageActionType.Music */.rx.Music ? 6 : _ctx.t0 === VSObject/* TourImageActionType.Video */.rx.Video ? 21 : _ctx.t0 === VSObject/* TourImageActionType.Treedis */.rx.Treedis ? 30 : _ctx.t0 === VSObject/* TourImageActionType.Menu */.rx.Menu ? 39 : _ctx.t0 === VSObject/* TourImageActionType.Panorama */.rx.Panorama ? 41 : _ctx.t0 === VSObject/* TourImageActionType.ExperiencePopUp */.rx.ExperiencePopUp ? 43 : 55;
                            break;
                        case 4:
                            if (data.action === VSObject/* TourImageAction.Hover */.Z5.Hover) {
                                window.open(data.actionURL);
                            } else if (data.action === VSObject/* TourImageAction.Click */.Z5.Click) {
                                window.open(data.actionURL);
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            if (!(noAudioMode && _this37.state.room)) {
                                _ctx.next = 8;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 8:
                            src = "".concat("https://cdn.treedis.com", "/tours/").concat(_this37.state.tour.id, "/vsimages/").concat(data.actionURL);
                            if (!_this37.polygonAudio) {
                                _ctx.next = 12;
                                break;
                            }
                            if (!(_this37.polygonAudio.src === src && data.action === VSObject/* TourImageAction.Hover */.Z5.Hover)) {
                                _ctx.next = 12;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.next = 14;
                            return _this37.pauseAllAudio("polygonAudio");
                        case 14:
                            _ctx.next = 16;
                            return _this37.createAudioStream("polygonAudio", src, true);
                        case 16:
                            _this37.polygonAudio = _ctx.sent;
                            _ctx.next = 19;
                            return _this37.playContainerAudio("polygonAudio");
                        case 19:
                            _this37.setState({
                                mainPlaying: false,
                                otherPlaying: true
                            });
                            return _ctx.abrupt("return");
                        case 21:
                            data.actionURL = (0,util_all/* getVideoLink */.rp)(data.actionURL, {
                                mute: noAudioMode && _this37.state.room
                            });
                            if (!(_this37.state.tourType === Tour/* TourType.Game */.v.Game)) {
                                _ctx.next = 26;
                                break;
                            }
                            {
                                _this37.pauseTourMusic();
                            }
                            _ctx.next = 29;
                            break;
                        case 26:
                            _ctx.next = 28;
                            return _this37.pauseAllAudio();
                        case 28:
                            _this37.setState({
                                mainPlaying: false,
                                otherPlaying: false
                            });
                        case 29:
                            return _ctx.abrupt("break", 55);
                        case 30:
                            segments = data.actionURL.split("/");
                            id = segments[segments.length - 1].split("?")[0];
                            if (!(0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")) {
                                _ctx.next = 35;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                            return _ctx.abrupt("return");
                        case 35:
                            tour = _this37.state.tour;
                            changeMinimap = tour && !tour.customMinimap;
                            _this37.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this37.getTour({
                                    id: id,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.actionURL
                                });
                            });
                            return _ctx.abrupt("return");
                        case 39:
                            _this37.setState({
                                menuOpen: false,
                                activeMenu: null
                            }, function() {
                                _this37.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        id: data.menuId,
                                        subMenu: data.subMenuId,
                                        subSubMenu: data.subSubMenuId
                                    }
                                });
                            });
                            return _ctx.abrupt("return");
                        case 41:
                            _this37.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return _ctx.abrupt("return");
                        case 43:
                            ;
                            tourMusicWasPaused = _this37.tourAudio && !_this37.tourAudio.ended && !_this37.tourAudio.paused;
                            if (!(_this37.state.tourType === Tour/* TourType.Game */.v.Game)) {
                                _ctx.next = 50;
                                break;
                            }
                            _ctx.next = 48;
                            return _this37.pauseTourMusic();
                        case 48:
                            _ctx.next = 53;
                            break;
                        case 50:
                            _ctx.next = 52;
                            return _this37.pauseAllAudio();
                        case 52:
                            _this37.setState({
                                mainPlaying: false,
                                otherPlaying: false
                            });
                        case 53:
                            _this37.setState({
                                tourMusicWasPaused: tourMusicWasPaused,
                                experiencePopUpIsOpen: true,
                                closedElementPopup: false,
                                experiencePopUpData: {
                                    title: data.popupTitle,
                                    url: data.actionURL,
                                    description: data.text,
                                    defaultImageUrl: data === null || data === void 0 ? void 0 : (ref = data.details) === null || ref === void 0 ? void 0 : ref.url,
                                    prefixImageUrl: "/tours/".concat(tourId, "/vsimages/"),
                                    rotation: data.rotation,
                                    backgroundColor: data.backgroundColor,
                                    backgroundOpacity: data.backgroundOpacity,
                                    textColor: data.textColor,
                                    buttonColor: data.buttonColor
                                }
                            });
                            return _ctx.abrupt("return");
                        case 55:
                            _this37.setState({
                                vsActionPopOn: true,
                                openedVSAction: data,
                                closedElementPopup: false
                            });
                        case 56:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this38 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePolygonAction = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var noAudioMode, src, segments, id, tour, changeMinimap;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            noAudioMode = _this38.state.tour.noAudioMode;
                            _ctx.t0 = data.type;
                            _ctx.next = _ctx.t0 === Polygon/* PolygonActionType.Tab */.zS.Tab ? 4 : _ctx.t0 === Polygon/* PolygonActionType.Music */.zS.Music ? 6 : _ctx.t0 === Polygon/* PolygonActionType.Video */.zS.Video ? 21 : _ctx.t0 === Polygon/* PolygonActionType.Treedis */.zS.Treedis ? 26 : _ctx.t0 === Polygon/* PolygonActionType.Menu */.zS.Menu ? 35 : _ctx.t0 === Polygon/* PolygonActionType.Panorama */.zS.Panorama ? 37 : 39;
                            break;
                        case 4:
                            if (data.action !== Polygon/* PolygonActionAction.Hover */.IW.Hover) {
                                window.open(data.url);
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            if (!(noAudioMode && _this38.state.room)) {
                                _ctx.next = 8;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 8:
                            src = "".concat("https://cdn.treedis.com", "/tours/").concat(_this38.state.tour.id, "/polygons/").concat(data.url);
                            if (!_this38.polygonAudio) {
                                _ctx.next = 12;
                                break;
                            }
                            if (!(_this38.polygonAudio.src === src && data.action === Polygon/* PolygonActionAction.Hover */.IW.Hover)) {
                                _ctx.next = 12;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.next = 14;
                            return _this38.pauseAllAudio("polygonAudio");
                        case 14:
                            _ctx.next = 16;
                            return _this38.createAudioStream("polygonAudio", src, true);
                        case 16:
                            _this38.polygonAudio = _ctx.sent;
                            _ctx.next = 19;
                            return _this38.playContainerAudio("polygonAudio");
                        case 19:
                            _this38.setState({
                                mainPlaying: false,
                                otherPlaying: true
                            });
                            return _ctx.abrupt("return");
                        case 21:
                            data.url = (0,util_all/* getVideoLink */.rp)(data.url, {
                                mute: noAudioMode && _this38.state.room,
                                autoplay: data.autoPlay ? 1 : 0
                            });
                            _ctx.next = 24;
                            return _this38.pauseAllAudio();
                        case 24:
                            _this38.setState({
                                mainPlaying: false,
                                otherPlaying: false
                            });
                            return _ctx.abrupt("break", 39);
                        case 26:
                            segments = data.url.split("/");
                            id = segments[segments.length - 1].split("?")[0];
                            if (!(0,util_all/* getQueryVariable */.Dv)(data.url, "m")) {
                                _ctx.next = 31;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                            return _ctx.abrupt("return");
                        case 31:
                            tour = _this38.state.tour;
                            changeMinimap = tour && !tour.customMinimap;
                            _this38.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this38.getTour({
                                    id: id,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.url
                                });
                            });
                            return _ctx.abrupt("return");
                        case 35:
                            _this38.setState({
                                menuOpen: false,
                                activeMenu: {
                                    id: null,
                                    subMenu: null,
                                    subSubMenu: null
                                }
                            }, function() {
                                _this38.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        id: data.menuId,
                                        subMenu: data.subMenuId,
                                        subSubMenu: data.subSubMenuId
                                    }
                                });
                            });
                            return _ctx.abrupt("return");
                        case 37:
                            _this38.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return _ctx.abrupt("return");
                        case 39:
                            _this38.setState({
                                vsActionPopOn: true,
                                closedElementPopup: false,
                                openedVSAction: new Polygon/* PolygonAction */.fD(data)
                            });
                        case 40:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.updateSweepLoc = function(nextSweep) {
            _this.ticketUpdateSweepLoc(nextSweep);
            if (_this.pose.mode !== _this.showCaseTemp.showcase.Mode.Mode.INSIDE) return;
            var _state = _this.state, tour = _state.tour, sweepGroups = _state.sweepGroups;
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "Sweep",
                eventAction: "move",
                eventLabel: nextSweep
            });
            var activeSweepGroup = null;
            sweepGroups.forEach(function(group, i) {
                var ref;
                (ref = group.sweeps) === null || ref === void 0 ? void 0 : ref.forEach(function(sweep) {
                    if (sweep.uuid === nextSweep) {
                        activeSweepGroup = group.id;
                    }
                });
            });
            _this.setState({
                activeSweepGroup: activeSweepGroup
            }, function() {
                _this.resumeMusicAfterSweepGroup();
                _this.filterTags();
            });
            if (tour.minimap) {
                var loc = _this.calculateLocation();
                if (!loc) return;
                _this.setState({
                    mapWalkerX: loc.px,
                    mapWalkerY: loc.py,
                    minimaps: loc.minimaps
                });
            }
        };
        _this.resumeMusicAfterSweepGroup = function() {
            var _state = _this.state, currentFloor = _state.currentFloor, tour = _state.tour, activeSweepGroup = _state.activeSweepGroup, forceMusicPause = _state.forceMusicPause, tagPopOn = _state.tagPopOn, openedTag = _state.openedTag;
            if (activeSweepGroup !== null) return;
            var music = tour.musics.find(function(item) {
                return item.floor === currentFloor + 1;
            });
            var autoplay = (music === null || music === void 0 ? void 0 : music.autoplay) || false;
            if (!music && tour.music) {
                autoplay = tour.autoplayMusic;
            }
            if (autoplay && !tour.noAudioMode && !forceMusicPause) {
                var ref;
                var vsVideos = (ref = _this.vsObjects) === null || ref === void 0 ? void 0 : ref.filter(function(obj) {
                    var ref, ref1, ref2, ref3;
                    return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components) && ((ref2 = (ref1 = obj.node) === null || ref1 === void 0 ? void 0 : ref1.components[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.instance) === null || ref3 === void 0 ? void 0 : ref3.componentType) === videoRendererType;
                });
                var hasActiveVsVideo = vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.find(function(vsVideo) {
                    var ref, ref1;
                    var ref2 = (0,_sliced_to_array/* default */.Z)((ref = vsVideo.node) === null || ref === void 0 ? void 0 : ref.components, 1), videoBtn = ref2[0];
                    return !(videoBtn === null || videoBtn === void 0 ? void 0 : (ref1 = videoBtn.instance) === null || ref1 === void 0 ? void 0 : ref1.active);
                });
                if (!hasActiveVsVideo && !(tagPopOn && openedTag.type === "video")) {
                    _this.playAudio();
                }
            }
        };
        _this.markMinimap = function(p) {
            var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
            if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
            minimaps[selectedMinimap].hotspots.forEach(function(h) {
                if (h.type === "panorama" && h.panoramaId === p.id) {
                    _this.setState({
                        mapWalkerX: h.x,
                        mapWalkerY: h.y,
                        activePano: null
                    });
                }
            });
        };
        var _this39 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playAudio = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, _state, activeSweepGroup, sweepGroups, showIntro, _$tourType, videoPlaying, group;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _state = _this39.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, showIntro = _state.showIntro, _$tourType = _state.tourType, videoPlaying = _state.videoPlaying;
                        group = activeSweepGroup ? sweepGroups.find(function(sg) {
                            return sg.id === activeSweepGroup;
                        }) : null;
                        if (!(_$tourType === Tour/* TourType.Game */.v.Game && showIntro)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        if (!(videoPlaying || (group === null || group === void 0 ? void 0 : group.type) === Sweep/* SweepType.Music */.G.Music && group.overrideMusic)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if (!((ref = _this39.tourAudio) === null || ref === void 0 ? void 0 : ref.paused)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 11;
                        return _this39.pauseAllAudio("tourAudio");
                    case 11:
                        _ctx.next = 13;
                        return _this39.tourAudio.play();
                    case 13:
                        _this39.setState({
                            mainPlaying: true,
                            otherPlaying: false
                        });
                    case 14:
                        _ctx.next = 20;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setTimeout(_this39.playAudio, 500);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    16
                ]
            ]);
        }));
        var _this40 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToSweep = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sweepId, rotation) {
                var transition, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            transition = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "INSTANT";
                            if (!_this40.showCaseTemp) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", _this40.showCaseTemp.showcase.Sweep.moveTo(sweepId, {
                                rotation: rotation,
                                transition: _this40.showCaseTemp.showcase.Sweep.Transition[transition]
                            }).then(function() {
                                window.history.replaceState(null, "", _this40.buildLink(sweepId, rotation));
                            }).catch(function(err) {
                                ;
                            }));
                        case 3:
                            react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sweepId, rotation) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this41 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToStep = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(step) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!_this41.showCaseTemp) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 3;
                            return _this41.showCaseTemp.showcase.Tour.step(step).catch(function(err) {
                                ;
                            });
                        case 3:
                            _ctx.next = 6;
                            break;
                        case 5:
                            {
                                react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(step) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this42 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopPolygons = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var polygons;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        polygons = _this42.state.polygons;
                        _ctx.t0 = _this42;
                        _ctx.next = 5;
                        return Promise.all(polygons.map(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                var nodeIndex;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (item.active) {
                                                _ctx.next = 2;
                                                break;
                                            }
                                            return _ctx.abrupt("return", item);
                                        case 2:
                                            nodeIndex = _this42.modelNodes.findIndex(function(node) {
                                                var ref;
                                                return ((ref = node[0]) === null || ref === void 0 ? void 0 : ref.uuid) === item.uuid;
                                            });
                                            if (nodeIndex >= 0) {
                                                _this42.modelNodes[nodeIndex][0].stop();
                                                item.uuid = null;
                                                _this42.modelNodes.splice(nodeIndex, 1);
                                            }
                                            return _ctx.abrupt("return", item);
                                        case 5:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 5:
                        _ctx.t1 = _ctx.sent;
                        _ctx.t2 = {
                            polygons: _ctx.t1
                        };
                        _ctx.t0.setState.call(_ctx.t0, _ctx.t2);
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t3 = _ctx["catch"](0);
                        ;
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        var _this43 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleVS = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(state) {
                var ref, isVSEnabled;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if ((ref = _this43.vsObjects) === null || ref === void 0 ? void 0 : ref.length) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            isVSEnabled = _this43.state.isVSEnabled;
                            if (!isVSEnabled) {
                                _ctx.next = 11;
                                break;
                            }
                            _ctx.next = 7;
                            return _this43.stopVS();
                        case 7:
                            _ctx.next = 9;
                            return _this43.stopPolygons();
                        case 9:
                            _ctx.next = 15;
                            break;
                        case 11:
                            _ctx.next = 13;
                            return _this43.initVS();
                        case 13:
                            _ctx.next = 15;
                            return _this43.initPolygons();
                        case 15:
                            _this43.setState({
                                isVSEnabled: !isVSEnabled
                            });
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(state) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this44 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleTogglePano = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, panoramaOn, showcaseLoaded, room, host, tourPlaying, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this44.state, panoramaOn = _state.panoramaOn, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host, tourPlaying = _state.tourPlaying;
                        if (!(!panoramaOn && tourPlaying)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return _this44.showCaseTemp.showcase.Tour.stop();
                    case 4:
                        data = {
                            panoramaOn: !panoramaOn,
                            activePano: panoramaOn ? null : _this44.state.activePano
                        };
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("toggle-pano", data);
                        }
                        if (!_this44.state.lock) {
                            _this44.setState(data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.getShareLocation = function() {
            var location = sdk/* getLocation.call */.k$.call((0,_assert_this_initialized/* default */.Z)(_this));
            var _state = _this.state, panoramaOn = _state.panoramaOn, panoramas = _state.panoramas;
            if (panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && _this.currentPanorama) {
                var pano = "pano=".concat(_this.currentPanorama.id);
                var panoPitch = "panoPitch=".concat(_this.panoPose.pitch);
                var panoYaw = "panoYaw=".concat(_this.panoPose.yaw);
                var panoHfov = "panoHfov=".concat(_this.panoPose.hfov);
                var query = "".concat(pano, "&").concat(panoPitch, "&").concat(panoYaw, "&").concat(panoHfov);
                if (location.split("?")[1]) {
                    location += "&".concat(query);
                } else {
                    location += "?".concat(query);
                }
            }
            return location;
        };
        _this.updatePanoRotation = function(north, pos, scene) {
            var _state = _this.state, room = _state.room, host = _state.host, lock = _state.lock, panoramas = _state.panoramas;
            if (room && socket/* default */.Z && socket/* default.connected */.Z.connected) {
                if (host) {
                    var pano = panoramas.find(function(p) {
                        return p.name === scene;
                    });
                    if ((pano === null || pano === void 0 ? void 0 : pano.id) === _this.currentPanorama.id) {
                        socket/* default.emit */.Z.emit("move-pano", {
                            panoPose: pos,
                            currentPanorama: _this.currentPanorama
                        });
                    }
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                } else if (!lock) {
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                }
            } else {
                util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
            }
        };
        _this.handlePanoSceneChange = function(scene) {
            _this.currentPanorama = scene;
            var _state = _this.state, room = _state.room, showcaseLoaded = _state.showcaseLoaded, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("move-pano", {
                    panoPose: {
                        pitch: 0,
                        yaw: 0,
                        hfov: 100
                    },
                    currentPanorama: scene
                });
            }
        };
        _this.handleGameStartOnIntroModal = function(username) {
            _this.handleGameStart(username, true);
        };
        var _this45 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, myX, myZ, ref21, x, z;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            ref20 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this45.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, data === null || data === void 0 ? void 0 : (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref20[0], myZ = ref20[1];
                            ref21 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref21[0], z = ref21[1];
                            ;
                            _ctx.next = 6;
                            return _this45.onAddAvatar(new virtualStaging_avatar/* Avatar */.qE({
                                uuid: data.avatarId,
                                name: data.name,
                                url: data.avatarUrl,
                                positionX: x,
                                positionY: (ref4 = data.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.y,
                                positionZ: z,
                                rotationX: (ref6 = data.pose) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.rotation) === null || ref7 === void 0 ? void 0 : ref7._x,
                                rotationY: (ref8 = data.pose) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.rotation) === null || ref9 === void 0 ? void 0 : ref9._y,
                                rotationZ: (ref10 = data.pose) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.rotation) === null || ref11 === void 0 ? void 0 : ref11._z,
                                quaternionX: (ref12 = data.pose) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.quaternion) === null || ref13 === void 0 ? void 0 : ref13._x,
                                quaternionY: (ref14 = data.pose) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.quaternion) === null || ref15 === void 0 ? void 0 : ref15._y,
                                quaternionZ: (ref16 = data.pose) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.quaternion) === null || ref17 === void 0 ? void 0 : ref17._z,
                                quaternionW: (ref18 = data.pose) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.quaternion) === null || ref19 === void 0 ? void 0 : ref19._w,
                                degree: data.degree
                            }));
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this46 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onAddAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, avatarNode;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (_this46.avatarNodes.has(data.uuid)) {
                                _ctx.next = 12;
                                break;
                            }
                            ;
                            if (!data.positionX && !data.positionY && !data.positionZ) {
                                data.positionX = _this46.pose.position.x;
                                data.positionY = _this46.pose.position.y;
                                data.positionZ = _this46.pose.position.z;
                            }
                            _ctx.next = 5;
                            return _this46.initAvatarNode(data);
                        case 5:
                            avatarNode = _ctx.sent;
                            avatarNode[0].obj3D.position.set(data.positionX, data.positionY, data.positionZ);
                            avatarNode[0].obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
                            avatarNode[0].obj3D.quaternion.set(data.quaternionX, data.quaternionY, data.quaternionZ, data.quaternionW);
                            (ref = avatarNode[0].obj3D.children[0]) === null || ref === void 0 ? void 0 : ref.rotation.set(0, Math.PI, 0);
                            if (avatarNode === null || avatarNode === void 0 ? void 0 : avatarNode.length) {
                                if (!(data === null || data === void 0 ? void 0 : data.muted)) {
                                    if (avatarNode[2]) {
                                        // changing state to !active if video is not muted
                                        avatarNode[2].setActive(!avatarNode[2].isActive());
                                    }
                                }
                                _this46.avatarNodes.set(data.uuid, avatarNode);
                            }
                            return _ctx.abrupt("return", avatarNode);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this47 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onRemoveAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(uuid) {
                var ref, avatar;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (_this47.avatarNodes.size) {
                                ref = (0,_sliced_to_array/* default */.Z)(_this47.avatarNodes.get(uuid), 1), avatar = ref[0];
                                if (avatar) {
                                    avatar.stop();
                                    _this47.avatarNodes.delete(uuid);
                                }
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(uuid) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.videoEndCall = function() {
            socket/* default.removeAllListeners */.Z.removeAllListeners();
            socket/* default.close */.Z.close();
            _this.setState({
                room: null,
                reelVideos: []
            });
        };
        _this.videoChangeTour = function(data) {
            var tour = _this.state.tour;
            var m = (0,util_all/* getQueryVariable */.Dv)(_this.state.iframeUrl, "m");
            if (data.id && data.id !== m) {
                if (data.mp) {
                    var ref;
                    _this.moveModel("/mp-sdk/".concat("3.1.63", "/showcase.html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.user) === null || ref === void 0 ? void 0 : ref.mpSDK, "&m=").concat(data.id));
                } else {
                    _this.getTour({
                        id: data.id,
                        changeMenu: false,
                        changeMinimap: true,
                        changePanorama: false
                    });
                }
            }
        };
        _this.changeMuteStatus = function(name, muted) {
            var _state = _this.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, reelVideos = _state.reelVideos;
            var isReeled = reelVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isPinned = pinnedVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.name) === name;
            if (isFullscreen) {
                fullscreenVideo.muted = muted;
            } else if (isPinned >= 0) {
                pinnedVideos[isPinned].muted = muted;
                _this.addPinnedVideo(pinnedVideos[isPinned]);
            } else if (isReeled >= 0) {
                reelVideos[isReeled].muted = muted;
                _this.addVideoReel(reelVideos[isReeled]);
            }
        };
        var _this48 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addTrack = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                var ref, ref1, _state, fullscreenVideo, pinnedVideos, audioEl, isFullscreen, isPinned;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                ;
                                _state = _this48.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos;
                                if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "audio" && !p.self) {
                                    audioEl = new Audio();
                                    audioEl.append(p.track.attach());
                                    audioEl.setAttribute("data-cy-audio-track-name", p.track.name);
                                    audioEl.setAttribute("data-cy-audio-track-sid", p.sid);
                                    document.body.appendChild(audioEl);
                                    if (!p.enabled) {
                                        audioEl.pause();
                                        _this48.changeMuteStatus(p.name, true);
                                    } else {
                                        _this48.changeMuteStatus(p.name, false);
                                    }
                                } else if (((ref1 = p.track) === null || ref1 === void 0 ? void 0 : ref1.kind) === "video") {
                                    isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === p.sid;
                                    isPinned = pinnedVideos.findIndex(function(i) {
                                        return i.sid === p.sid;
                                    });
                                    if (p.dominant) {
                                        _this48.setState({
                                            dominantSpeaker: p
                                        });
                                    } else if (isFullscreen) {
                                        _this48.setState({
                                            fullscreenVideo: p
                                        });
                                    } else if (isPinned >= 0) {
                                        // || p.track.name.includes('-screen')
                                        // we pin screen shares
                                        _this48.addPinnedVideo(p);
                                    } else {
                                        _this48.addVideoReel(p);
                                    }
                                }
                            } catch (e) {
                                ;
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this49 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeTrack = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                var _state, fullscreenVideo, pinnedVideos, audioOnly, isFullscreen, isPinned;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                _state = _this49.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, audioOnly = _state.audioOnly;
                                isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === sid;
                                isPinned = pinnedVideos.findIndex(function(i) {
                                    return i.sid === sid;
                                });
                                if (isFullscreen) {
                                    _this49.setState({
                                        fullscreenVideo: null
                                    });
                                } else if (isPinned >= 0) {
                                    _this49.removePinnedVideo(sid);
                                    if (audioOnly) _this49.removePinnedVideo("".concat(sid, "_video"));
                                } else {
                                    _this49.removeVideoReel(sid);
                                    if (audioOnly) _this49.removeVideoReel("".concat(sid, "_video"));
                                }
                            } catch (e) {
                                ;
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this50 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addVideoReel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                var ref, reelVideos, index;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                ;
                                if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
                                    reelVideos = (0,_to_consumable_array/* default */.Z)(_this50.state.reelVideos);
                                    index = reelVideos.findIndex(function(i) {
                                        return i.sid === p.sid;
                                    });
                                    if (index >= 0) {
                                        reelVideos[index] = p;
                                    } else {
                                        reelVideos.push(p);
                                    }
                                    _this50.setState({
                                        reelVideos: reelVideos
                                    });
                                }
                            } catch (e) {
                                ;
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this51 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeVideoReel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _this51.setState({
                                reelVideos: _this51.state.reelVideos.filter(function(i) {
                                    return i.sid !== sid;
                                })
                            });
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this52 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addPinnedVideo = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            addPinnedVideoFunc(p, _this52.state.pinnedVideos, function(pinnedVideos) {
                                _this52.setState({
                                    pinnedVideos: pinnedVideos
                                }, function() {
                                    if (!p.pinned) _this52.removeVideoReel(p.sid);
                                });
                            });
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this53 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removePinnedVideo = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _this53.setState({
                                pinnedVideos: _this53.state.pinnedVideos.filter(function(i) {
                                    return i.sid !== sid;
                                })
                            });
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this54 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleFullscreenVideo = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(participant) {
                var pinned, fullscreenVideo, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            pinned = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            fullscreenVideo = _this54.state.fullscreenVideo;
                            if ((fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === participant.sid) {
                                // close fullscreen video
                                if (fullscreenVideo.pinned) {
                                    _this54.addPinnedVideo(fullscreenVideo);
                                } else {
                                    _this54.addVideoReel(fullscreenVideo);
                                }
                                _this54.setState({
                                    fullscreenVideo: null
                                });
                                document.removeEventListener("keydown", _this54.exitFullscreenVideo);
                            } else {
                                // open fullscreen video
                                if (fullscreenVideo) {
                                    // first close old one, then add the new one
                                    if (fullscreenVideo.pinned) {
                                        _this54.addPinnedVideo(fullscreenVideo);
                                    } else {
                                        _this54.addVideoReel(fullscreenVideo);
                                    }
                                }
                                _this54.setState({
                                    fullscreenVideo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, participant), {
                                        pinned: pinned
                                    })
                                });
                                _this54.removePinnedVideo(participant.sid);
                                _this54.removeVideoReel(participant.sid);
                                document.addEventListener("keydown", _this54.exitFullscreenVideo);
                            }
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(participant) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.exitFullscreenVideo = function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                if (_this.state.fullscreenVideo) {
                    _this.toggleFullscreenVideo(_this.state.fullscreenVideo);
                }
            }
        };
        var _this55 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatar = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tour, avatar;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tour = _this55.state.tour;
                        if (tour.enableAvatar) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        avatar = undefined; // storage('avatar').get();
                        if (avatar) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            _this55.setState({
                                avatar: null,
                                chatParticipant: null
                            });
                        }
                        _ctx.next = 11;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return _this55.setAvatar(avatar);
                    case 11:
                        _ctx.next = 15;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](3);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    13
                ]
            ]);
        }));
        var _this56 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleMuteParticipants = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                var audioEl, mute;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            audioEl = document.querySelectorAll("[data-cy-audio-track-sid=".concat(sid, "]"));
                            mute = false;
                            if (audioEl && audioEl.length > 0) {
                                if (audioEl[0].playing) {
                                    audioEl[0].pause();
                                    mute = true;
                                } else {
                                    audioEl[0].play();
                                    mute = false;
                                }
                                if (_this56.state.host) {
                                    socket/* default.emit */.Z.emit("mute_participant", {
                                        participantId: sid,
                                        mute: mute
                                    });
                                }
                            }
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this57 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, ref1, _state, tour, room, avatarId, avatar;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _state = _this57.state, tour = _state.tour, room = _state.room;
                            _this57.setState({
                                chatParticipant: data
                            });
                            ;
                            if (tour.enableAvatar) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            avatarId = (0,v4/* default */.Z)();
                            avatar = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                uuid: avatarId
                            });
                            // storage('avatar').set(avatar);
                            _this57.setState({
                                avatar: avatar
                            });
                            ;
                            socket/* default.emit */.Z.emit("user_joining", {
                                name: data.name,
                                room: room || tour.id,
                                avatarUrl: data.url,
                                avatarId: avatarId,
                                model: data.model,
                                pose: {
                                    rotation: (ref = _this57.camera) === null || ref === void 0 ? void 0 : ref.camera.rotation,
                                    quaternion: (ref1 = _this57.camera) === null || ref1 === void 0 ? void 0 : ref1.camera.quaternion,
                                    position: _this57.pose.position
                                },
                                sweep: _this57.pose.sweep
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleSketchfabPopup = function(state) {
            return function() {
                _this.setState({
                    showSketchfabPopup: state
                });
            };
        };
        _this.onCloseIntro = function() {
            var _state = _this.state, tour = _state.tour, _$tourType = _state.tourType;
            if (_$tourType === Tour/* TourType.Game */.v.Game) {
                _this.setState({
                    showIntro: false
                }, function() {
                    if (tour === null || tour === void 0 ? void 0 : tour.autoplayMusic) _this.playAudio();
                });
            } else {
                _this.setState({
                    showIntro: false,
                    forcePlayGameIntro: true
                }, function() {
                    _this.processTourMusic(tour);
                });
            }
        };
        _this.getCurrentLanguage = function() {
            var ref;
            var pathnameSplitted = window.location.pathname.split("/");
            var currentSlug = pathnameSplitted[pathnameSplitted.length - 1];
            return (ref = _this.state.initialDuplicates) === null || ref === void 0 ? void 0 : ref.find(function(duplicate) {
                return duplicate.slug === currentSlug;
            });
        };
        _this.unlockChapter = function(targetObj, type) {
            var ref;
            var _state = _this.state, _game = _state.game, book = _game.book, gameBookOn = _game.gameBookOn, unlockedChapterIds = _state.unlockedChapterIds, clickedElements = _state.clickedElements;
            var value = targetObj === null || targetObj === void 0 ? void 0 : (ref = targetObj.details) === null || ref === void 0 ? void 0 : ref.id;
            if (type === GameBook/* ChapterType.Tag */._U.Tag || type === GameBook/* ChapterType.Polygon */._U.Polygon) {
                value = targetObj === null || targetObj === void 0 ? void 0 : targetObj.id;
            }
            _this.setState({
                clickedElements: (0,_to_consumable_array/* default */.Z)(clickedElements).concat([
                    {
                        type: type,
                        value: value
                    }, 
                ])
            });
            if (!gameBookOn || !book) return;
            var chapters = sortBy_default()(book === null || book === void 0 ? void 0 : book.chapters, "order");
            var chapter = chapters.find(function(item) {
                return item.order === unlockedChapterIds.length + 1;
            });
            var unblock = false;
            switch(type){
                case GameBook/* ChapterType.Tag */._U.Tag:
                    {
                        var tag = targetObj;
                        unblock = chapter && chapter.type === GameBook/* ChapterType.Tag */._U.Tag && (chapter.value === String(tag.id) || chapter.value === tag.sid);
                        break;
                    }
                case GameBook/* ChapterType.Polygon */._U.Polygon:
                    var polygon = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.Polygon */._U.Polygon && chapter.value === String(polygon.id);
                    break;
                case GameBook/* ChapterType.VSItem */._U.VSItem:
                    var vsItem = targetObj.details;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSItem */._U.VSItem && chapter.value === String(vsItem.id);
                    break;
                case GameBook/* ChapterType.VSImage */._U.VSImage:
                    var vsImage = targetObj.details;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSImage */._U.VSImage && chapter.value === String(vsImage.id);
                    break;
                case GameBook/* ChapterType.VSVideo */._U.VSVideo:
                    var vsVideo = targetObj.details;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSVideo */._U.VSVideo && chapter.value === String(vsVideo.id);
                    break;
                default:
                    break;
            }
            if (unblock) {
                _this.tryButtonPlaySound();
                _this.setState({
                    unlockedChapterIds: (0,_to_consumable_array/* default */.Z)(unlockedChapterIds).concat([
                        chapter.id
                    ])
                });
            }
        };
        _this.state = {
            iframeId: "iframe_".concat(randomNumberId()),
            showcaseLoaded: false,
            showSketchfabPopup: false,
            tour: null,
            floors: [],
            allowGuestBeforeHost: false,
            changeMenu: false,
            showIntroScreen: true,
            menus: [],
            reelVideos: [],
            pinnedVideos: [],
            reel: [],
            sweeps: [],
            deprecatedSweeps: [],
            mpFloors: [],
            mpLabels: [],
            translation: {},
            tourEmail: null,
            sweepGroups: [],
            host: props.rule === "host",
            audioOnly: props.videoType === "audio",
            minimaps: [],
            allTags: new Map(),
            interacted: false,
            selectedMinimap: 0,
            menuOpened: false,
            iframeUrl: null,
            menuOpen: false,
            overlayOn: false,
            mainPlaying: false,
            otherPlaying: true,
            videoPlaying: false,
            externalPopupOn: false,
            contactPopupOn: false,
            panoramas: [],
            polygons: [],
            agents: [],
            tagPopOn: false,
            panoPopOn: false,
            gameLockPopOn: false,
            openedLock: null,
            userAnswerForGameLock: null,
            videoChatTagPopOn: false,
            vsActionPopOn: false,
            panoramaOn: false,
            openedTag: null,
            openedPanoHotspot: null,
            openedVSAction: new VSObject/* TourImage */.oP(),
            externalPopupUrl: null,
            minimapOn: false,
            minimapVisible: false,
            mesurementsOn: false,
            markerPopupOn: false,
            sharePopupOn: false,
            tourPlaying: false,
            mapWalkerRotation: 0,
            reelStep: 0,
            mapWalkerX: null,
            mapWalkerY: null,
            activeSweepGroup: null,
            dominantSpeaker: null,
            // user: null,
            selectedMarker: {
                url: null,
                external: null
            },
            tokenRemainingTime: -1,
            tokenExpiresAt: null,
            // createdAt: null,
            // clock: false,
            ticketingOpen: false,
            activePano: null,
            appointmentsModal: false,
            appointmentsHintOn: true,
            getInTouchHintOn: true,
            MenuHintOn: true,
            lock: false,
            room: props.room,
            whiteLabelData: null,
            showHelpModal: false,
            showTermsModal: false,
            showCollectLeadsModal: false,
            activeMenu: null,
            products: new Map(),
            isProductsLoaded: false,
            tourType: tourType,
            vsSettings: new VSSettings(),
            isVSReady: false,
            containerId: "public",
            loadingTags: true,
            game: null,
            currentFloor: null,
            panoPose: {
                yaw: 0,
                pitch: 0,
                hfov: 0
            },
            isVSEnabled: true,
            loadedOnce: false,
            showPathFinderPopup: false,
            ticketTimeLeftMs: null,
            tourMode: null,
            experiencePopUpIsOpen: false,
            onExperienceCloseCallback: function() {
                return undefined;
            },
            currentSweep: null,
            experiencePopUpData: null,
            closedElementPopup: true,
            isEnableNextPathLock: true,
            initialDuplicates: null,
            isChangeIframe: false,
            tourMusicWasPaused: false,
            avatar: {},
            chatParticipant: {},
            infoModalData: null,
            gameTrialErr: null,
            crashScreen: false,
            unlockedChapterIds: [],
            clickedElements: []
        };
        _this.loadingQueue = LoadingQueue/* default.getInstance */.Z.getInstance();
        _this.loadingQueue.subscribe(function(loaded) {
            if (loaded === true) {
                _this.setState({
                    loaded: true
                });
            }
        });
        _this.renderButtonBg = renderButtonBg.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.calculateLocation = calculateLocation.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buildLink = util_all/* buildLink.bind */.DF.bind((0,_assert_this_initialized/* default */.Z)(_this)); // need this code ??
        _this.openTagIframe = sdk/* openTagIframe.bind */.$O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsObjectIframe = sdk/* openVsObjectIframe.bind */.BY.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsImageIframe = sdk/* openVsImageIframe.bind */.IW.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsVideoIframe = sdk/* openVsVideoIframe.bind */.O7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.loadModel = sdk/* loadModel.bind */.u7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.moveToMPLabels = sdk/* moveToMPLabels.bind */.QO.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setWhiteLabel = util_all/* setWhiteLabel.bind */.Jw.bind((0,_assert_this_initialized/* default */.Z)(_this));
        document.addEventListener("keydown", _this.takePosition);
        _this.toggleExternalPopup = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this));
        var room = _this.state.room;
        socket/* default.on */.Z.on("move_avatar", function(data) {
            var ref, ref1, ref2, ref3;
            var tour = _this.state.tour;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            // Is the avatar moving into my sweep? (sweep id...)
            // if it does, use relative position, avatar.relative
            var ref4 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref4[0], myZ = ref4[1];
            var ref5 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref5[0], z = ref5[1];
            if (avatar) {
                var ref6;
                avatar[0].obj3D.position.set(x, data.pose.position.y, z);
                avatar[0].obj3D.rotation.set(data.pose.rotation._x, data.pose.rotation._y, data.pose.rotation._z);
                avatar[0].obj3D.quaternion.set(data.pose.quaternion._x, data.pose.quaternion._y, data.pose.quaternion._z, data.pose.quaternion._w);
                (ref6 = avatar[0].obj3D.children[0]) === null || ref6 === void 0 ? void 0 : ref6.rotation.set(0, Math.PI, 0);
            }
        });
        socket/* default.on */.Z.on("move_avatar_face", function(data) {
            var tour = _this.state.tour;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            if (avatar) {
                avatar[1].updateFromResults(data.pose);
            }
        });
        socket/* default.on */.Z.on("all_users", function(users) {
            var tour = _this.state.tour;
            if (tour.enableAvatar) {
                users.forEach(function(user) {
                    if (user.socketId !== socket/* default.id */.Z.id) {
                        _this.addAvatar(user);
                    }
                });
            }
        });
        var _this58 = (0,_assert_this_initialized/* default */.Z)(_this);
        socket/* default.on */.Z.on("avatar_config", function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _this58.avatarDegree = data.degree;
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this59 = (0,_assert_this_initialized/* default */.Z)(_this);
        socket/* default.on */.Z.on("user_leave", function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var tour;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            tour = _this59.state.tour;
                            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return _this59.onRemoveAvatar(data.avatarId);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        socket/* default.on */.Z.on("move", function(pose) {
            if (_this.state.lock) {
                _this.moveToSweepIO(pose);
            }
        });
        if (room) {
            socket/* default.on */.Z.on("menu", function(menu) {
                _this.loadModel(menu.name, menu.url, menu.type);
            });
            socket/* default.on */.Z.on("tag", function(tag) {
                if (_this.state.lock) {
                    _this.moveToTagIO(tag);
                }
            });
            socket/* default.on */.Z.on("lock", function(_lock) {
                if (_this.state.lock !== _lock) {
                    _this.setState({
                        lock: _lock
                    });
                }
            });
            socket/* default.on */.Z.on("close-tag", function() {
                _this.setState({
                    tagPopOn: false
                });
            });
            socket/* default.on */.Z.on("close-pano-pop", function() {
                _this.setState({
                    panoPopOn: false
                });
            });
            socket/* default.on */.Z.on("toggle-pano", function(data) {
                _this.setState(data);
            });
            socket/* default.on */.Z.on("move-pano", function(data) {
                _this.setState({
                    panoPose: data.panoPose,
                    activePano: data.currentPanorama.id
                });
            });
            socket/* default.on */.Z.on("pano-hotspot-click", function(data) {
                _this.setState({
                    panoramaOn: false,
                    activePano: null
                }, function() {
                    _this.getTour({
                        id: data.id,
                        changeMenu: data.changeMenu,
                        changeMinimap: data.changeMinimap,
                        changePanorama: data.changePanorama,
                        url: data.url,
                        tourData: props.tourData
                    });
                });
            });
        }
        socket/* default.on */.Z.on("disconnect", function(reason) {
            ;
        });
        socket/* default.io.on */.Z.io.on("reconnect", function() {
            ;
            _this.initAvatar().catch(function(e) {
                ;
            });
        });
        window.addEventListener("beforeunload", function() {
            var ref, ref1, ref2;
            return logoutHandler({
                ticket: (ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.ticket,
                ticketingOrderedTicket: (ref2 = _this.state.ticketing) === null || ref2 === void 0 ? void 0 : ref2.ticketingOrderedTicket
            });
        });
        (0,styles/* calculateMobileHeight */.U_)();
        window.addEventListener("resize", styles/* calculateMobileHeight */.U_);
        return _this;
    }
    var _proto = BaseTour.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", styles/* calculateMobileHeight */.U_);
    };
    _proto.goToPreviousValidSweep = function goToPreviousValidSweep() {
        var ref;
        if ((ref = this.ticketValidSweepsHistory) === null || ref === void 0 ? void 0 : ref.length) {
            var THREE = index_modern/* ThreeInstance.get */.ur.get();
            this.moveToSweep(this.ticketValidSweepsHistory[this.ticketValidSweepsHistory.length - 1], new THREE.Euler());
        } else {
            stopApp();
        }
    };
    _proto.setParentState = function setParentState(attr, val) {
        this.setState((0,src_define_property/* default */.Z)({}, attr, val));
    };
    _proto.loadedShowcaseHandler = function loadedShowcaseHandler() {
        var cb = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, room, reel;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this.state, tour = _state.tour, room = _state.room;
                        if ((tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || room) {
                            socket/* default.open */.Z.open();
                        }
                        _ctx.next = 4;
                        return _this.showCaseTemp.showcase.Tour.getData().catch(function() {
                            return [];
                        });
                    case 4:
                        reel = _ctx.sent;
                        _this.setState({
                            reel: reel
                        });
                        _this.showCaseTemp.showcase.Settings.update("highlight_reel", false);
                        _this.showCaseTemp.showcase.Settings.update("tour_buttons", false);
                        if (tour.hidePucks) {
                            _this.showCaseTemp.showcase.Settings.update("features/sweep_pucks", false);
                        }
                        _this.showCaseTemp.showcase.Camera.pose.subscribe(function(p) {
                            var floors = _this.state.floors;
                            _this.pose = (0,_object_spread/* default */.Z)({}, p);
                            try {
                                if (_this.pose.sweep && floors.length) {
                                    for(var i = 0; i < floors.length; i += 1){
                                        var floor = floors[i];
                                        var sweep = (floor === null || floor === void 0 ? void 0 : floor.sweeps) ? floor.sweeps.find(function(item) {
                                            return item.uuid === _this.pose.sweep;
                                        }) : null;
                                        if (sweep) {
                                            if (_this.floor.floor !== sweep.floor_index) {
                                                _this.floor = floor;
                                                if (_this.showCaseTemp) {
                                                // if floor is changed, rerender the VS
                                                // this.initVS(); //TODO: check why?
                                                }
                                            }
                                            if (_this.shadowNode) {
                                                var ref, ref1;
                                                var currentDeprecatedSweep = (ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.deprecatedSweeps) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                                                    var ref;
                                                    return ((ref = item.sweep_uuid) === null || ref === void 0 ? void 0 : ref.replace(/-/g, "")) === _this.pose.sweep;
                                                });
                                                _this.shadowNode.obj3D.position.set(_this.pose.position.x, (currentDeprecatedSweep === null || currentDeprecatedSweep === void 0 ? void 0 : currentDeprecatedSweep.floor_position.z) + 0.01, _this.pose.position.z);
                                                // turn of visibility for MP panorama sweeps
                                                _this.shadowNode.obj3D.visible = _this.pose.mode !== _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE;
                                            }
                                            break;
                                        }
                                    }
                                }
                                cb();
                            } catch (e) {
                                ;
                            }
                        });
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function(currentSweep) {
                            _this.adjustVSToTourMode();
                            if (currentSweep.sid !== "") {
                                _this.updateSweepLoc(currentSweep.sid);
                                _this.setState({
                                    currentSweep: currentSweep
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Camera.Event.MOVE, function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                                var _state, showcaseLoaded, host, room, tour, panoramaOn, ref, ref1, pose;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room, tour = _state.tour, panoramaOn = _state.panoramaOn;
                                            if (showcaseLoaded) {
                                                _ctx.next = 3;
                                                break;
                                            }
                                            return _ctx.abrupt("return");
                                        case 3:
                                            if (socket/* default */.Z && socket/* default.connected */.Z.connected) {
                                                ;
                                                pose = {
                                                    walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE,
                                                    position: p.position,
                                                    rotation: (ref = _this.camera) === null || ref === void 0 ? void 0 : ref.camera.rotation,
                                                    quaternion: (ref1 = _this.camera) === null || ref1 === void 0 ? void 0 : ref1.camera.quaternion,
                                                    mode: p.mode,
                                                    degree: _this.avatarDegree
                                                };
                                                if (room) {
                                                    if (host) {
                                                        socket/* default.emit */.Z.emit("move", {
                                                            pose: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                                                walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE
                                                            })
                                                        });
                                                    }
                                                }
                                                if (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) {
                                                    socket/* default.emit */.Z.emit("move_avatar", {
                                                        pose: pose
                                                    });
                                                }
                                            }
                                            if (tour.minimap) {
                                                if (p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE && !panoramaOn) {
                                                    _this.setState({
                                                        mapWalkerRotation: p.rotation.y * -1
                                                    });
                                                }
                                            }
                                        case 5:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(p) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showCaseTemp.showcase.Floor.current.subscribe(function(floor) {
                            if (floor.sequence !== -1 && floor.sequence !== undefined && floor.sequence !== _this.state.selectedMinimap) {
                                var minimaps = _this.state.minimaps;
                                if (minimaps.length > 0 && minimaps[floor.sequence]) {
                                    _this.setState({
                                        selectedMinimap: floor.sequence
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && _this.state.currentFloor !== floor.sequence) {
                                _this.setState({
                                    currentFloor: floor.sequence
                                }, function() {
                                    _this.processTourMusic(tour);
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Measurements.mode.subscribe(function(measurementModeState) {
                            _this.setState({
                                mesurementsOn: measurementModeState.active
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STEPPED, function(i) {
                            _this.setState({
                                reelStep: i,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STARTED, function() {
                            _this.setState({
                                tourPlaying: true,
                                panoramaOn: false,
                                tourMode: _this.pose.mode
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STOPPED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.ENDED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false,
                                reelStep: 0
                            });
                        });
                        _this.showcase.on(_this.showcase.Mattertag.Event.CLICK, function(tagId) {
                            var _state = _this.state, room = _state.room, host = _state.host, showcaseLoaded = _state.showcaseLoaded;
                            var tags = Array.from(_this.state.allTags.values());
                            var tag = tags.find(function(t) {
                                return t.sid === tagId || t.defaultSid === tagId;
                            });
                            if (room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && showcaseLoaded) {
                                socket/* default.emit */.Z.emit("tag", {
                                    tag: {
                                        id: tag.sid,
                                        action: "click"
                                    }
                                });
                            }
                            _this.openTagIframe(tagId);
                            if (tag && tag.title) {
                                (0,analytic/* sendToGA */.o$)("event", {
                                    eventCategory: "Mattertag",
                                    eventAction: "click",
                                    eventLabel: tag.title
                                });
                            }
                        });
                        _this.showcase.on(_this.showcase.Mattertag.Event.HOVER, function(tagId) {
                            var _state = _this.state, room = _state.room, host = _state.host, showcaseLoaded = _state.showcaseLoaded;
                            var tags = Array.from(_this.state.allTags.values());
                            var tag = tags.find(function(t) {
                                return t.sid === tagId || t.defaultSid === tagId;
                            });
                            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                                if (tag) {
                                    socket/* default.emit */.Z.emit("tag", {
                                        tag: {
                                            id: tag.sid
                                        }
                                    });
                                }
                            }
                            if (tag && tag.enabled && tag.embedMedia && tag.type === "video") {
                                _this.pauseTourMusic();
                            }
                            if (tag && tag.title) {
                                (0,analytic/* sendToGA */.o$)("event", {
                                    eventCategory: "Mattertag",
                                    eventAction: "hover",
                                    eventLabel: tag.title
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Floor.data.subscribe({
                            // Get floor data
                            onCollectionUpdated: function(collection) {
                                var mpFloors = [];
                                Object.keys(collection).forEach(function(o) {
                                    var floor = collection[o];
                                    if (!floor.name || floor.name.length === 0) return;
                                    mpFloors.push(floor);
                                });
                                _this.setState({
                                    mpFloors: mpFloors
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Label.getData().then(function(labels) {
                            _this.setState({
                                mpLabels: labels
                            });
                        }).catch(function() {
                            return console.error("Error to load MP labels");
                        });
                        _this.showCaseTemp.showcase.Mattertag.data.subscribe({
                            onAdded: function(sid, item) {
                                var room = _this.state.room;
                                if (room && item.media.type === _this.showCaseTemp.showcase.Mattertag.MediaType.VIDEO) {
                                    // ToDo: matterport vimeo video does not support mute
                                    var clone = cloneDeep_default()(item);
                                    var urlC = clone.media.src.split("https://vimeo.com/");
                                    clone.media.src += urlC.length > 1 ? "?muted=1" : "&muted=1";
                                    _this.showCaseTemp.showcase.Mattertag.editBillboard(sid, clone);
                                }
                            }
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getPolygons = function getPolygons() {
        return this.state.polygons;
    };
    _proto.handlePolygonProduct = function handlePolygonProduct(polygon) {};
    _proto.moveToSweepIO = function moveToSweepIO(p) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (_this.state.showcaseLoaded) {
                            setTimeout(function() {
                                if (!p.walking) {
                                    _this.showCaseTemp.showcase.Mode.moveTo(p.mode, {
                                        position: p.position,
                                        rotation: p.rotation,
                                        transition: _this.showCaseTemp.showcase.Mode.TransitionType.FLY
                                    }).catch(function(e) {});
                                } else {
                                    _this.showcase.Sweep.moveTo(p.sweep, {
                                        position: p.position,
                                        rotation: p.rotation,
                                        transition: _this.showCaseTemp.showcase.Sweep.Transition.FLY
                                    }).catch(function(e) {});
                                }
                            }, 100);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.moveToTagIO = function moveToTagIO(tag) {
        var doOpenTag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (this.state.showcaseLoaded) {
            var _this = this;
            setTimeout(function() {
                var tags = Array.from(_this.state.allTags.values());
                var foundTag = tags.find(function(t) {
                    return t.sid === tag.sid || t.defaultSid === tag.sid;
                });
                if (!foundTag) {
                    return;
                }
                if (_this.pose.mode !== _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                    var _this1 = _this;
                    _this.showCaseTemp.showcase.Mattertag.navigateToTag(foundTag.sid, _this.showCaseTemp.showcase.Mattertag.Transition.FLY).then(function() {
                        if (doOpenTag) {
                            _this1.openTagIframe(tag.id);
                        }
                    }).catch(function(err) {
                        ;
                    });
                } else if (doOpenTag) {
                    _this.openTagIframe(foundTag.sid);
                }
            }, 100);
        }
    };
    _proto.getLogoUrl = function getLogoUrl() {
        var ref;
        var tour = this.state.tour;
        return tour && (tour === null || tour === void 0 ? void 0 : tour.client) ? "".concat("https://cdn.treedis.com", "/clients/").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)) : "";
    };
    _proto.renderMenu = function renderMenu() {
        var ref, ref1;
        var _state = this.state, tour = _state.tour, room = _state.room, tokenRemainingTime = _state.tokenRemainingTime, whiteLabelData = _state.whiteLabelData, menuOpen = _state.menuOpen, changeMenu = _state.changeMenu, translation = _state.translation, tourEmail = _state.tourEmail;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseTour_Menu, {
            activeMenu: this.state.activeMenu,
            tourMode: tour.mode,
            tourId: tour.id,
            changeMenu: changeMenu,
            menuOpen: menuOpen,
            menuSearch: tour.menuSearch,
            menuCategoryExpand: tour.menuCategoryExpand,
            bookUrl: tour.bookUrl,
            bookText: tour.bookText,
            bookColor: tour.bookColor,
            client: tour.client,
            unbranded: tour.unbranded,
            bookAppointment: tour.appointmentsOn && !room && tokenRemainingTime < 1,
            toggleAppointmentsModal: this.toggleAppointmentsModal,
            contact: tour.contactForm && (((ref = tour.client) === null || ref === void 0 ? void 0 : ref.phone) || ((ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.email) || (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone)),
            whitelabel: whiteLabelData,
            address: tour.address,
            loadModel: this.loadModel,
            moveToMPLabels: this.moveToMPLabels,
            toggleContactPopup: popups/* toggleContactPopup.bind */.O.bind(this),
            toggleExternalPopup: this.toggleExternalPopup.bind(this),
            translation: translation
        });
    };
    _proto.injectBottomBg = function injectBottomBg() {};
    _proto.hideIframeButtons = function hideIframeButtons() {
        try {
            if (this.iframe) {
                var ref, ref1, ref2;
                var iframeButtons = (ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector("#bottom-ui");
                if (iframeButtons && iframeButtons.style.display !== "none") {
                    iframeButtons.style.display = "none";
                }
            }
        } catch (err) {
            ;
        }
    };
    _proto.openVR = function openVR() {
        var ref, ref1, ref2;
        var iframeVrButton = (ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".bottom-controls .view-in-vr");
        if (iframeVrButton) iframeVrButton.click();
    };
    _proto.getOtherAudio = function getOtherAudio() {
        var ref, ref1, ref2, ref3;
        var audio = !((ref = this.tagAudio) === null || ref === void 0 ? void 0 : ref.paused) ? this.tagAudio : null;
        // added removing sweepAudio on change sweep, removed check paused sweep audio to
        // not miss paused player on sweep change from same audio groups
        if (!audio && this.sweepAudio && !this.sweepAudio.ended) {
            audio = this.sweepAudio;
        }
        if (!audio && !((ref1 = this.polygonAudio) === null || ref1 === void 0 ? void 0 : ref1.paused)) {
            audio = this.polygonAudio;
        }
        if (!audio && !((ref2 = this.panoramaAudio) === null || ref2 === void 0 ? void 0 : ref2.paused)) {
            audio = this.panoramaAudio;
        }
        if (!audio && !((ref3 = this.buttonAudio) === null || ref3 === void 0 ? void 0 : ref3.paused)) {
            audio = this.buttonAudio;
        }
        return audio;
    };
    _proto.renderBottomBar = function renderBottomBar(isFullScreen, toggleFullscreen) {
        var _this = this;
        var ref, ref1, ref2, ref3;
        var _state = this.state, tour = _state.tour, room = _state.room, sharePopupOn = _state.sharePopupOn, minimapVisible = _state.minimapVisible, panoramaOn = _state.panoramaOn, mainPlaying = _state.mainPlaying, mesurementsOn = _state.mesurementsOn, whiteLabelData = _state.whiteLabelData, reel = _state.reel, reelStep = _state.reelStep, translation = _state.translation, otherPlaying = _state.otherPlaying, currentFloor = _state.currentFloor, isVSEnabled = _state.isVSEnabled, ticketing = _state.ticketing, mpFloors = _state.mpFloors, host = _state.host;
        var audio = this.getOtherAudio();
        var handleSoundControlClose = function() {
            var _this1 = _this;
            _this.setState({
                otherPlaying: false
            }, function() {
                _this1.resumeTourMusic();
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                otherPlaying && audio && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundControls["default"], {
                    audio: audio,
                    onClose: handleSoundControlClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBar, {
                    host: host,
                    allowedTours: ticketing === null || ticketing === void 0 ? void 0 : (ref = ticketing.ticketingTourTicket) === null || ref === void 0 ? void 0 : ref.accessTours,
                    showTicketRestrictedAreaPopup: this.showTicketRestrictedAreaPopup,
                    onTicketingReel: this.handleTicketingReel,
                    audio: this.tourAudio,
                    mainPlaying: mainPlaying,
                    otherPlaying: otherPlaying,
                    toggleSketchfabPopup: this.toggleSketchfabPopup,
                    isFull: isFullScreen,
                    translation: translation,
                    vsObjects: this.vsObjects,
                    changeFull: toggleFullscreen,
                    openShare: function() {
                        _this.setState({
                            sharePopupOn: !sharePopupOn
                        });
                    },
                    reelVideos: this.state.reelVideos,
                    reel: reel,
                    mpFloors: mpFloors,
                    room: room,
                    loadModel: this.loadModel,
                    tour: tour,
                    reelStep: reelStep,
                    sharePopupOn: sharePopupOn,
                    isVSEnabled: isVSEnabled,
                    moveToStep: this.moveToStep.bind(this),
                    playTour: this.playTour,
                    tourPlaying: this.state.tourPlaying,
                    showcase: this.showCaseTemp.showcase,
                    changeViewMode: this.changeViewMode,
                    mesurementsOn: mesurementsOn,
                    panoramaOn: panoramaOn,
                    measurementsMode: this.measurementsMode,
                    changeFloor: this.changeFloor,
                    showPanorama: tour.panorama,
                    toggleExternalPopup: this.toggleExternalPopup.bind(this),
                    handleToggleMusic: this.handleToggleMusic.bind(this),
                    takeScreenshot: sdk/* takeScreenshot.bind */.ss.bind(this),
                    takePano: sdk/* takePano.bind */.Zy.bind(this),
                    whitelabel: whiteLabelData,
                    showMinimapClick: function() {
                        _this.setState({
                            minimapVisible: !minimapVisible
                        });
                    },
                    showPanoramaClick: this.handleTogglePano,
                    onHelpClick: function() {
                        _this.setState({
                            showHelpModal: true,
                            showTermsModal: false
                        });
                    },
                    onTermsClick: function() {
                        _this.setState({
                            showTermsModal: true,
                            showHelpModal: false
                        });
                    },
                    toggleVS: this.toggleVS,
                    openVR: this.openVR.bind(this),
                    onStartVideo: function() {
                        _this.setState({
                            videoPlaying: true
                        });
                        _this.pauseAllAudio();
                    },
                    onStopVideo: function() {
                        _this.playContainerAudio("tourAudio");
                        _this.setState({
                            videoPlaying: false,
                            mainPlaying: true,
                            otherPlaying: false
                        });
                    },
                    currentFloor: currentFloor,
                    onMuteClick: this.toggleMuteParticipants,
                    onFullscreenClick: this.toggleFullscreenVideo,
                    onPinClick: this.addPinnedVideo,
                    initialDuplicates: (ref1 = this.props) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tourData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tour) === null || ref3 === void 0 ? void 0 : ref3.initialDuplicates
                })
            ]
        });
    };
    _proto.injectChildComponents = function injectChildComponents() {};
    /** experience handlers * */ _proto.renderGameContent = function renderGameContent() {};
    _proto.renderGameTourConfig = function renderGameTourConfig() {};
    _proto.hideItemsFromConditions = function hideItemsFromConditions() {};
    _proto.renderEndGameScreen = function renderEndGameScreen() {};
    _proto.handleGameStart = function handleGameStart(username, skipValidation) {};
    _proto.tryButtonPlaySound = function tryButtonPlaySound() {};
    /** experience handlers * */ _proto.isRenderAuth = function isRenderAuth() {
        var tour = this.state.tour;
        var p = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "p");
        if (tour.password && p && atob(decodeURIComponent(p)) === tour.password) return false;
        return tour.password;
    };
    _proto.renderAuth = function renderAuth() {
        var _state = this.state, tour = _state.tour, whiteLabelData = _state.whiteLabelData;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
            password: tour.password,
            whitelabel: whiteLabelData,
            login: util_all/* login.bind */.x4.bind(this)
        });
    };
    _proto.pauseAllAudio = function pauseAllAudio() {
        var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", withVsAudio = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(_this.tourAudio && type !== "tourAudio")) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return _this.tourAudio.pause();
                    case 4:
                        if (!(_this.tagAudio && type !== "tagAudio")) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return _this.tagAudio.pause();
                    case 7:
                        if (!(_this.sweepAudio && type !== "sweepAudio")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 10;
                        return _this.sweepAudio.pause();
                    case 10:
                        if (!(_this.polygonAudio && type !== "polygonAudio")) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 13;
                        return _this.polygonAudio.pause();
                    case 13:
                        if (!(_this.panoramaAudio && type !== "panoramaAudio")) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 16;
                        return _this.panoramaAudio.pause();
                    case 16:
                        if (!(_this.buttonAudio && type !== "buttonAudio")) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 19;
                        return _this.buttonAudio.pause();
                    case 19:
                        if (_this.state.vsAudio && withVsAudio) {
                            _this.state.vsAudio.component.toggleMute();
                            _this.state.vsAudio.btn.setActive(true);
                            _this.setState({
                                vsAudio: null
                            });
                        }
                        _this.setState({
                            mainPlaying: false,
                            otherPlaying: false
                        });
                        _ctx.next = 25;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](0);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    23
                ]
            ]);
        }))();
    };
    _proto.createAudioStream = function createAudioStream(type, src) {
        var clearPrev = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (clearPrev && this[type]) {
            this[type].src = "";
        }
        this[type] = new Audio();
        this[type].src = src;
        this[type].autoplay = false;
        this[type].autoplay = false;
        this[type].load();
        return this[type];
    };
    _proto.getAudioContainer = function getAudioContainer(type) {
        if (this[type]) {
            return this[type];
        }
        return null;
    };
    _proto.playContainerAudio = function playContainerAudio(type) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(_this[type] && _this[type].paused)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return _this[type].play();
                    case 5:
                        return _ctx.abrupt("return", true);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        return _ctx.abrupt("return", setTimeout(function() {
                            return _this.playContainerAudio(type);
                        }, 500));
                    case 12:
                        _ctx.next = 14;
                        return (ref = _this[type]) === null || ref === void 0 ? void 0 : ref.pause();
                    case 14:
                        return _ctx.abrupt("return", false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }))();
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3;
        var _state = this.state, tour = _state.tour, game = _state.game, sweepGroups = _state.sweepGroups, mesurementsOn = _state.mesurementsOn, allowGuestBeforeHost = _state.allowGuestBeforeHost, room = _state.room, activeSweepGroup = _state.activeSweepGroup, sharePopupOn = _state.sharePopupOn, overlayOn = _state.overlayOn, showcaseLoaded = _state.showcaseLoaded, tokenRemainingTime = _state.tokenRemainingTime, tokenExpiresAt = _state.tokenExpiresAt, showSketchfabPopup = _state.showSketchfabPopup, whiteLabelData = _state.whiteLabelData, minimapVisible = _state.minimapVisible, minimapOn = _state.minimapOn, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap, mapWalkerX = _state.mapWalkerX, mapWalkerY = _state.mapWalkerY, mapWalkerRotation = _state.mapWalkerRotation, lock = _state.lock, tagPopOn = _state.tagPopOn, panoPopOn = _state.panoPopOn, openedTag = _state.openedTag, openedPanoHotspot = _state.openedPanoHotspot, vsActionPopOn = _state.vsActionPopOn, openedVSAction = _state.openedVSAction, contactPopupOn = _state.contactPopupOn, externalPopupOn = _state.externalPopupOn, externalPopupUrl = _state.externalPopupUrl, panoramaOn = _state.panoramaOn, host = _state.host, selectedMarker = _state.selectedMarker, showHelpModal = _state.showHelpModal, showTermsModal = _state.showTermsModal, showCollectLeadsModal = _state.showCollectLeadsModal, panoramas = _state.panoramas, interacted = _state.interacted, showIntroScreen = _state.showIntroScreen, showIntro = _state.showIntro, containerId = _state.containerId, loadingTags = _state.loadingTags, agents = _state.agents, tourEmail = _state.tourEmail, translation = _state.translation, tourType = _state.tourType, reelVideos = _state.reelVideos, experiencePopUpIsOpen = _state.experiencePopUpIsOpen, initialDuplicates = _state.initialDuplicates, experiencePopUpData = _state.experiencePopUpData, forcePlayGameIntro = _state.forcePlayGameIntro, // --- to add
        ticketingOpen = _state.ticketingOpen, ticketing = _state.ticketing, avatar = _state.avatar, chatParticipant = _state.chatParticipant, iframeUrl = _state.iframeUrl, audioOnly = _state.audioOnly;
        var _props = this.props, _tour = _props._tour, tourImage = _props.tourImage;
        var preview = !!_tour;
        var loadSweeps = !showIntro && !showIntroScreen && !loadingTags && showcaseLoaded && sweepGroups && sweepGroups.length > 0;
        var isGameTour = tourType === Tour/* TourType.Game */.v.Game;
        var showGameWatermark = isGameTour && game && tour && !game.paid && tour.userId !== 1;
        var showTicketWatermark = tourType !== Tour/* TourType.ECommerce */.v.ECommerce && (tour === null || tour === void 0 ? void 0 : tour.ticket) && !(ticketing === null || ticketing === void 0 ? void 0 : (ref = ticketing.ticketingGeneral) === null || ref === void 0 ? void 0 : ref.paid);
        var showEcommerceWatermark = tourType === Tour/* TourType.ECommerce */.v.ECommerce && !(tour === null || tour === void 0 ? void 0 : tour.ecommercePaidStatus);
        var ticketingContentTickets = [];
        if ((ticketing === null || ticketing === void 0 ? void 0 : (ref1 = ticketing.ticketingOrderedTicket) === null || ref1 === void 0 ? void 0 : ref1.ticketType) === "tourByYourself") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref2 = ticketing.ticketingOrderedTicket) === null || ref2 === void 0 ? void 0 : ref2.ticketType) === "gameTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref3 = ticketing.ticketingOrderedTicket) === null || ref3 === void 0 ? void 0 : ref3.ticketType) === "guidedTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreen/* default */.Z, {
            attrs: {
                id: "global-fullscreen"
            },
            rootBody: true,
            children: function(param) {
                var isFullScreen = param.isFullScreen, toggleFullscreen = param.toggleFullscreen;
                var _this1 = _this;
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                var _this2 = _this;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !ticketingOpen && !showIntroScreen && !showCollectLeadsModal && _this.state.tourType !== Tour/* TourType.Game */.v.Game && !_this.isRenderAuth() && !_this.state.loaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "intro-screen",
                            style: {
                                backgroundImage: "url(".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/images/").concat((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.mainImage, ")")
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    style: {
                                        marginTop: "100px",
                                        fontSize: "50px"
                                    },
                                    children: tour === null || tour === void 0 ? void 0 : tour.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "shadow"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProgress/* default */.Z, {
                                    showSpinner: true,
                                    showBar: false
                                })
                            ]
                        }),
                        _this.state.gameTrialErr && _this.state.tourType === Tour/* TourType.Game */.v.Game && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "gameTrialErr",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "gameTrialErr-text",
                                    children: _this.state.gameTrialErr
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(units.Button, {
                                    onClick: function() {
                                        return window.close();
                                    },
                                    children: "Close"
                                })
                            ]
                        }),
                        experiencePopUpIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperiencePopUp, {
                            onInit: function() {
                                if (_this1.state.tourType === Tour/* TourType.Game */.v.Game) {
                                    _this1.pauseTourMusic();
                                } else {
                                    _this1.pauseAllAudio();
                                }
                            },
                            tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                            logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo,
                            initialDuplicates: initialDuplicates,
                            tryButtonPlaySound: _this.tryButtonPlaySound,
                            experiencePopUpData: experiencePopUpData,
                            isOpen: experiencePopUpIsOpen,
                            translations: translation,
                            setIsOpen: function(status) {
                                // as I understand this using only for closing experience from itself
                                if (_this1.state.tourMusicWasPaused) {
                                    _this1.resumeTourMusic();
                                }
                                _this1.state.onExperienceCloseCallback();
                                _this1.setState({
                                    tourMusicWasPaused: false,
                                    experiencePopUpIsOpen: status,
                                    closedElementPopup: !status,
                                    onExperienceCloseCallback: function() {
                                        return undefined;
                                    }
                                });
                            }
                        }),
                        showcaseLoaded && (showGameWatermark || showTicketWatermark || showEcommerceWatermark) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Watermark, {
                            show: showcaseLoaded && (showGameWatermark || showTicketWatermark || showEcommerceWatermark),
                            id: "game-watermark",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Demo"
                            })
                        }),
                        ticketingOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingRouter, {
                            matterId: tour.slug,
                            parentTourId: tour.parentId,
                            tourId: tour.id,
                            gameId: tour.gameId,
                            ticketing: ticketing,
                            reactAppDomain: _this.root,
                            reactAws: _this.props.reactAws,
                            tourImage: tourImage,
                            onTicketLoginSuccess: _this.onTicketLoginSuccess,
                            translation: translation,
                            whiteLabelData: whiteLabelData
                        }),
                        !ticketingOpen && showIntroScreen && tour && !tour.password && _this.state.tourType !== Tour/* TourType.Game */.v.Game && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroScreen, {
                            tour: tour,
                            introScreen: tour.introScreen,
                            showcaseLoaded: showcaseLoaded,
                            vsObjectsLength: _this.vsObjects.length,
                            whiteLabelData: whiteLabelData,
                            onPlayClick: _this.onPlayClick
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "".concat(containerId, "-tour-root"),
                            className: classnames_default()(preview ? "preview base-tour tour-container" : "base-tour tour-container", deviceManager["default"].isMobile() && "no-visible-scrollbar"),
                            // eslint-disable-next-line no-return-assign
                            ref: function(el) {
                                return _this1.root = el;
                            },
                            children: [
                                tokenRemainingTime > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "countDownWrap",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "countDown",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                                            date: tokenExpiresAt,
                                            zeroPadDays: 0,
                                            onComplete: function() {
                                                _this1.props.history.push("/");
                                            }
                                        })
                                    })
                                }),
                                showCollectLeadsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectLeadsForm, {
                                    tour: tour,
                                    rtl: (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl,
                                    translation: translation,
                                    onStart: _this.handleCollectLeadsSubmit
                                }),
                                !ticketingOpen && tour && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: _this.isRenderAuth() ? _this.renderAuth() : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("inner", deviceManager["default"].isMobile() && "mobile"),
                                        style: showCollectLeadsModal && tour.mainImage ? {
                                            backgroundColor: "#000"
                                        } : {},
                                        children: [
                                            tour.messengerLink && tour.messengerGreeting && _this.messenger !== 0 && !room && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerCustomerChat, {
                                                pageId: tour.messengerLink,
                                                appId: "741048509750318",
                                                loggedInGreeting: tour.messengerGreeting,
                                                loggedOutGreeting: tour.messengerGreeting,
                                                themeColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c",
                                                shouldShowDialog: true,
                                                version: "7.0"
                                            }),
                                            externalPopupUrl && externalPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalPopup, {
                                                show: externalPopupUrl && externalPopupOn,
                                                url: externalPopupUrl,
                                                onClose: _this.toggleExternalPopup.bind(_this, null),
                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                            }),
                                            _this.injectChildComponents(),
                                            !isGameTour && tour.gameId && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPaths, {
                                                gameId: tour.gameId,
                                                allTags: _this.state.allTags,
                                                modelNodes: _this.modelNodes,
                                                polygons: _this.state.polygons,
                                                showcase: _this.showCaseTemp,
                                                vsObjects: _this.vsObjects,
                                                sweeps: _this.state.sweeps,
                                                clickedElement: _this.state.clickedElement
                                            }),
                                            tagPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsPopup, {
                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo,
                                                obj: openedTag,
                                                type: "tags",
                                                tourId: tour.id,
                                                closePop: _this.closeTagPop
                                            }),
                                            !ticketingOpen && (ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderTicketingContent, {
                                                tickets: ticketingContentTickets,
                                                translation: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingTranslation,
                                                tourSlug: tour.slug,
                                                ticketingOrderedTicket: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket,
                                                ticketTimeLeftMs: _this.state.ticketTimeLeftMs,
                                                ticketModalInfo: _this.state.ticketModalInfo,
                                                root: _this.root,
                                                tourId: tour.id,
                                                gameId: tour.gameId,
                                                ticketingGeneral: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGeneral,
                                                showTicketModal: _this.state.showTicketModal
                                            }),
                                            openedPanoHotspot && panoPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PanoPopup, {
                                                hotspot: openedPanoHotspot,
                                                show: panoPopOn,
                                                onClose: _this.closePanoPop,
                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                            }),
                                            _this.state.showPathFinderPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PathFinderPopup, {
                                                open: _this.state.showPathFinderPopup,
                                                closePopup: _this.closePathFinderPop
                                            }),
                                            vsActionPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(VSActionsPopup, {
                                                tourId: tour.id,
                                                object: openedVSAction,
                                                onClose: _this.closeActionPop
                                            }),
                                            contactPopupOn && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopup, {
                                                agents: agents,
                                                rtl: (ref3 = tour.client) === null || ref3 === void 0 ? void 0 : ref3.rtl,
                                                translation: translation,
                                                to: (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.menuGetInTouch) || (tour === null || tour === void 0 ? void 0 : (ref4 = tour.client) === null || ref4 === void 0 ? void 0 : ref4.email),
                                                legalBookingBox: tour.legalBookingBox,
                                                legalBookingBox2: tour.legalBookingBox2,
                                                userId: tour.userId,
                                                tourId: tour.id,
                                                title: tour.title,
                                                client: tour.client,
                                                hideClientContact: tour.hideClientContact,
                                                phone: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone,
                                                name: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactName,
                                                toggleContactPopup: popups/* toggleContactPopup.bind */.O.bind(_this)
                                            }),
                                            tour.qualtricsId && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Qualtrics, {
                                                onClick: function() {
                                                    var tour = _this1.state.tour;
                                                    tour.qualtricsId = null;
                                                    _this1.setState({
                                                        tour: tour
                                                    });
                                                },
                                                qualtricsId: tour.qualtricsId,
                                                onKeyPress: function() {}
                                            }),
                                            !room && /*#__PURE__*/ (0,jsx_runtime.jsx)(Ad, {
                                                time: tour.adTime,
                                                res: deviceManager["default"].isMobile() ? tour.adResMobile : tour.adRes,
                                                width: deviceManager["default"].isMobile() ? tour.adWidthMobile : tour.adWidth,
                                                height: deviceManager["default"].isMobile() ? tour.adHeightMobile : tour.adHeight,
                                                tourId: tour.id,
                                                matterId: tour.matterId,
                                                to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                                rtl: (ref5 = tour.client) === null || ref5 === void 0 ? void 0 : ref5.rtl,
                                                updatedAt: tour.updatedAt,
                                                enabled: tour.ad,
                                                url: tour.adUrl,
                                                leads: tour.adLeads,
                                                userId: tour.userId,
                                                clientId: tour.clientId,
                                                translation: translation,
                                                legalBookingBox: tour.legalBookingBox,
                                                legalBookingBox2: tour.legalBookingBox2,
                                                leadsPhone: tour.leadsPhone
                                            }),
                                            !isGameTour && panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Panorama, {
                                                panoramas: panoramas,
                                                markMinimap: _this.markMinimap,
                                                panoPose: _this.state.panoPose,
                                                activePano: _this.state.activePano,
                                                transition: tour.panoramaTransition,
                                                isChatGuest: room && socket/* default */.Z && socket/* default.connected */.Z.connected && !host,
                                                defaultPanorama: tour.defaultPanorama,
                                                updatePanoRotation: _this.updatePanoRotation,
                                                openHotspot: sdk/* openedPanoHotspot.bind */.Z4.bind(_this),
                                                onSceneChange: _this.handlePanoSceneChange
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "overlay ".concat(overlayOn ? "open" : "")
                                            }),
                                            tour.menuEnabled && tourType !== Tour/* TourType.Game */.v.Game && showcaseLoaded && !(mesurementsOn && !!(deviceManager["default"].isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop)) && _this.renderMenu(),
                                            room && _this.showCaseTemp && _this.pose && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedVideo, {
                                                sdk: _this.showCaseTemp.showcase,
                                                tour: tour,
                                                host: host,
                                                audioOnly: audioOnly,
                                                measurementsOn: mesurementsOn,
                                                room: room,
                                                slug: tour.slug,
                                                name: chatParticipant === null || chatParticipant === void 0 ? void 0 : chatParticipant.name,
                                                avatar: chatParticipant,
                                                reelVideos: reelVideos,
                                                endCall: _this.videoEndCall,
                                                clientId: tour.clientId,
                                                tourId: tour.id,
                                                enterprise: tour === null || tour === void 0 ? void 0 : (ref6 = tour.user) === null || ref6 === void 0 ? void 0 : ref6.enterprise,
                                                translation: translation,
                                                allowGuestBeforeHost: allowGuestBeforeHost,
                                                changeTour: _this.videoChangeTour,
                                                addTrack: _this.addTrack,
                                                removeTrack: _this.removeTrack,
                                                pinnedVideos: _this.state.pinnedVideos,
                                                removePinnedVideo: _this.removePinnedVideo,
                                                onToggleMute: _this.toggleMuteParticipants,
                                                onToggleFullscreen: _this.toggleFullscreenVideo,
                                                dominantSpeaker: _this.state.dominantSpeaker,
                                                fullscreenVideo: _this.state.fullscreenVideo,
                                                addVideoReel: _this.addVideoReel
                                            }),
                                            _this.showCaseTemp && (!avatar || room && !(tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !((ref7 = chatParticipant.name) === null || ref7 === void 0 ? void 0 : ref7.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "video-name-overlay",
                                                className: "overlay",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroPopup, {
                                                    sdk: _this.showCaseTemp.showcase,
                                                    enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                    translation: translation,
                                                    showVideoCameraCheckbox: true,
                                                    room: room,
                                                    onSubmit: _this.setAvatar
                                                })
                                            }),
                                            tour.legalNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "legal-note ".concat(tour.client && tour.client.rtl && "rtl"),
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML: {
                                                    // eslint-disable-next-line no-control-regex
                                                    __html: tour.legalNote.replace(new RegExp("\r?\n", "g"), "<br />")
                                                }
                                            }),
                                            showcaseLoaded && !tour.unbranded && tour.client && tour.client.logo && !room && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: ((ref8 = tour.client) === null || ref8 === void 0 ? void 0 : ref8.website) ? ((ref9 = tour.client.website) === null || ref9 === void 0 ? void 0 : ref9.includes("https://")) ? tour.client.website : "https://".concat(tour.client.website) : "",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: tour.client.widthLogo ? "logo width" : "logo",
                                                    src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)),
                                                    alt: ""
                                                })
                                            }),
                                            showcaseLoaded && _this.renderButtonBg(),
                                            _this.state.markerPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "popup",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "btn",
                                                        onClick: function() {
                                                            _this1.setState({
                                                                overlayOn: false,
                                                                markerPopupOn: false
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-times"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: "What do you want to do?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: _this.toggleExternalPopup.bind(_this, _this.state.selectedMarker.external),
                                                        children: "Open Autodesk Viewer"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function() {
                                                            return _this1.moveModel(selectedMarker.url);
                                                        },
                                                        children: "Move to this point"
                                                    })
                                                ]
                                            }),
                                            showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Minimap, {
                                                tour: tour,
                                                minimapOn: minimapOn,
                                                minimapVisible: minimapVisible,
                                                minimaps: minimaps,
                                                selectedMinimap: selectedMinimap,
                                                mapWalkerX: mapWalkerX,
                                                mapWalkerY: mapWalkerY,
                                                mapWalkerRotation: mapWalkerRotation,
                                                markerClick: _this.markerClick,
                                                onClick: function() {
                                                    _this1.setState({
                                                        minimapOn: !minimapOn
                                                    });
                                                }
                                            }),
                                            _this.state.appointmentsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Appointment, {
                                                tour: tour,
                                                translation: translation,
                                                tourEmail: tourEmail,
                                                rtl: tour.client && tour.client.rtl,
                                                appointmentsModal: _this.state.appointmentsModal,
                                                toggleAppointmentsModal: _this.toggleAppointmentsModal,
                                                appointmentTime: tour.appointmentTime
                                            }),
                                            sharePopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Share, {
                                                getLocation: _this.getShareLocation,
                                                onClose: function() {
                                                    _this1.setState({
                                                        sharePopupOn: false
                                                    });
                                                },
                                                copyToClipboard: util_all/* copyToClipboard */.vQ,
                                                translation: translation,
                                                onColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                            }),
                                            showcaseLoaded && !(window.innerWidth < 1024 && mesurementsOn) && _this.renderBottomBar(isFullScreen, toggleFullscreen),
                                            loadSweeps && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseTour_Sweep, {
                                                clearSweepAudio: function() {
                                                    if (_this1.sweepAudio) _this1.sweepAudio.pause();
                                                    _this1.sweepAudio = null;
                                                },
                                                audioContainer: {
                                                    audio: _this.sweepAudio,
                                                    createAudioStream: _this.createAudioStream.bind(_this),
                                                    pause: function() {
                                                        var ref;
                                                        (ref = _this1.sweepAudio) === null || ref === void 0 ? void 0 : ref.pause();
                                                        _this1.setState({
                                                            otherPlaying: false
                                                        });
                                                    },
                                                    play: function() {
                                                        _this1.playContainerAudio("sweepAudio");
                                                        _this1.setState({
                                                            mainPlaying: false,
                                                            otherPlaying: true
                                                        });
                                                    },
                                                    pauseAllAudio: (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return _this2.pauseAllAudio("sweepAudio");
                                                                case 2:
                                                                    _this2.setState({
                                                                        mainPlaying: false,
                                                                        otherPlaying: true
                                                                    });
                                                                case 3:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    }))
                                                },
                                                videoContainer: {
                                                    pause: _this.pauseTourMusic,
                                                    play: _this.resumeTourMusic
                                                },
                                                title: tour.title,
                                                client: tour.client,
                                                legalBookingBox: tour.legalBookingBox,
                                                legalBookingBox2: tour.legalBookingBox2,
                                                panoramaStart: panoramaOn,
                                                userId: tour.userId,
                                                tourId: tour.id,
                                                email: tourEmail && tourEmail.leadSweeps || tour.client && tour.client.email,
                                                groups: sweepGroups,
                                                selectedGroup: activeSweepGroup,
                                                noAudioMode: tour.noAudioMode && room,
                                                translation: translation,
                                                showPanoramaClick: function(panoramaId) {
                                                    var pIndex = panoramas.findIndex(function(p) {
                                                        return p.id === panoramaId;
                                                    });
                                                    panoramas[pIndex].default = true;
                                                    _this1.setState({
                                                        panoramas: panoramas,
                                                        panoramaOn: !panoramaOn
                                                    });
                                                },
                                                onInteractedChange: function(interacted) {
                                                    _this1.setState({
                                                        interacted: interacted
                                                    });
                                                },
                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                            }),
                                            showHelpModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Help, {
                                                translation: translation,
                                                onClose: function() {
                                                    _this1.setState({
                                                        showHelpModal: false
                                                    });
                                                }
                                            }),
                                            showTermsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {
                                                translation: translation,
                                                tourId: tour.id,
                                                onClose: function() {
                                                    _this1.setState({
                                                        showTermsModal: false
                                                    });
                                                }
                                            }),
                                            lock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lock-layer"
                                            }),
                                            showcaseLoaded && (tour.music && tour.autoplayMusic || activeSweepGroup) && !room && !interacted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "music-cover",
                                                style: {
                                                    zIndex: 2,
                                                    position: "fixed",
                                                    height: "100vh",
                                                    width: "100vw",
                                                    top: 0,
                                                    left: 0
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loadTourIframe_LoadTourIframe, {
                                                iframeId: _this.state.iframeId,
                                                mesurementsOn: mesurementsOn,
                                                iframeStyle: getIframeStyle({
                                                    tour: _this.state.tour,
                                                    activeSweepGroup: _this.state.activeSweepGroup,
                                                    sweepGroups: _this.state.sweepGroups
                                                }),
                                                cb: function(el) {
                                                    _this1.iframe = el;
                                                    _this1.hideIframeButtons();
                                                },
                                                iframeUrl: iframeUrl,
                                                isFullScreen: isFullScreen
                                            }),
                                            showIntro && !showIntroScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipScreen/* default */.Z, {
                                                videoUrl: (game === null || game === void 0 ? void 0 : game.introClipUrl) || "",
                                                close: function() {
                                                    _this1.onCloseIntro();
                                                },
                                                forcePlay: forcePlayGameIntro,
                                                subtitles: (ref10 = _this.getCurrentLanguage()) === null || ref10 === void 0 ? void 0 : ref10.languageCode,
                                                onStartEvent: function() {}
                                            }) : _this.renderGameContent(),
                                            !isGameTour && (game === null || game === void 0 ? void 0 : game.book) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameBookHandle/* GameBookHandle */.V, {
                                                gameBook: game.book,
                                                onToggleGameBookModal: function() {
                                                    return _this1.setState(function(state) {
                                                        return {
                                                            showBook: !state.showBook
                                                        };
                                                    });
                                                },
                                                showBook: _this.state.showBook,
                                                closeGameBook: function() {
                                                    return _this1.setState({
                                                        showBook: false
                                                    });
                                                },
                                                unlockedChapterIds: _this.state.unlockedChapterIds,
                                                tryButtonPlaySound: _this.tryButtonPlaySound,
                                                moveToSweep: _this.moveToSweep,
                                                hideBook: !(game === null || game === void 0 ? void 0 : game.gameBookOn) || !(game === null || game === void 0 ? void 0 : game.book) || _this.state.showBook
                                            }),
                                            _this.renderGameTourConfig()
                                        ]
                                    })
                                })
                            ]
                        }),
                        tour && !tour.hideCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent/* CustomCookieConsent */.Le, {
                            tour: tour,
                            loaded: showcaseLoaded,
                            message: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentText),
                            accept: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentAccept),
                            decline: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentDecline)
                        }),
                        showSketchfabPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(SketchfabPopup, {
                            show: showSketchfabPopup,
                            vsObjects: _this.vsObjects,
                            onClose: _this.toggleSketchfabPopup(false)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SetDataToRecoil, {
                            translation: translation,
                            rtl: tour === null || tour === void 0 ? void 0 : (ref11 = tour.client) === null || ref11 === void 0 ? void 0 : ref11.rtl
                        }),
                        _this.renderCrashScreen()
                    ]
                });
            }
        });
    };
    return BaseTour;
}(react.Component);



/***/ }),

/***/ 82107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ game_ClipScreen; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@vimeo/player/dist/player.es.js
var player_es = __webpack_require__(48333);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/types.ts
var PlayerType;
(function(PlayerType) {
    PlayerType[PlayerType["NONE"] = 0] = "NONE";
    PlayerType[PlayerType["YOUTUBE"] = 1] = "YOUTUBE";
    PlayerType[PlayerType["VIMEO"] = 2] = "VIMEO";
    PlayerType[PlayerType["YOUKU"] = 3] = "YOUKU";
})(PlayerType || (PlayerType = {}));

;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/data.ts

var getPlayerType = function(url) {
    if (url.includes("https://vimeo.com/")) {
        return PlayerType.VIMEO;
    }
    if (url.includes("https://www.youtube.com/") || url.includes("youtu.be")) {
        return PlayerType.YOUTUBE;
    }
    if (url.includes("youku.com")) {
        return PlayerType.YOUKU;
    }
    return PlayerType.NONE;
};
var getVimeoId = function(url) {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};
var getYoutubeId = function(url) {
    var videoId = url.split("v=")[1] || url.split("youtu.be/")[1];
    var ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition);
    }
    return videoId;
};
var getYoukuId = function(url) {
    var match = /id_(\w+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/index.tsx

/* eslint-disable @typescript-eslint/ban-ts-comment */ 






var PERCENT_AFTER_START_EVENT = 0.7;
var ClipScreen = function(props) {
    var videoUrl = props.videoUrl, close = props.close, disableAutoplay = props.disableAutoplay, hideBtnGroup = props.hideBtnGroup, forcePlay = props.forcePlay, showControls = props.showControls, noMobile = props.noMobile, subtitles = props.subtitles, onStartEvent = props.onStartEvent, _autoClose = props.autoClose, autoClose = _autoClose === void 0 ? true : _autoClose;
    var player = (0,react.useRef)(null);
    var isEventStarted = (0,react.useRef)(false);
    var ref = (0,react.useState)(false), muted = ref[0], setMuted = ref[1];
    var ref1 = (0,react.useState)(PlayerType.NONE), type = ref1[0], setType = ref1[1];
    var translation = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    (0,react.useEffect)(function() {
        if (!videoUrl) return;
        setType(getPlayerType(videoUrl));
    }, [
        videoUrl
    ]);
    (0,react.useEffect)(function() {
        if (player && forcePlay && disableAutoplay) {
            var ref, ref1, ref2, ref3;
            if (type === PlayerType.VIMEO && typeof ((ref = player.current) === null || ref === void 0 ? void 0 : ref.play) === "function") (ref1 = player.current) === null || ref1 === void 0 ? void 0 : ref1.play();
            else if (typeof ((ref2 = player.current) === null || ref2 === void 0 ? void 0 : ref2.playVideo) === "function") (ref3 = player.current) === null || ref3 === void 0 ? void 0 : ref3.playVideo();
        }
    }, [
        player,
        forcePlay,
        disableAutoplay,
        type
    ]);
    var subtitlesCustomReplace = function(subCode) {
        // vimeo only
        // vimeo have different language codes (non iso) for some languages
        // for more check
        // https://vimeo.zendesk.com/hc/en-us/articles/224968828-Captions-and-subtitles#h_01FH9P8GQJ1ERMDZB2DRHJKAR0
        var subsToReplace = {
            he: "iw"
        };
        return subsToReplace[subCode] || subCode;
    };
    var loadVimeoVideo = (0,react.useCallback)(function() {
        var playerVars = {
            id: getVimeoId(videoUrl),
            autoplay: !disableAutoplay && !deviceManager["default"].isIOS(),
            controls: !!showControls || deviceManager["default"].isIOS()
        };
        if (subtitles) playerVars.texttrack = subtitlesCustomReplace(subtitles);
        player.current = new player_es/* default */.Z("intro-clip-iframe", playerVars);
        player.current.on("timeupdate", function(data) {
            if (onStartEvent && data.percent >= PERCENT_AFTER_START_EVENT && !isEventStarted.current) {
                onStartEvent();
                isEventStarted.current = true;
            }
        });
        player.current.on("loaded", function() {
            if (disableAutoplay) return;
            player.current.play().catch(function() {
            //nothing
            });
        });
        if (close) player.current.on("ended", function() {
            return autoClose && close();
        });
    }, [
        videoUrl,
        disableAutoplay,
        showControls,
        subtitles,
        close,
        onStartEvent,
        autoClose
    ]);
    var loadYKUVideo = (0,react.useCallback)(function() {
        var container = window.document.getElementById("intro-clip-iframe");
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "https://player.youku.com/embed/".concat(getYoukuId(videoUrl), "?autoplay=1&controls=0&rel=0&showinfo=0"));
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        container.appendChild(iframe);
    }, [
        videoUrl
    ]);
    var loadYTVideo = (0,react.useCallback)(function() {
        // @ts-ignore
        var playerVars = {
            autoplay: disableAutoplay ? 0 : 1,
            controls: showControls ? 1 : 0,
            rel: 0,
            showinfo: 0,
            disablekb: 1,
            fs: 0,
            modestbranding: 1
        };
        if (subtitles) playerVars.hl = subtitles;
        // @ts-ignore
        player.current = new window.YT.Player("intro-clip-iframe", {
            videoId: getYoutubeId(videoUrl),
            playerVars: playerVars,
            events: {
                onStateChange: function(event) {
                    // @ts-ignore
                    if (event.data === window.YT.PlayerState.ENDED && close) {
                        if (autoClose) close();
                    }
                },
                onReady: function(event) {
                    if (disableAutoplay) return;
                    event.target.playVideo();
                }
            }
        });
    }, [
        disableAutoplay,
        showControls,
        subtitles,
        videoUrl,
        close,
        autoClose
    ]);
    (0,react.useEffect)(function() {
        switch(type){
            case PlayerType.VIMEO:
                loadVimeoVideo();
                break;
            case PlayerType.YOUTUBE:
                // @ts-ignore
                if (!window.YT) {
                    var tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    // @ts-ignore
                    window.onYouTubeIframeAPIReady = loadYTVideo;
                    var firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                } else {
                    loadYTVideo();
                }
                break;
            case PlayerType.YOUKU:
                loadYKUVideo();
                break;
            default:
        }
    }, [
        loadVimeoVideo,
        loadYKUVideo,
        loadYTVideo,
        type
    ]);
    var mute = (0,react.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case PlayerType.VIMEO:
                player.current.setMuted(true);
                break;
            case PlayerType.YOUTUBE:
                player.current.mute();
                break;
            default:
                break;
        }
        setMuted(true);
    }, [
        type
    ]);
    var unMute = (0,react.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case PlayerType.VIMEO:
                player.current.setMuted(false);
                break;
            case PlayerType.YOUTUBE:
                player.current.unMute();
                break;
            default:
                break;
        }
        setMuted(false);
    }, [
        type
    ]);
    var isMobile = deviceManager["default"].isMobile();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "intro",
        className: classnames_default()("intro", deviceManager["default"].isMobile() && "mobile"),
        children: [
            !hideBtnGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "intro-btn-group",
                children: [
                    type !== PlayerType.YOUKU && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "intro-button",
                        onClick: muted ? unMute : mute,
                        children: muted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-volume-off"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-volume-mute"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "intro-button",
                        onClick: close || function() {
                            return null;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            children: (translation === null || translation === void 0 ? void 0 : translation.skip) || "Skip"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "intro-clip-iframe",
                className: classnames_default()(!noMobile && isMobile && "mobile")
            })
        ]
    });
};
function areEqual(prevProps, nextProps) {
    return prevProps.videoUrl !== nextProps.videoUrl;
}
/* harmony default export */ var game_ClipScreen = (/*#__PURE__*/(0,react.memo)(ClipScreen, areEqual));


/***/ }),

/***/ 17098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ GameBookHandle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./components/tour/game/gameBookBtn/index.tsx



var GameBookBtn = function(param) {
    var onToggle = param.onToggle, hide = param.hide;
    if (hide) return null;
    var isMobile = deviceManager["default"].isMobile();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("game-book-button", isMobile && "mobile"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("book-image"),
            onClick: onToggle
        })
    });
};
/* harmony default export */ var gameBookBtn = (GameBookBtn);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 6 modules
var store = __webpack_require__(8667);
// EXTERNAL MODULE: ./units/Icon/index.ts + 33 modules
var Icon = __webpack_require__(10530);
// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
// EXTERNAL MODULE: ./components/util/index.ts + 3 modules
var util = __webpack_require__(99351);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 120;\n  position: absolute;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-4278e250-0"
})(_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/index.tsx





var Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Root = (Root);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1em 2em;\n\n  h2 {\n    font-size: 2em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  .close-modal {\n    position: absolute;\n    right: 35px;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ",
        "\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-c647ccb6-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/index.tsx





var Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Header = (Header);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/style.tsx

function List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  width: 200px;\n\n  .chapter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1em;\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &.active {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n      opacity: 0.7;\n    }\n\n    &.locked {\n      cursor: none;\n      pointer-events: none;\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ListStyled = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-27471df0-0"
})(List_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/index.tsx





var List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_List = (List);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/style.tsx

function Content_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  padding: 3em 10em;\n\n  ",
        "\n"
    ]);
    Content_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ContentStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ContentStyled",
    componentId: "sc-3a0c8cfe-0"
})(Content_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      padding: 1em 6em;\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/index.tsx





var Content = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ContentStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Content = (Content);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/style.tsx

function Main_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    max-height: 70vh;\n    width: 30vw;\n    min-height: 50vh;\n    word-wrap: break-word;\n    overflow-y: auto;\n  }\n\n  ",
        "\n"
    ]);
    Main_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__MainStyled",
    componentId: "sc-9195c60f-0"
})(Main_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    p {\n      width: 50vw;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/index.tsx





var Main = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(MainStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Main = (Main);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/style.tsx

function Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-d65b2058-0"
})(Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/index.tsx





var Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Footer = (Footer);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/index.ts







;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/style.tsx

function Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  height: 100%;\n  background: rgba(0, 0, 0, 1);\n  z-index: 1200;\n  position: absolute;\n  top: 0;\n  font-family: WorkSans;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n\n  .game-book-no-content {\n    padding: 70px 60px 30px 60px;\n    font-family: WorkSans;\n    font-size: 28px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.36;\n    letter-spacing: -0.56px;\n    text-align: center;\n    color: var(--white);\n  }\n"
    ]);
    Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-7d6a60d3-0"
})(Root_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/index.tsx





var Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Root = (Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/style.tsx

function Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .close-modal {\n    right: 10px;\n    position: absolute;\n    color: white;\n  }\n"
    ]);
    Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-881094ed-0"
})(Header_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/index.tsx





var Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Header = (Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/index.ts



;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/BannerHorizontalViewOnly.tsx






var BannerHorizontalViewOnly = function(param) {
    var show = param.show, onClose = param.onClose;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    if (!show) return null;
    var isMobile = deviceManager["default"].isMobile();
    var isHorMob = deviceManager["default"].isHorizontalMobileView();
    if (isMobile && !isHorMob) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHorizontalViewOnly_styled_Root, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly_styled_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        className: "close-modal",
                        onClick: onClose,
                        fontSize: "large"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "game-book-no-content",
                    children: (translation === null || translation === void 0 ? void 0 : translation.expGbNoContent) || "Available only for horizontal view"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "game-book-gif",
                    src: "/experience/mobile.gif",
                    alt: "Screen orientation"
                })
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./components/tour/game/gameBook/index.tsx










var GameBook = function(param) {
    var onClose = param.onClose, book = param.book, unlockedChapterIds = param.unlockedChapterIds, tryButtonPlaySound = param.tryButtonPlaySound, show = param.show, moveToSweep = param.moveToSweep;
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    if (!show) return null;
    var ref = (0,react.useState)(), activePage = ref[0], setActivePage = ref[1];
    var ref1 = (0,react.useState)([]), pages = ref1[0], setPages = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    (0,react.useEffect)(function() {
        var ref;
        if ((book === null || book === void 0 ? void 0 : (ref = book.chapters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var data = sortBy_default()(book.chapters, "order").reduce(function(acc, chapter) {
                acc.push({
                    id: chapter.id,
                    title: chapter.title,
                    description: chapter.description,
                    url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                    moveToSweepUuid: chapter.sweepUuid
                });
                return acc;
            }, [
                {
                    id: 0,
                    title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                    description: book.description,
                    url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                    moveToSweepUuid: undefined
                }, 
            ]);
            setPages(data);
            setActivePage(data[0]);
        }
    }, [
        book
    ]);
    (0,react.useEffect)(function() {
        if (activePage && !activePage.url) {
            if (activePage.moveToSweepUuid) {
                moveToSweep(activePage.moveToSweepUuid);
            } else if (activePage.id !== 0) {
                onClose();
            }
        }
    }, [
        activePage
    ]);
    var isPageLocked = function(chapterId) {
        if (chapterId === 0 || !chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var changePage = function(page) {
        if (!isPageLocked(page.id)) {
            tryButtonPlaySound();
            setActivePage(page);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                onClose: onClose,
                show: show
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Root, {
                background: backgroundColor,
                opacity: backgroundOpacity,
                color: textColor,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                className: "close-modal",
                                onClick: onClose,
                                fontSize: "large"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Main, {
                                children: [
                                    activePage ? activePage.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "book",
                                        src: activePage.url,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "page-description",
                                        children: activePage.description
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Loader */.aN, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Footer, {
                                        show: !!(activePage === null || activePage === void 0 ? void 0 : activePage.moveToSweepUuid),
                                        buttonColor: buttonColor,
                                        color: textColor,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: function() {
                                                return moveToSweep(activePage.moveToSweepUuid);
                                            },
                                            children: [
                                                (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_List, {
                                color: textColor,
                                buttonColor: buttonColor,
                                children: (pages || []).map(function(page) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: classnames_default()("chapter", isPageLocked(page.id) && "locked", !isPageLocked(page.id) && activePage.id === page.id && "active"),
                                        onClick: function() {
                                            return changePage(page);
                                        },
                                        children: [
                                            page.title,
                                            isPageLocked(page.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                fontSize: "inherit"
                                            })
                                        ]
                                    }, page.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var game_gameBook = (GameBook);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/style.tsx

function styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 999;\n  top: 20px;\n  right: 250px;\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  padding: 1.25em;\n  justify-content: space-between;\n  border-radius: 10px;\n  max-width: 60%;\n  min-width: 320px;\n  min-height: 320px;\n\n  ",
        "\n"
    ]);
    styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-53d9d43b-0"
})(styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, withFooter = param.withFooter, theme = param.theme;
    var styles = "";
    if (!withFooter) {
        styles += "justify-content: flex-start;";
    }
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/index.tsx





var styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Root = (styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/style.tsx

function styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  h2 {\n    font-size: 1.25em;\n  }\n\n  ",
        "\n"
    ]);
    styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-87aa418e-0"
})(styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/index.tsx





var styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Header = (styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/style.tsx

function Body_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1em 0;\n\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    overflow-wrap: anywhere;\n  }\n\n  ",
        "\n"
    ]);
    Body_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BodyStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__BodyStyled",
    componentId: "sc-d3e442b0-0"
})(Body_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    img {\n      max-height: 60vh;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/index.tsx





var Body = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(BodyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Body = (Body);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/style.tsx

function styled_Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-1575e035-0"
})(styled_Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/index.tsx





var Footer_Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Footer = (Footer_Footer);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/index.ts





;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/ChapterDetails.tsx






var ChapterDetails = function(param) {
    var book = param.book, chapter = param.chapter, onClose = param.onClose, moveToSweep = param.moveToSweep;
    if (!chapter) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor;
    var showFooter = !!chapter.moveToSweepUuid;
    var moveTo = function() {
        moveToSweep(chapter.moveToSweepUuid);
        onClose();
    };
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Root, {
        background: backgroundColor,
        opacity: backgroundOpacity,
        color: textColor,
        withFooter: showFooter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: chapter.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Body, {
                children: chapter.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: chapter.url,
                    alt: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: chapter.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChapterDetails_styled_Footer, {
                show: showFooter,
                buttonColor: buttonColor,
                color: textColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: moveTo,
                    children: [
                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                            fontSize: "inherit"
                        })
                    ]
                })
            })
        ]
    }), document.getElementById("page-root"));
};

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/index.ts

/* harmony default export */ var components_ChapterDetails = (ChapterDetails);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/style.tsx

function OpenGameBook_styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 200px;\n  top: 20px;\n  z-index: 110;\n  background: rgba(0, 0, 0, 0.6);\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  right: 0;\n  padding: 0.5em 0;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styled_Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-bf53c24f-0"
})(OpenGameBook_styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/index.tsx





var OpenGameBook_styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Root = (OpenGameBook_styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/style.tsx

function OpenGameBook_styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5em 1.25em;\n\n  h2 {\n    font-size: 0.8em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styled_Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-9a2c996e-0"
})(OpenGameBook_styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/index.tsx





var OpenGameBook_styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Header = (OpenGameBook_styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/style.tsx

function styled_List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n\n  .chapter {\n    display: block;\n    font-size: 1em;\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    overflow: hidden;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_ListStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-ab79791b-0"
})(styled_List_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/index.tsx





var List_List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_List = (List_List);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/index.ts




;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/OpenGameBook.tsx









var OpenGameBook = function(param) {
    var book = param.book, show = param.show, unlockedChapterIds = param.unlockedChapterIds, onClose = param.onClose, moveToSweep = param.moveToSweep;
    if (!show) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    var ref = (0,react.useState)(), activeData = ref[0], setActiveData = ref[1];
    var isChapterLocked = function(chapterId) {
        if (!chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var openChapter = function(chapterId) {
        var data;
        if (chapterId === 0) {
            data = {
                title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                description: book.description,
                url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                moveToSweepUuid: undefined
            };
        } else if (!isChapterLocked(chapterId)) {
            var chapter = book.chapters.find(function(x) {
                return x.id === chapterId;
            });
            data = {
                title: chapter.title,
                description: chapter.description,
                url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                moveToSweepUuid: chapter.sweepUuid
            };
        }
        if (data) {
            setActiveData(data);
        }
    };
    (0,react.useEffect)(function() {
        if (activeData && !activeData.url) {
            if (activeData.moveToSweepUuid) {
                moveToSweep(activeData.moveToSweepUuid);
            }
            setActiveData(undefined);
            onClose();
        }
    }, [
        activeData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                show: show,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Root, {
                background: backgroundColor,
                opacity: backgroundOpacity,
                color: textColor,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_List, {
                        buttonColor: buttonColor,
                        color: textColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "chapter",
                                onClick: function() {
                                    return openChapter(0);
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover"
                            }, "0"),
                            sortBy_default()(book.chapters || [], "order").map(function(chapter) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "d-flex justify-content-between align-center chapter",
                                    onClick: function() {
                                        return openChapter(chapter.id);
                                    },
                                    children: [
                                        chapter.title,
                                        isChapterLocked(chapter.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                            fontSize: "inherit"
                                        })
                                    ]
                                }, chapter.id);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChapterDetails, {
                        book: book,
                        chapter: activeData,
                        onClose: function() {
                            return setActiveData(undefined);
                        },
                        moveToSweep: moveToSweep
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/index.ts

/* harmony default export */ var game_OpenGameBook = (OpenGameBook);

// EXTERNAL MODULE: ./_models/game/GameBook.ts
var game_GameBook = __webpack_require__(97741);
;// CONCATENATED MODULE: ./components/tour/game/GameBookHandle/index.tsx





var GameBookHandle = function(param) {
    var gameBook = param.gameBook, showBook = param.showBook, onToggleGameBookModal = param.onToggleGameBookModal, closeGameBook = param.closeGameBook, hideBook = param.hideBook, unlockedChapterIds = param.unlockedChapterIds, moveToSweep = param.moveToSweep, tryButtonPlaySound = param.tryButtonPlaySound;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gameBookBtn, {
                onToggle: onToggleGameBookModal,
                hide: hideBook
            }),
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Close */.u6.Close && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_gameBook, {
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                tryButtonPlaySound: tryButtonPlaySound,
                moveToSweep: function(sweepUuid) {
                    moveToSweep(sweepUuid);
                    closeGameBook();
                }
            }),
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Open */.u6.Open && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_OpenGameBook, {
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                moveToSweep: moveToSweep
            })
        ]
    });
};


/***/ }),

/***/ 18621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Reel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);







var Reel = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Reel, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Reel);
    function Reel(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Reel);
        var _this;
        _this = _super.call(this, props);
        _this.state = {};
        _this.scrollHorizontally = _this.scrollHorizontally.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
        return _this;
    }
    var _proto = Reel.prototype;
    _proto.scrollHorizontally = function scrollHorizontally(e) {
        if (this.reel) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
            this.reel.scrollLeft -= delta * 10; // Multiplied by 40
            e.preventDefault();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.reel) {
            this.reel.addEventListener("DOMMouseScroll", this.scrollHorizontally, false);
            this.reel.addEventListener("mousewheel", this.scrollHorizontally, false);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, reel = _props.reel, move = _props.move, reelStep = _props.reelStep, _isBlackBackground = _props.isBlackBackground, isBlackBackground = _isBlackBackground === void 0 ? true : _isBlackBackground;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "reel-bar",
            ref: function(e) {
                _this.reel = e;
            },
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                white: !isBlackBackground
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "scroll-div",
                style: {
                    width: "".concat(170 * reel.length, "px")
                },
                children: reel.map(function(p, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onClick: function() {
                            return move(i);
                        },
                        className: reelStep === i ? "preview active" : "preview",
                        style: {
                            backgroundImage: "url(".concat(p.thumbnailUrl, ")")
                        },
                        children: [
                            !p.is360 && p.mode === "mode.inside" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fas fa-walking"
                            }),
                            p.is360 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/panorama.png",
                                alt: "panorama-icon"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: p.name
                            })
                        ]
                    }, i);
                })
            })
        });
    };
    return Reel;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 67644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8667);





var lastTimestamp = 0;
var SoundControls = function(param) {
    var audio = param.audio, onClose = param.onClose;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), soundTime = ref1[0], setSoundTime = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowVolumeRange = ref2[0], toggleVolumeRange = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_store__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(_store__WEBPACK_IMPORTED_MODULE_3__/* .captionsEnabledState */ .b_), 2), captionsEnabled = ref3[0], setCaptionsEnabled = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeupdate = function() {
            if (!audio.currentTime || !audio.duration) {
                return;
            }
            setSoundTime(audio.currentTime / audio.duration * 100);
        };
        audio.addEventListener("timeupdate", timeupdate);
        return function() {
            audio.removeEventListener("timeupdate", timeupdate);
        };
    }, [
        audio
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), volume = ref4[0], setVolume = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (audio) {
            // eslint-disable-next-line no-param-reassign
            audio.volume = volume;
        }
        return function() {
            var ref;
            if (audio) audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
        };
    }, [
        audio,
        volume
    ]);
    var getSoundTime = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ONE_MINUTE = 60;
        if (audio) {
            var duration = !Number.isNaN(audio.duration) ? audio.duration : 0;
            var hour = parseInt(String(duration / ONE_MINUTE), 10);
            var minutes = Math.round(duration % ONE_MINUTE);
            return "".concat(hour, ":").concat(String(minutes).length === 1 ? "0".concat(minutes) : minutes);
        }
        return "00:00";
    }, [
        audio
    ]);
    var setCurrentTime = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(time, data) {
        if (data.timeStamp - lastTimestamp > 300) {
            lastTimestamp = data.timeStamp;
            var duration = audio.duration;
            if (audio && !Number.isNaN(duration)) {
                // eslint-disable-next-line no-param-reassign
                audio.currentTime = time * duration / 100;
            }
        }
    }, [
        audio
    ]);
    var setTogglePlay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!(audio === null || audio === void 0 ? void 0 : audio.paused)) {
            audio.pause();
        } else {
            audio.play();
        }
    }, [
        audio
    ]);
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(mode) {
        return function() {
            if (mode === "close") {
                audio === null || audio === void 0 ? void 0 : audio.pause();
                audio.src = null;
                if (audio === null || audio === void 0 ? void 0 : audio.closeReceivers) {
                    var ref;
                    audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
                }
            }
            if (onClose && typeof onClose === "function") {
                onClose();
            }
        };
    }, [
        audio,
        onClose
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sounds",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-minus",
                        onClick: handleClose("hide")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-times",
                        onClick: handleClose("close")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sound-range",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "range",
                    step: "0.1",
                    min: "0",
                    max: "100",
                    value: soundTime,
                    onChange: function(data) {
                        return setCurrentTime(parseFloat(data.target.value), data);
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sound-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "left-side",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "play",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("fas", !(audio === null || audio === void 0 ? void 0 : audio.paused) ? "fa-pause" : "fa-play"),
                                    onClick: setTogglePlay
                                })
                            }),
                            (audio === null || audio === void 0 ? void 0 : (ref = audio.textTracks) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(captionsEnabled ? "fas fa-closed-captioning" : "fal fa-closed-captioning"),
                                    onClick: function() {
                                        return setCaptionsEnabled(!captionsEnabled);
                                    }
                                })
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "volume",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fas fa-volume-up",
                                        onClick: function() {
                                            return toggleVolumeRange(!isShowVolumeRange);
                                        }
                                    }),
                                    isShowVolumeRange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "range",
                                        step: "0.1",
                                        min: "0",
                                        max: "1",
                                        value: volume,
                                        onChange: function(data) {
                                            return setVolume(parseFloat(data.target.value));
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "right-side",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "time",
                            children: getSoundTime()
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SoundControls);


/***/ }),

/***/ 27096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var VOLUME_STEP = 0.1;
var SoundVolumeControls = function(param) {
    var audio = param.audio;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), volume = ref[0], setVolume = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!audio) {
            return;
        }
        setVolume(audio.volume);
    }, [
        audio
    ]);
    var decrease = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (volume - VOLUME_STEP < 0) {
            return;
        }
        setVolume(function(prev) {
            return Number((prev - VOLUME_STEP).toFixed(1));
        });
    }, [
        volume
    ]);
    var increase = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (volume + VOLUME_STEP > 1) {
            return;
        }
        setVolume(function(prev) {
            return Number((prev + VOLUME_STEP).toFixed(1));
        });
    }, [
        volume
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!audio) {
            return;
        }
        audio.volume = volume;
    }, [
        audio,
        volume
    ]);
    var handleVolume = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        setVolume(parseFloat(data.target.value));
    }, [
        setVolume
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sound-volume",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sound-volume-range",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-plus-circle",
                        onClick: increase
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "range",
                        step: VOLUME_STEP,
                        min: "0",
                        max: "1",
                        value: volume,
                        onChange: handleVolume
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-minus-circle",
                        onClick: decrease
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sound-controls",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: "fas fa-volume-up"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SoundVolumeControls);


/***/ }),

/***/ 44:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);








/* eslint-disable prefer-promise-reject-errors,class-methods-use-this */ // noinspection TypeScriptValidateTypes

var FullScreenContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isFullScreen: false,
    toggleFullscreen: function() {
        return null;
    }
});
var FullScreenStateProvider = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FullScreenStateProvider, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FullScreenStateProvider);
    function FullScreenStateProvider(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FullScreenStateProvider);
        var _this;
        _this = _super.call(this, props);
        _this.targetRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
        _this.state = {
            isFullScreen: false,
            // eslint-disable-next-line react/no-unused-state
            toggleFullscreen: _this.toggleFullscreen.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this))
        };
        return _this;
    }
    var _proto = FullScreenStateProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = function(event) {
            var isTargetElem = targetElem === event.target;
            if (!isTargetElem) {
                // Need to sync state when fullscreen mode turned off but isFullScreen is true
                // Case when more than one fullscreen mode is active and user closed mode by ESC tab
                if (_this.state.isFullScreen === true && !document.fullscreenElement) {
                    _this.setState({
                        isFullScreen: false
                    });
                }
                return;
            }
            var isFullScreen = document.fullscreenElement === event.target;
            _this.setState({
                isFullScreen: isFullScreen
            });
        };
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.startFullscreen) {
            this.toggleFullscreen();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = null;
    };
    _proto.toggleFullscreen = function toggleFullscreen() {
        if (!this.state.isFullScreen) {
            var ref;
            (ref = this.openFullscreen()) === null || ref === void 0 ? void 0 : ref.catch(console.error);
        } else {
            var ref1;
            (ref1 = this.exitFullscreen()) === null || ref1 === void 0 ? void 0 : ref1.catch(console.error);
        }
        // noinspection TypeScriptValidateTypes
        this.setState({
            isFullScreen: !this.state.isFullScreen
        });
    };
    _proto.exitFullscreen = function exitFullscreen() {
        if (!document.fullscreen) return Promise.resolve();
        if (document.exitFullscreen) {
            return document.exitFullscreen();
        }
        if (document.webkitExitFullscreen) {
            return document.webkitExitFullscreen();
        }
        if (document.msExitFullscreen) {
            return document.msExitFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.openFullscreen = function openFullscreen() {
        var _this = this;
        return this.exitFullscreen().then(function() {
            var elem = _this.getTargetElement();
            if (elem.requestFullscreen) {
                return elem.requestFullscreen();
            }
            if (elem.webkitRequestFullscreen) {
                return elem.webkitRequestFullscreen();
            }
            if (elem.msRequestFullscreen) {
                return elem.msRequestFullscreen();
            }
            return Promise.reject("API does not response");
        });
    };
    _proto.getTargetElement = function getTargetElement() {
        var rootBody = this.props.rootBody;
        return rootBody ? window.document.body : this.targetRef.current;
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, attrs = _props.attrs;
        var attr = {
            id: attrs === null || attrs === void 0 ? void 0 : attrs.id,
            className: attrs === null || attrs === void 0 ? void 0 : attrs.class
        };
        var customStyles = (attrs === null || attrs === void 0 ? void 0 : attrs.styles) || {};
        var styles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            height: "100%",
            width: "100%",
            background: "#fff"
        }, customStyles);
        return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Provider, {
            value: this.state,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: this.targetRef
            }, attr), {
                style: styles,
                children: children
            }))
        }));
    };
    return FullScreenStateProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
function FullScreen(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenStateProvider, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Consumer, {
            children: children
        })
    }));
};


/***/ }),

/***/ 91950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ useGlobalDOMEvents; },
  "O": function() { return /* reexport */ hooks_useToggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useGlobalDOMEvents.ts

/* eslint-disable @typescript-eslint/ban-ts-comment,no-restricted-syntax */ 
function useGlobalDOMEvents(props) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                // @ts-ignore
                window.addEventListener(key, func, false);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                    // @ts-ignore
                    window.removeEventListener(key, func, false);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

;// CONCATENATED MODULE: ./hooks/useToggle.tsx

var initialDefault = false;
var useToggle = function(initial) {
    var ref = (0,react.useState)(initial !== null && initial !== void 0 ? initial : initialDefault), isOpen = ref[0], setIsOpen = ref[1];
    var set = (0,react.useCallback)(function(value) {
        return setIsOpen(value);
    }, [
        setIsOpen
    ]);
    var open = (0,react.useCallback)(function() {
        return setIsOpen(true);
    }, [
        setIsOpen
    ]);
    var close = (0,react.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    var toggle = (0,react.useCallback)(function() {
        return setIsOpen(function(prev) {
            return !prev;
        });
    }, [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        set: set,
        open: open,
        close: close,
        toggle: toggle
    };
};
/* harmony default export */ var hooks_useToggle = (useToggle);

;// CONCATENATED MODULE: ./hooks/index.ts




/***/ }),

/***/ 8667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b1": function() { return /* reexport */ bgImageState; },
  "b_": function() { return /* reexport */ captionsEnabledState; },
  "F3": function() { return /* reexport */ gamePointsState; },
  "WW": function() { return /* reexport */ gameSoundOnState; },
  "WN": function() { return /* reexport */ gameSoundVolumeState; },
  "uP": function() { return /* reexport */ infoModalDataState; },
  "wN": function() { return /* reexport */ lockInfoPopupStatusState; },
  "bG": function() { return /* reexport */ lockTimerState; },
  "jF": function() { return /* reexport */ orderedTicketsState; },
  "Sy": function() { return /* reexport */ redirectTicketsState; },
  "Ys": function() { return /* reexport */ ticketingCurrentLanguage; },
  "$W": function() { return /* reexport */ ticketingDataState; },
  "Uq": function() { return /* reexport */ tourConfigsState; },
  "Jv": function() { return /* reexport */ translationDataState; },
  "FV": function() { return /* reexport */ recoil/* useRecoilState */.FV; },
  "sJ": function() { return /* reexport */ recoil/* useRecoilValue */.sJ; },
  "Zl": function() { return /* reexport */ recoil/* useSetRecoilState */.Zl; }
});

// UNUSED EXPORTS: DefaultValue, RecoilLoadable, RecoilRoot, atom, atomFamily, constSelector, errorSelector, isRecoilValue, noWait, readOnlySelector, retentionZone, selector, selectorFamily, snapshot_UNSTABLE, useGetRecoilValueInfo_UNSTABLE, useGotoRecoilSnapshot, useRecoilBridgeAcrossReactRoots_UNSTABLE, useRecoilCallback, useRecoilRefresher_UNSTABLE, useRecoilSnapshot, useRecoilStateLoadable, useRecoilTransactionObserver_UNSTABLE, useRecoilTransaction_UNSTABLE, useRecoilValueLoadable, useResetRecoilState, useRetain, useSetUnvalidatedAtomValues_UNSTABLE, useTransactionObservation_UNSTABLE, waitForAll, waitForAllSettled, waitForAny, waitForNone

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
;// CONCATENATED MODULE: ./store/atoms/basic.ts

var captionsEnabledState = (0,recoil/* atom */.cn)({
    key: "captionsEnabledState",
    default: true
});
var translationDataState = (0,recoil/* atom */.cn)({
    key: "translationDataState",
    default: null
});
var tourConfigsState = (0,recoil/* atom */.cn)({
    key: "tourConfigsState",
    default: {}
});

;// CONCATENATED MODULE: ./store/atoms/game/sound.ts

var gameSoundOnState = (0,recoil/* atom */.cn)({
    key: "gameSoundOnState",
    default: true
});
var gameSoundVolumeState = (0,recoil/* atom */.cn)({
    key: "gameSoundVolumeState",
    default: 0.5
});

;// CONCATENATED MODULE: ./store/atoms/game/basic.ts

var lockTimerState = (0,recoil/* atom */.cn)({
    key: "lockTimerState",
    default: {
        running: false,
        value: 0
    }
});
var lockInfoPopupStatusState = (0,recoil/* atom */.cn)({
    key: "lockInfoPopupStatusState",
    default: null
});
var gamePointsState = (0,recoil/* atom */.cn)({
    key: "gamePointsState",
    default: 0
});

;// CONCATENATED MODULE: ./store/atoms/game/index.ts



// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
;// CONCATENATED MODULE: ./store/atoms/ticketing.ts


var ticketingCurrentLanguage = (0,recoil/* atom */.cn)({
    key: "ticketingCurrentLanguage",
    default: {}
});
var infoModalDataState = (0,recoil/* atom */.cn)({
    key: "infoModalDataState",
    default: {
        mode: InfoModal/* EInfoModal.error */.Y.error,
        isOpen: false
    }
});
var redirectTicketsState = (0,recoil/* atom */.cn)({
    key: "redirectTicketsState",
    default: null
});
var orderedTicketsState = (0,recoil/* atom */.cn)({
    key: "orderedTicketsState",
    default: null
});
var ticketingDataState = (0,recoil/* atom */.cn)({
    key: "ticketingDataState",
    default: null
});
var bgImageState = (0,recoil/* atom */.cn)({
    key: "bgImageState",
    default: ""
});

;// CONCATENATED MODULE: ./store/atoms/index.ts




;// CONCATENATED MODULE: ./store/index.ts

 // export * from './selectors';


/***/ }),

/***/ 47835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Info.js
var Info = __webpack_require__(18362);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Error.js
var Error = __webpack_require__(72063);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Warning.js
var Warning = __webpack_require__(21727);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
;// CONCATENATED MODULE: ./units/Alert/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.75rem 1.25rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var backgroundColor = {
    info: "#cce5ff",
    warning: "#fff3cd",
    error: "#f8d7da",
    success: "#d4edda"
};
var borderColor = {
    info: "#b8daff",
    warning: "#ffeeba",
    error: "#f5c6cb",
    success: "#c3e6cb"
};
var color = {
    info: "#004085",
    warning: "#856404",
    error: "#721c24",
    success: "#155724"
};
var AlertStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__AlertStyled",
    componentId: "sc-deb339e0-0"
})(_templateObject(), function(param) {
    var type = param.type;
    return backgroundColor[type];
}, function(param) {
    var type = param.type;
    return color[type];
}, function(param) {
    var type = param.type;
    return borderColor[type];
});

;// CONCATENATED MODULE: ./units/Alert/index.tsx









var getIcon = function(type) {
    switch(type){
        case "warning":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {});
            }
        case "error":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {});
            }
        case "success":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {});
            }
        case "info":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {});
            }
        default:
            return null;
    }
};
var Alert = function(_param) {
    var id = _param.id, type = _param.type, show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "type",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: id,
            type: type
        }, restProps), {
            children: [
                getIcon(type),
                children
            ]
        }));
    }
    return null;
};
/* harmony default export */ var units_Alert = (Alert);


/***/ }),

/***/ 10530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Icon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(62087);
;// CONCATENATED MODULE: ./units/Icon/ArrowDown.tsx




var Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 268l144 144 144-144M256 392V100"
            })
        ]
    }));
};
/* harmony default export */ var ArrowDown = (Icon);

;// CONCATENATED MODULE: ./units/Icon/ArrowUp.tsx




var ArrowUp_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Up"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 244l144-144 144 144M256 120v292"
            })
        ]
    }));
};
/* harmony default export */ var ArrowUp = (ArrowUp_Icon);

;// CONCATENATED MODULE: ./units/Icon/ArrowRight.tsx




var ArrowRight_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z"
            })
        ]
    }));
};
/* harmony default export */ var ArrowRight = (ArrowRight_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronDown.tsx




var ChevronDown_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 184l144 144 144-144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronDown = (ChevronDown_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronLeft.tsx




var ChevronLeft_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Back"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M328 112L184 256l144 144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronLeft = (ChevronLeft_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronRight.tsx




var ChevronRight_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Forward"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M184 112l144 144-144 144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronRight = (ChevronRight_Icon);

;// CONCATENATED MODULE: ./units/Icon/Close.tsx




var Close_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Close"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M368 368L144 144M368 144L144 368"
            })
        ]
    }));
};
/* harmony default export */ var Close = (Close_Icon);

;// CONCATENATED MODULE: ./units/Icon/ColorPalette.tsx




var ColorPalette_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Color Palette"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "144",
                cy: "208",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "152",
                cy: "311",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "224",
                cy: "144",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "256",
                cy: "367",
                r: "48"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "328",
                cy: "144",
                r: "32"
            })
        ]
    }));
};
/* harmony default export */ var ColorPalette = (ColorPalette_Icon);

;// CONCATENATED MODULE: ./units/Icon/Droplet.tsx




var Droplet_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0.652 0.759 9.825 13.46",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M5.565.759l-.557.557c-.18.18-4.356 4.405-4.356 7.99a4.927 4.927 0 0 0 4.913 4.913 4.927 4.927 0 0 0 4.912-4.912c0-3.57-4.176-7.811-4.356-7.991L5.565.759zM3.108 8.488a.81.81 0 0 1 .819.819c0 .9.737 1.637 1.638 1.637a.81.81 0 0 1 .818.819.81.81 0 0 1-.818.819A3.285 3.285 0 0 1 2.29 9.307a.81.81 0 0 1 .818-.82z"
        })
    }));
};
/* harmony default export */ var Droplet = (Droplet_Icon);

;// CONCATENATED MODULE: ./units/Icon/Edit.tsx




var Edit_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Edit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            })
        ]
    }));
};
/* harmony default export */ var Edit = (Edit_Icon);

;// CONCATENATED MODULE: ./units/Icon/ExpandArrowsAlt.tsx




var ExpandArrowsAlt_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
        })
    }));
};
/* harmony default export */ var ExpandArrowsAlt = (ExpandArrowsAlt_Icon);

;// CONCATENATED MODULE: ./units/Icon/Filter.tsx




var Filter_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Forward"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
            })
        ]
    }));
};
/* harmony default export */ var Filter = (Filter_Icon);

;// CONCATENATED MODULE: ./units/Icon/Image.tsx




var Image_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "48",
                y: "80",
                width: "416",
                height: "352",
                rx: "48",
                ry: "48",
                fill: "none",
                stroke: "currentColor",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "336",
                cy: "176",
                r: "32",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352M224 432l123.34-123.34a32 32 0 0143.11-2L464 368",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            })
        ]
    }));
};
/* harmony default export */ var Image = (Image_Icon);

;// CONCATENATED MODULE: ./units/Icon/Layout.tsx




var Layout_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Layout"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "3",
                y1: "9",
                x2: "21",
                y2: "9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "9",
                y1: "21",
                x2: "9",
                y2: "9"
            })
        ]
    }));
};
/* harmony default export */ var Layout = (Layout_Icon);

;// CONCATENATED MODULE: ./units/Icon/Loading.tsx




var Loading_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 1024 1024",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Loading"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
            })
        ]
    }));
};
/* harmony default export */ var Loading = (Loading_Icon);

;// CONCATENATED MODULE: ./units/Icon/Lock.tsx




var Lock_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 16 18",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Lock"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.84375 13.5C8.84375 13.9676 8.46758 14.3438 8 14.3438C7.53242 14.3438 7.15625 13.9676 7.15625 13.5V11.25C7.15625 10.7824 7.53242 10.4062 8 10.4062C8.46758 10.4062 8.84375 10.7824 8.84375 11.25V13.5ZM8 0C10.4855 0 12.5 2.0148 12.5 4.5V6.75H13.625C14.866 6.75 15.875 7.75898 15.875 9V15.75C15.875 16.991 14.866 18 13.625 18H2.375C1.13223 18 0.125 16.991 0.125 15.75V9C0.125 7.75898 1.13223 6.75 2.375 6.75H3.5V4.5C3.5 2.0148 5.51445 0 8 0ZM8 1.6875C6.44609 1.6875 5.1875 2.9468 5.1875 4.5V6.75H10.8125V4.5C10.8125 2.9468 9.55391 1.6875 8 1.6875ZM2.375 8.4375C2.06422 8.4375 1.8125 8.69063 1.8125 9V15.75C1.8125 16.0594 2.06422 16.3125 2.375 16.3125H13.625C13.9344 16.3125 14.1875 16.0594 14.1875 15.75V9C14.1875 8.69063 13.9344 8.4375 13.625 8.4375H2.375Z",
                fill: "currentColor"
            })
        ]
    }));
};
/* harmony default export */ var Lock = (Lock_Icon);

;// CONCATENATED MODULE: ./units/Icon/MetroShrink.tsx




var MetroShrink_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.5 15 15",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.875 7.125h5.688l-2.188-2.188L14 2.312 12.687 1l-2.625 2.625-2.187-2.188v5.688zm0 1.75v5.687l2.187-2.187L12.687 15 14 13.687l-2.625-2.625 2.188-2.187H7.875zm-1.75 0H.437l2.188 2.187L0 13.687 1.313 15l2.624-2.625 2.188 2.187V8.875zm0-1.75V1.437L3.937 3.625 1.313 1 0 2.312l2.625 2.625L.437 7.125h5.688z"
        })
    }));
};
/* harmony default export */ var MetroShrink = (MetroShrink_Icon);

;// CONCATENATED MODULE: ./units/Icon/Redo.tsx




var Redo_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "14",
        viewBox: "0.081 0.138 15.684 13.723",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
        })
    }));
};
/* harmony default export */ var Redo = (Redo_Icon);

;// CONCATENATED MODULE: ./units/Icon/Resize.tsx




var Resize_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "16",
        viewBox: "0.321 0.356 15.289 15.289",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.966.356l3.172 3.172-7.644 7.644L.32 8v7.644h7.645l-3.173-3.172 7.645-7.644L15.61 8V.356H7.966z"
        })
    }));
};
/* harmony default export */ var Resize = (Resize_Icon);

;// CONCATENATED MODULE: ./units/Icon/Ruler.tsx




var Ruler_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.375 15 11.25",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M14.716 4.382l-1.842-3.137A.745.745 0 0 0 11.867.98l-1.598.905 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L9.63 2.247l-1.277.725.646 1.097a.18.18 0 0 1-.068.248l-.319.18a.185.185 0 0 1-.252-.067l-.646-1.095-1.278.725L7.82 6.414a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L5.799 4.421l-1.277.725.646 1.097a.18.18 0 0 1-.068.247l-.319.181a.185.185 0 0 1-.252-.067l-.646-1.1-1.278.725 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.252-.067L1.966 6.597.37 7.502a.72.72 0 0 0-.27.99l1.842 3.14a.745.745 0 0 0 1.007.266l11.5-6.526a.718.718 0 0 0 .268-.99z"
        })
    }));
};
/* harmony default export */ var Ruler = (Ruler_Icon);

;// CONCATENATED MODULE: ./units/Icon/Search.tsx




var Search_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "11",
                cy: "11",
                r: "8",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var Search = (Search_Icon);

;// CONCATENATED MODULE: ./units/Icon/SortAlphaDown.tsx




var SortAlphaDown_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sort Alpha Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M187.298 395.314l-79.984 80.002c-6.248 6.247-16.383 6.245-22.627 0L4.705 395.314C-5.365 385.244 1.807 368 16.019 368H64V48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v320h47.984c14.241 0 21.363 17.264 11.314 27.314zm119.075-180.007A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"
            })
        ]
    }));
};
/* harmony default export */ var SortAlphaDown = (SortAlphaDown_Icon);

;// CONCATENATED MODULE: ./units/Icon/SortAlphaUp.tsx




var SortAlphaUp_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sort Alpha Up"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M4.702 116.686l79.984-80.002c6.248-6.247 16.383-6.245 22.627 0l79.981 80.002c10.07 10.07 2.899 27.314-11.314 27.314H128v320c0 8.837-7.163 16-16 16H80c-8.837 0-16-7.163-16-16V144H16.016c-14.241 0-21.363-17.264-11.314-27.314zm301.671 98.621A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"
            })
        ]
    }));
};
/* harmony default export */ var SortAlphaUp = (SortAlphaUp_Icon);

;// CONCATENATED MODULE: ./units/Icon/Tag.tsx




var Tag_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Tag"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "7",
                y1: "7",
                x2: "7.01",
                y2: "7"
            })
        ]
    }));
};
/* harmony default export */ var Tag = (Tag_Icon);

;// CONCATENATED MODULE: ./units/Icon/ToggleOn.tsx




var ToggleOn_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0.5 0 15 10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M10.05 0h-5c-2.76 0-5 2.24-5 5s2.24 5 5 5h5c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8.333A3.331 3.331 0 0 1 6.717 5a3.331 3.331 0 0 1 3.333-3.333A3.332 3.332 0 0 1 13.383 5a3.332 3.332 0 0 1-3.333 3.333z"
        })
    }));
};
/* harmony default export */ var ToggleOn = (ToggleOn_Icon);

;// CONCATENATED MODULE: ./units/Icon/ToggleOff.tsx




var ToggleOff_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.167 16 10.667",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M10.6.5h-5a5 5 0 1 0 0 10h5a5 5 0 1 0 0-10zm-8.333 5A3.331 3.331 0 0 1 5.6 2.167 3.331 3.331 0 0 1 8.933 5.5 3.332 3.332 0 0 1 5.6 8.833 3.331 3.331 0 0 1 2.267 5.5zM10.6 8.833H9.326a4.998 4.998 0 0 0 0-6.666H10.6A3.332 3.332 0 0 1 13.933 5.5 3.332 3.332 0 0 1 10.6 8.833z"
        })
    }));
};
/* harmony default export */ var ToggleOff = (ToggleOff_Icon);

;// CONCATENATED MODULE: ./units/Icon/Undo.tsx




var Undo_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "14",
        viewBox: "0.081 0.138 15.684 13.723",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "scale(-1, 1)",
            "transform-origin": "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                paintOrder: "stroke fill markers",
                fillRule: "evenodd",
                d: "M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
            })
        })
    }));
};
/* harmony default export */ var Undo = (Undo_Icon);

;// CONCATENATED MODULE: ./units/Icon/Upload.tsx




var Upload_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                points: "17 8 12 3 7 8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "12",
                y1: "3",
                x2: "12",
                y2: "15"
            })
        ]
    }));
};
/* harmony default export */ var Upload = (Upload_Icon);

;// CONCATENATED MODULE: ./units/Icon/Public.tsx




var Public_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Public"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
            })
        ]
    }));
};
/* harmony default export */ var Public = (Public_Icon);

;// CONCATENATED MODULE: ./units/Icon/Add.tsx




var Add_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Add"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
            })
        ]
    }));
};
/* harmony default export */ var Add = (Add_Icon);

;// CONCATENATED MODULE: ./units/Icon/Print.tsx




var Print = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
        })
    }));
};
/* harmony default export */ var Icon_Print = (Print);

;// CONCATENATED MODULE: ./units/Icon/Star.tsx




var Star_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Star"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M287.9 0C297.1 0 305.5 5.25 309.5 13.52L378.1 154.8L531.4 177.5C540.4 178.8 547.8 185.1 550.7 193.7C553.5 202.4 551.2 211.9 544.8 218.2L433.6 328.4L459.9 483.9C461.4 492.9 457.7 502.1 450.2 507.4C442.8 512.7 432.1 513.4 424.9 509.1L287.9 435.9L150.1 509.1C142.9 513.4 133.1 512.7 125.6 507.4C118.2 502.1 114.5 492.9 115.1 483.9L142.2 328.4L31.11 218.2C24.65 211.9 22.36 202.4 25.2 193.7C28.03 185.1 35.5 178.8 44.49 177.5L197.7 154.8L266.3 13.52C270.4 5.249 278.7 0 287.9 0L287.9 0zM287.9 78.95L235.4 187.2C231.9 194.3 225.1 199.3 217.3 200.5L98.98 217.9L184.9 303C190.4 308.5 192.9 316.4 191.6 324.1L171.4 443.7L276.6 387.5C283.7 383.7 292.2 383.7 299.2 387.5L404.4 443.7L384.2 324.1C382.9 316.4 385.5 308.5 391 303L476.9 217.9L358.6 200.5C350.7 199.3 343.9 194.3 340.5 187.2L287.9 78.95z"
            })
        ]
    }));
};
/* harmony default export */ var Star = (Star_Icon);

;// CONCATENATED MODULE: ./units/Icon/StarSolid.tsx




var StarSolid_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Star Solid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
            })
        ]
    }));
};
/* harmony default export */ var StarSolid = (StarSolid_Icon);

;// CONCATENATED MODULE: ./units/Icon/index.ts

































var collection = {
    ArrowDown: ArrowDown,
    ArrowUp: ArrowUp,
    ArrowRight: ArrowRight,
    ChevronDown: ChevronDown,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    Close: Close,
    ColorPalette: ColorPalette,
    Droplet: Droplet,
    Edit: Edit,
    ExpandArrowsAlt: ExpandArrowsAlt,
    Filter: Filter,
    Image: Image,
    Layout: Layout,
    Loading: Loading,
    Lock: Lock,
    MetroShrink: MetroShrink,
    Redo: Redo,
    Resize: Resize,
    Ruler: Ruler,
    Search: Search,
    SortAlphaDown: SortAlphaDown,
    SortAlphaUp: SortAlphaUp,
    Tag: Tag,
    ToggleOn: ToggleOn,
    ToggleOff: ToggleOff,
    Undo: Undo,
    Upload: Upload,
    Public: Public,
    Add: Add,
    Print: Icon_Print,
    Star: Star,
    StarSolid: StarSolid
};
/* harmony default export */ var units_Icon = (collection);


/***/ }),

/***/ 12978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Iframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./units/Iframe/IframeStyledHOC.tsx




var IframeStyledHOC = function(_param) {
    var onLoad = _param.onLoad, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onLoad"
    ]);
    var playerRef = (0,react.useRef)();
    var getPlayerInstanceAndTryToPlay = function() {
        try {
            if (rest.autoplay) {
                var ref;
                // youtube autoplay fix
                var ytPlayer = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                if (typeof (ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo) === "function") {
                    ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo();
                }
            }
            onLoad();
        } catch (err) {
            ;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
        width: "100%",
        height: "100%",
        controls: true,
        url: rest.url,
        onReady: getPlayerInstanceAndTryToPlay,
        playing: rest.autoplay,
        muted: rest.mute,
        ref: playerRef
    });
};
/* harmony default export */ var Iframe_IframeStyledHOC = (/*#__PURE__*/(0,react.memo)(IframeStyledHOC, function() {
    return true;
}));

;// CONCATENATED MODULE: ./units/Iframe/index.tsx






var Iframe = function(_param) {
    var src = _param.src, logoSrc = _param.logoSrc, useModernPlayer = _param.useModernPlayer, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "logoSrc",
        "useModernPlayer"
    ]);
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var hideSpinner = function() {
        setLoading(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* Root */.fC, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* Loader */.aN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Spinner */.$j, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Logo */.TR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logoSrc,
                            alt: ""
                        })
                    })
                ]
            }),
            useModernPlayer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe_IframeStyledHOC, (0,_object_spread/* default */.Z)({
                width: "100%",
                height: "100%",
                src: src,
                onLoad: hideSpinner
            }, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* IframeStyled */.C, (0,_object_spread/* default */.Z)({
                width: "100%",
                height: "100%",
                src: src,
                allow: "camera;microphone",
                onLoad: hideSpinner
            }, rest))
        ]
    });
};
/* harmony default export */ var units_Iframe = (Iframe);


/***/ }),

/***/ 54811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ Spinner; },
/* harmony export */   "C": function() { return /* binding */ IframeStyled; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59016);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 115px;\n  height: 115px;\n  object-fit: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  & img {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  min-height: 150px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  &::after {\n    content: ' ';\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    border-color: var(--color-secondary) transparent var(--color-secondary) transparent;\n    animation: ",
        " 1.2s linear infinite;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  html body img {\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var spinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var Root = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-5c3f9880-0"
})(_templateObject1());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Loader",
    componentId: "sc-5c3f9880-1"
})(_templateObject2());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Logo",
    componentId: "sc-5c3f9880-2"
})(_templateObject3());
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Spinner",
    componentId: "sc-5c3f9880-3"
})(_templateObject4(), spinner);
var IframeStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "style__IframeStyled",
    componentId: "sc-5c3f9880-4"
})(_templateObject5());


/***/ }),

/***/ 85591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Alert": function() { return /* reexport */ Alert/* default */.Z; },
  "Button": function() { return /* reexport */ units_Button; },
  "Checkbox": function() { return /* reexport */ units_Checkbox; },
  "CloseButton": function() { return /* reexport */ units_CloseButton; },
  "Collapse": function() { return /* reexport */ units_Collapse; },
  "DatePicker": function() { return /* reexport */ DatePicker; },
  "Field": function() { return /* reexport */ units_Field; },
  "Form": function() { return /* reexport */ units_Form; },
  "FullscreenButton": function() { return /* reexport */ units_FullscreenButton; },
  "Icon": function() { return /* reexport */ units_Icon/* default */.Z; },
  "Iframe": function() { return /* reexport */ Iframe/* default */.Z; },
  "Input": function() { return /* reexport */ units_Input; },
  "Text": function() { return /* reexport */ units_Text; },
  "VideoBox": function() { return /* reexport */ VideoBox; },
  "Watermark": function() { return /* reexport */ units_Watermark; }
});

// EXTERNAL MODULE: ./units/Alert/index.tsx + 1 modules
var Alert = __webpack_require__(47835);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./units/Button/defaultProps.ts
var defaultProps = {
    palette: "default",
    size: "medium",
    variant: "solid",
    flow: "auto",
    type: "button",
    borderRadius: "small"
};
/* harmony default export */ var Button_defaultProps = (defaultProps);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
;// CONCATENATED MODULE: ./units/Button/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: 1fr;\n  align-items: center;\n  overflow: hidden;\n\n  height: ",
        ";\n\n  min-width: ",
        ";\n\n  width: ",
        ";\n\n  color: ",
        ";\n\n  border-style: solid;\n\n  border-radius: ",
        ";\n\n  border-width: ",
        ";\n\n  border-color: ",
        ";\n\n  --background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  height: inherit;\n  background: var(--background);\n\n  width: ",
        ";\n\n  text-decoration: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  gap: ",
        ";\n\n  padding: 0 1rem;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n\n  & > svg {\n    font-size: inherit;\n  }\n\n  transition: 0.3s background ease-in;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  & + & {\n    border-left: 1px solid currentColor;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    transform: rotate(1turn);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-7c7d2c4-0"
})(_templateObject(), function(param) {
    var size = param.size, variant = param.variant;
    switch(variant){
        case "link":
            {
                return "auto";
            }
        default:
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "unset";
            }
        default:
            {
                return "80px";
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    case "secondary":
                        {
                            return "#fff";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "ghost":
        case "soft":
        case "link":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "solid"
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var borderRadius = param.borderRadius;
    switch(borderRadius){
        case "large":
            {
                return "15px";
            }
        case "medium":
            {
                return "10px";
            }
        case "small":
            {
                return "5px";
            }
        case "none":
            {
                return "0px";
            }
        default:
            {
                return "4px";
            }
    }
}, function(param) {
    var variant = param.variant, size = param.size;
    switch(variant){
        case "ghost":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "1px";
                        }
                    case "small":
                        {
                            return "1px";
                        }
                    default:
                        {
                            return "2px";
                        }
                }
            }
        default:
            {
                return "0";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "ghost":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "transparent"
        // case "solid"
        // case "link"
        default:
            {
                return "transparent";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
        case "ghost":
        case "link":
            {
                return "transparent";
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            // TODO: add opacity
                            return "rgb(234 71 92 / .2)";
                        }
                    default:
                        {
                            // TODO: add opacity
                            return "rgb(41 41 41 / .2)";
                        }
                }
            }
        // case "solid"
        default:
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(--color-secondary)";
                        }
                    default:
                        {
                            return "var(--color-primary)";
                        }
                }
            }
    }
});
var ButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ButtonStyled",
    componentId: "sc-7c7d2c4-1"
})(_templateObject1(), function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "link":
            {
                return "underline";
            }
        // case "solid"
        // case "link"
        default:
            {
                return "none";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "4px";
            }
        case "small":
            {
                return "6px";
            }
        default:
            {
                return "10px";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "transparent":
            {
                return "rgba(0, 0, 0, .2)";
            }
        default:
            {
                return "var(--background)";
            }
    }
});
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Rotate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Rotate",
    componentId: "sc-7c7d2c4-2"
})(_templateObject3(), rotate);

;// CONCATENATED MODULE: ./units/Button/index.tsx







var Button = function(_param) /*#__PURE__*/ {
    var _palette = _param.palette, palette = _palette === void 0 ? Button_defaultProps.palette : _palette, _size = _param.size, size = _size === void 0 ? Button_defaultProps.size : _size, _variant = _param.variant, variant = _variant === void 0 ? Button_defaultProps.variant : _variant, _flow = _param.flow, flow = _flow === void 0 ? Button_defaultProps.flow : _flow, _type = _param.type, type = _type === void 0 ? Button_defaultProps.type : _type, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? Button_defaultProps.borderRadius : _borderRadius, disabled = _param.disabled, loading = _param.loading, className = _param.className, onClear = _param.onClear, onClick = _param.onClick, onMouseDown = _param.onMouseDown, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "palette",
        "size",
        "variant",
        "flow",
        "type",
        "borderRadius",
        "disabled",
        "loading",
        "className",
        "onClear",
        "onClick",
        "onMouseDown",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(Root, {
        palette: palette,
        size: size,
        variant: variant,
        flow: flow,
        borderRadius: borderRadius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                palette: palette,
                size: size,
                variant: variant,
                flow: flow,
                borderRadius: borderRadius,
                type: type,
                onClick: onClick,
                onMouseDown: onMouseDown,
                disabled: disabled || loading,
                className: className
            }, restProps), {
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rotate, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Loading */.Z.Loading, {})
                    }),
                    children
                ]
            })),
            onClear && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                palette: palette,
                size: size,
                flow: "square",
                variant: "transparent",
                borderRadius: borderRadius,
                type: "button",
                disabled: disabled || loading,
                onClick: onClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Close */.Z.Close, {})
            })
        ]
    });
};
/* harmony default export */ var units_Button = (Button);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-checkbox/es/index.js
var es = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/omit.js
var omit = __webpack_require__(18475);
;// CONCATENATED MODULE: ./units/Checkbox/Group/index.tsx









var GroupContext = /*#__PURE__*/ (0,react.createContext)(null);
var CheckboxGroup = function(_param) {
    var defaultValue = _param.defaultValue, children = _param.children, _options = _param.options, options = _options === void 0 ? [] : _options, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, style = _param.style, onChange = _param.onChange, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var ref = (0,react.useState)(restProps.value || defaultValue || []), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)([]), registeredValues = ref1[0], setRegisteredValues = ref1[1];
    (0,react.useEffect)(function() {
        if ("value" in restProps) {
            setValue(restProps.value || []);
        }
    }, [
        restProps
    ]);
    var getOptions = function() {
        return options.map(function(option) {
            if (typeof option === "string") {
                return {
                    label: option,
                    value: option
                };
            }
            return option;
        });
    };
    var cancelValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return (0,_to_consumable_array/* default */.Z)(prevValues).concat([
                val
            ]);
        });
    };
    var toggleOption = function(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0,_to_consumable_array/* default */.Z)(value);
        if (optionIndex === -1) {
            newValue.push(option.value);
        } else {
            newValue.splice(optionIndex, 1);
        }
        if (!("value" in restProps)) {
            setValue(newValue);
        }
        var opts = getOptions();
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(function(val) {
            return registeredValues.indexOf(val) !== -1;
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0,omit/* default */.Z)(restProps, [
        "value",
        "disabled"
    ]);
    if (options && options.length > 0) {
        children = getOptions().map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                prefixCls: prefixCls,
                disabled: "disabled" in option ? option.disabled : restProps.disabled,
                value: option.value,
                checked: value.indexOf(option.value) !== -1,
                onChange: option.onChange,
                className: "".concat(groupPrefixCls, "-item"),
                style: option.style,
                children: option.label
            }, option.value.toString());
        });
    }
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = classnames_default()(groupPrefixCls, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classString,
        style: style
    }, domProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupContext.Provider, {
            value: context,
            children: react.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    value: value,
                    toggleOption: toggleOption
                });
            })
        })
    }));
};
/* harmony default export */ var Group = (/*#__PURE__*/(0,react.memo)(CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n\n  & .checkbox {\n    width: 20px;\n    height: 20px;\n    display: block;\n    border-radius: 2px;\n    position: relative;\n    overflow: hidden;\n\n    & .checkbox-input {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      margin: 0;\n      padding: 0;\n      opacity: 0;\n    }\n\n    & .checkbox-inner {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      border: 2px solid #2c2c2c;\n      transition: background 0.2s ease-in;\n\n      border-color: ",
        ";\n    }\n\n    &.checkbox-checked {\n      & .checkbox-inner {\n        background: #2c2c2c;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n\n    &.checkbox-indeterminate {\n      & .checkbox-inner {\n        background: #2c2c2c;\n        opacity: 0.8;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M19 13H5v-2h14v2z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var style_Root = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "style__Root",
    componentId: "sc-7b231797-0"
})(style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
});

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/index.tsx











var InternalCheckbox = function(_param, ref) {
    var _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, children = _param.children, _indeterminate = _param.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, style = _param.style, onMouseEnter = _param.onMouseEnter, onMouseLeave = _param.onMouseLeave, _skipGroup = _param.skipGroup, skipGroup = _skipGroup === void 0 ? false : _skipGroup, palette = _param.palette, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "palette"
    ]);
    var checkboxGroup = (0,react.useContext)(GroupContext);
    var prevValue = (0,react.useRef)(restProps.value);
    (0,react.useEffect)(function() {
        checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }, [
        checkboxGroup,
        restProps.value
    ]);
    (0,react.useEffect)(function() {
        if (skipGroup) {
            return;
        }
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
        }
        // eslint-disable-next-line consistent-return
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        checkboxGroup,
        restProps.value,
        skipGroup
    ]);
    var checkboxProps = (0,_object_spread/* default */.Z)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (restProps.onChange) {
                var _restProps;
                (_restProps = restProps).onChange.apply(_restProps, (0,_to_consumable_array/* default */.Z)(args));
            }
            if (checkboxGroup.toggleOption) {
                checkboxGroup.toggleOption({
                    label: children,
                    value: restProps.value
                });
            }
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
        checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
    }
    var _obj;
    var classString = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper"), true), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _obj), className);
    var checkboxClass = classnames_default()((0,_define_property/* default */.Z)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Root, {
        palette: palette,
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, checkboxProps), {
                prefixCls: prefixCls,
                className: checkboxClass,
                // @ts-ignore
                ref: ref
            })),
            children
        ]
    }));
};
// @ts-ignore
var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(InternalCheckbox);
Checkbox.displayName = "Checkbox";
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

// EXTERNAL MODULE: ./node_modules/rc-collapse/assets/index.css
var assets = __webpack_require__(29969);
// EXTERNAL MODULE: ./node_modules/rc-collapse/es/index.js + 3 modules
var rc_collapse_es = __webpack_require__(16538);
;// CONCATENATED MODULE: ./units/Collapse/Panel/style.tsx

function Panel_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.rc-collapse-item {\n    padding: 0;\n    color: #666;\n    transition: 0.2s background ease-in;\n\n    & > .rc-collapse-header {\n      --background: ",
        ";\n\n      background: var(--background);\n      display: grid;\n      grid-template-columns: 1fr auto;\n      grid-template-areas: 'content arrow';\n      align-items: center;\n      overflow: hidden;\n      line-height: 1;\n      padding: 0;\n\n      &:hover {\n        background: ",
        ";\n      }\n\n      & .arrow {\n        grid-area: arrow;\n        border: none;\n        display: block;\n        width: 40px;\n        margin: 0;\n        position: relative;\n        top: 0;\n        background: transparent;\n        transition: 0.2s transform ease-in;\n        transform: rotate(180deg);\n        padding-bottom: 100%;\n\n        &:before {\n          content: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Up%3C/title%3E%3Cpath fill='none' stroke='%23727272' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 328l144-144 144 144'/%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          padding: 10px;\n        }\n      }\n\n      & .arrow + * {\n        grid-area: content;\n      }\n    }\n\n    &.rc-collapse-item-active {\n      & > .rc-collapse-header {\n        & .arrow {\n          transform: rotate(0deg);\n        }\n      }\n    }\n  }\n"
    ]);
    Panel_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PanelStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default.Panel */.Z.Panel).withConfig({
    displayName: "style__PanelStyled",
    componentId: "sc-e8df8a15-0"
})(Panel_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475ccc";
            }
        default:
            {
                return "#292929cc";
            }
    }
});

;// CONCATENATED MODULE: ./units/Collapse/Panel/index.tsx






var Panel = function(_param) /*#__PURE__*/ {
    var // custom
    palette = _param.palette, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(PanelStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        // custom
        palette: palette
    }));
};
/* harmony default export */ var Collapse_Panel = (Panel);

;// CONCATENATED MODULE: ./units/Collapse/style.tsx

function Collapse_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  border: none;\n  margin-bottom: 12px;\n  background: transparent;\n\n  & .rc-collapse-content {\n    padding: 0;\n    background: transparent;\n\n    & .rc-collapse-content-box {\n      margin: 8px 0;\n    }\n  }\n"
    ]);
    Collapse_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CollapseStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default */.Z).withConfig({
    displayName: "style__CollapseStyled",
    componentId: "sc-ffd29dd0-0"
})(Collapse_style_templateObject());

;// CONCATENATED MODULE: ./units/Collapse/index.tsx






var Collapse = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(CollapseStyled, (0,_object_spread/* default */.Z)({
        // custom
        palette: palette
    }, rest));
};
Collapse.Panel = Collapse_Panel;
/* harmony default export */ var units_Collapse = (Collapse);

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/style.tsx

function Collapsable_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  height: 100%;\n  display: grid;\n  justify-content: inherit;\n\n  & > label {\n    padding-left: 25px;\n  }\n"
    ]);
    Collapsable_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Header",
    componentId: "sc-f04741cd-0"
})(Collapsable_style_templateObject());

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/index.tsx






var defaultCheckedList = [];
var Collapsable_CheckboxGroup = function(param) {
    var name = param.name, label = param.label, children = param.children, onChangeAll = param.onChangeAll;
    var optionsAll = (0,react.useMemo)(function() {
        return children.map(function(e) {
            return e.props.name;
        });
    }, [
        children
    ]);
    var ref = (0,react.useState)(defaultCheckedList), checkedList = ref[0], setCheckedList = ref[1];
    var ref1 = (0,react.useState)(false), indeterminate = ref1[0], setIndeterminate = ref1[1];
    var ref2 = (0,react.useState)(false), checkAll = ref2[0], setCheckAll = ref2[1];
    var handleChange = (0,react.useCallback)(function(list) {
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < optionsAll.length);
        setCheckAll(list.length === optionsAll.length);
    }, [
        optionsAll
    ]);
    var onCheckAllChange = (0,react.useCallback)(function(e) {
        setCheckedList(e.target.checked ? optionsAll : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
        // sorting out nodes with the same state as group checkbox
        var list = children.filter(function(node) {
            return node.props.checked !== e.target.checked;
        });
        onChangeAll === null || onChangeAll === void 0 ? void 0 : onChangeAll(e.target.checked, list.map(function(event) {
            return event.props.name;
        }));
    }, [
        children,
        onChangeAll,
        optionsAll
    ]);
    var header = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                indeterminate: indeterminate,
                onChange: onCheckAllChange,
                checked: checkAll,
                name: name,
                palette: "primary",
                children: label
            })
        });
    }, [
        name,
        label,
        indeterminate,
        onCheckAllChange,
        checkAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse.Panel, {
            header: header,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                name: name,
                value: checkedList,
                onChange: handleChange,
                children: children
            })
        })
    });
};
/* harmony default export */ var Collapsable = (/*#__PURE__*/(0,react.memo)(Collapsable_CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/index.tsx




var units_Checkbox_Checkbox = Checkbox_Checkbox;
units_Checkbox_Checkbox.Collapsable = Collapsable;
units_Checkbox_Checkbox.Group = Group;
/* harmony default export */ var units_Checkbox = (units_Checkbox_Checkbox);

;// CONCATENATED MODULE: ./units/CloseButton/style.tsx

function CloseButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  top: ",
        ";\n  right: ",
        ";\n  border-radius: 50%;\n  background-color: var(--color-primary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-secondary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    right: ",
        ";\n  }\n"
    ]);
    CloseButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CloseButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__CloseButtonStyled",
    componentId: "sc-2535d2b1-0"
})(CloseButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "15px" : "68px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});

;// CONCATENATED MODULE: ./units/CloseButton/index.tsx


var CloseButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonStyled, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "fas fa-times"
        })
    });
};
/* harmony default export */ var units_CloseButton = (CloseButton);

// EXTERNAL MODULE: ./node_modules/rc-field-form/es/index.js + 13 modules
var rc_field_form_es = __webpack_require__(54216);
;// CONCATENATED MODULE: ./units/Field/Group/style.tsx

function Group_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: column;\n  gap: ",
        ";\n"
    ]);
    Group_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Content",
    componentId: "sc-1d2645c-0"
})(Group_style_templateObject(), function(param) {
    var gap = param.gap;
    return "".concat(gap !== null && gap !== void 0 ? gap : 0, "px");
});

;// CONCATENATED MODULE: ./units/Field/style.tsx

function Field_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    Field_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Lato', sans-serif;\n  font-size: 12px;\n  margin: 0 0 6px;\n  display: grid;\n  grid-template-areas: 'icon label lock';\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  & svg {\n    font-size: 15px;\n    margin-right: 9px;\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: icon;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: label;\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: lock;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ea475c;\n  margin-top: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Field_style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Label",
    componentId: "sc-4f2f6e14-0"
})(Field_style_templateObject(), function(param) {
    var labelInline = param.labelInline;
    if (labelInline) {
        return "flex";
    }
    return "block";
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Title",
    componentId: "sc-4f2f6e14-1"
})(style_templateObject1(), function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#888";
            }
    }
}, function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "normal";
            }
        default:
            {
                return "bolder";
            }
    }
});
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Icon",
    componentId: "sc-4f2f6e14-2"
})(style_templateObject2());
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Name",
    componentId: "sc-4f2f6e14-3"
})(style_templateObject3());
var Lock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Lock",
    componentId: "sc-4f2f6e14-4"
})(_templateObject4());
var Error = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Error",
    componentId: "sc-4f2f6e14-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./units/Field/Group/index.tsx



var Group_Group = function(param) {
    var label = param.label, labelIcon = param.labelIcon, labelPalette = param.labelPalette, gap = param.gap, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                labelPalette: labelPalette,
                children: [
                    labelIcon,
                    label
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                gap: gap,
                children: children
            })
        ]
    });
};
/* harmony default export */ var Field_Group = (Group_Group);

;// CONCATENATED MODULE: ./units/Field/index.tsx








var Field = function(_param) {
    var name = _param.name, label = _param.label, labelIcon = _param.labelIcon, labelPalette = _param.labelPalette, noStyle = _param.noStyle, labelInline = _param.labelInline, lockable = _param.lockable, isLocked = _param.isLocked, isLockedByDefault = _param.isLockedByDefault, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "labelIcon",
        "labelPalette",
        "noStyle",
        "labelInline",
        "lockable",
        "isLocked",
        "isLockedByDefault",
        "children"
    ]);
    var ref;
    var ref1 = (0,react.useState)((ref = isLocked !== null && isLocked !== void 0 ? isLocked : isLockedByDefault) !== null && ref !== void 0 ? ref : false), locked = ref1[0], setLocked = ref1[1];
    (0,react.useEffect)(function() {
        if (typeof isLocked === "boolean") {
            setLocked(isLocked);
        }
    }, [
        isLocked
    ]);
    if (noStyle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            name: name
        }, restProps), {
            children: function(control, meta, form) {
                var childNode = typeof children === "function" ? children((0,_object_spread/* default */.Z)({}, lockable ? {
                    disabled: locked
                } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, control), {
                    name: name
                }));
                return childNode;
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        name: name
    }, restProps), {
        children: function(control, meta, form) {
            var error = name && form.getFieldError(name)[0] || "";
            var childNode = typeof children === "function" ? children((0,_object_spread/* default */.Z)({}, lockable ? {
                disabled: locked
            } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, control), {
                name: name
            }), lockable ? {
                disabled: locked
            } : {}));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                labelInline: labelInline,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        labelPalette: labelPalette,
                        children: [
                            labelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                children: labelIcon
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                children: label
                            })
                        ]
                    }),
                    childNode,
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        children: error
                    })
                ]
            });
        }
    }));
};
Field.Group = Field_Group;
/* harmony default export */ var units_Field = (Field);

;// CONCATENATED MODULE: ./units/Form/style.tsx

function Form_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  /* global override */\n  max-height: unset !important;\n  overflow: unset !important;\n"
    ]);
    Form_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Form = (0,styled_components_browser_esm/* default */.ZP)(rc_field_form_es/* default */.ZP).withConfig({
    displayName: "style__Form",
    componentId: "sc-a03062af-0"
})(Form_style_templateObject());

;// CONCATENATED MODULE: ./units/Form/index.tsx

/* harmony default export */ var units_Form = (Form);

;// CONCATENATED MODULE: ./units/FullscreenButton/style.tsx

function FullscreenButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  border-radius: 50%;\n  top: ",
        ";\n  right: ",
        ";\n  background-color: var(--color-secondary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-primary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    top: ",
        ";\n    right: ",
        ";\n  }\n"
    ]);
    FullscreenButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FullscreenButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__FullscreenButtonStyled",
    componentId: "sc-17a6388c-0"
})(FullscreenButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "48px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "52px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});
/* harmony default export */ var style = (FullscreenButtonStyled);

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./units/FullscreenButton/index.tsx



var FullscreenButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return !deviceManager["default"].isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: isFullscreen ? "fas fa-compress" : "fas fa-expand"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var units_FullscreenButton = (FullscreenButton);

// EXTERNAL MODULE: ./units/Iframe/index.tsx + 1 modules
var Iframe = __webpack_require__(12978);
// EXTERNAL MODULE: ./node_modules/rc-textarea/es/index.js + 2 modules
var rc_textarea_es = __webpack_require__(57239);
;// CONCATENATED MODULE: ./units/Input/TextArea/style.tsx

function TextArea_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n  line-height: 1.2;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    TextArea_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextArea_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var TextAreaStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_textarea_es/* default */.Z).withConfig({
    displayName: "style__TextAreaStyled",
    componentId: "sc-ea1cbca6-0"
})(TextArea_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/TextArea/index.tsx




var autoSizeDefault = {
    minRows: 3,
    maxRows: 5
};
var TextArea = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, _autoSize = _param.autoSize, autoSize = _autoSize === void 0 ? autoSizeDefault : _autoSize, _value = _param.value, value = _value === void 0 ? "" : _value, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onChange = _param.onChange, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "textarea" : _prefixCls, props = (0,_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "autoSize",
        "value",
        "placeholder",
        "name",
        "disabled",
        "onChange",
        "prefixCls"
    ]);
    return (0,jsx_runtime.jsx)(TextAreaStyled, (0,_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        autoSize: autoSize,
        value: value,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onChange: onChange,
        prefixCls: prefixCls
    }, props));
};
/* harmony default export */ var Input_TextArea = (TextArea);

;// CONCATENATED MODULE: ./units/Input/style.tsx

function Input_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  min-width: 60px;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    Input_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Input_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var InputStyled = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "style__InputStyled",
    componentId: "sc-60cb3ca-0"
})(Input_style_templateObject(), function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "".concat(Input_style_SIZES.XSMALL, "px");
            }
        case "small":
            {
                return "".concat(Input_style_SIZES.SMALL, "px");
            }
        default:
            {
                return "".concat(Input_style_SIZES.MEDIUM, "px");
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/index.tsx





var Input = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, value = _param.value, min = _param.min, max = _param.max, step = _param.step, onChange = _param.onChange, onBlur = _param.onBlur, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onKeyDown = _param.onKeyDown, tabIndex = _param.tabIndex, type = _param.type, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "value",
        "min",
        "max",
        "step",
        "onChange",
        "onBlur",
        "placeholder",
        "name",
        "disabled",
        "onKeyDown",
        "tabIndex",
        "type"
    ]);
    return (0,jsx_runtime.jsx)(InputStyled, (0,_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        value: value,
        min: min,
        max: max,
        step: step,
        onChange: onChange,
        onBlur: onBlur,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onKeyDown: onKeyDown,
        tabIndex: tabIndex,
        type: type
    }, restProps));
};
Input.TextArea = Input_TextArea;
/* harmony default export */ var units_Input = (Input);

;// CONCATENATED MODULE: ./units/Text/style.tsx

function Text_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  text-transform: ",
        ";\n  text-decoration: ",
        ";\n"
    ]);
    Text_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Text_style_Root = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Root",
    componentId: "sc-c6e4aab7-0"
})(Text_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "#888";
            }
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var weight = param.weight;
    switch(weight){
        case "regular":
            {
                return "bolder";
            }
        case "strong":
            {
                return "bold";
            }
        // case "weak"
        default:
            {
                return "normal";
            }
    }
}, function(param) {
    var uppercase = param.uppercase;
    return uppercase ? "uppercase" : "none";
}, function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});

;// CONCATENATED MODULE: ./units/Text/index.tsx


var Text = function(param) {
    var size = param.size, weight = param.weight, align = param.align, truncate = param.truncate, underline = param.underline, uppercase = param.uppercase, palette = param.palette, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_style_Root, {
        size: size,
        weight: weight,
        align: align,
        truncate: truncate,
        underline: underline,
        uppercase: uppercase,
        palette: palette,
        children: children
    });
};
/* harmony default export */ var units_Text = (Text);

// EXTERNAL MODULE: ./units/Icon/index.ts + 33 modules
var units_Icon = __webpack_require__(10530);
;// CONCATENATED MODULE: ./units/VideoBox/index.tsx

function VideoBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  position: absolute;\n  bottom: 70px;\n  left: 60px;\n  z-index: 100;\n"
    ]);
    VideoBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  transition: all 0.25s ease;\n"
    ]);
    VideoBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: -10px;\n  top: -10px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  color: #fff;\n  padding: 8px;\n  font-size: 14px;\n  line-height: 10px;\n  z-index: 2;\n  cursor: pointer;\n"
    ]);
    VideoBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoBox__Container",
    componentId: "sc-2616173e-0"
})(VideoBox_templateObject(), function(param) {
    var width = param.width, isMobile = param.isMobile;
    return isMobile ? "70vw" : "".concat(width || 350, "px");
}, function(param) {
    var height = param.height, isMobile = param.isMobile;
    return isMobile ? "auto" : "".concat(height || 200, "px");
});
var VideoBox_Iframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    displayName: "VideoBox__Iframe",
    componentId: "sc-2616173e-1"
})(VideoBox_templateObject1());
var VideoBox_Icon = styled_components_browser_esm/* default.i.withConfig */.ZP.i.withConfig({
    displayName: "VideoBox__Icon",
    componentId: "sc-2616173e-2"
})(VideoBox_templateObject2());
/* harmony default export */ var VideoBox = ({
    Container: Container,
    Iframe: VideoBox_Iframe,
    Icon: VideoBox_Icon
});

;// CONCATENATED MODULE: ./units/Watermark/style.tsx

function Watermark_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  width: 100%;\n  top: 30%;\n  text-align: center;\n  opacity: 0.5;\n  z-index: 99999;\n  color: white;\n  transform: rotate(-30deg);\n  font-size: 30vh;\n  pointer-events: none;\n  @media (orientation: portrait) {\n    transform: rotate(-45deg);\n    font-size: 22vh;\n  }\n"
    ]);
    Watermark_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var WatermarkStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__WatermarkStyled",
    componentId: "sc-74f85d7c-0"
})(Watermark_style_templateObject());
/* harmony default export */ var Watermark_style = (WatermarkStyled);

;// CONCATENATED MODULE: ./units/Watermark/index.tsx





var Watermark = function(_param) {
    var id = _param.id, show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Watermark_style, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: id
        }, restProps), {
            children: children
        }));
    }
    return null;
};
/* harmony default export */ var units_Watermark = (Watermark);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39828);
;// CONCATENATED MODULE: ./units/DatePicker/index.tsx



var DatePickerCreator = function(param) {
    var dateFormat = param.dateFormat, startDate = param.startDate, handleDateChange = param.handleDateChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
        dateFormat: dateFormat,
        selected: startDate,
        onChange: handleDateChange,
        autoComplete: "disable_autocomplete"
    });
};
/* harmony default export */ var DatePicker = (DatePickerCreator);

;// CONCATENATED MODULE: ./units/index.ts

















/***/ }),

/***/ 94697:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var blobToUrl = function(blob) {
    return window.URL.createObjectURL(new Blob([
        blob
    ]));
};
var existFile = function(url) {
    return new Promise(function(resolve) {
        fetch(url, {
            method: "HEAD"
        }).then(function(response) {
            return resolve(!!response.ok);
        }).catch(function() {
            return resolve(false);
        });
    });
};
var file = {
    blobToUrl: blobToUrl,
    existFile: existFile
};
/* harmony default export */ __webpack_exports__["Z"] = (file);


/***/ }),

/***/ 56413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var crypto_js_md5__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68214);
/* harmony import */ var crypto_js_md5__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto_js_md5__WEBPACK_IMPORTED_MODULE_0__);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var getDeviceFingerprint = function() {
    // Text with lowercase/uppercase/punctuation symbols
    var txt = "BrowserLeaks,com <canvas> 1.0";
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d"); // 2d, webgl, webgl2, bitmaprenderer
    ctx.textBaseline = "top";
    // The most common type
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    // Some tricks for color mixing to increase the difference in rendering
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);
    var dataString = canvas.toDataURL();
    return crypto_js_md5__WEBPACK_IMPORTED_MODULE_0___default()(dataString).toString();
};
/* harmony default export */ __webpack_exports__["Z"] = (getDeviceFingerprint);


/***/ }),

/***/ 9163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bI": function() { return /* reexport */ AnalyticsCSVGenerator; },
  "IX": function() { return /* reexport */ utils_array; },
  "$_": function() { return /* reexport */ utils_color; },
  "tP": function() { return /* reexport */ file/* default */.Z; },
  "UI": function() { return /* reexport */ fingerprint/* default */.Z; },
  "p4": function() { return /* reexport */ utils_link; }
});

// UNUSED EXPORTS: ThreeInstance, css, number, random, string

;// CONCATENATED MODULE: ./utils/css.ts
var setProperty = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    document.documentElement.style.setProperty(name, value);
};
var getProperty = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return document.documentElement.style.getPropertyValue(name);
};
var COLOR_PRIMARY = "--color-primary";
var COLOR_SECONDARY = "--color-secondary";
/*
  #TODO: Add types for all Keys
  type Keys = COLOR_PRIMARY | COLOR_SECONDARY;
*/ var css = {
    setProperty: setProperty,
    getProperty: getProperty,
    COLOR_PRIMARY: COLOR_PRIMARY,
    COLOR_SECONDARY: COLOR_SECONDARY
};
/* harmony default export */ var utils_css = ((/* unused pure expression or super */ null && (css)));

// EXTERNAL MODULE: ./utils/number.ts
var number = __webpack_require__(60632);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./utils/array.ts




var groupBy = function(items, group) {
    return items.reduce(function(acc, item) {
        // TODO: fix Assigned expression type any[] is not assignable to type T[T[string]]
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[item[group]] = (0,_to_consumable_array/* default */.Z)(acc[item[group]] || []).concat([
            item
        ]);
        return acc;
    }, {});
};
var toDictionary = function(list) {
    var userDefinedOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var defaultOptions = {
        indexKey: "name",
        valueKey: "value"
    };
    if (!Array.isArray(list)) {
        throw new Error("Cannot convert a non-array value to dictionary.");
    }
    var ref = (0,_object_spread/* default */.Z)({}, defaultOptions, userDefinedOptions), indexKey = ref.indexKey, valueKey = ref.valueKey, transformValues = ref.transformValues;
    return list.reduce(function(dictionary, item) {
        if (!item || !(item[indexKey] || item[indexKey] === 0)) {
            return dictionary;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dictionary), (0,_define_property/* default */.Z)({}, item[indexKey], transformValues ? transformValues(item) : item[valueKey]));
    }, {});
};
var getMinItemByField = function(data, field) {
    return data.reduce(function(min, p) {
        return p[field] < min[field] ? p[field] : min;
    }, data[0] || null);
};
var array = {
    groupBy: groupBy,
    toDictionary: toDictionary,
    getMinItemByField: getMinItemByField
};
/* harmony default export */ var utils_array = (array);

;// CONCATENATED MODULE: ./utils/link.ts
var download = function(url, filename) {
    var link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "".concat(filename));
    document.body.appendChild(link);
    link.click();
    link.remove();
};
var blobToBase64 = function(blob) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function() {
        return reader.result;
    };
};
var openInNewTab = function(url) {
    var newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
};
var link_link = {
    download: download,
    blobToBase64: blobToBase64,
    openInNewTab: openInNewTab
};
/* harmony default export */ var utils_link = (link_link);

// EXTERNAL MODULE: ./utils/file.ts
var file = __webpack_require__(94697);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/jszip/dist/jszip.min.js
var jszip_min = __webpack_require__(55733);
var jszip_min_default = /*#__PURE__*/__webpack_require__.n(jszip_min);
;// CONCATENATED MODULE: ./utils/csv.ts

/* eslint-disable @typescript-eslint/no-explicit-any,no-useless-concat */ // TODO: fix type any


var AnalyticsCSVGenerator = function AnalyticsCSVGenerator(tourName, startDate, endDate) {
    "use strict";
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, AnalyticsCSVGenerator);
    this.eachResult = [];
    this.generateCSV = function(data, csvDataStorage, conversionValues) {
        var ref, ref1, ref2;
        if (!data || !csvDataStorage || !conversionValues) return;
        var viewsCsv = "VIEWS:, ".concat(((ref = data.totals) === null || ref === void 0 ? void 0 : ref.views) || 0);
        _this.appendData(viewsCsv, "Views", "Views");
        var timeCsv = "TIME (MIN):, ".concat((((ref1 = data.totals) === null || ref1 === void 0 ? void 0 : ref1.time) || 0) / 60);
        _this.appendData(timeCsv, "Time (min)", "Time (min)");
        var usersCsv = "USERS:, ".concat(((ref2 = data.totals) === null || ref2 === void 0 ? void 0 : ref2.users) || 0);
        _this.appendData(usersCsv, "Users", "Users");
        var usersVsViewsData = "DAYS:, ".concat(csvDataStorage.usersVsViews.days.join(", "), "\n") + "USERS:, ".concat(csvDataStorage.usersVsViews.users.join(", "), "\n") + "VIEWS:, ".concat(csvDataStorage.usersVsViews.views.join(", "));
        _this.appendData(usersVsViewsData, "Users Vs. Views", "Users vs. Views Chart (days users views)");
        var averageTimeData = "DAYS:, ".concat(csvDataStorage.averageTime.days.join(", "), "\n") + "TIME:, ".concat(csvDataStorage.averageTime.time.join(", "));
        _this.appendData(averageTimeData, "Average time", "Average time spent per days");
        var usersVsViewsByHourForData = "DAYS:, ".concat(csvDataStorage.usersVsViewsByHourFor.days.join(", "), "\n") + "USERS:, ".concat(csvDataStorage.usersVsViewsByHourFor.users.join(", "), "\n") + "VIEWS:, ".concat(csvDataStorage.usersVsViewsByHourFor.views.join(", "));
        _this.appendData(usersVsViewsByHourForData, "Users vs Views by hour", "Users vs Views by hour (days users views)");
        var interactivityData = "TAGS CLICKS:, ".concat(csvDataStorage.interactivity.data[0], "\n") + "MENU CLICKS:, ".concat(csvDataStorage.interactivity.data[1], "\n") + "MAP CLICKS:, ".concat(csvDataStorage.interactivity.data[2], "\n") + "INTRO BUTTON CLICKS:, ".concat(csvDataStorage.interactivity.data[3]);
        _this.appendData(interactivityData, "Interactivity", "Interactivity (clicks)");
        var deviceChartByUsersData = "DESKTOP:, ".concat(csvDataStorage.deviceChartByUsers.data[0], "\n") + "MOBILE:, ".concat(csvDataStorage.deviceChartByUsers.data[1], "\n") + "TABLET:, ".concat(csvDataStorage.deviceChartByUsers.data[2]);
        _this.appendData(deviceChartByUsersData, "Device chart by users data", "Device chart by users data");
        var deviceChartByViewsData = "DESKTOP:, ".concat(csvDataStorage.deviceChartByViews.data[0], "\n") + "MOBILE:, ".concat(csvDataStorage.deviceChartByViews.data[1], "\n") + "TABLET:, ".concat(csvDataStorage.deviceChartByViews.data[2]);
        _this.appendData(deviceChartByViewsData, "Device chart by views", "Device chart by views");
        // Conversion chart data
        var contactFormConversionValues = "OPEN:, ".concat(conversionValues.conv.convOpen, "\n") + "SUBMIT:, ".concat(conversionValues.conv.convSubmit, "\n") + "CONVERSION RATE (%):, ".concat(conversionValues.conv.conversion);
        _this.appendData(contactFormConversionValues, "Conversion Rate - Contact Form", "Leads from Contact Form - Conversion Rate");
        var sweepConversionValues = "OPEN:, ".concat(conversionValues.sweep.sweepOpen, "\n") + "SUBMIT:, ".concat(conversionValues.sweep.sweepSubmit, "\n") + "CONVERSION RATE (%):, ".concat(conversionValues.sweepConversion);
        _this.appendData(sweepConversionValues, "Conversion Rate - Sweep", "Leads from Sweep - Conversion Rate");
        var imageConversionValues = "OPEN:, ".concat(conversionValues.image.imageOpen, "\n") + "SUBMIT:, ".concat(conversionValues.image.imageSubmit, "\n") + "CONVERSION RATE (%):, ".concat(conversionValues.image.imageConversion);
        _this.appendData(imageConversionValues, "Conversion Rate - Image", "Leads from Image Form - Conversion Rate");
        var entryConversionValues = "OPEN:, ".concat(conversionValues.entry.entryOpen, "\n") + "SUBMIT:, ".concat(conversionValues.entry.entrySubmit, "\n") + "CONVERSION RATE (%):, ".concat(conversionValues.entry.entryConversion);
        _this.appendData(entryConversionValues, "Conversion Rate - Entry", "Leads from Tour Entry - Conversion Rate");
        var tagClicksData = "TAGS:, ".concat(csvDataStorage.tagClicks.labels.join(", "), "\n") + "CLICKS:, ".concat(csvDataStorage.tagClicks.data.join(", "));
        _this.appendData(tagClicksData, "Tag clicks", "Tag clicks");
        var menuClicksData = "MENU ITEM:, ".concat(csvDataStorage.menuClicks.labels.join(", "), "\n") + "CLICKS:, ".concat(csvDataStorage.menuClicks.data.join(", "));
        _this.appendData(menuClicksData, "Menu clicks", "Menu clicks");
        var heatmapData = "TAG NAME:, ".concat(csvDataStorage.heatmap.tags.map(function(e) {
            return e.name;
        }).join(", "), "\n") + "TAG HEAT:, ".concat(csvDataStorage.heatmap.tags.map(function(e) {
            return e.heat;
        }).join(", "), "\n") + "SWEEP NAME:, ".concat(csvDataStorage.heatmap.sweeps.map(function(e) {
            return e.name;
        }).join(", "), "\n") + "SWEEP HEAT:, ".concat(csvDataStorage.heatmap.sweeps.map(function(e) {
            return e.heat;
        }).join(", "));
        _this.appendData(heatmapData, "Heatmap", "Heatmap (tags and sweeps)");
        var sourcesViewsData = "LABEL:, ".concat(csvDataStorage.sourcesViews.labels.join(", "), "\n") + "VIEWS:, ".concat(csvDataStorage.sourcesViews.data.join(", "));
        _this.appendData(sourcesViewsData, "Sources views", "Sources views");
        var sourcesUsersData = "LABEL:, ".concat(csvDataStorage.sourcesUsers.labels.join(", "), "\n") + "VIEWS:, ".concat(csvDataStorage.sourcesUsers.data.join(", "));
        _this.appendData(sourcesUsersData, "Sources users", "Sources users");
    };
    this.appendData = function(data, name) {
        var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        // coma separate, newline each row
        // dashes separator for each result
        _this.eachResult.push({
            name: name,
            data: data
        });
        _this.result += "".concat((separator ? "".concat(separator, "\n") : "") + data, "\n");
    };
    this.downloadCSV = function() {
        var _this1 = _this;
        // write whole result in file
        // create several files for each result
        // zip them all
        var zip = new (jszip_min_default())();
        zip.file("all_analytics.csv", _this.result);
        _this.eachResult.forEach(function(result) {
            return zip.file("".concat(result.name, ".csv"), result.data);
        });
        zip.generateAsync({
            type: "blob"
        }).then(function(content) {
            // see FileSaver.js
            utils_link.download(file/* default.blobToUrl */.Z.blobToUrl(content), "".concat(_this1.tourName, "_").concat(_this1.startDate, "-").concat(_this1.endDate, ".zip"));
        });
        return {
            result: _this.result,
            eachResult: _this.eachResult
        };
    };
    this.printCSV = function() {
    // console.log('CSV, ', this.result);
    };
    this.tourName = tourName;
    this.startDate = startDate;
    this.endDate = endDate;
    this.generateCSV = this.generateCSV.bind(this);
    this.appendData = this.appendData.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
};


// EXTERNAL MODULE: ./utils/fingerprint.ts
var fingerprint = __webpack_require__(56413);
;// CONCATENATED MODULE: ./utils/random.ts
var random_string = function(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for(var i = 0; i < length; i += 1){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
var random = {
    string: random_string
};
/* harmony default export */ var utils_random = ((/* unused pure expression or super */ null && (random)));

;// CONCATENATED MODULE: ./utils/color.ts
var hexToRgbA = function(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length === 3) {
            c = [
                c[0],
                c[0],
                c[1],
                c[1],
                c[2],
                c[2]
            ];
        }
        c = "0x".concat(c.join(""));
        return "rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',".concat(opacity, ")");
    }
    return "rgba(255,255,255,0.25)";
};
var color = {
    hexToRgbA: hexToRgbA
};
/* harmony default export */ var utils_color = (color);

;// CONCATENATED MODULE: ./utils/index.ts













/***/ }),

/***/ 60632:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var round = function(value) {
    var toFixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (!value) return 1;
    if (typeof value !== "number") return parseFloat(value);
    return parseFloat(value.toFixed(toFixed));
};
var random = function(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
};
var number = {
    round: round,
    random: random
};
/* harmony default export */ __webpack_exports__["Z"] = (number);


/***/ }),

/***/ 14045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kC": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* unused harmony export hasAtSymbol */
var capitalize = function(s) {
    return s.charAt(0).toUpperCase() + s.toLowerCase().slice(1);
};
var hasAtSymbol = function(str) {
    if (str === null || str === void 0 ? void 0 : str.length) {
        return str.includes("@");
    }
    return false;
};
var stripTags = function(value) {
    if (value === null || value === void 0 ? void 0 : value.length) {
        return value.replace(/(<([^>]+)>)/gi, "");
    }
    return value;
};
var string = {
    capitalize: capitalize,
    hasAtSymbol: hasAtSymbol,
    stripTags: stripTags
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (string)));


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);